'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var crypto = require('crypto');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var crypto__default = /*#__PURE__*/_interopDefaultLegacy(crypto);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, basedir, module) {
	return module = {
		path: basedir,
		exports: {},
		require: function (path, base) {
			return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
		}
	}, fn(module, module.exports), module.exports;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var es6Promise = createCommonjsModule(function (module, exports) {
/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.8+1e68dce6
 */

(function (global, factory) {
	 module.exports = factory() ;
}(commonjsGlobal, (function () {
function objectOrFunction(x) {
  var type = typeof x;
  return x !== null && (type === 'object' || type === 'function');
}

function isFunction(x) {
  return typeof x === 'function';
}



var _isArray = void 0;
if (Array.isArray) {
  _isArray = Array.isArray;
} else {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
}

var isArray = _isArray;

var len = 0;
var vertxNext = void 0;
var customSchedulerFn = void 0;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  if (typeof vertxNext !== 'undefined') {
    return function () {
      vertxNext(flush);
    };
  }

  return useSetTimeout();
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var vertx = Function('return this')().require('vertx');
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = void 0;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && typeof commonjsRequire === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;


  if (_state) {
    var callback = arguments[_state - 1];
    asap(function () {
      return invokeCallback(_state, child, callback, parent._result);
    });
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve$1(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(2);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
  try {
    then$$1.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then$$1) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then$$1, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return resolve(promise, value);
    }, function (reason) {
      return reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$1) {
  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$1 === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$1)) {
      handleForeignThenable(promise, maybeThenable, then$$1);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function resolve(promise, value) {
  if (promise === value) {
    reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    var then$$1 = void 0;
    try {
      then$$1 = value.then;
    } catch (error) {
      reject(promise, error);
      return;
    }
    handleMaybeThenable(promise, value, then$$1);
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;


  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = void 0,
      callback = void 0,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = void 0,
      error = void 0,
      succeeded = true;

  if (hasCallback) {
    try {
      value = callback(detail);
    } catch (e) {
      succeeded = false;
      error = e;
    }

    if (promise === value) {
      reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
  }

  if (promise._state !== PENDING) ; else if (hasCallback && succeeded) {
    resolve(promise, value);
  } else if (succeeded === false) {
    reject(promise, error);
  } else if (settled === FULFILLED) {
    fulfill(promise, value);
  } else if (settled === REJECTED) {
    reject(promise, value);
  }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      resolve(promise, value);
    }, function rejectPromise(reason) {
      reject(promise, reason);
    });
  } catch (e) {
    reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
}

var Enumerator = function () {
  function Enumerator(Constructor, input) {
    this._instanceConstructor = Constructor;
    this.promise = new Constructor(noop);

    if (!this.promise[PROMISE_ID]) {
      makePromise(this.promise);
    }

    if (isArray(input)) {
      this.length = input.length;
      this._remaining = input.length;

      this._result = new Array(this.length);

      if (this.length === 0) {
        fulfill(this.promise, this._result);
      } else {
        this.length = this.length || 0;
        this._enumerate(input);
        if (this._remaining === 0) {
          fulfill(this.promise, this._result);
        }
      }
    } else {
      reject(this.promise, validationError());
    }
  }

  Enumerator.prototype._enumerate = function _enumerate(input) {
    for (var i = 0; this._state === PENDING && i < input.length; i++) {
      this._eachEntry(input[i], i);
    }
  };

  Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
    var c = this._instanceConstructor;
    var resolve$$1 = c.resolve;


    if (resolve$$1 === resolve$1) {
      var _then = void 0;
      var error = void 0;
      var didError = false;
      try {
        _then = entry.then;
      } catch (e) {
        didError = true;
        error = e;
      }

      if (_then === then && entry._state !== PENDING) {
        this._settledAt(entry._state, i, entry._result);
      } else if (typeof _then !== 'function') {
        this._remaining--;
        this._result[i] = entry;
      } else if (c === Promise$1) {
        var promise = new c(noop);
        if (didError) {
          reject(promise, error);
        } else {
          handleMaybeThenable(promise, entry, _then);
        }
        this._willSettleAt(promise, i);
      } else {
        this._willSettleAt(new c(function (resolve$$1) {
          return resolve$$1(entry);
        }), i);
      }
    } else {
      this._willSettleAt(resolve$$1(entry), i);
    }
  };

  Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
    var promise = this.promise;


    if (promise._state === PENDING) {
      this._remaining--;

      if (state === REJECTED) {
        reject(promise, value);
      } else {
        this._result[i] = value;
      }
    }

    if (this._remaining === 0) {
      fulfill(promise, this._result);
    }
  };

  Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
    var enumerator = this;

    subscribe(promise, undefined, function (value) {
      return enumerator._settledAt(FULFILLED, i, value);
    }, function (reason) {
      return enumerator._settledAt(REJECTED, i, reason);
    });
  };

  return Enumerator;
}();

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all(entries) {
  return new Enumerator(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject$1(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/

var Promise$1 = function () {
  function Promise(resolver) {
    this[PROMISE_ID] = nextId();
    this._result = this._state = undefined;
    this._subscribers = [];

    if (noop !== resolver) {
      typeof resolver !== 'function' && needsResolver();
      this instanceof Promise ? initializePromise(this, resolver) : needsNew();
    }
  }

  /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */

  /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */


  Promise.prototype.catch = function _catch(onRejection) {
    return this.then(null, onRejection);
  };

  /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @return {Promise}
  */


  Promise.prototype.finally = function _finally(callback) {
    var promise = this;
    var constructor = promise.constructor;

    if (isFunction(callback)) {
      return promise.then(function (value) {
        return constructor.resolve(callback()).then(function () {
          return value;
        });
      }, function (reason) {
        return constructor.resolve(callback()).then(function () {
          throw reason;
        });
      });
    }

    return promise.then(callback, callback);
  };

  return Promise;
}();

Promise$1.prototype.then = then;
Promise$1.all = all;
Promise$1.race = race;
Promise$1.resolve = resolve$1;
Promise$1.reject = reject$1;
Promise$1._setScheduler = setScheduler;
Promise$1._setAsap = setAsap;
Promise$1._asap = asap;

/*global self*/
function polyfill() {
  var local = void 0;

  if (typeof commonjsGlobal !== 'undefined') {
    local = commonjsGlobal;
  } else if (typeof self !== 'undefined') {
    local = self;
  } else {
    try {
      local = Function('return this')();
    } catch (e) {
      throw new Error('polyfill failed because global object is unavailable in this environment');
    }
  }

  var P = local.Promise;

  if (P) {
    var promiseToString = null;
    try {
      promiseToString = Object.prototype.toString.call(P.resolve());
    } catch (e) {
      // silently ignored
    }

    if (promiseToString === '[object Promise]' && !P.cast) {
      return;
    }
  }

  local.Promise = Promise$1;
}

// Strange compat..
Promise$1.polyfill = polyfill;
Promise$1.Promise = Promise$1;

return Promise$1;

})));




});

function n(n){for(var t=arguments.length,r=Array(t>1?t-1:0),e=1;e<t;e++)r[e-1]=arguments[e];if("production"!==process.env.NODE_ENV){var i=Y[n],o=i?"function"==typeof i?i.apply(null,r):i:"unknown error nr: "+n;throw Error("[Immer] "+o)}throw Error("[Immer] minified error nr: "+n+(r.length?" "+r.map((function(n){return "'"+n+"'"})).join(","):"")+". Find the full error at: https://bit.ly/3cXEKWf")}function t(n){return !!n&&!!n[Q]}function r(n){return !!n&&(function(n){if(!n||"object"!=typeof n)return !1;var t=Object.getPrototypeOf(n);return !t||t===Object.prototype}(n)||Array.isArray(n)||!!n[L]||!!n.constructor[L]||s(n)||v(n))}function i(n,t,r){void 0===r&&(r=!1),0===o(n)?(r?Object.keys:Z)(n).forEach((function(e){r&&"symbol"==typeof e||t(e,n[e],n);})):n.forEach((function(r,e){return t(e,r,n)}));}function o(n){var t=n[Q];return t?t.i>3?t.i-4:t.i:Array.isArray(n)?1:s(n)?2:v(n)?3:0}function u(n,t){return 2===o(n)?n.has(t):Object.prototype.hasOwnProperty.call(n,t)}function a(n,t){return 2===o(n)?n.get(t):n[t]}function f(n,t,r){var e=o(n);2===e?n.set(t,r):3===e?(n.delete(t),n.add(r)):n[t]=r;}function c(n,t){return n===t?0!==n||1/n==1/t:n!=n&&t!=t}function s(n){return X&&n instanceof Map}function v(n){return q&&n instanceof Set}function p(n){return n.o||n.t}function l(n){if(Array.isArray(n))return Array.prototype.slice.call(n);var t=nn(n);delete t[Q];for(var r=Z(t),e=0;e<r.length;e++){var i=r[e],o=t[i];!1===o.writable&&(o.writable=!0,o.configurable=!0),(o.get||o.set)&&(t[i]={configurable:!0,writable:!0,enumerable:o.enumerable,value:n[i]});}return Object.create(Object.getPrototypeOf(n),t)}function d(n,e){return void 0===e&&(e=!1),y(n)||t(n)||!r(n)?n:(o(n)>1&&(n.set=n.add=n.clear=n.delete=h),Object.freeze(n),e&&i(n,(function(n,t){return d(t,!0)}),!0),n)}function h(){n(2);}function y(n){return null==n||"object"!=typeof n||Object.isFrozen(n)}function b(t){var r=tn[t];return r||n(18,t),r}function m(n,t){tn[n]||(tn[n]=t);}function _(){return "production"===process.env.NODE_ENV||U||n(0),U}function j(n,t){t&&(b("Patches"),n.u=[],n.s=[],n.v=t);}function g(n){O(n),n.p.forEach(S),n.p=null;}function O(n){n===U&&(U=n.l);}function w(n){return U={p:[],l:U,h:n,m:!0,_:0}}function S(n){var t=n[Q];0===t.i||1===t.i?t.j():t.g=!0;}function P(t,e){e._=e.p.length;var i=e.p[0],o=void 0!==t&&t!==i;return e.h.O||b("ES5").S(e,t,o),o?(i[Q].P&&(g(e),n(4)),r(t)&&(t=M(e,t),e.l||x(e,t)),e.u&&b("Patches").M(i[Q],t,e.u,e.s)):t=M(e,i,[]),g(e),e.u&&e.v(e.u,e.s),t!==H?t:void 0}function M(n,t,r){if(y(t))return t;var e=t[Q];if(!e)return i(t,(function(i,o){return A(n,e,t,i,o,r)}),!0),t;if(e.A!==n)return t;if(!e.P)return x(n,e.t,!0),e.t;if(!e.I){e.I=!0,e.A._--;var o=4===e.i||5===e.i?e.o=l(e.k):e.o;i(3===e.i?new Set(o):o,(function(t,i){return A(n,e,o,t,i,r)})),x(n,o,!1),r&&n.u&&b("Patches").R(e,r,n.u,n.s);}return e.o}function A(e,i,o,a,c,s){if("production"!==process.env.NODE_ENV&&c===o&&n(5),t(c)){var v=M(e,c,s&&i&&3!==i.i&&!u(i.D,a)?s.concat(a):void 0);if(f(o,a,v),!t(v))return;e.m=!1;}if(r(c)&&!y(c)){if(!e.h.N&&e._<1)return;M(e,c),i&&i.A.l||x(e,c);}}function x(n,t,r){void 0===r&&(r=!1),n.h.N&&n.m&&d(t,r);}function z(n,t){var r=n[Q];return (r?p(r):n)[t]}function I(n,t){if(t in n)for(var r=Object.getPrototypeOf(n);r;){var e=Object.getOwnPropertyDescriptor(r,t);if(e)return e;r=Object.getPrototypeOf(r);}}function E(n){n.P||(n.P=!0,n.l&&E(n.l));}function k(n){n.o||(n.o=l(n.t));}function R(n,t,r){var e=s(t)?b("MapSet").T(t,r):v(t)?b("MapSet").F(t,r):n.O?function(n,t){var r=Array.isArray(n),e={i:r?1:0,A:t?t.A:_(),P:!1,I:!1,D:{},l:t,t:n,k:null,o:null,j:null,C:!1},i=e,o=rn;r&&(i=[e],o=en);var u=Proxy.revocable(i,o),a=u.revoke,f=u.proxy;return e.k=f,e.j=a,f}(t,r):b("ES5").J(t,r);return (r?r.A:_()).p.push(e),e}function D(e){return t(e)||n(22,e),function n(t){if(!r(t))return t;var e,u=t[Q],c=o(t);if(u){if(!u.P&&(u.i<4||!b("ES5").K(u)))return u.t;u.I=!0,e=N(t,c),u.I=!1;}else e=N(t,c);return i(e,(function(t,r){u&&a(u.t,t)===r||f(e,t,n(r));})),3===c?new Set(e):e}(e)}function N(n,t){switch(t){case 2:return new Map(n);case 3:return Array.from(n)}return l(n)}function T(){function r(n,t){var r=s[n];return r?r.enumerable=t:s[n]=r={configurable:!0,enumerable:t,get:function(){var t=this[Q];return "production"!==process.env.NODE_ENV&&f(t),rn.get(t,n)},set:function(t){var r=this[Q];"production"!==process.env.NODE_ENV&&f(r),rn.set(r,n,t);}},r}function e(n){for(var t=n.length-1;t>=0;t--){var r=n[t][Q];if(!r.P)switch(r.i){case 5:a(r)&&E(r);break;case 4:o(r)&&E(r);}}}function o(n){for(var t=n.t,r=n.k,e=Z(r),i=e.length-1;i>=0;i--){var o=e[i];if(o!==Q){var a=t[o];if(void 0===a&&!u(t,o))return !0;var f=r[o],s=f&&f[Q];if(s?s.t!==a:!c(f,a))return !0}}var v=!!t[Q];return e.length!==Z(t).length+(v?0:1)}function a(n){var t=n.k;if(t.length!==n.t.length)return !0;var r=Object.getOwnPropertyDescriptor(t,t.length-1);return !(!r||r.get)}function f(t){t.g&&n(3,JSON.stringify(p(t)));}var s={};m("ES5",{J:function(n,t){var e=Array.isArray(n),i=function(n,t){if(n){for(var e=Array(t.length),i=0;i<t.length;i++)Object.defineProperty(e,""+i,r(i,!0));return e}var o=nn(t);delete o[Q];for(var u=Z(o),a=0;a<u.length;a++){var f=u[a];o[f]=r(f,n||!!o[f].enumerable);}return Object.create(Object.getPrototypeOf(t),o)}(e,n),o={i:e?5:4,A:t?t.A:_(),P:!1,I:!1,D:{},l:t,t:n,k:i,o:null,g:!1,C:!1};return Object.defineProperty(i,Q,{value:o,writable:!0}),i},S:function(n,r,o){o?t(r)&&r[Q].A===n&&e(n.p):(n.u&&function n(t){if(t&&"object"==typeof t){var r=t[Q];if(r){var e=r.t,o=r.k,f=r.D,c=r.i;if(4===c)i(o,(function(t){t!==Q&&(void 0!==e[t]||u(e,t)?f[t]||n(o[t]):(f[t]=!0,E(r)));})),i(e,(function(n){void 0!==o[n]||u(o,n)||(f[n]=!1,E(r));}));else if(5===c){if(a(r)&&(E(r),f.length=!0),o.length<e.length)for(var s=o.length;s<e.length;s++)f[s]=!1;else for(var v=e.length;v<o.length;v++)f[v]=!0;for(var p=Math.min(o.length,e.length),l=0;l<p;l++)void 0===f[l]&&n(o[l]);}}}}(n.p[0]),e(n.p));},K:function(n){return 4===n.i?o(n):a(n)}});}var G,U,W="undefined"!=typeof Symbol&&"symbol"==typeof Symbol("x"),X="undefined"!=typeof Map,q="undefined"!=typeof Set,B="undefined"!=typeof Proxy&&void 0!==Proxy.revocable&&"undefined"!=typeof Reflect,H=W?Symbol.for("immer-nothing"):((G={})["immer-nothing"]=!0,G),L=W?Symbol.for("immer-draftable"):"__$immer_draftable",Q=W?Symbol.for("immer-state"):"__$immer_state",Y={0:"Illegal state",1:"Immer drafts cannot have computed properties",2:"This object has been frozen and should not be mutated",3:function(n){return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? "+n},4:"An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",5:"Immer forbids circular references",6:"The first or second argument to `produce` must be a function",7:"The third argument to `produce` must be a function or undefined",8:"First argument to `createDraft` must be a plain object, an array, or an immerable object",9:"First argument to `finishDraft` must be a draft returned by `createDraft`",10:"The given draft is already finalized",11:"Object.defineProperty() cannot be used on an Immer draft",12:"Object.setPrototypeOf() cannot be used on an Immer draft",13:"Immer only supports deleting array indices",14:"Immer only supports setting array indices and the 'length' property",15:function(n){return "Cannot apply patch, path doesn't resolve: "+n},16:'Sets cannot have "replace" patches.',17:function(n){return "Unsupported patch operation: "+n},18:function(n){return "The plugin for '"+n+"' has not been loaded into Immer. To enable the plugin, import and call `enable"+n+"()` when initializing your application."},20:"Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",21:function(n){return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '"+n+"'"},22:function(n){return "'current' expects a draft, got: "+n},23:function(n){return "'original' expects a draft, got: "+n}},Z="undefined"!=typeof Reflect&&Reflect.ownKeys?Reflect.ownKeys:void 0!==Object.getOwnPropertySymbols?function(n){return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n))}:Object.getOwnPropertyNames,nn=Object.getOwnPropertyDescriptors||function(n){var t={};return Z(n).forEach((function(r){t[r]=Object.getOwnPropertyDescriptor(n,r);})),t},tn={},rn={get:function(n,t){if(t===Q)return n;var e=p(n);if(!u(e,t))return function(n,t,r){var e,i=I(t,r);return i?"value"in i?i.value:null===(e=i.get)||void 0===e?void 0:e.call(n.k):void 0}(n,e,t);var i=e[t];return n.I||!r(i)?i:i===z(n.t,t)?(k(n),n.o[t]=R(n.A.h,i,n)):i},has:function(n,t){return t in p(n)},ownKeys:function(n){return Reflect.ownKeys(p(n))},set:function(n,t,r){var e=I(p(n),t);if(null==e?void 0:e.set)return e.set.call(n.k,r),!0;if(!n.P){var i=z(p(n),t),o=null==i?void 0:i[Q];if(o&&o.t===r)return n.o[t]=r,n.D[t]=!1,!0;if(c(r,i)&&(void 0!==r||u(n.t,t)))return !0;k(n),E(n);}return n.o[t]=r,n.D[t]=!0,!0},deleteProperty:function(n,t){return void 0!==z(n.t,t)||t in n.t?(n.D[t]=!1,k(n),E(n)):delete n.D[t],n.o&&delete n.o[t],!0},getOwnPropertyDescriptor:function(n,t){var r=p(n),e=Reflect.getOwnPropertyDescriptor(r,t);return e?{writable:!0,configurable:1!==n.i||"length"!==t,enumerable:e.enumerable,value:r[t]}:e},defineProperty:function(){n(11);},getPrototypeOf:function(n){return Object.getPrototypeOf(n.t)},setPrototypeOf:function(){n(12);}},en={};i(rn,(function(n,t){en[n]=function(){return arguments[0]=arguments[0][0],t.apply(this,arguments)};})),en.deleteProperty=function(t,r){return "production"!==process.env.NODE_ENV&&isNaN(parseInt(r))&&n(13),rn.deleteProperty.call(this,t[0],r)},en.set=function(t,r,e){return "production"!==process.env.NODE_ENV&&"length"!==r&&isNaN(parseInt(r))&&n(14),rn.set.call(this,t[0],r,e,t[0])};var on=function(){function e(n){this.O=B,this.N=!0,"boolean"==typeof(null==n?void 0:n.useProxies)&&this.setUseProxies(n.useProxies),"boolean"==typeof(null==n?void 0:n.autoFreeze)&&this.setAutoFreeze(n.autoFreeze),this.produce=this.produce.bind(this),this.produceWithPatches=this.produceWithPatches.bind(this);}var i=e.prototype;return i.produce=function(t,e,i){if("function"==typeof t&&"function"!=typeof e){var o=e;e=t;var u=this;return function(n){var t=this;void 0===n&&(n=o);for(var r=arguments.length,i=Array(r>1?r-1:0),a=1;a<r;a++)i[a-1]=arguments[a];return u.produce(n,(function(n){var r;return (r=e).call.apply(r,[t,n].concat(i))}))}}var a;if("function"!=typeof e&&n(6),void 0!==i&&"function"!=typeof i&&n(7),r(t)){var f=w(this),c=R(this,t,void 0),s=!0;try{a=e(c),s=!1;}finally{s?g(f):O(f);}return "undefined"!=typeof es6Promise.Promise&&a instanceof es6Promise.Promise?a.then((function(n){return j(f,i),P(n,f)}),(function(n){throw g(f),n})):(j(f,i),P(a,f))}if(!t||"object"!=typeof t){if((a=e(t))===H)return;return void 0===a&&(a=t),this.N&&d(a,!0),a}n(21,t);},i.produceWithPatches=function(n,t){var r,e,i=this;return "function"==typeof n?function(t){for(var r=arguments.length,e=Array(r>1?r-1:0),o=1;o<r;o++)e[o-1]=arguments[o];return i.produceWithPatches(t,(function(t){return n.apply(void 0,[t].concat(e))}))}:[this.produce(n,t,(function(n,t){r=n,e=t;})),r,e]},i.createDraft=function(e){r(e)||n(8),t(e)&&(e=D(e));var i=w(this),o=R(this,e,void 0);return o[Q].C=!0,O(i),o},i.finishDraft=function(t,r){var e=t&&t[Q];"production"!==process.env.NODE_ENV&&(e&&e.C||n(9),e.I&&n(10));var i=e.A;return j(i,r),P(void 0,i)},i.setAutoFreeze=function(n){this.N=n;},i.setUseProxies=function(t){t&&!B&&n(20),this.O=t;},i.applyPatches=function(n,r){var e;for(e=r.length-1;e>=0;e--){var i=r[e];if(0===i.path.length&&"replace"===i.op){n=i.value;break}}var o=b("Patches").$;return t(n)?o(n,r):this.produce(n,(function(n){return o(n,r.slice(e+1))}))},e}(),un=new on,an=un.produce,fn=un.produceWithPatches.bind(un),cn=un.setAutoFreeze.bind(un),sn=un.setUseProxies.bind(un),vn=un.applyPatches.bind(un),pn=un.createDraft.bind(un),ln=un.finishDraft.bind(un);

function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
}

/* global window */

var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (typeof module !== 'undefined') {
  root = module;
} else {
  root = Function('return this')();
}

var result = symbolObservablePonyfill(root);

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function.');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[result] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[result] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && "action \"" + String(actionType) + "\"" || 'an action';
  return "Given " + actionDescription + ", reducer \"" + key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle " + ActionTypes.INIT + " or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (process.env.NODE_ENV !== 'production') {
      if (typeof reducers[key] === 'undefined') {
        warning("No reducer provided for key \"" + key + "\"");
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (process.env.NODE_ENV !== 'production') {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (process.env.NODE_ENV !== 'production') {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);

      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread2$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$1(source, true).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread2$1({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (process.env.NODE_ENV !== 'production' && typeof isCrushed.name === 'string' && isCrushed.name !== 'isCrushed') {
  warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
}

function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = memoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.dependencies = dependencies;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = createSelectorCreator(defaultMemoize);

function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

/**
 * @public
 */

var composeWithDevTools = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function () {
  if (arguments.length === 0) return undefined;
  if (typeof arguments[0] === 'object') return compose;
  return compose.apply(null, arguments);
};

/**
 * Returns true if the passed value is "plain" object, i.e. an object whose
 * protoype is the root `Object.prototype`. This includes objects created
 * using object literals, but not for instance for class instances.
 *
 * @param {any} value The value to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 *
 * @public
 */
function isPlainObject$1(value) {
  if (typeof value !== 'object' || value === null) return false;
  var proto = value;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(value) === proto;
}

function getTimeMeasureUtils(maxDelay, fnName) {
  var elapsed = 0;
  return {
    measureTime: function measureTime(fn) {
      var started = Date.now();

      try {
        return fn();
      } finally {
        var finished = Date.now();
        elapsed += finished - started;
      }
    },
    warnIfExceeded: function warnIfExceeded() {
      if (elapsed > maxDelay) {
        console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
      }
    }
  };
}
/**
 * @public
 */

var MiddlewareArray =
/*#__PURE__*/
function (_Array) {
  _inheritsLoose(MiddlewareArray, _Array);

  function MiddlewareArray() {
    return _Array.apply(this, arguments) || this;
  }

  var _proto = MiddlewareArray.prototype;

  _proto.concat = function concat() {
    var _Array$prototype$conc;

    for (var _len = arguments.length, arr = new Array(_len), _key = 0; _key < _len; _key++) {
      arr[_key] = arguments[_key];
    }

    return _construct(MiddlewareArray, (_Array$prototype$conc = _Array.prototype.concat).call.apply(_Array$prototype$conc, [this].concat(arr)));
  };

  _proto.prepend = function prepend() {
    for (var _len2 = arguments.length, arr = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      arr[_key2] = arguments[_key2];
    }

    if (arr.length === 1 && Array.isArray(arr[0])) {
      return _construct(MiddlewareArray, arr[0].concat(this));
    }

    return _construct(MiddlewareArray, arr.concat(this));
  };

  return MiddlewareArray;
}(
/*#__PURE__*/
_wrapNativeSuper(Array));

var isProduction = process.env.NODE_ENV === 'production';
var prefix = 'Invariant failed'; // Throw an error if the condition fails
// Strip out error messages for production
// > Not providing an inline default argument for message as the result is smaller

function invariant(condition, message) {
  if (condition) {
    return;
  } // Condition not passed
  // In production we strip the message but still throw


  if (isProduction) {
    throw new Error(prefix);
  } // When not in production we allow the message to pass through
  // *This block will be removed in production builds*


  throw new Error(prefix + ": " + (message || ''));
}

function stringify(obj, serializer, indent, decycler) {
  return JSON.stringify(obj, getSerialize(serializer, decycler), indent);
}

function getSerialize(serializer, decycler) {
  var stack = [],
      keys = [];
  if (!decycler) decycler = function decycler(_, value) {
    if (stack[0] === value) return '[Circular ~]';
    return '[Circular ~.' + keys.slice(0, stack.indexOf(value)).join('.') + ']';
  };
  return function (key, value) {
    if (stack.length > 0) {
      var thisPos = stack.indexOf(this);
      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
      if (~stack.indexOf(value)) value = decycler.call(this, key, value);
    } else stack.push(value);

    return serializer == null ? value : serializer.call(this, key, value);
  };
}
/**
 * The default `isImmutable` function.
 *
 * @public
 */


function isImmutableDefault(value) {
  return typeof value !== 'object' || value === null || typeof value === 'undefined';
}
function trackForMutations(isImmutable, ignorePaths, obj) {
  var trackedProperties = trackProperties(isImmutable, ignorePaths, obj);
  return {
    detectMutations: function detectMutations() {
      return _detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
    }
  };
}

function trackProperties(isImmutable, ignorePaths, obj, path) {
  if (ignorePaths === void 0) {
    ignorePaths = [];
  }

  if (path === void 0) {
    path = [];
  }

  var tracked = {
    value: obj
  };

  if (!isImmutable(obj)) {
    tracked.children = {};

    for (var key in obj) {
      var childPath = path.concat(key);

      if (ignorePaths.length && ignorePaths.indexOf(childPath.join('.')) !== -1) {
        continue;
      }

      tracked.children[key] = trackProperties(isImmutable, ignorePaths, obj[key], childPath);
    }
  }

  return tracked;
}

function _detectMutations(isImmutable, ignorePaths, trackedProperty, obj, sameParentRef, path) {
  if (ignorePaths === void 0) {
    ignorePaths = [];
  }

  if (sameParentRef === void 0) {
    sameParentRef = false;
  }

  if (path === void 0) {
    path = [];
  }

  var prevObj = trackedProperty ? trackedProperty.value : undefined;
  var sameRef = prevObj === obj;

  if (sameParentRef && !sameRef && !Number.isNaN(obj)) {
    return {
      wasMutated: true,
      path: path
    };
  }

  if (isImmutable(prevObj) || isImmutable(obj)) {
    return {
      wasMutated: false
    };
  } // Gather all keys from prev (tracked) and after objs


  var keysToDetect = {};
  Object.keys(trackedProperty.children).forEach(function (key) {
    keysToDetect[key] = true;
  });
  Object.keys(obj).forEach(function (key) {
    keysToDetect[key] = true;
  });
  var keys = Object.keys(keysToDetect);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var childPath = path.concat(key);

    if (ignorePaths.length && ignorePaths.indexOf(childPath.join('.')) !== -1) {
      continue;
    }

    var result = _detectMutations(isImmutable, ignorePaths, trackedProperty.children[key], obj[key], sameRef, childPath);

    if (result.wasMutated) {
      return result;
    }
  }

  return {
    wasMutated: false
  };
}
/**
 * Creates a middleware that checks whether any state was mutated in between
 * dispatches or during a dispatch. If any mutations are detected, an error is
 * thrown.
 *
 * @param options Middleware options.
 *
 * @public
 */


function createImmutableStateInvariantMiddleware(options) {
  if (options === void 0) {
    options = {};
  }

  if (process.env.NODE_ENV === 'production') {
    return function () {
      return function (next) {
        return function (action) {
          return next(action);
        };
      };
    };
  }

  var _options = options,
      _options$isImmutable = _options.isImmutable,
      isImmutable = _options$isImmutable === void 0 ? isImmutableDefault : _options$isImmutable,
      ignoredPaths = _options.ignoredPaths,
      _options$warnAfter = _options.warnAfter,
      warnAfter = _options$warnAfter === void 0 ? 32 : _options$warnAfter,
      ignore = _options.ignore; // Alias ignore->ignoredPaths, but prefer ignoredPaths if present

  ignoredPaths = ignoredPaths || ignore;
  var track = trackForMutations.bind(null, isImmutable, ignoredPaths);
  return function (_ref) {
    var getState = _ref.getState;
    var state = getState();
    var tracker = track(state);
    var result;
    return function (next) {
      return function (action) {
        var measureUtils = getTimeMeasureUtils(warnAfter, 'ImmutableStateInvariantMiddleware');
        measureUtils.measureTime(function () {
          state = getState();
          result = tracker.detectMutations(); // Track before potentially not meeting the invariant

          tracker = track(state);
          !!result.wasMutated ? process.env.NODE_ENV !== "production" ? invariant(false, "A state mutation was detected between dispatches, in the path '" + (result.path || []).join('.') + "'.  This may cause incorrect behavior. (https://redux.js.org/troubleshooting#never-mutate-reducer-arguments)") : invariant(false) : void 0;
        });
        var dispatchedAction = next(action);
        measureUtils.measureTime(function () {
          state = getState();
          result = tracker.detectMutations(); // Track before potentially not meeting the invariant

          tracker = track(state);
          result.wasMutated && (!!result.wasMutated ? process.env.NODE_ENV !== "production" ? invariant(false, "A state mutation was detected inside a dispatch, in the path: " + (result.path || []).join('.') + ". Take a look at the reducer(s) handling the action " + stringify(action) + ". (https://redux.js.org/troubleshooting#never-mutate-reducer-arguments)") : invariant(false) : void 0);
        });
        measureUtils.warnIfExceeded();
        return dispatchedAction;
      };
    };
  };
}

/**
 * Returns true if the passed value is "plain", i.e. a value that is either
 * directly JSON-serializable (boolean, number, string, array, plain object)
 * or `undefined`.
 *
 * @param val The value to check.
 *
 * @public
 */

function isPlain(val) {
  return typeof val === 'undefined' || val === null || typeof val === 'string' || typeof val === 'boolean' || typeof val === 'number' || Array.isArray(val) || isPlainObject$1(val);
}
/**
 * @public
 */

function findNonSerializableValue(value, path, isSerializable, getEntries, ignoredPaths) {
  if (path === void 0) {
    path = [];
  }

  if (isSerializable === void 0) {
    isSerializable = isPlain;
  }

  if (ignoredPaths === void 0) {
    ignoredPaths = [];
  }

  var foundNestedSerializable;

  if (!isSerializable(value)) {
    return {
      keyPath: path.join('.') || '<root>',
      value: value
    };
  }

  if (typeof value !== 'object' || value === null) {
    return false;
  }

  var entries = getEntries != null ? getEntries(value) : Object.entries(value);
  var hasIgnoredPaths = ignoredPaths.length > 0;

  for (var _iterator = entries, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var _ref2 = _ref,
        property = _ref2[0],
        nestedValue = _ref2[1];
    var nestedPath = path.concat(property);

    if (hasIgnoredPaths && ignoredPaths.indexOf(nestedPath.join('.')) >= 0) {
      continue;
    }

    if (!isSerializable(nestedValue)) {
      return {
        keyPath: nestedPath.join('.'),
        value: nestedValue
      };
    }

    if (typeof nestedValue === 'object') {
      foundNestedSerializable = findNonSerializableValue(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths);

      if (foundNestedSerializable) {
        return foundNestedSerializable;
      }
    }
  }

  return false;
}
/**
 * Creates a middleware that, after every state change, checks if the new
 * state is serializable. If a non-serializable value is found within the
 * state, an error is printed to the console.
 *
 * @param options Middleware options.
 *
 * @public
 */

function createSerializableStateInvariantMiddleware(options) {
  if (options === void 0) {
    options = {};
  }

  if (process.env.NODE_ENV === 'production') {
    return function () {
      return function (next) {
        return function (action) {
          return next(action);
        };
      };
    };
  }

  var _options = options,
      _options$isSerializab = _options.isSerializable,
      isSerializable = _options$isSerializab === void 0 ? isPlain : _options$isSerializab,
      getEntries = _options.getEntries,
      _options$ignoredActio = _options.ignoredActions,
      ignoredActions = _options$ignoredActio === void 0 ? [] : _options$ignoredActio,
      _options$ignoredActio2 = _options.ignoredActionPaths,
      ignoredActionPaths = _options$ignoredActio2 === void 0 ? ['meta.arg'] : _options$ignoredActio2,
      _options$ignoredPaths = _options.ignoredPaths,
      ignoredPaths = _options$ignoredPaths === void 0 ? [] : _options$ignoredPaths,
      _options$warnAfter = _options.warnAfter,
      warnAfter = _options$warnAfter === void 0 ? 32 : _options$warnAfter;
  return function (storeAPI) {
    return function (next) {
      return function (action) {
        if (ignoredActions.length && ignoredActions.indexOf(action.type) !== -1) {
          return next(action);
        }

        var measureUtils = getTimeMeasureUtils(warnAfter, 'SerializableStateInvariantMiddleware');
        measureUtils.measureTime(function () {
          var foundActionNonSerializableValue = findNonSerializableValue(action, [], isSerializable, getEntries, ignoredActionPaths);

          if (foundActionNonSerializableValue) {
            var keyPath = foundActionNonSerializableValue.keyPath,
                value = foundActionNonSerializableValue.value;
            console.error("A non-serializable value was detected in an action, in the path: `" + keyPath + "`. Value:", value, '\nTake a look at the logic that dispatched this action: ', action, '\n(See https://redux.js.org/faq/actions#why-should-type-be-a-string-or-at-least-serializable-why-should-my-action-types-be-constants)', '\n(To allow non-serializable values see: https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data)');
          }
        });
        var result = next(action);
        measureUtils.measureTime(function () {
          var state = storeAPI.getState();
          var foundStateNonSerializableValue = findNonSerializableValue(state, [], isSerializable, getEntries, ignoredPaths);

          if (foundStateNonSerializableValue) {
            var keyPath = foundStateNonSerializableValue.keyPath,
                value = foundStateNonSerializableValue.value;
            console.error("A non-serializable value was detected in the state, in the path: `" + keyPath + "`. Value:", value, "\nTake a look at the reducer(s) handling this action type: " + action.type + ".\n(See https://redux.js.org/faq/organizing-state#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state)");
          }
        });
        measureUtils.warnIfExceeded();
        return result;
      };
    };
  };
}

function isBoolean(x) {
  return typeof x === 'boolean';
}

function curryGetDefaultMiddleware() {
  return function curriedGetDefaultMiddleware(options) {
    return getDefaultMiddleware(options);
  };
}
/**
 * Returns any array containing the default middleware installed by
 * `configureStore()`. Useful if you want to configure your store with a custom
 * `middleware` array but still keep the default set.
 *
 * @return The default middleware used by `configureStore()`.
 *
 * @public
 */

function getDefaultMiddleware(options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$thunk = _options.thunk,
      thunk$1 = _options$thunk === void 0 ? true : _options$thunk,
      _options$immutableChe = _options.immutableCheck,
      immutableCheck = _options$immutableChe === void 0 ? true : _options$immutableChe,
      _options$serializable = _options.serializableCheck,
      serializableCheck = _options$serializable === void 0 ? true : _options$serializable;
  var middlewareArray = new MiddlewareArray();

  if (thunk$1) {
    if (isBoolean(thunk$1)) {
      middlewareArray.push(thunk);
    } else {
      middlewareArray.push(thunk.withExtraArgument(thunk$1.extraArgument));
    }
  }

  if (process.env.NODE_ENV !== 'production') {
    if (immutableCheck) {
      /* PROD_START_REMOVE_UMD */
      var immutableOptions = {};

      if (!isBoolean(immutableCheck)) {
        immutableOptions = immutableCheck;
      }

      middlewareArray.unshift(createImmutableStateInvariantMiddleware(immutableOptions));
      /* PROD_STOP_REMOVE_UMD */
    }

    if (serializableCheck) {
      var serializableOptions = {};

      if (!isBoolean(serializableCheck)) {
        serializableOptions = serializableCheck;
      }

      middlewareArray.push(createSerializableStateInvariantMiddleware(serializableOptions));
    }
  }

  return middlewareArray;
}

var IS_PRODUCTION = process.env.NODE_ENV === 'production';
/**
 * A friendly abstraction over the standard Redux `createStore()` function.
 *
 * @param config The store configuration.
 * @returns A configured Redux store.
 *
 * @public
 */

function configureStore(options) {
  var curriedGetDefaultMiddleware = curryGetDefaultMiddleware();

  var _ref = options || {},
      _ref$reducer = _ref.reducer,
      reducer = _ref$reducer === void 0 ? undefined : _ref$reducer,
      _ref$middleware = _ref.middleware,
      middleware = _ref$middleware === void 0 ? curriedGetDefaultMiddleware() : _ref$middleware,
      _ref$devTools = _ref.devTools,
      devTools = _ref$devTools === void 0 ? true : _ref$devTools,
      _ref$preloadedState = _ref.preloadedState,
      preloadedState = _ref$preloadedState === void 0 ? undefined : _ref$preloadedState,
      _ref$enhancers = _ref.enhancers,
      enhancers = _ref$enhancers === void 0 ? undefined : _ref$enhancers;

  var rootReducer;

  if (typeof reducer === 'function') {
    rootReducer = reducer;
  } else if (isPlainObject$1(reducer)) {
    rootReducer = combineReducers(reducer);
  } else {
    throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
  }

  var middlewareEnhancer = applyMiddleware.apply(void 0, typeof middleware === 'function' ? middleware(curriedGetDefaultMiddleware) : middleware);
  var finalCompose = compose;

  if (devTools) {
    finalCompose = composeWithDevTools(_extends({
      // Enable capture of stack traces for dispatched Redux actions
      trace: !IS_PRODUCTION
    }, typeof devTools === 'object' && devTools));
  }

  var storeEnhancers = [middlewareEnhancer];

  if (Array.isArray(enhancers)) {
    storeEnhancers = [middlewareEnhancer].concat(enhancers);
  } else if (typeof enhancers === 'function') {
    storeEnhancers = enhancers(storeEnhancers);
  }

  var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
  return createStore(rootReducer, preloadedState, composedEnhancer);
}

function createAction(type, prepareAction) {
  function actionCreator() {
    if (prepareAction) {
      var prepared = prepareAction.apply(void 0, arguments);

      if (!prepared) {
        throw new Error('prepareAction did not return an object');
      }

      return _extends({
        type: type,
        payload: prepared.payload
      }, 'meta' in prepared && {
        meta: prepared.meta
      }, {}, 'error' in prepared && {
        error: prepared.error
      });
    }

    return {
      type: type,
      payload: arguments.length <= 0 ? undefined : arguments[0]
    };
  }

  actionCreator.toString = function () {
    return "" + type;
  };

  actionCreator.type = type;

  actionCreator.match = function (action) {
    return action.type === type;
  };

  return actionCreator;
}

function executeReducerBuilderCallback(builderCallback) {
  var actionsMap = {};
  var actionMatchers = [];
  var defaultCaseReducer;
  var builder = {
    addCase: function addCase(typeOrActionCreator, reducer) {
      if (process.env.NODE_ENV !== 'production') {
        /*
         to keep the definition by the user in line with actual behavior,
         we enforce `addCase` to always be called before calling `addMatcher`
         as matching cases take precedence over matchers
         */
        if (actionMatchers.length > 0) {
          throw new Error('`builder.addCase` should only be called before calling `builder.addMatcher`');
        }

        if (defaultCaseReducer) {
          throw new Error('`builder.addCase` should only be called before calling `builder.addDefaultCase`');
        }
      }

      var type = typeof typeOrActionCreator === 'string' ? typeOrActionCreator : typeOrActionCreator.type;

      if (type in actionsMap) {
        throw new Error('addCase cannot be called with two reducers for the same action type');
      }

      actionsMap[type] = reducer;
      return builder;
    },
    addMatcher: function addMatcher(matcher, reducer) {
      if (process.env.NODE_ENV !== 'production') {
        if (defaultCaseReducer) {
          throw new Error('`builder.addMatcher` should only be called before calling `builder.addDefaultCase`');
        }
      }

      actionMatchers.push({
        matcher: matcher,
        reducer: reducer
      });
      return builder;
    },
    addDefaultCase: function addDefaultCase(reducer) {
      if (process.env.NODE_ENV !== 'production') {
        if (defaultCaseReducer) {
          throw new Error('`builder.addDefaultCase` can only be called once');
        }
      }

      defaultCaseReducer = reducer;
      return builder;
    }
  };
  builderCallback(builder);
  return [actionsMap, actionMatchers, defaultCaseReducer];
}

function createReducer(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
  if (actionMatchers === void 0) {
    actionMatchers = [];
  }

  var _ref = typeof mapOrBuilderCallback === 'function' ? executeReducerBuilderCallback(mapOrBuilderCallback) : [mapOrBuilderCallback, actionMatchers, defaultCaseReducer],
      actionsMap = _ref[0],
      finalActionMatchers = _ref[1],
      finalDefaultCaseReducer = _ref[2];

  return function (state, action) {
    if (state === void 0) {
      state = initialState;
    }

    var caseReducers = [actionsMap[action.type]].concat(finalActionMatchers.filter(function (_ref2) {
      var matcher = _ref2.matcher;
      return matcher(action);
    }).map(function (_ref3) {
      var reducer = _ref3.reducer;
      return reducer;
    }));

    if (caseReducers.filter(function (cr) {
      return !!cr;
    }).length === 0) {
      caseReducers = [finalDefaultCaseReducer];
    }

    return caseReducers.reduce(function (previousState, caseReducer) {
      if (caseReducer) {
        if (t(previousState)) {
          // If it's already a draft, we must already be inside a `createNextState` call,
          // likely because this is being wrapped in `createReducer`, `createSlice`, or nested
          // inside an existing draft. It's safe to just pass the draft to the mutator.
          var draft = previousState; // We can assume this is already a draft

          var result = caseReducer(draft, action);

          if (typeof result === 'undefined') {
            return previousState;
          }

          return result;
        } else if (!r(previousState)) {
          // If state is not draftable (ex: a primitive, such as 0), we want to directly
          // return the caseReducer func and not wrap it with produce.
          var _result = caseReducer(previousState, action);

          if (typeof _result === 'undefined') {
            if (previousState === null) {
              return previousState;
            }

            throw Error('A case reducer on a non-draftable value must not return undefined');
          }

          return _result;
        } else {
          // @ts-ignore createNextState() produces an Immutable<Draft<S>> rather
          // than an Immutable<S>, and TypeScript cannot find out how to reconcile
          // these two types.
          return an(previousState, function (draft) {
            return caseReducer(draft, action);
          });
        }
      }

      return previousState;
    }, state);
  };
}

function getType$1(slice, actionKey) {
  return slice + "/" + actionKey;
}
/**
 * A function that accepts an initial state, an object full of reducer
 * functions, and a "slice name", and automatically generates
 * action creators and action types that correspond to the
 * reducers and state.
 *
 * The `reducer` argument is passed to `createReducer()`.
 *
 * @public
 */


function createSlice(options) {
  var name = options.name,
      initialState = options.initialState;

  if (!name) {
    throw new Error('`name` is a required option for createSlice');
  }

  var reducers = options.reducers || {};

  var _ref = typeof options.extraReducers === 'undefined' ? [] : typeof options.extraReducers === 'function' ? executeReducerBuilderCallback(options.extraReducers) : [options.extraReducers],
      _ref$ = _ref[0],
      extraReducers = _ref$ === void 0 ? {} : _ref$,
      _ref$2 = _ref[1],
      actionMatchers = _ref$2 === void 0 ? [] : _ref$2,
      _ref$3 = _ref[2],
      defaultCaseReducer = _ref$3 === void 0 ? undefined : _ref$3;

  var reducerNames = Object.keys(reducers);
  var sliceCaseReducersByName = {};
  var sliceCaseReducersByType = {};
  var actionCreators = {};
  reducerNames.forEach(function (reducerName) {
    var maybeReducerWithPrepare = reducers[reducerName];
    var type = getType$1(name, reducerName);
    var caseReducer;
    var prepareCallback;

    if ('reducer' in maybeReducerWithPrepare) {
      caseReducer = maybeReducerWithPrepare.reducer;
      prepareCallback = maybeReducerWithPrepare.prepare;
    } else {
      caseReducer = maybeReducerWithPrepare;
    }

    sliceCaseReducersByName[reducerName] = caseReducer;
    sliceCaseReducersByType[type] = caseReducer;
    actionCreators[reducerName] = prepareCallback ? createAction(type, prepareCallback) : createAction(type);
  });

  var finalCaseReducers = _extends({}, extraReducers, {}, sliceCaseReducersByType);

  var reducer = createReducer(initialState, finalCaseReducers, actionMatchers, defaultCaseReducer);
  return {
    name: name,
    reducer: reducer,
    actions: actionCreators,
    caseReducers: sliceCaseReducersByName
  };
}

// A type of promise-like that resolves synchronously and supports only one observer

const _iteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator"))) : "@@iterator";

const _asyncIteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator"))) : "@@asyncIterator";

// Asynchronously call a function and send errors to recovery continuation
function _catch(body, recover) {
	try {
		var result = body();
	} catch(e) {
		return recover(e);
	}
	if (result && result.then) {
		return result.then(void 0, recover);
	}
	return result;
}

// Borrowed from https://github.com/ai/nanoid/blob/3.0.2/non-secure/index.js
// This alphabet uses `A-Za-z0-9_-` symbols. A genetic algorithm helped
// optimize the gzip compression for this alphabet.
var urlAlphabet = 'ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW';
/**
 *
 * @public
 */

var nanoid = function nanoid(size) {
  if (size === void 0) {
    size = 21;
  }

  var id = ''; // A compact alternative for `for (var i = 0; i < step; i++)`.

  var i = size;

  while (i--) {
    // `| 0` is more compact and faster than `Math.floor()`.
    id += urlAlphabet[Math.random() * 64 | 0];
  }

  return id;
};

var commonProperties = ['name', 'message', 'stack', 'code'];

var RejectWithValue = function RejectWithValue(payload) {
  this.payload = payload;
  this.name = 'RejectWithValue';
  this.message = 'Rejected';
}; // Reworked from https://github.com/sindresorhus/serialize-error


var miniSerializeError = function miniSerializeError(value) {
  if (typeof value === 'object' && value !== null) {
    var simpleError = {};

    for (var _iterator = commonProperties, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var property = _ref;

      if (typeof value[property] === 'string') {
        simpleError[property] = value[property];
      }
    }

    return simpleError;
  }

  return {
    message: String(value)
  };
};
/**
 *
 * @param typePrefix
 * @param payloadCreator
 * @param options
 *
 * @public
 */

function createAsyncThunk(typePrefix, payloadCreator, options) {
  var fulfilled = createAction(typePrefix + '/fulfilled', function (result, requestId, arg) {
    return {
      payload: result,
      meta: {
        arg: arg,
        requestId: requestId,
        requestStatus: 'fulfilled'
      }
    };
  });
  var pending = createAction(typePrefix + '/pending', function (requestId, arg) {
    return {
      payload: undefined,
      meta: {
        arg: arg,
        requestId: requestId,
        requestStatus: 'pending'
      }
    };
  });
  var rejected = createAction(typePrefix + '/rejected', function (error, requestId, arg) {
    var rejectedWithValue = error instanceof RejectWithValue;
    var aborted = !!error && error.name === 'AbortError';
    var condition = !!error && error.name === 'ConditionError';
    return {
      payload: error instanceof RejectWithValue ? error.payload : undefined,
      error: (options && options.serializeError || miniSerializeError)(error || 'Rejected'),
      meta: {
        arg: arg,
        requestId: requestId,
        rejectedWithValue: rejectedWithValue,
        requestStatus: 'rejected',
        aborted: aborted,
        condition: condition
      }
    };
  });
  var displayedWarning = false;
  var AC = typeof AbortController !== 'undefined' ? AbortController :
  /*#__PURE__*/
  function () {
    function _class() {
      this.signal = {
        aborted: false,
        addEventListener: function addEventListener() {},
        dispatchEvent: function dispatchEvent() {
          return false;
        },
        onabort: function onabort() {},
        removeEventListener: function removeEventListener() {}
      };
    }

    var _proto = _class.prototype;

    _proto.abort = function abort() {
      if (process.env.NODE_ENV !== 'production') {
        if (!displayedWarning) {
          displayedWarning = true;
          console.info("This platform does not implement AbortController. \nIf you want to use the AbortController to react to `abort` events, please consider importing a polyfill like 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only'.");
        }
      }
    };

    return _class;
  }();

  function actionCreator(arg) {
    return function (dispatch, getState, extra) {
      var requestId = nanoid();
      var abortController = new AC();
      var abortReason;
      var abortedPromise = new es6Promise.Promise(function (_, reject) {
        return abortController.signal.addEventListener('abort', function () {
          return reject({
            name: 'AbortError',
            message: abortReason || 'Aborted'
          });
        });
      });
      var started = false;

      function abort(reason) {
        if (started) {
          abortReason = reason;
          abortController.abort();
        }
      }

      var promise = function () {
        try {
          var _temp3 = function _temp3(_result) {
            if (_exit2) return _result;
            // We dispatch the result action _after_ the catch, to avoid having any errors
            // here get swallowed by the try/catch block,
            // per https://twitter.com/dan_abramov/status/770914221638942720
            // and https://redux-toolkit.js.org/tutorials/advanced-tutorial#async-error-handling-logic-in-thunks
            var skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;

            if (!skipDispatch) {
              dispatch(finalAction);
            }

            return finalAction;
          };

          var _exit2 = false;
          var finalAction;

          var _temp4 = _catch(function () {
            if (options && options.condition && options.condition(arg, {
              getState: getState,
              extra: extra
            }) === false) {
              // eslint-disable-next-line no-throw-literal
              throw {
                name: 'ConditionError',
                message: 'Aborted due to condition callback returning false.'
              };
            }

            started = true;
            dispatch(pending(requestId, arg));
            return es6Promise.Promise.resolve(es6Promise.Promise.race([abortedPromise, es6Promise.Promise.resolve(payloadCreator(arg, {
              dispatch: dispatch,
              getState: getState,
              extra: extra,
              requestId: requestId,
              signal: abortController.signal,
              rejectWithValue: function rejectWithValue(value) {
                return new RejectWithValue(value);
              }
            })).then(function (result) {
              if (result instanceof RejectWithValue) {
                return rejected(result, requestId, arg);
              }

              return fulfilled(result, requestId, arg);
            })])).then(function (_Promise$race) {
              finalAction = _Promise$race;
            });
          }, function (err) {
            finalAction = rejected(err, requestId, arg);
          });

          return es6Promise.Promise.resolve(_temp4 && _temp4.then ? _temp4.then(_temp3) : _temp3(_temp4));
        } catch (e) {
          return es6Promise.Promise.reject(e);
        }
      }();

      return Object.assign(promise, {
        abort: abort,
        requestId: requestId,
        arg: arg
      });
    };
  }

  return Object.assign(actionCreator, {
    pending: pending,
    rejected: rejected,
    fulfilled: fulfilled,
    typePrefix: typePrefix
  });
}

// we assume RTK will be used with React Native and other Proxy-less
// environments.  In addition, that's how Immer 4 behaved, and since
// we want to ship this in an RTK minor, we should keep the same behavior.

T();

const rnds8Pool = new Uint8Array(256); // # of random values to pre-allocate

let poolPtr = rnds8Pool.length;
function rng() {
  if (poolPtr > rnds8Pool.length - 16) {
    crypto__default['default'].randomFillSync(rnds8Pool);
    poolPtr = 0;
  }

  return rnds8Pool.slice(poolPtr, poolPtr += 16);
}

var REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

function validate(uuid) {
  return typeof uuid === 'string' && REGEX.test(uuid);
}

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}

function stringify$1(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  const uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

function v4(options, buf, offset) {
  options = options || {};
  const rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return stringify$1(rnds);
}

var _upsertQuery;
var __baseUrl__ = "".concat(process.env.REACT_APP_BASE_URL_PROTOCAL, "://").concat(process.env.REACT_APP_BASE_URL_HOST, ":").concat(process.env.REACT_APP_BASE_URL_PORT, "/api");
var __options = function __options() {
  var _localStorage;

  var otherHeader = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    method: "POST",
    headers: _objectSpread2({
      "Content-Type": "application/json",
      "Authorization": (_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.getItem('auth_token'),
      "db-name": process.env.REACT_APP_DB
    }, otherHeader),
    body: {}
  };
};
var giveMeStatuArray = function giveMeStatuArray(type) {
  switch (type) {
    case 0:
      return [1, 9];

    case 1:
      return [2, 3, 10, 11];

    case 2:
      return [7, 8, 10, 11];

    case 3:
      return [5, 6];

    default:
      return [];
  }
};
var upsertQuery = (_upsertQuery = {
  masterCountry: {
    db_name: "".concat(process.env.REACT_APP_DB),
    entity: "master_country",
    is_metadata: false,
    filter: {},
    doc: {}
  },
  upsertCountryDisease: {
    db_name: "".concat(process.env.REACT_APP_DB),
    entity: "rl_country_disease",
    is_metadata: false,
    filter: {},
    doc: {}
  },
  masterDisease: {
    db_name: "".concat(process.env.REACT_APP_DB),
    entity: "master_disease",
    is_metadata: false,
    filter: {},
    doc: {}
  },
  upsertForm: {
    db_name: "".concat(process.env.REACT_APP_DB),
    entity: "forms",
    is_metadata: false,
    filter: {},
    doc: {}
  },
  upsertSection: {
    db_name: "".concat(process.env.REACT_APP_DB),
    entity: "section",
    is_metadata: false,
    filter: {},
    doc: {}
  },
  upsertEdgeFormSection: {
    db_name: "".concat(process.env.REACT_APP_DB),
    entity: "edge_form_section",
    is_metadata: false,
    filter: {},
    doc: {}
  },
  upsertTag: {
    db_name: "".concat(process.env.REACT_APP_DB),
    entity: "rl_disease_form",
    is_metadata: false,
    filter: {},
    doc: {}
  }
}, _defineProperty(_upsertQuery, "upsertSection", {
  db_name: "".concat(process.env.REACT_APP_DB),
  entity: "section",
  is_metadata: false,
  filter: {},
  doc: {}
}), _defineProperty(_upsertQuery, "upsertQuestion", {
  db_name: "".concat(process.env.REACT_APP_DB),
  entity: "questions",
  is_metadata: false,
  filter: {},
  doc: {}
}), _defineProperty(_upsertQuery, "upsertTemplateForm", {
  db_name: "".concat(process.env.REACT_APP_DB),
  entity: "form_template",
  is_metadata: false,
  filter: {},
  doc: {}
}), _defineProperty(_upsertQuery, "upsertDependency", {
  db_name: "".concat(process.env.REACT_APP_DB),
  entity: "dependency_questions",
  is_metadata: false,
  filter: {},
  doc: {}
}), _defineProperty(_upsertQuery, "upsertOption", {
  db_name: "".concat(process.env.REACT_APP_DB),
  entity: "options",
  is_metadata: false,
  filter: {},
  doc: {}
}), _defineProperty(_upsertQuery, "upsertEntry", {
  db_name: "".concat(process.env.REACT_APP_DB),
  entity: "form_entries",
  is_metadata: false,
  filter: {},
  doc: {}
}), _defineProperty(_upsertQuery, "upsertRole", {
  db_name: "".concat(process.env.REACT_APP_DB),
  entity: "roles",
  is_metadata: false,
  filter: {},
  doc: {}
}), _defineProperty(_upsertQuery, "upsertUser", {
  db_name: "".concat(process.env.REACT_APP_DB),
  entity: "user_profiles",
  is_metadata: false,
  filter: {},
  doc: {}
}), _defineProperty(_upsertQuery, "upsertManageNotification", {
  db_name: "".concat(process.env.REACT_APP_DB),
  entity: "notification_flow",
  is_metadata: false,
  filter: {},
  doc: {}
}), _defineProperty(_upsertQuery, "upsertEdgeUserRole", {
  db_name: "".concat(process.env.REACT_APP_DB),
  entity: "user_roles",
  is_metadata: false,
  filter: {},
  doc: {}
}), _defineProperty(_upsertQuery, "upsertTodo", {
  db_name: "".concat(process.env.REACT_APP_DB),
  entity: "todos",
  is_metadata: false,
  filter: {},
  doc: {}
}), _defineProperty(_upsertQuery, "upsertNotificationStatus", {
  db_name: "".concat(process.env.REACT_APP_DB),
  entity: "notifications",
  is_metadata: false,
  filter: {},
  doc: {}
}), _defineProperty(_upsertQuery, "upsertLocation", function upsertLocation(level) {
  return {
    db_name: "".concat(process.env.REACT_APP_DB),
    entity: "country_level_".concat(level),
    is_metadata: false,
    filter: {},
    doc: {}
  };
}), _defineProperty(_upsertQuery, "upsertChild", function upsertChild(level) {
  return {
    db_name: "".concat(process.env.REACT_APP_DB),
    entity: "country_level_".concat(level, "_childs"),
    is_metadata: false,
    filter: {},
    doc: {}
  };
}), _defineProperty(_upsertQuery, "upsertPatient", {
  db_name: "".concat(process.env.REACT_APP_DB),
  entity: "patients",
  is_metadata: false,
  filter: {},
  doc: {}
}), _upsertQuery);
var defaultReject = {
  loading: false,
  error: true,
  message: "",
  data: {}
};
var defaultState = {
  List: {
    loading: false,
    error: false,
    data: [],
    message: ""
  },
  Info: {
    loading: false,
    error: false,
    data: {},
    message: ""
  }
};
var giveMeFormsToShow = function giveMeFormsToShow(authData) {
  var formObj = {
    formsIds: [],
    isAllForm: true
  };
  return formObj;
};
var statusUpdatedBy = ['notified_by', 'verified_by', 'register_by', 'investigation_by'];
var statusUpdatedByDate = ['notified_at', 'verified_at', 'register_at', 'investigation_at'];

var queries = {
  //1. To Get all the countries
  getAllCountries: function getAllCountries(countryName, sortField, sortDirection) {
    var icd10 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var classification = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
    var countryId = arguments.length > 5 ? arguments[5] : undefined;
    var countryIds = arguments.length > 7 ? arguments[7] : undefined;
    var created_by = arguments.length > 8 ? arguments[8] : undefined;
    return "\n\n        ".concat(countryName || (icd10 === null || icd10 === void 0 ? void 0 : icd10.length) > 0 || (classification === null || classification === void 0 ? void 0 : classification.length) > 0 ? "let country_keys = (\n            \n            ".concat(countryName ? "let icd_keys = (\n                for icd_key in master_icd10\n                    filter icd_key.is_active == true && UPPER(icd_key.icd_10) like \"".concat(countryName.toUpperCase(), "%\"\n                        return icd_key.icd_10_id\n            )") : "", "\n\n            for disease_key in master_disease\n                filter disease_key.is_active == true ").concat(countryName ? "&& UPPER(disease_key.disease_name) like \"".concat(countryName.toUpperCase(), "%\" || icd_keys[0] in disease_key.icd_10") : "", "\n                    ").concat((icd10 === null || icd10 === void 0 ? void 0 : icd10.length) > 0 ? "".concat(icd10.map(function (_) {
      return "&& ".concat(_, " in disease_key.icd_10");
    })) : "", "\n                    ").concat((classification === null || classification === void 0 ? void 0 : classification.length) > 0 ? "&& disease_key.classification in [".concat(classification, "]") : "", "\n                    for rl_c_d in rl_country_disease\n                        filter rl_c_d.is_active == true && rl_c_d.disease_id == disease_key.disease_id\n                        return rl_c_d.country_id\n            )") : "", "\n\n\n        for ct in master_country \n            FILTER ct.is_active == true \n            ").concat(created_by ? "|| ct.created_by in ".concat(JSON.stringify(created_by)) : "", "\n            ").concat(countryName ? "FILTER UPPER(ct.country_name) like \"".concat(countryName.toUpperCase(), "%\" || ct.country_id in country_keys") : "", "\n            ").concat((icd10 === null || icd10 === void 0 ? void 0 : icd10.length) > 0 || classification !== null && classification !== void 0 && classification.length ? "&& ct.country_id in country_keys" : "", "\n            ").concat(countryId ? "FILTER ct.country_id == \"".concat(countryId, "\"") : "", "\n            ").concat((countryIds === null || countryIds === void 0 ? void 0 : countryIds.length) > 0 ? "FILTER ct.country_id in ".concat(JSON.stringify(countryIds)) : "", "\n            SORT ct.").concat(sortField, " ").concat(sortDirection, " \n            LET map = (\n                for rl in rl_country_disease \n                    filter rl.country_id == ct.country_id && rl.is_active == true \n                    return rl\n            ) \n            LET diseases = (\n                for m in map \n                    for ds in master_disease \n                        filter m.disease_id == ds.disease_id \n                        return ds\n            ) \n            return { \n                country_id : ct.country_id, \n                country_code: ct.country_code, \n                value : ct.country_id, \n                label: concat(ct.country_name,\" (\",ct.country_code,\")\"), \n                country_name:ct.country_name , \n                patient_details: ct.patient_details,\n                diseases: diseases \n            }\n        ");
  },
  //2. To Get all mapped disease to a country
  getAllCountryMappedDiseases: function getAllCountryMappedDiseases(countryId) {
    if (!countryId) return "";
    return "\n            FOR doc IN rl_country_disease \n                FOR ct IN master_country \n                    FOR ds IN master_disease \n                    FILTER doc.country_id== \"".concat(countryId, "\" && doc.country_id == ct.country_id && doc.disease_id== ds.disease_id && doc.is_active == true \n                    COLLECT country_id = ct.country_id , country_name = ct.country_name, country_code = ct.country_code into g \n                    let a = (\n                        for el in g[*].ds \n                            return { \n                                disease_name : el.disease_name, \n                                disease_id : el.disease_id, \n                                label : el.disease_name, \n                                value : el.disease_id, \n                                classification: FIRST(\n                                    for cl in master_disease_classification\n                                        filter cl.disease_classification_id == el.classification\n                                        return {\n                                            value: cl.disease_classification_id,\n                                            label: cl.disease_classification\n                                        }\n                                ), \n                                icd_10 : (\n                                    for icd in master_icd10\n                                        filter icd.icd_10_id in el.icd_10\n                                        return {\n                                            value: icd.icd_10_id,\n                                            label: icd.icd_10\n                                        }\n                                ), \n                                form_count : LENGTH(\n                                    for fr in forms \n                                        filter fr.is_active == true\n                                        for rl in rl_disease_form \n                                        filter rl.is_active == true && rl.disease_id == el.disease_id && rl.country_id == \"").concat(countryId, "\" && rl.form_id == fr.form_id return 1\n                                ) \n                        } \n                    ) \n                    RETURN { \n                        country_id :country_id , \n                        country_name:country_name , \n                        country_code:country_code , \n                        diseases: a \n                    }\n        ");
  },
  //3. To Get all forms to map/unmap to a disease and contry
  getAllFormsForMapping: function getAllFormsForMapping(diseaseId, countryId, diseases, countryIds, created_by) {
    return "\n            ".concat((diseases === null || diseases === void 0 ? void 0 : diseases.length) > 0 || (countryIds === null || countryIds === void 0 ? void 0 : countryIds.length) > 0 ? "\n                let rlFormIds = (\n                    for rld in rl_disease_form\n                        filter rld.is_active == true\n                        ".concat((diseases === null || diseases === void 0 ? void 0 : diseases.length) > 0 ? "filter rld.disease_id in ".concat(JSON.stringify(diseases)) : "", "\n                        ").concat((countryIds === null || countryIds === void 0 ? void 0 : countryIds.length) > 0 ? "filter rld.country_id in ".concat(JSON.stringify(countryIds)) : "", "\n                        return rld.form_id\n                )\n            ") : "", "\n\n            for fr in forms \n                filter fr.is_active == true\n                ").concat((diseases === null || diseases === void 0 ? void 0 : diseases.length) > 0 || (countryIds === null || countryIds === void 0 ? void 0 : countryIds.length) > 0 ? "filter fr.form_id in rlFormIds" : "", "\n                ").concat(created_by ? "|| fr.created_by == \"".concat(created_by, "\"") : "", "\n                let is_tagged = LENGTH(\n                    for rl in rl_disease_form \n                    filter rl.is_active == true && fr.form_id == rl.form_id && rl.disease_id == \"").concat(diseaseId, "\" && rl.country_id == \"").concat(countryId, "\" \n                        return rl\n                ) > 0 ? true : false\n                return { \n                    form_id: fr.form_id , \n                    form_name : fr.form_name , \n                    is_mapped: is_tagged \n                }");
  },
  //4. To Get all mapped forms
  getAllMappedForms: function getAllMappedForms(diseaseId, countryId) {
    return "\n            for fr in forms \n                filter fr.is_active == true\n                let is_tagged = LENGTH(\n                    for rl in rl_disease_form \n                    filter rl.is_active == true && fr.form_id == rl.form_id && rl.disease_id == \"".concat(diseaseId, "\" && rl.country_id == \"").concat(countryId, "\" \n                        return rl\n                ) > 0 ? true : false \n                return { \n                    form_id: fr.form_id , \n                    form_name : fr.form_name , \n                    is_mapped: is_tagged \n                }\n        ");
  },
  //5. To Get all disease for map/unmap it to a country
  getAllDiseaseForMapping: function getAllDiseaseForMapping(countryId, diseaseName, diseases, countryIds, created_by) {
    if (!countryId) return "";
    return "\n\n        ".concat((countryIds === null || countryIds === void 0 ? void 0 : countryIds.length) > 0 ? "\n        let countryDiseaseIds = (\n            for countryDiseases in rl_country_disease\n              filter countryDiseases.country_id in ".concat(JSON.stringify(countryIds), "\n              filter countryDiseases.is_active == true\n                return countryDiseases.disease_id\n\n        )\n    ") : "", "\n\n            for ds in master_disease \n                filter ds.is_active == true \n                ").concat(diseaseName ? "&& UPPER(ds.disease_name) like \"".concat(diseaseName.toUpperCase(), "%\"") : "", "\n                ").concat(countryIds !== null && countryIds !== void 0 && countryIds.length ? "filter ds.disease_id in countryDiseaseIds" : "", "\n                ").concat(diseases !== null && diseases !== void 0 && diseases.length ? "|| ds.disease_id in ".concat(JSON.stringify(diseases)) : "", "\n                ").concat(created_by ? "|| ds.created_by == \"".concat(created_by, "\"") : "", "\n                let mapped = LENGTH(\n                    for rl in rl_country_disease \n                    filter rl.disease_id == ds.disease_id && rl.is_active == true && rl.country_id == \"").concat(countryId, "\" \n                    return rl\n                ) \n                return { \n                    disease_id: ds.disease_id, \n                    disease_name : ds.disease_name , \n                    mapped: mapped > 0 ? true : false \n            }\n        ");
  },
  //6. To get only mapped forms
  getMappedForms: function getMappedForms(diseaseId, countryId) {
    return "\n            for rl in rl_disease_form \n                filter rl.is_active == true && rl.disease_id == \"".concat(diseaseId, "\" && rl.country_id == \"").concat(countryId, "\" \n                   for fr in forms\n                      filter fr.form_id == rl.form_id\n                      filter fr.is_active == true\n                        return merge(fr,{\n                            value:fr.form_id,\n                            label:fr.form_name\n                        })\n               \n        ");
  }
};

var _extraReducers;
var GET_ALL_COUNTRIES = createAsyncThunk("countrySlice/getAllCountries", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
  var payload,
      _ref2,
      rejectWithValue,
      _payload$countryName,
      countryName,
      _payload$sortField,
      sortField,
      _payload$sortDirectio,
      sortDirection,
      _payload$icd,
      icd10,
      _payload$classificati,
      classification,
      countryId,
      _payload$diseases,
      diseases,
      _payload$countryIds,
      countryIds,
      created_by,
      _,
      _args = arguments;

  return regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _payload$countryName = payload.countryName, countryName = _payload$countryName === void 0 ? "" : _payload$countryName, _payload$sortField = payload.sortField, sortField = _payload$sortField === void 0 ? 'country_name' : _payload$sortField, _payload$sortDirectio = payload.sortDirection, sortDirection = _payload$sortDirectio === void 0 ? 'ASC' : _payload$sortDirectio, _payload$icd = payload.icd10, icd10 = _payload$icd === void 0 ? [] : _payload$icd, _payload$classificati = payload.classification, classification = _payload$classificati === void 0 ? [] : _payload$classificati, countryId = payload.countryId, _payload$diseases = payload.diseases, diseases = _payload$diseases === void 0 ? [] : _payload$diseases, _payload$countryIds = payload.countryIds, countryIds = _payload$countryIds === void 0 ? [] : _payload$countryIds, created_by = payload.created_by;
          _context.prev = 3;
          _context.next = 6;
          return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
            body: JSON.stringify({
              db_name: "".concat(process.env.REACT_APP_DB),
              query: queries.getAllCountries(countryName, sortField, sortDirection, icd10, classification, countryId, diseases, countryIds, created_by)
            })
          }));

        case 6:
          _ = _context.sent;
          _context.next = 9;
          return _.json();

        case 9:
          _ = _context.sent;
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: _
          }));

        case 13:
          _context.prev = 13;
          _context.t0 = _context["catch"](3);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context.t0.message
          })));

        case 16:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[3, 13]]);
})));
var SUGGESTIVE_SEARCH_ALL_COUNTRIES = createAsyncThunk("countrySlice/suggestiveSearchAllCountries", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
  var payload,
      _ref4,
      rejectWithValue,
      _payload$countryName2,
      countryName,
      _payload$sortField2,
      sortField,
      _payload$sortDirectio2,
      sortDirection,
      _payload$icd2,
      icd10,
      _payload$classificati2,
      classification,
      countryId,
      _,
      _args2 = arguments;

  return regeneratorRuntime.wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
          _ref4 = _args2.length > 1 ? _args2[1] : undefined, rejectWithValue = _ref4.rejectWithValue;
          _payload$countryName2 = payload.countryName, countryName = _payload$countryName2 === void 0 ? "" : _payload$countryName2, _payload$sortField2 = payload.sortField, sortField = _payload$sortField2 === void 0 ? 'country_name' : _payload$sortField2, _payload$sortDirectio2 = payload.sortDirection, sortDirection = _payload$sortDirectio2 === void 0 ? 'ASC' : _payload$sortDirectio2, _payload$icd2 = payload.icd10, icd10 = _payload$icd2 === void 0 ? [] : _payload$icd2, _payload$classificati2 = payload.classification, classification = _payload$classificati2 === void 0 ? [] : _payload$classificati2, countryId = payload.countryId;
          _context2.prev = 3;
          _context2.next = 6;
          return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
            body: JSON.stringify({
              db_name: "".concat(process.env.REACT_APP_DB),
              query: queries.getAllCountries(countryName, sortField, sortDirection, icd10, classification, countryId)
            })
          }));

        case 6:
          _ = _context2.sent;
          _context2.next = 9;
          return _.json();

        case 9:
          _ = _context2.sent;
          return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: _
          }));

        case 13:
          _context2.prev = 13;
          _context2.t0 = _context2["catch"](3);
          return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context2.t0.message
          })));

        case 16:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[3, 13]]);
})));
var UPSERT_COUNTRY = createAsyncThunk("countrySlice/upsertCountry", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
  var payload,
      _ref6,
      rejectWithValue,
      getState,
      _getState,
      _getState$authSlice,
      _getState$authSlice$l,
      _getState$authSlice$l2,
      user_profile_id,
      countryName,
      countryCode,
      isActive,
      countryId,
      doc,
      _,
      _args3 = arguments;

  return regeneratorRuntime.wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
          _ref6 = _args3.length > 1 ? _args3[1] : undefined, rejectWithValue = _ref6.rejectWithValue, getState = _ref6.getState;
          _context3.prev = 2;
          user_profile_id = (_getState = getState()) === null || _getState === void 0 ? void 0 : (_getState$authSlice = _getState.authSlice) === null || _getState$authSlice === void 0 ? void 0 : (_getState$authSlice$l = _getState$authSlice.login) === null || _getState$authSlice$l === void 0 ? void 0 : (_getState$authSlice$l2 = _getState$authSlice$l.data) === null || _getState$authSlice$l2 === void 0 ? void 0 : _getState$authSlice$l2.user_profile_id;
          countryName = payload.countryName, countryCode = payload.countryCode, isActive = payload.isActive, countryId = payload.countryId;
          doc = {};

          if (countryId) {
            doc.updated_at = new Date().toISOString();
            doc.updated_by = user_profile_id;
          } else {
            doc.created_at = new Date().toISOString();
            doc.updated_at = new Date().toISOString();
            doc.created_by = user_profile_id;
            doc.updated_by = user_profile_id;
          }

          countryId = countryId ? countryId : v4();
          doc.is_active = isActive;
          doc.country_id = countryId;
          doc._key = countryId;

          if (countryName) {
            doc.country_name = countryName.charAt(0).toUpperCase() + countryName.slice(1);
          }

          if (countryCode) {
            doc.country_code = countryCode.toUpperCase();
          }

          _context3.next = 15;
          return fetch("".concat(__baseUrl__, "/upsert_document"), _objectSpread2(_objectSpread2({}, __options()), {}, {
            body: JSON.stringify([_objectSpread2(_objectSpread2({}, upsertQuery.masterCountry), {}, {
              filter: {
                country_id: String(countryId)
              },
              doc: doc
            })])
          }));

        case 15:
          _ = _context3.sent;
          _context3.next = 18;
          return _.json();

        case 18:
          _ = _context3.sent;
          return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: _
          }));

        case 22:
          _context3.prev = 22;
          _context3.t0 = _context3["catch"](2);
          return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context3.t0.message
          })));

        case 25:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3, null, [[2, 22]]);
})));
var UPSERT_COUNTRY_PATIENT_DETAIL = createAsyncThunk("countrySlice/upsertCountryPatientDetail", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
  var payload,
      _ref8,
      rejectWithValue,
      getState,
      _getState2,
      _getState2$authSlice,
      _getState2$authSlice$,
      _getState2$authSlice$2,
      _patient_details$comp,
      user_profile_id,
      patient_details,
      countryId,
      components,
      doc,
      _,
      _args4 = arguments;

  return regeneratorRuntime.wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
          _ref8 = _args4.length > 1 ? _args4[1] : undefined, rejectWithValue = _ref8.rejectWithValue, getState = _ref8.getState;
          _context4.prev = 2;
          user_profile_id = (_getState2 = getState()) === null || _getState2 === void 0 ? void 0 : (_getState2$authSlice = _getState2.authSlice) === null || _getState2$authSlice === void 0 ? void 0 : (_getState2$authSlice$ = _getState2$authSlice.login) === null || _getState2$authSlice$ === void 0 ? void 0 : (_getState2$authSlice$2 = _getState2$authSlice$.data) === null || _getState2$authSlice$2 === void 0 ? void 0 : _getState2$authSlice$2.user_profile_id;
          patient_details = payload.patient_details, countryId = payload.countryId;
          components = patient_details === null || patient_details === void 0 ? void 0 : (_patient_details$comp = patient_details.components) === null || _patient_details$comp === void 0 ? void 0 : _patient_details$comp.map(function (_) {
            return _objectSpread2({
              id: v4()
            }, _);
          });
          patient_details.components = components;
          doc = {};
          doc.updated_at = new Date().toISOString();
          doc.updated_by = user_profile_id;
          doc.patient_details = patient_details;
          _context4.next = 13;
          return fetch("".concat(__baseUrl__, "/upsert_document"), _objectSpread2(_objectSpread2({}, __options()), {}, {
            body: JSON.stringify([_objectSpread2(_objectSpread2({}, upsertQuery.masterCountry), {}, {
              filter: {
                country_id: String(countryId)
              },
              doc: doc
            })])
          }));

        case 13:
          _ = _context4.sent;
          _context4.next = 16;
          return _.json();

        case 16:
          _ = _context4.sent;
          return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: _
          }));

        case 20:
          _context4.prev = 20;
          _context4.t0 = _context4["catch"](2);
          return _context4.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context4.t0.message
          })));

        case 23:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, null, [[2, 20]]);
})));
var GET_COUNTRY_MAPPED_DISEASES = createAsyncThunk("countrySlice/getCountryMappedDiseases", /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(payload, _ref9) {
    var rejectWithValue, countryId, _payload$diseases2, diseases, _payload$countryIds2, countryIds, created_by, _;

    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            rejectWithValue = _ref9.rejectWithValue;
            _context5.prev = 1;
            countryId = payload.countryId, _payload$diseases2 = payload.diseases, diseases = _payload$diseases2 === void 0 ? [] : _payload$diseases2, _payload$countryIds2 = payload.countryIds, countryIds = _payload$countryIds2 === void 0 ? [] : _payload$countryIds2, created_by = payload.created_by;
            _context5.next = 5;
            return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
              body: JSON.stringify({
                db_name: "".concat(process.env.REACT_APP_DB),
                query: queries.getAllCountryMappedDiseases(countryId, diseases, countryIds, created_by)
              })
            }));

          case 5:
            _ = _context5.sent;
            _context5.next = 8;
            return _.json();

          case 8:
            _ = _context5.sent;
            return _context5.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
              data: _
            }));

          case 12:
            _context5.prev = 12;
            _context5.t0 = _context5["catch"](1);
            return _context5.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context5.t0.message
            })));

          case 15:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[1, 12]]);
  }));

  return function (_x, _x2) {
    return _ref10.apply(this, arguments);
  };
}());
var TAG_UNTAG_FORMS = createAsyncThunk("countrySlice/tagUntagForm", /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(payload, _ref11) {
    var rejectWithValue, getState, _getState3, _getState3$authSlice, _getState3$authSlice$, _getState3$authSlice$2, user_profile_id, diseaseId, countryId, isActive, formId, doc, _;

    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            rejectWithValue = _ref11.rejectWithValue, getState = _ref11.getState;
            _context6.prev = 1;
            user_profile_id = (_getState3 = getState()) === null || _getState3 === void 0 ? void 0 : (_getState3$authSlice = _getState3.authSlice) === null || _getState3$authSlice === void 0 ? void 0 : (_getState3$authSlice$ = _getState3$authSlice.login) === null || _getState3$authSlice$ === void 0 ? void 0 : (_getState3$authSlice$2 = _getState3$authSlice$.data) === null || _getState3$authSlice$2 === void 0 ? void 0 : _getState3$authSlice$2.user_profile_id;
            diseaseId = payload.diseaseId, countryId = payload.countryId, isActive = payload.isActive, formId = payload.formId;
            doc = {};
            doc.is_active = isActive;
            doc.disease_id = diseaseId;
            doc.country_id = countryId;
            doc.form_id = formId;
            doc.created_at = new Date().toISOString();
            doc.created_by = user_profile_id;
            doc.updated_at = new Date().toISOString();
            doc.updated_by = user_profile_id;
            _context6.next = 15;
            return fetch("".concat(__baseUrl__, "/upsert_document"), _objectSpread2(_objectSpread2({}, __options()), {}, {
              body: JSON.stringify([_objectSpread2(_objectSpread2({}, upsertQuery.upsertTag), {}, {
                filter: {
                  disease_id: String(diseaseId),
                  form_id: String(formId),
                  country_id: String(countryId)
                },
                doc: doc
              })])
            }));

          case 15:
            _ = _context6.sent;
            _context6.next = 18;
            return _.json();

          case 18:
            _ = _context6.sent;
            return _context6.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
              data: _
            }));

          case 22:
            _context6.prev = 22;
            _context6.t0 = _context6["catch"](1);
            return _context6.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context6.t0.message
            })));

          case 25:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[1, 22]]);
  }));

  return function (_x3, _x4) {
    return _ref12.apply(this, arguments);
  };
}());
var GET_ALL_FORMS_FOR_MAPPING = createAsyncThunk("countrySlice/getAllFormsForMapping", /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(payload, _ref13) {
    var rejectWithValue, diseaseId, countryId, formName, _payload$diseases3, diseases, _payload$countryIds3, countryIds, created_by, _;

    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            rejectWithValue = _ref13.rejectWithValue;
            _context7.prev = 1;
            diseaseId = payload.diseaseId, countryId = payload.countryId, formName = payload.formName, _payload$diseases3 = payload.diseases, diseases = _payload$diseases3 === void 0 ? [] : _payload$diseases3, _payload$countryIds3 = payload.countryIds, countryIds = _payload$countryIds3 === void 0 ? [] : _payload$countryIds3, created_by = payload.created_by;
            _context7.next = 5;
            return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
              body: JSON.stringify({
                db_name: "".concat(process.env.REACT_APP_DB),
                query: queries.getAllFormsForMapping(diseaseId, countryId, diseases, countryIds, created_by)
              })
            }));

          case 5:
            _ = _context7.sent;
            _context7.next = 8;
            return _.json();

          case 8:
            _ = _context7.sent;
            return _context7.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
              data: _
            }));

          case 12:
            _context7.prev = 12;
            _context7.t0 = _context7["catch"](1);
            return _context7.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context7.t0.message
            })));

          case 15:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[1, 12]]);
  }));

  return function (_x5, _x6) {
    return _ref14.apply(this, arguments);
  };
}());
var GET_ALL_MAPPED_FORMS = createAsyncThunk("countrySlice/getAllMappedForms", /*#__PURE__*/function () {
  var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(payload, _ref15) {
    var rejectWithValue, diseaseId, countryId, formName, _;

    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            rejectWithValue = _ref15.rejectWithValue;
            _context8.prev = 1;
            diseaseId = payload.diseaseId, countryId = payload.countryId, formName = payload.formName;
            _context8.next = 5;
            return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
              body: JSON.stringify({
                db_name: "".concat(process.env.REACT_APP_DB),
                query: queries.getAllMappedForms(diseaseId, countryId)
              })
            }));

          case 5:
            _ = _context8.sent;
            _context8.next = 8;
            return _.json();

          case 8:
            _ = _context8.sent;
            return _context8.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
              data: _
            }));

          case 12:
            _context8.prev = 12;
            _context8.t0 = _context8["catch"](1);
            return _context8.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context8.t0.message
            })));

          case 15:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[1, 12]]);
  }));

  return function (_x7, _x8) {
    return _ref16.apply(this, arguments);
  };
}());
var GET_MAPPED_FORMS = createAsyncThunk("countrySlice/getMappedForms", /*#__PURE__*/function () {
  var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(payload, _ref17) {
    var rejectWithValue, diseaseId, countryId, formName, _;

    return regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            rejectWithValue = _ref17.rejectWithValue;
            _context9.prev = 1;
            diseaseId = payload.diseaseId, countryId = payload.countryId, formName = payload.formName;
            _context9.next = 5;
            return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
              body: JSON.stringify({
                db_name: "".concat(process.env.REACT_APP_DB),
                query: queries.getMappedForms(diseaseId, countryId)
              })
            }));

          case 5:
            _ = _context9.sent;
            _context9.next = 8;
            return _.json();

          case 8:
            _ = _context9.sent;
            return _context9.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
              data: _
            }));

          case 12:
            _context9.prev = 12;
            _context9.t0 = _context9["catch"](1);
            return _context9.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context9.t0.message
            })));

          case 15:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[1, 12]]);
  }));

  return function (_x9, _x10) {
    return _ref18.apply(this, arguments);
  };
}());
var GET_ALL_DISEASE_FOR_MAPPING = createAsyncThunk("v1slice/getAllDiseaseForMapping", /*#__PURE__*/function () {
  var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(payload, _ref19) {
    var rejectWithValue, countryId, diseaseName, _payload$diseases4, diseases, _payload$countryIds4, countryIds, created_by, _;

    return regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            rejectWithValue = _ref19.rejectWithValue;
            _context10.prev = 1;
            countryId = payload.countryId, diseaseName = payload.diseaseName, _payload$diseases4 = payload.diseases, diseases = _payload$diseases4 === void 0 ? [] : _payload$diseases4, _payload$countryIds4 = payload.countryIds, countryIds = _payload$countryIds4 === void 0 ? [] : _payload$countryIds4, created_by = payload.created_by;
            _context10.next = 5;
            return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
              body: JSON.stringify({
                db_name: "".concat(process.env.REACT_APP_DB),
                query: queries.getAllDiseaseForMapping(countryId, diseaseName, diseases, countryIds, created_by)
              })
            }));

          case 5:
            _ = _context10.sent;
            _context10.next = 8;
            return _.json();

          case 8:
            _ = _context10.sent;
            return _context10.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
              data: _
            }));

          case 12:
            _context10.prev = 12;
            _context10.t0 = _context10["catch"](1);
            return _context10.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context10.t0.message
            })));

          case 15:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[1, 12]]);
  }));

  return function (_x11, _x12) {
    return _ref20.apply(this, arguments);
  };
}());
var REMOVE_ADD_DISEASE = createAsyncThunk("countrySlice/removeAddDisease", /*#__PURE__*/function () {
  var _ref22 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(payload, _ref21) {
    var rejectWithValue, getState, _getState4, _getState4$authSlice, _getState4$authSlice$, _getState4$authSlice$2, user_profile_id, diseaseId, countryId, isActive, doc, _;

    return regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            rejectWithValue = _ref21.rejectWithValue, getState = _ref21.getState;
            _context11.prev = 1;
            user_profile_id = (_getState4 = getState()) === null || _getState4 === void 0 ? void 0 : (_getState4$authSlice = _getState4.authSlice) === null || _getState4$authSlice === void 0 ? void 0 : (_getState4$authSlice$ = _getState4$authSlice.login) === null || _getState4$authSlice$ === void 0 ? void 0 : (_getState4$authSlice$2 = _getState4$authSlice$.data) === null || _getState4$authSlice$2 === void 0 ? void 0 : _getState4$authSlice$2.user_profile_id;
            diseaseId = payload.diseaseId, countryId = payload.countryId, isActive = payload.isActive;
            doc = {};
            doc.is_active = isActive;
            doc.disease_id = String(diseaseId);
            doc.country_id = String(countryId);
            doc.created_at = new Date().toISOString();
            doc.created_by = user_profile_id;
            doc.updated_at = new Date().toISOString();
            doc.updated_by = user_profile_id;
            _context11.next = 14;
            return fetch("".concat(__baseUrl__, "/upsert_document"), _objectSpread2(_objectSpread2({}, __options()), {}, {
              body: JSON.stringify([_objectSpread2(_objectSpread2({}, upsertQuery.upsertCountryDisease), {}, {
                filter: {
                  disease_id: String(diseaseId),
                  country_id: String(countryId)
                },
                doc: doc
              })])
            }));

          case 14:
            _ = _context11.sent;
            _context11.next = 17;
            return _.json();

          case 17:
            _ = _context11.sent;
            return _context11.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
              data: _
            }));

          case 21:
            _context11.prev = 21;
            _context11.t0 = _context11["catch"](1);
            return _context11.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context11.t0.message
            })));

          case 24:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11, null, [[1, 21]]);
  }));

  return function (_x13, _x14) {
    return _ref22.apply(this, arguments);
  };
}());
var countrySlice = createSlice({
  name: "countrySlice",
  initialState: {
    getAllCountries: _objectSpread2({}, defaultState.List),
    suggestiveSearchAllCountries: _objectSpread2({}, defaultState.List),
    getCountryMappedDiseases: _objectSpread2({}, defaultState.List),
    getAllFormsForMapping: _objectSpread2({}, defaultState.List),
    getAllMappedForms: _objectSpread2({}, defaultState.List),
    getAllDiseaseForMapping: _objectSpread2({}, defaultState.List),
    getMappedForms: _objectSpread2({}, defaultState.List),
    upsertCountry: _objectSpread2({}, defaultState.Info),
    upsertCountryPatientDetail: _objectSpread2({}, defaultState.Info),
    tagUntagForm: _objectSpread2({}, defaultState.Info),
    removeAddDisease: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers = {}, _defineProperty(_extraReducers, GET_ALL_COUNTRIES.fulfilled, function (state, action) {
    var _action$payload;

    state.getAllCountries = (_action$payload = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload !== void 0 ? _action$payload : {};
  }), _defineProperty(_extraReducers, GET_ALL_COUNTRIES.pending, function (state, action) {
    state.getAllCountries.loading = true;
  }), _defineProperty(_extraReducers, GET_ALL_COUNTRIES.rejected, function (state, action) {
    var _action$payload2;

    state.getAllCountries = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers, SUGGESTIVE_SEARCH_ALL_COUNTRIES.fulfilled, function (state, action) {
    var _action$payload3;

    state.suggestiveSearchAllCountries = (_action$payload3 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload3 !== void 0 ? _action$payload3 : {};
  }), _defineProperty(_extraReducers, SUGGESTIVE_SEARCH_ALL_COUNTRIES.pending, function (state, action) {
    state.suggestiveSearchAllCountries.loading = true;
  }), _defineProperty(_extraReducers, SUGGESTIVE_SEARCH_ALL_COUNTRIES.rejected, function (state, action) {
    var _action$payload4;

    state.suggestiveSearchAllCountries = (_action$payload4 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload4 !== void 0 ? _action$payload4 : {};
  }), _defineProperty(_extraReducers, GET_COUNTRY_MAPPED_DISEASES.fulfilled, function (state, action) {
    var _action$payload5;

    state.getCountryMappedDiseases = (_action$payload5 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload5 !== void 0 ? _action$payload5 : {};
  }), _defineProperty(_extraReducers, GET_COUNTRY_MAPPED_DISEASES.pending, function (state, action) {
    state.getCountryMappedDiseases.loading = true;
  }), _defineProperty(_extraReducers, GET_COUNTRY_MAPPED_DISEASES.rejected, function (state, action) {
    var _action$payload6;

    state.getCountryMappedDiseases = (_action$payload6 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload6 !== void 0 ? _action$payload6 : {};
  }), _defineProperty(_extraReducers, GET_ALL_FORMS_FOR_MAPPING.fulfilled, function (state, action) {
    var _action$payload7;

    state.getAllFormsForMapping = (_action$payload7 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload7 !== void 0 ? _action$payload7 : {};
  }), _defineProperty(_extraReducers, GET_ALL_FORMS_FOR_MAPPING.pending, function (state, action) {
    state.getAllFormsForMapping.loading = true;
  }), _defineProperty(_extraReducers, GET_ALL_FORMS_FOR_MAPPING.rejected, function (state, action) {
    var _action$payload8;

    state.getAllFormsForMapping = (_action$payload8 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload8 !== void 0 ? _action$payload8 : {};
  }), _defineProperty(_extraReducers, GET_ALL_MAPPED_FORMS.fulfilled, function (state, action) {
    var _action$payload9;

    state.getAllMappedForms = (_action$payload9 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload9 !== void 0 ? _action$payload9 : {};
  }), _defineProperty(_extraReducers, GET_ALL_MAPPED_FORMS.pending, function (state, action) {
    state.getAllMappedForms.loading = true;
  }), _defineProperty(_extraReducers, GET_ALL_MAPPED_FORMS.rejected, function (state, action) {
    var _action$payload10;

    state.getAllMappedForms = (_action$payload10 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload10 !== void 0 ? _action$payload10 : {};
  }), _defineProperty(_extraReducers, GET_ALL_DISEASE_FOR_MAPPING.fulfilled, function (state, action) {
    var _action$payload11;

    state.getAllDiseaseForMapping = (_action$payload11 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload11 !== void 0 ? _action$payload11 : {};
  }), _defineProperty(_extraReducers, GET_ALL_DISEASE_FOR_MAPPING.pending, function (state, action) {
    state.getAllDiseaseForMapping.loading = true;
  }), _defineProperty(_extraReducers, GET_ALL_DISEASE_FOR_MAPPING.rejected, function (state, action) {
    var _action$payload12;

    state.getAllDiseaseForMapping = (_action$payload12 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload12 !== void 0 ? _action$payload12 : {};
  }), _defineProperty(_extraReducers, GET_MAPPED_FORMS.fulfilled, function (state, action) {
    var _action$payload13;

    state.getMappedForms = (_action$payload13 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload13 !== void 0 ? _action$payload13 : {};
  }), _defineProperty(_extraReducers, GET_MAPPED_FORMS.pending, function (state, action) {
    state.getMappedForms.loading = true;
  }), _defineProperty(_extraReducers, GET_MAPPED_FORMS.rejected, function (state, action) {
    var _action$payload14;

    state.getMappedForms = (_action$payload14 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload14 !== void 0 ? _action$payload14 : {};
  }), _defineProperty(_extraReducers, UPSERT_COUNTRY.fulfilled, function (state, action) {
    var _action$payload15;

    state.upsertCountry = (_action$payload15 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload15 !== void 0 ? _action$payload15 : {};
  }), _defineProperty(_extraReducers, UPSERT_COUNTRY.pending, function (state, action) {
    state.upsertCountry.loading = true;
  }), _defineProperty(_extraReducers, UPSERT_COUNTRY.rejected, function (state, action) {
    var _action$payload16;

    state.upsertCountry = (_action$payload16 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload16 !== void 0 ? _action$payload16 : {};
  }), _defineProperty(_extraReducers, UPSERT_COUNTRY_PATIENT_DETAIL.fulfilled, function (state, action) {
    var _action$payload17;

    state.upsertCountryPatientDetail = (_action$payload17 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload17 !== void 0 ? _action$payload17 : {};
  }), _defineProperty(_extraReducers, UPSERT_COUNTRY_PATIENT_DETAIL.pending, function (state, action) {
    state.upsertCountryPatientDetail.loading = true;
  }), _defineProperty(_extraReducers, UPSERT_COUNTRY_PATIENT_DETAIL.rejected, function (state, action) {
    var _action$payload18;

    state.upsertCountryPatientDetail = (_action$payload18 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload18 !== void 0 ? _action$payload18 : {};
  }), _defineProperty(_extraReducers, TAG_UNTAG_FORMS.fulfilled, function (state, action) {
    var _action$payload19;

    state.tagUntagForm = (_action$payload19 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload19 !== void 0 ? _action$payload19 : {};
  }), _defineProperty(_extraReducers, TAG_UNTAG_FORMS.pending, function (state, action) {
    state.tagUntagForm.loading = true;
  }), _defineProperty(_extraReducers, TAG_UNTAG_FORMS.rejected, function (state, action) {
    var _action$payload20;

    state.tagUntagForm = (_action$payload20 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload20 !== void 0 ? _action$payload20 : {};
  }), _defineProperty(_extraReducers, REMOVE_ADD_DISEASE.fulfilled, function (state, action) {
    var _action$payload21;

    state.removeAddDisease = (_action$payload21 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload21 !== void 0 ? _action$payload21 : {};
  }), _defineProperty(_extraReducers, REMOVE_ADD_DISEASE.pending, function (state, action) {
    state.removeAddDisease.loading = true;
  }), _defineProperty(_extraReducers, REMOVE_ADD_DISEASE.rejected, function (state, action) {
    var _action$payload22;

    state.removeAddDisease = (_action$payload22 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload22 !== void 0 ? _action$payload22 : {};
  }), _extraReducers)
});
var countryActions = {
  GET_ALL_COUNTRIES: GET_ALL_COUNTRIES,
  SUGGESTIVE_SEARCH_ALL_COUNTRIES: SUGGESTIVE_SEARCH_ALL_COUNTRIES,
  GET_COUNTRY_MAPPED_DISEASES: GET_COUNTRY_MAPPED_DISEASES,
  GET_ALL_FORMS_FOR_MAPPING: GET_ALL_FORMS_FOR_MAPPING,
  GET_ALL_MAPPED_FORMS: GET_ALL_MAPPED_FORMS,
  GET_ALL_DISEASE_FOR_MAPPING: GET_ALL_DISEASE_FOR_MAPPING,
  GET_MAPPED_FORMS: GET_MAPPED_FORMS,
  UPSERT_COUNTRY: UPSERT_COUNTRY,
  UPSERT_COUNTRY_PATIENT_DETAIL: UPSERT_COUNTRY_PATIENT_DETAIL,
  TAG_UNTAG_FORMS: TAG_UNTAG_FORMS,
  REMOVE_ADD_DISEASE: REMOVE_ADD_DISEASE
};
var countrySlice$1 = countrySlice.reducer;

var queries$1 = {
  //1. To get all diseases
  getAllDiseases: function getAllDiseases(diseaseName, sortField, sortDirection) {
    var icd10 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var classification = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
    var diseaseId = arguments.length > 5 ? arguments[5] : undefined;
    var diseases = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
    var countryIds = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : [];
    var created_by = arguments.length > 8 ? arguments[8] : undefined;
    return "\n            \n            ".concat(diseaseName ? "let icd_keys = (\n                for icd_key in master_icd10\n                    filter icd_key.is_active == true && UPPER(icd_key.icd_10) like \"".concat(diseaseName.toUpperCase(), "%\"\n                    return icd_key.icd_10_id\n            )") : "", "\n\n            ").concat((countryIds === null || countryIds === void 0 ? void 0 : countryIds.length) > 0 ? "\n                let countryDiseaseIds = (\n                    for countryDiseases in rl_country_disease\n                      filter countryDiseases.country_id in ".concat(JSON.stringify(countryIds), "\n                      filter countryDiseases.is_active == true\n                        return countryDiseases.disease_id\n\n                )\n            ") : "", "\n\n            for md in master_disease \n                FILTER md.is_active == true \n                ").concat(created_by ? "|| md.created_by == \"".concat(created_by, "\"") : "", " \n                ").concat(diseaseName ? "FILTER UPPER(md.disease_name) like \"".concat(diseaseName.toUpperCase(), "%\" || icd_keys[0] in md.icd_10") : "", "\n                ").concat((icd10 === null || icd10 === void 0 ? void 0 : icd10.length) > 0 ? "".concat(icd10.map(function (_) {
      return "&& ".concat(_, " in md.icd_10");
    })) : "", "\n                ").concat((classification === null || classification === void 0 ? void 0 : classification.length) > 0 ? "&& md.classification in [".concat(classification, "]") : "", "\n                ").concat((diseaseId === null || diseaseId === void 0 ? void 0 : diseaseId.length) > 0 ? "FILTER md.disease_id == \"".concat(diseaseId, "\"") : "", "\n                ").concat((diseases === null || diseases === void 0 ? void 0 : diseases.length) > 0 ? "FILTER md.disease_id in ".concat(JSON.stringify(diseases)) : "", "\n                ").concat((countryIds === null || countryIds === void 0 ? void 0 : countryIds.length) > 0 ? "FILTER md.disease_id in countryDiseaseIds" : "", "\n                SORT md.").concat(sortField, " ").concat(sortDirection, " \n                LET map = (\n                    for rl in rl_country_disease \n                    filter md.disease_id == rl.disease_id && rl.is_active == true\n                    return rl\n                ) \n                LET countries = (\n                    for m in map \n                        for ds in master_country \n                        filter m.country_id == ds.country_id && ds.is_active == true\n                        return ds\n                ) \n                return { \n                    disease_id : md.disease_id, \n                    disease_name: md.disease_name ? md.disease_name : \"\",\n                    disease_definition: md.disease_definition ? md.disease_definition : \"\",\n                    classification: FIRST(\n                        for cl in master_disease_classification\n                            filter cl.disease_classification_id == md.classification\n                            return {\n                                value: cl.disease_classification_id,\n                                label: cl.disease_classification\n                            }\n                    ), \n                    countries: countries,\n                    icd_10 : (\n                        for icd in master_icd10\n                            filter icd.icd_10_id in md.icd_10\n                            return {\n                                value: icd.icd_10_id,\n                                label: icd.icd_10\n                            }\n                    ) \n                }\n        ");
  },
  //2. To get all ICD10Code
  getAllICD10Code: function getAllICD10Code() {
    return "\n                       FOR cd IN master_icd10\n                       FILTER cd.is_active == true\n                       SORT cd.icd_10 ASC\n                       RETURN {\n                                 value : cd.icd_10_id,\n                                 label : cd.icd_10\n                               }\n           \n        ";
  },
  //3. To get all getAllDiseasesClassification
  getAllDiseasesClassification: function getAllDiseasesClassification() {
    return "\n                      \n                       FOR cl IN master_disease_classification\n                       FILTER cl.is_active == true\n                       SORT cl.disease_classification ASC\n                       RETURN {\n                                  value : cl.disease_classification_id,\n                                  label : cl.disease_classification\n                               }\n        \n        ";
  },
  // 4. duplicate disease check
  duplicateDiseaseCheck: function duplicateDiseaseCheck(disease_name) {
    return "\n    for md in master_disease \n    FILTER md.is_active == true && UPPER(md.disease_name) == \"".concat(disease_name.toUpperCase(), "\"\n    return md\n    ");
  }
};

var _extraReducers$1;
var UPSERT_DISEASE = createAsyncThunk("diseaseSlice/upsertDisease", /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(payload, _ref) {
    var _getState, _getState$authSlice, _getState$authSlice$l, _getState$authSlice$l2;

    var rejectWithValue, getState, user_profile_id, diseaseName, isActive, diseaseId, Classification, ICD10, diseaseDefinition, _uniqCheck, uniqCheck, doc, _;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            rejectWithValue = _ref.rejectWithValue, getState = _ref.getState;
            user_profile_id = (_getState = getState()) === null || _getState === void 0 ? void 0 : (_getState$authSlice = _getState.authSlice) === null || _getState$authSlice === void 0 ? void 0 : (_getState$authSlice$l = _getState$authSlice.login) === null || _getState$authSlice$l === void 0 ? void 0 : (_getState$authSlice$l2 = _getState$authSlice$l.data) === null || _getState$authSlice$l2 === void 0 ? void 0 : _getState$authSlice$l2.user_profile_id;
            _context.prev = 2;
            diseaseName = payload.diseaseName, isActive = payload.isActive, diseaseId = payload.diseaseId, Classification = payload.Classification, ICD10 = payload.ICD10, diseaseDefinition = payload.diseaseDefinition;

            if (!diseaseName) {
              _context.next = 13;
              break;
            }

            _context.next = 7;
            return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
              body: JSON.stringify({
                db_name: "".concat(process.env.REACT_APP_DB),
                query: queries$1.duplicateDiseaseCheck(diseaseName.trim())
              })
            }));

          case 7:
            uniqCheck = _context.sent;
            _context.next = 10;
            return uniqCheck.json();

          case 10:
            uniqCheck = _context.sent;

            if (!(((_uniqCheck = uniqCheck) === null || _uniqCheck === void 0 ? void 0 : _uniqCheck.length) !== 0)) {
              _context.next = 13;
              break;
            }

            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
              data: [],
              error: true,
              message: "Disease Already Exist !"
            }));

          case 13:
            doc = {};

            if (!diseaseId) {
              doc.created_at = new Date().toISOString();
              doc.created_by = user_profile_id ? user_profile_id : "user profile id not available";
            }

            doc.updated_at = new Date().toISOString();
            doc.updated_by = user_profile_id ? user_profile_id : "user profile id not available";
            diseaseId = diseaseId ? diseaseId : v4();
            doc.is_active = isActive;
            doc.disease_id = diseaseId;

            if (diseaseName) {
              doc.disease_name = diseaseName;
            }

            if (Classification) {
              doc.classification = Classification.value;
            }

            if (ICD10) {
              doc.icd_10 = ICD10.map(function (data) {
                return data.value;
              });
            }

            if (diseaseDefinition) {
              doc.disease_definition = diseaseDefinition;
            }

            _context.next = 26;
            return fetch("".concat(__baseUrl__, "/upsert_document"), _objectSpread2(_objectSpread2({}, __options()), {}, {
              body: JSON.stringify([_objectSpread2(_objectSpread2({}, upsertQuery.masterDisease), {}, {
                filter: {
                  disease_id: String(diseaseId)
                },
                doc: doc
              })])
            }));

          case 26:
            _ = _context.sent;
            _context.next = 29;
            return _.json();

          case 29:
            _ = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
              data: _
            }));

          case 33:
            _context.prev = 33;
            _context.t0 = _context["catch"](2);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 36:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 33]]);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());
var GET_ALL_DISEASES = createAsyncThunk("diseaseSlice/getAllDiseases", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
  var payload,
      _ref4,
      rejectWithValue,
      _payload$diseaseName,
      diseaseName,
      _payload$sortField,
      sortField,
      _payload$sortDirectio,
      sortDirection,
      _payload$icd,
      icd10,
      _payload$classificati,
      classification,
      diseaseId,
      _payload$diseases,
      diseases,
      _payload$countryIds,
      countryIds,
      created_by,
      _,
      _args2 = arguments;

  return regeneratorRuntime.wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
          _ref4 = _args2.length > 1 ? _args2[1] : undefined, rejectWithValue = _ref4.rejectWithValue;
          _context2.prev = 2;
          _payload$diseaseName = payload.diseaseName, diseaseName = _payload$diseaseName === void 0 ? "" : _payload$diseaseName, _payload$sortField = payload.sortField, sortField = _payload$sortField === void 0 ? 'disease_name' : _payload$sortField, _payload$sortDirectio = payload.sortDirection, sortDirection = _payload$sortDirectio === void 0 ? 'ASC' : _payload$sortDirectio, _payload$icd = payload.icd10, icd10 = _payload$icd === void 0 ? [] : _payload$icd, _payload$classificati = payload.classification, classification = _payload$classificati === void 0 ? [] : _payload$classificati, diseaseId = payload.diseaseId, _payload$diseases = payload.diseases, diseases = _payload$diseases === void 0 ? [] : _payload$diseases, _payload$countryIds = payload.countryIds, countryIds = _payload$countryIds === void 0 ? [] : _payload$countryIds, created_by = payload.created_by;
          _context2.next = 6;
          return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
            body: JSON.stringify({
              db_name: "".concat(process.env.REACT_APP_DB),
              query: queries$1.getAllDiseases(diseaseName, sortField, sortDirection, icd10, classification, diseaseId, diseases, countryIds, created_by)
            })
          }));

        case 6:
          _ = _context2.sent;
          _context2.next = 9;
          return _.json();

        case 9:
          _ = _context2.sent;
          return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: _
          }));

        case 13:
          _context2.prev = 13;
          _context2.t0 = _context2["catch"](2);
          return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context2.t0.message
          })));

        case 16:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[2, 13]]);
})));
var SUGGESTIVE_SEARCH_ALL_DISEASES = createAsyncThunk("diseaseSlice/suggestiveSearchgetAllDiseases", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
  var payload,
      _ref6,
      rejectWithValue,
      _payload$diseaseName2,
      diseaseName,
      _payload$sortField2,
      sortField,
      _payload$sortDirectio2,
      sortDirection,
      _payload$icd2,
      icd10,
      _payload$classificati2,
      classification,
      diseaseId,
      _,
      _args3 = arguments;

  return regeneratorRuntime.wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
          _ref6 = _args3.length > 1 ? _args3[1] : undefined, rejectWithValue = _ref6.rejectWithValue;
          _context3.prev = 2;
          _payload$diseaseName2 = payload.diseaseName, diseaseName = _payload$diseaseName2 === void 0 ? "" : _payload$diseaseName2, _payload$sortField2 = payload.sortField, sortField = _payload$sortField2 === void 0 ? 'disease_name' : _payload$sortField2, _payload$sortDirectio2 = payload.sortDirection, sortDirection = _payload$sortDirectio2 === void 0 ? 'ASC' : _payload$sortDirectio2, _payload$icd2 = payload.icd10, icd10 = _payload$icd2 === void 0 ? [] : _payload$icd2, _payload$classificati2 = payload.classification, classification = _payload$classificati2 === void 0 ? [] : _payload$classificati2, diseaseId = payload.diseaseId;
          _context3.next = 6;
          return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
            body: JSON.stringify({
              db_name: "".concat(process.env.REACT_APP_DB),
              query: queries$1.getAllDiseases(diseaseName, sortField, sortDirection, icd10, classification, diseaseId)
            })
          }));

        case 6:
          _ = _context3.sent;
          _context3.next = 9;
          return _.json();

        case 9:
          _ = _context3.sent;
          return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: _
          }));

        case 13:
          _context3.prev = 13;
          _context3.t0 = _context3["catch"](2);
          return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context3.t0.message
          })));

        case 16:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3, null, [[2, 13]]);
})));
var GET_ALL_ICD10CODE = createAsyncThunk("diseaseSlice/getAllICD10Code", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
  var payload,
      _ref8,
      rejectWithValue,
      _,
      _args4 = arguments;

  return regeneratorRuntime.wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
          _ref8 = _args4.length > 1 ? _args4[1] : undefined, rejectWithValue = _ref8.rejectWithValue;
          _context4.prev = 2;
          _context4.next = 5;
          return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
            body: JSON.stringify({
              db_name: "".concat(process.env.REACT_APP_DB),
              query: queries$1.getAllICD10Code()
            })
          }));

        case 5:
          _ = _context4.sent;
          _context4.next = 8;
          return _.json();

        case 8:
          _ = _context4.sent;
          return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: _
          }));

        case 12:
          _context4.prev = 12;
          _context4.t0 = _context4["catch"](2);
          return _context4.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context4.t0.message
          })));

        case 15:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, null, [[2, 12]]);
})));
var GET_ALL_DISEASES_CLASSIFICATION = createAsyncThunk("diseaseSlice/getAllDiseasesClassification", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
  var payload,
      _ref10,
      rejectWithValue,
      _,
      _args5 = arguments;

  return regeneratorRuntime.wrap(function _callee5$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          payload = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
          _ref10 = _args5.length > 1 ? _args5[1] : undefined, rejectWithValue = _ref10.rejectWithValue;
          _context5.prev = 2;
          _context5.next = 5;
          return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
            body: JSON.stringify({
              db_name: "".concat(process.env.REACT_APP_DB),
              query: queries$1.getAllDiseasesClassification()
            })
          }));

        case 5:
          _ = _context5.sent;
          _context5.next = 8;
          return _.json();

        case 8:
          _ = _context5.sent;
          return _context5.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: _
          }));

        case 12:
          _context5.prev = 12;
          _context5.t0 = _context5["catch"](2);
          return _context5.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context5.t0.message
          })));

        case 15:
        case "end":
          return _context5.stop();
      }
    }
  }, _callee5, null, [[2, 12]]);
})));
var diseaseSlice = createSlice({
  name: "diseaseSlice",
  initialState: {
    getAllDiseases: _objectSpread2({}, defaultState.List),
    suggestiveSearchgetAllDiseases: _objectSpread2({}, defaultState.List),
    upsertDisease: _objectSpread2({}, defaultState.Info),
    getAllICD10Code: _objectSpread2({}, defaultState.List),
    getAllDiseasesClassification: _objectSpread2({}, defaultState.List)
  },
  extraReducers: (_extraReducers$1 = {}, _defineProperty(_extraReducers$1, GET_ALL_DISEASES_CLASSIFICATION.fulfilled, function (state, action) {
    var _action$payload;

    state.getAllDiseasesClassification = (_action$payload = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload !== void 0 ? _action$payload : {};
  }), _defineProperty(_extraReducers$1, GET_ALL_DISEASES_CLASSIFICATION.pending, function (state, action) {
    state.getAllDiseasesClassification.loading = true;
  }), _defineProperty(_extraReducers$1, GET_ALL_DISEASES_CLASSIFICATION.rejected, function (state, action) {
    var _action$payload2;

    state.getAllDiseasesClassification = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$1, GET_ALL_ICD10CODE.fulfilled, function (state, action) {
    var _action$payload3;

    state.getAllICD10Code = (_action$payload3 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload3 !== void 0 ? _action$payload3 : {};
  }), _defineProperty(_extraReducers$1, GET_ALL_ICD10CODE.pending, function (state, action) {
    state.getAllICD10Code.loading = true;
  }), _defineProperty(_extraReducers$1, GET_ALL_ICD10CODE.rejected, function (state, action) {
    var _action$payload4;

    state.getAllICD10Code = (_action$payload4 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload4 !== void 0 ? _action$payload4 : {};
  }), _defineProperty(_extraReducers$1, GET_ALL_DISEASES.fulfilled, function (state, action) {
    var _action$payload5;

    state.getAllDiseases = (_action$payload5 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload5 !== void 0 ? _action$payload5 : {};
  }), _defineProperty(_extraReducers$1, GET_ALL_DISEASES.pending, function (state, action) {
    state.getAllDiseases.loading = true;
  }), _defineProperty(_extraReducers$1, GET_ALL_DISEASES.rejected, function (state, action) {
    var _action$payload6;

    state.getAllDiseases = (_action$payload6 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload6 !== void 0 ? _action$payload6 : {};
  }), _defineProperty(_extraReducers$1, SUGGESTIVE_SEARCH_ALL_DISEASES.fulfilled, function (state, action) {
    var _action$payload7;

    state.suggestiveSearchgetAllDiseases = (_action$payload7 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload7 !== void 0 ? _action$payload7 : {};
  }), _defineProperty(_extraReducers$1, SUGGESTIVE_SEARCH_ALL_DISEASES.pending, function (state, action) {
    state.suggestiveSearchgetAllDiseases.loading = true;
  }), _defineProperty(_extraReducers$1, SUGGESTIVE_SEARCH_ALL_DISEASES.rejected, function (state, action) {
    var _action$payload8;

    state.suggestiveSearchgetAllDiseases = (_action$payload8 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload8 !== void 0 ? _action$payload8 : {};
  }), _defineProperty(_extraReducers$1, UPSERT_DISEASE.fulfilled, function (state, action) {
    var _action$payload9;

    state.upsertDisease = (_action$payload9 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload9 !== void 0 ? _action$payload9 : {};
  }), _defineProperty(_extraReducers$1, UPSERT_DISEASE.pending, function (state, action) {
    state.upsertDisease.loading = true;
  }), _defineProperty(_extraReducers$1, UPSERT_DISEASE.rejected, function (state, action) {
    var _action$payload10;

    state.upsertDisease = (_action$payload10 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload10 !== void 0 ? _action$payload10 : {};
  }), _extraReducers$1)
});
var diseaseActions = {
  GET_ALL_DISEASES: GET_ALL_DISEASES,
  UPSERT_DISEASE: UPSERT_DISEASE,
  GET_ALL_ICD10CODE: GET_ALL_ICD10CODE,
  GET_ALL_DISEASES_CLASSIFICATION: GET_ALL_DISEASES_CLASSIFICATION,
  SUGGESTIVE_SEARCH_ALL_DISEASES: SUGGESTIVE_SEARCH_ALL_DISEASES
};
var diseaseSlice$1 = diseaseSlice.reducer;

var queries$2 = {
  //1. To get all forms
  getAllForms: function getAllForms(formName, sortField, sortDirection, formTypeId, formId, diseases, countryIds, formIds, created_by, clientId, projectId) {
    return "\n            ".concat((diseases === null || diseases === void 0 ? void 0 : diseases.length) > 0 || (countryIds === null || countryIds === void 0 ? void 0 : countryIds.length) > 0 ? "\n                let rlFormIds = (\n                    for rld in rl_disease_form\n                        filter rld.is_active == true\n                        ".concat((diseases === null || diseases === void 0 ? void 0 : diseases.length) > 0 ? "filter rld.disease_id in ".concat(JSON.stringify(diseases)) : "", "\n                        ").concat((countryIds === null || countryIds === void 0 ? void 0 : countryIds.length) > 0 ? "filter rld.country_id in ".concat(JSON.stringify(countryIds)) : "", "\n                        return rld.form_id\n                )\n            ") : "", "\n\n            for doc in forms \n                filter doc.projectId == \"").concat(projectId, "\" && doc.clientId == \"").concat(clientId, "\"  && doc.is_active == true \n                ").concat(created_by ? "|| doc.created_by == \"".concat(created_by, "\"") : "", "\n                ").concat(formName ? "FILTER UPPER(doc.form_name) like \"".concat(formName.toUpperCase(), "%\"") : "", "\n                ").concat(formTypeId ? "&& doc.form_type_id == \"".concat(formTypeId, "\"") : "", "\n                ").concat(formId ? "FILTER doc.form_id == \"".concat(formId, "\"") : "", "\n                ").concat((diseases === null || diseases === void 0 ? void 0 : diseases.length) > 0 || (countryIds === null || countryIds === void 0 ? void 0 : countryIds.length) > 0 ? "filter doc.form_id in rlFormIds" : "", "\n                ").concat((formIds === null || formIds === void 0 ? void 0 : formIds.length) > 0 ? "|| doc.form_id in ".concat(JSON.stringify(formIds)) : "", "\n                SORT doc.").concat(sortField, " ").concat(sortDirection, "  \n                LET types = (\n                    for ms in master_form_types \n                    filter ms.form_type_id == doc.form_type_id \n                        return {\n                            form_type_name : ms.form_type_name ,\n                            form_type_id: ms.form_type_id\n                        }\n                )\n                return { \n                    form_id : doc.form_id , \n                    form_name: doc.form_name , \n                    form_type:types[0] , \n                    created_at : doc.created_at , \n                    updated_at: doc.updated_at,\n                    notification_count: LENGTH(\n                        for entry in form_entries\n                            filter entry.form_id == doc.form_id\n                            return entry\n                    ) \n                }\n        ");
  },
  //2. To get all form types
  getAllFormTypes: function getAllFormTypes() {
    return "\n        FOR doc in master_form_types \n            FILTER doc.is_active == true \n            return doc\n        ";
  },
  //3. To get a form detail
  getFormDetailById: function getFormDetailById(formId) {
    return "\n            for doc in forms \n                filter doc.form_id == \"".concat(formId, "\" && doc.is_active == true\n                let formType = (\n                    for d1 in master_form_types \n                    filter d1.form_type_id == doc.form_type_id \n                    return { \n                        type: d1.form_type_name \n                    } \n                ) \n                return { \n                    form : { \n                        title: doc.form_name, \n                        formType :formType[0] ? formType[0] : {},\n                        mapped_diseases: (\n                            for mapForm in rl_disease_form\n                                filter mapForm.is_active == true && mapForm.form_id == doc.form_id\n                                    return FIRST(for mapForm_disease in master_disease\n                                        filter mapForm_disease.is_active == true && mapForm_disease.disease_id == mapForm.disease_id\n                                            return {\n                                                disease_name: mapForm_disease.disease_name,\n                                                disease_definition: mapForm_disease.disease_definition\n                                            }\n                                    )       \n                        )  \n                    } \n                }\n        ");
  },
  //4. To get a ui components of the form
  getFormComponents: function getFormComponents() {
    return "\n        for compType in master_component_types\n            filter compType.is_active == true\n            return {\n                value:compType.component_value,\n                label:compType.component_name\n            }\n        ";
  },
  //5. To get all form tree
  getFormTree: function getFormTree(form_id) {
    if (!form_id) return "";
    return "for doc in forms \n            filter doc.form_id == \"".concat(form_id, "\"\n            for vertices , edges , paths in OUTBOUND CONCAT(\"forms/\" ,doc.form_id ) edge_form_section\n                filter vertices.parent_section_id == null && vertices.is_active == true\n                sort vertices.priority ASC\n                return {\n                    id: vertices.section_id,\n                    form_id: vertices.form_id,\n                    is_form: vertices.is_form,\n                    section_name : vertices.section_name,\n                    priority: vertices.priority,\n                    is_skippable: vertices.is_skippable ? vertices.is_skippable :  false,\n                    is_smart_skip: vertices.is_smart_skip ? vertices.is_smart_skip : false,\n                    parent_section_id: vertices.parent_section_id,\n                    is_investigator_section: vertices.is_investigator_section,\n                    section_type: vertices.section_type,\n                    level: 1,\n                    is_active: vertices.is_active,\n                    created_by: vertices.created_at,\n                    updated_by: vertices.updated_at,\n                    child_sections: (\n                        for childSection1 in section\n                        filter childSection1.parent_section_id == vertices.section_id && childSection1.is_active == true\n                        sort childSection1.priority ASC\n                            return {\n                                id: childSection1.section_id,\n                                form_id: childSection1.form_id,\n                                is_form: childSection1.is_form,\n                                section_name : childSection1.section_name,\n                                priority: childSection1.priority,\n                                is_skippable: childSection1.is_skippable ? childSection1.is_skippable :  false,\n                                is_smart_skip: childSection1.is_smart_skip ? childSection1.is_smart_skip : false,\n                                parent_section_id: childSection1.parent_section_id,\n                                is_investigator_section: childSection1.is_investigator_section,\n                                section_type: childSection1.section_type,\n                                level: 2,\n                                is_active: childSection1.is_active,\n                                created_by: childSection1.created_at,\n                                updated_by: childSection1.updated_at,\n                                child_sections: (\n                                    for childSection2 in section\n                                    filter childSection2.parent_section_id == childSection1.section_id && childSection2.is_active == true\n                                    sort childSection2.priority ASC\n                                        return {\n                                            id: childSection2.section_id,\n                                            form_id: childSection2.form_id,\n                                            is_form: childSection2.is_form,\n                                            section_name : childSection2.section_name,\n                                            priority: childSection2.priority,\n                                            is_skippable: childSection2.is_skippable ? childSection2.is_skippable :  false,\n                                            is_smart_skip: childSection2.is_smart_skip ? childSection2.is_smart_skip : false,\n                                            parent_section_id: childSection2.parent_section_id,\n                                            is_investigator_section: childSection2.is_investigator_section,\n                                            section_type: childSection2.section_type,\n                                            level: 3,\n                                            is_active: childSection2.is_active,\n                                            created_by: childSection2.created_at,\n                                            updated_by: childSection2.updated_at,\n                                            child_sections: (\n                                                for childSection3 in section\n                                                filter childSection3.parent_section_id == childSection2.section_id && childSection3.is_active == true\n                                                sort childSection3.priority ASC\n                                                    return  {\n                                                        id: childSection3.section_id,\n                                                        form_id: childSection3.form_id,\n                                                        is_form: childSection3.is_form,\n                                                        section_name : childSection3.section_name,\n                                                        priority: childSection3.priority,\n                                                        is_skippable: childSection3.is_skippable ? childSection3.is_skippable :  false,\n                                                        is_smart_skip: childSection3.is_smart_skip ? childSection3.is_smart_skip : false,\n                                                        parent_section_id: childSection3.parent_section_id,\n                                                        is_investigator_section: childSection3.is_investigator_section,\n                                                        section_type: childSection3.section_type,\n                                                        level: 3,\n                                                        is_active: childSection3.is_active,\n                                                        created_by: childSection3.created_at,\n                                                        updated_by: childSection3.updated_at\n                                                    }\n                                            )\n                                        }\n                                )\n                            }\n                    )\n            }\n        ");
  },
  //6. To get all section components
  getSectionComponents: function getSectionComponents(section_id) {
    if (!section_id) return "";
    return "for sec in section\n    filter sec.section_id == \"".concat(section_id, "\"\n        return {\n            section_id:sec.section_id,\n            section_name:sec.section_name,\n            is_skippable:sec.is_skippable,\n            is_smart_skip:sec.is_smart_skip ? sec.is_smart_skip : false,\n            smart_question: sec.smart_question,\n            description: sec.description,\n            formLayoutType:sec.formLayoutType,\n            questions: (\n                for qn in questions \n                    filter qn.is_active == true && qn.section_id == \"").concat(section_id, "\"\n                    sort qn.priority asc\n                        return {\n                            id: qn.question_id,\n                            is_required: qn.is_required,\n                            ui_component: qn.ui_component,\n                            priority: qn.priority,\n                            question: qn.question_name,\n                            question_options: qn.options?qn.options : [],\n                            tag: qn.tag,\n                            has_dependency_qn: qn.has_dependency_qn,\n                            dependencies: qn.dependency ? qn.dependency : [],\n                            tableScheme:qn.table_scheme,\n                            validation: qn.validation,\n                        }\n            )\n        }");
  },
  //7. To get template forms
  getTemplateForm: function getTemplateForm() {
    return "\n        for form in form_template\n        filter form.is_active == true\n            return  merge(form,{\n                value:form.form_template_id,\n                label:form.template_name\n            })\n        ";
  },
  // 8. duplicate form check
  duplicateFormCheck: function duplicateFormCheck(form_Name) {
    return "\n           for fd in forms \n                 FILTER fd.is_active == true && UPPER(fd.form_name) == \"".concat(form_Name.toUpperCase(), "\"\n                 return fd\n    ");
  }
};

var _extraReducers$2;
var UPSERT_FORM = createAsyncThunk("formSlice/upsertForm", /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(payload, _ref) {
    var _getState, _getState$authSlice, _getState$authSlice$l, _getState$authSlice$l2;

    var rejectWithValue, getState, user_profile_id, formId, formName, isActive, formTypeId, projectId, clientId, _uniqCheck, uniqCheck, doc, _;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            rejectWithValue = _ref.rejectWithValue, getState = _ref.getState;
            user_profile_id = (_getState = getState()) === null || _getState === void 0 ? void 0 : (_getState$authSlice = _getState.authSlice) === null || _getState$authSlice === void 0 ? void 0 : (_getState$authSlice$l = _getState$authSlice.login) === null || _getState$authSlice$l === void 0 ? void 0 : (_getState$authSlice$l2 = _getState$authSlice$l.data) === null || _getState$authSlice$l2 === void 0 ? void 0 : _getState$authSlice$l2.user_profile_id;
            _context.prev = 2;
            formId = payload.formId, formName = payload.formName, isActive = payload.isActive, formTypeId = payload.formTypeId, projectId = payload.projectId, clientId = payload.clientId;

            if (!formName) {
              _context.next = 13;
              break;
            }

            _context.next = 7;
            return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
              body: JSON.stringify({
                db_name: "".concat(process.env.REACT_APP_DB),
                query: queries$2.duplicateFormCheck(formName.trim())
              })
            }));

          case 7:
            uniqCheck = _context.sent;
            _context.next = 10;
            return uniqCheck.json();

          case 10:
            uniqCheck = _context.sent;

            if (!(((_uniqCheck = uniqCheck) === null || _uniqCheck === void 0 ? void 0 : _uniqCheck.length) !== 0)) {
              _context.next = 13;
              break;
            }

            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
              data: [],
              error: true,
              message: "Form Already Exist !"
            }));

          case 13:
            doc = {};
            doc.form_id = formId ? formId : v4();
            doc._key = doc.form_id;
            doc.clientId = clientId;
            doc.projectId = projectId;

            if (formId) {
              if (isActive !== null) {
                doc.is_active = isActive;
              }
            } else {
              doc.is_active = true;
            }

            doc.form_type_id = formTypeId;

            if (formName) {
              doc.form_name = formName.trim();
            }

            if (!formId) {
              doc.created_at = new Date().toISOString();
              doc.created_by = user_profile_id ? user_profile_id : "user profile id not available";
            }

            doc.updated_at = new Date().toISOString();
            doc.updated_by = user_profile_id ? user_profile_id : "user profile id not available";
            _context.next = 26;
            return fetch("".concat(__baseUrl__, "/upsert_document"), _objectSpread2(_objectSpread2({}, __options()), {}, {
              body: JSON.stringify([_objectSpread2(_objectSpread2({}, upsertQuery.upsertForm), {}, {
                filter: {
                  form_id: formId
                },
                doc: doc
              })])
            }));

          case 26:
            _ = _context.sent;
            _context.next = 29;
            return _.json();

          case 29:
            _ = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
              data: _
            }));

          case 33:
            _context.prev = 33;
            _context.t0 = _context["catch"](2);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 36:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 33]]);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());
var UPSERT_SECTION = createAsyncThunk("formSlice/upsertSection", /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(payload, _ref3) {
    var _getState2, _getState2$authSlice, _getState2$authSlice$, _getState2$authSlice$2;

    var rejectWithValue, getState, user_profile_id, formId, sectionId, isSkippable, smartQuestion, sectionName, parentSection, priority, isActive, isEdit, is_form, _payload$is_investiga, is_investigator_section, section_type, doc, sec_id, _, _2, edge_update;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            rejectWithValue = _ref3.rejectWithValue, getState = _ref3.getState;
            user_profile_id = (_getState2 = getState()) === null || _getState2 === void 0 ? void 0 : (_getState2$authSlice = _getState2.authSlice) === null || _getState2$authSlice === void 0 ? void 0 : (_getState2$authSlice$ = _getState2$authSlice.login) === null || _getState2$authSlice$ === void 0 ? void 0 : (_getState2$authSlice$2 = _getState2$authSlice$.data) === null || _getState2$authSlice$2 === void 0 ? void 0 : _getState2$authSlice$2.user_profile_id;
            _context2.prev = 2;
            formId = payload.formId, sectionId = payload.sectionId, isSkippable = payload.isSkippable, smartQuestion = payload.smartQuestion, sectionName = payload.sectionName, parentSection = payload.parentSection, priority = payload.priority, isActive = payload.isActive, isEdit = payload.isEdit, is_form = payload.is_form, _payload$is_investiga = payload.is_investigator_section, is_investigator_section = _payload$is_investiga === void 0 ? false : _payload$is_investiga, section_type = payload.section_type;
            doc = {};
            sec_id = sectionId ? sectionId : v4();
            doc.form_id = formId;
            doc.section_id = sec_id;
            doc._key = sec_id;
            doc.is_investigator_section = is_investigator_section;
            doc.section_type = section_type;

            if (isSkippable != null && typeof isSkippable === "boolean") {
              doc.is_skippable = isSkippable;
            }

            if (typeof smartQuestion === "string" && smartQuestion.length > 0) {
              doc.smart_question = smartQuestion;
            }

            if (typeof sectionName === "string" && sectionName.length > 0) {
              doc.section_name = sectionName.trim();
            }

            if (typeof parentSection === "string" && parentSection.length > 0) {
              doc.parent_section_id = parentSection;
            }

            if (priority != null && typeof priority === "number") {
              doc.priority = priority;
            }

            if (is_form !== null && typeof is_form === "boolean") {
              doc.is_form = is_form;
            }

            if (sectionId) {
              // If Update Handle
              doc.updated_at = new Date().toISOString();

              if (isActive !== null) {
                doc.is_active = isActive;
              }
            } else {
              //  Create Handle
              doc.created_at = new Date().toISOString();
              doc.updated_at = new Date().toISOString();
              doc.created_by = user_profile_id ? user_profile_id : "user profile id not available";
              doc.updated_by = user_profile_id ? user_profile_id : "user profile id not available";
              doc.is_active = true;
            }

            if (!isEdit) {
              _context2.next = 28;
              break;
            }

            _context2.next = 21;
            return fetch("".concat(__baseUrl__, "/upsert_document"), _objectSpread2(_objectSpread2({}, __options()), {}, {
              body: JSON.stringify([_objectSpread2(_objectSpread2({}, upsertQuery.upsertSection), {}, {
                doc: doc,
                filter: {
                  _id: "section/" + sectionId
                }
              })])
            }));

          case 21:
            _ = _context2.sent;
            _context2.next = 24;
            return _.json();

          case 24:
            _ = _context2.sent;
            return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
              data: _
            }));

          case 28:
            _context2.next = 30;
            return fetch("".concat(__baseUrl__, "/upsert_document"), _objectSpread2(_objectSpread2({}, __options()), {}, {
              body: JSON.stringify([_objectSpread2(_objectSpread2({}, upsertQuery.upsertSection), {}, {
                doc: doc,
                filter: {
                  _key: "section/" + sectionId
                }
              })])
            }));

          case 30:
            _2 = _context2.sent;
            _context2.next = 33;
            return _2.json();

          case 33:
            _2 = _context2.sent;
            _context2.next = 36;
            return fetch("".concat(__baseUrl__, "/upsert_document"), _objectSpread2(_objectSpread2({}, __options()), {}, {
              body: JSON.stringify([_objectSpread2(_objectSpread2({}, upsertQuery.upsertEdgeFormSection), {}, {
                doc: {
                  _from: "forms/" + formId,
                  _to: "section/" + sec_id,
                  _key: v4()
                },
                filter: null
              })])
            }));

          case 36:
            edge_update = _context2.sent;
            _context2.next = 39;
            return edge_update.json();

          case 39:
            edge_update = _context2.sent;
            return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
              data: _2
            }));

          case 41:
            _context2.next = 46;
            break;

          case 43:
            _context2.prev = 43;
            _context2.t0 = _context2["catch"](2);
            return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultState.List), {}, {
              message: _context2.t0.message
            })));

          case 46:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[2, 43]]);
  }));

  return function (_x3, _x4) {
    return _ref4.apply(this, arguments);
  };
}());
var UPSERT_QUESTION = createAsyncThunk("formSlice/upsertQuestion", /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(payload, _ref5) {
    var _getState3, _getState3$authSlice, _getState3$authSlice$, _getState3$authSlice$2;

    var rejectWithValue, getState, user_profile_id, _questions$, form_id, section_id, is_skippable, smart_question, is_smart_skip, is_smart_skip_requried, section_name, formLayoutType, description, questions, delQuestions, questionDocs, dependency, _;

    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            rejectWithValue = _ref5.rejectWithValue, getState = _ref5.getState;
            user_profile_id = (_getState3 = getState()) === null || _getState3 === void 0 ? void 0 : (_getState3$authSlice = _getState3.authSlice) === null || _getState3$authSlice === void 0 ? void 0 : (_getState3$authSlice$ = _getState3$authSlice.login) === null || _getState3$authSlice$ === void 0 ? void 0 : (_getState3$authSlice$2 = _getState3$authSlice$.data) === null || _getState3$authSlice$2 === void 0 ? void 0 : _getState3$authSlice$2.user_profile_id;
            _context3.prev = 2;
            form_id = payload.form_id, section_id = payload.section_id, is_skippable = payload.is_skippable, smart_question = payload.smart_question, is_smart_skip = payload.is_smart_skip, is_smart_skip_requried = payload.is_smart_skip_requried, section_name = payload.section_name, formLayoutType = payload.formLayoutType, description = payload.description, questions = payload.questions, delQuestions = payload.delQuestions;
            questionDocs = [];
            dependency = [];
            delQuestions === null || delQuestions === void 0 ? void 0 : delQuestions.map(function (qn) {
              questionDocs.push(_objectSpread2(_objectSpread2({}, upsertQuery.upsertQuestion), {}, {
                filter: {
                  // "_key": "questions/" + qn.id
                  _key: qn.id
                },
                doc: {
                  is_active: false
                }
              }));
            });
            is_smart_skip = (questions === null || questions === void 0 ? void 0 : (_questions$ = questions[0]) === null || _questions$ === void 0 ? void 0 : _questions$.component) === "popup_switch";
            questions === null || questions === void 0 ? void 0 : questions.map(function (qn, index) {
              var _qn$dependency;

              qn.id = qn.id ? qn.id : v4();
              var updatedDepn = (_qn$dependency = qn.dependency) === null || _qn$dependency === void 0 ? void 0 : _qn$dependency.map(function (dp) {
                var _dp$dependency_id;

                var dependency_id = (_dp$dependency_id = dp === null || dp === void 0 ? void 0 : dp.dependency_id) !== null && _dp$dependency_id !== void 0 ? _dp$dependency_id : v4();
                dependency.push(_objectSpread2(_objectSpread2({}, upsertQuery.upsertDependency), {}, {
                  filter: {
                    _key: dependency_id
                  },
                  doc: {
                    _key: dependency_id,
                    dependency_question_id: dependency_id,
                    section_id: section_id,
                    form_id: form_id,
                    parent_question_id: qn.id,
                    target_question_id: dp.type.value === "question" ? dp.target.value : "",
                    target_form_id: dp.type.value === "form" ? dp.target.value : "",
                    target_section_id: dp.type.value === "section" ? dp.target.value : "",
                    parentQuestion: dp.parentQuestion,
                    option: dp.option,
                    type: dp.type,
                    target: dp.target,
                    created_at: new Date().toISOString(),
                    created_by: user_profile_id,
                    updated_at: new Date().toISOString(),
                    updated_by: user_profile_id,
                    is_active: true
                  }
                }));
                return _objectSpread2({
                  dependency_id: dependency_id
                }, dp);
              });
              questionDocs.push(_objectSpread2(_objectSpread2({}, upsertQuery.upsertQuestion), {}, {
                filter: {
                  // "_key": "questions/" + qn.id
                  _key: qn.id
                },
                doc: {
                  question_name: qn.label,
                  is_required: qn.required,
                  form_id: form_id,
                  section_id: section_id,
                  question_id: qn.id,
                  _key: qn.id,
                  ui_component: qn.component,
                  parent_question_id: qn.parent_question_id,
                  options: qn.options,
                  tag: qn.tag,
                  has_dependency_qn: qn.has_dependency_qn,
                  validation: qn.validation,
                  dependency: updatedDepn,
                  is_active: true,
                  priority: is_smart_skip ? index : index + 1,
                  table_scheme: qn.tableScheme,
                  created_at: new Date().toISOString(),
                  updated_at: new Date().toISOString(),
                  created_by: user_profile_id ? user_profile_id : "user profile id not available",
                  updated_by: user_profile_id ? user_profile_id : "user profile id not available"
                }
              }));
            });
            _context3.next = 11;
            return fetch("".concat(__baseUrl__, "/upsert_document"), _objectSpread2(_objectSpread2({}, __options()), {}, {
              body: JSON.stringify([_objectSpread2(_objectSpread2({}, upsertQuery.upsertSection), {}, {
                filter: {
                  // "_key": "section/" + section_id
                  _key: section_id
                },
                doc: {
                  is_skippable: is_skippable,
                  smart_question: smart_question,
                  is_smart_skip: is_smart_skip,
                  is_smart_skip_requried: is_smart_skip_requried,
                  section_name: section_name,
                  formLayoutType: formLayoutType,
                  description: description
                }
              })].concat(questionDocs, dependency))
            }));

          case 11:
            _ = _context3.sent;
            _context3.next = 14;
            return _.json();

          case 14:
            _ = _context3.sent;
            return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
              data: _
            }));

          case 18:
            _context3.prev = 18;
            _context3.t0 = _context3["catch"](2);
            return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context3.t0.message
            })));

          case 21:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[2, 18]]);
  }));

  return function (_x5, _x6) {
    return _ref6.apply(this, arguments);
  };
}());
var UPSERT_FORM_TEMPLATE = createAsyncThunk("formSlice/upsertFormTemplate", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
  var payload,
      _ref8,
      rejectWithValue,
      getState,
      _getState4,
      _getState4$authSlice,
      _getState4$authSlice$,
      _getState4$authSlice$2,
      formTemplateId,
      templateName,
      Questions,
      isActive,
      user_profile_id,
      doc,
      form_template_id,
      _,
      _args4 = arguments;

  return regeneratorRuntime.wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
          _ref8 = _args4.length > 1 ? _args4[1] : undefined, rejectWithValue = _ref8.rejectWithValue, getState = _ref8.getState;
          _context4.prev = 2;
          formTemplateId = payload.formTemplateId, templateName = payload.templateName, Questions = payload.Questions, isActive = payload.isActive;
          user_profile_id = (_getState4 = getState()) === null || _getState4 === void 0 ? void 0 : (_getState4$authSlice = _getState4.authSlice) === null || _getState4$authSlice === void 0 ? void 0 : (_getState4$authSlice$ = _getState4$authSlice.login) === null || _getState4$authSlice$ === void 0 ? void 0 : (_getState4$authSlice$2 = _getState4$authSlice$.data) === null || _getState4$authSlice$2 === void 0 ? void 0 : _getState4$authSlice$2.user_profile_id;
          doc = {};

          if (!formTemplateId) {
            doc.created_at = new Date().toISOString();
            doc.created_by = user_profile_id ? user_profile_id : "user profile id not available";
          }

          doc.updated_at = new Date().toISOString();
          doc.updated_by = user_profile_id ? user_profile_id : "user profile id not available";
          form_template_id = formTemplateId ? formTemplateId : v4();
          doc._key = form_template_id;
          doc.is_active = isActive;
          doc.form_template_id = form_template_id;
          doc.template_name = templateName;
          doc.questions = Questions;
          _context4.next = 17;
          return fetch("".concat(__baseUrl__, "/upsert_document"), _objectSpread2(_objectSpread2({}, __options()), {}, {
            body: JSON.stringify([_objectSpread2(_objectSpread2({}, upsertQuery.upsertTemplateForm), {}, {
              filter: {
                _key: form_template_id
              },
              doc: doc
            })])
          }));

        case 17:
          _ = _context4.sent;
          _context4.next = 20;
          return _.json();

        case 20:
          _ = _context4.sent;
          return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: _
          }));

        case 24:
          _context4.prev = 24;
          _context4.t0 = _context4["catch"](2);
          return _context4.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context4.t0.message
          })));

        case 27:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, null, [[2, 24]]);
})));
var GET_FORM_TEMPLATE = createAsyncThunk("roleSlice/getFormTemplate", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
  var payload,
      _ref10,
      rejectWithValue,
      _,
      _args5 = arguments;

  return regeneratorRuntime.wrap(function _callee5$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          payload = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
          _ref10 = _args5.length > 1 ? _args5[1] : undefined, rejectWithValue = _ref10.rejectWithValue;
          _context5.prev = 2;
          _context5.next = 5;
          return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
            body: JSON.stringify({
              db_name: "".concat(process.env.REACT_APP_DB),
              query: queries$2.getTemplateForm()
            })
          }));

        case 5:
          _ = _context5.sent;
          _context5.next = 8;
          return _.json();

        case 8:
          _ = _context5.sent;
          return _context5.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: _
          }));

        case 12:
          _context5.prev = 12;
          _context5.t0 = _context5["catch"](2);
          return _context5.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context5.t0.message
          })));

        case 15:
        case "end":
          return _context5.stop();
      }
    }
  }, _callee5, null, [[2, 12]]);
})));
var GET_ALL_FORMS = createAsyncThunk("formSlice/getAllForms", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
  var payload,
      _ref12,
      rejectWithValue,
      _payload$formName,
      formName,
      _payload$sortField,
      sortField,
      _payload$sortDirectio,
      sortDirection,
      formTypeId,
      formId,
      _payload$diseases,
      diseases,
      _payload$countryIds,
      countryIds,
      _payload$formIds,
      formIds,
      created_by,
      clientId,
      projectId,
      _,
      _args6 = arguments;

  return regeneratorRuntime.wrap(function _callee6$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          payload = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {};
          _ref12 = _args6.length > 1 ? _args6[1] : undefined, rejectWithValue = _ref12.rejectWithValue;
          _context6.prev = 2;
          _payload$formName = payload.formName, formName = _payload$formName === void 0 ? "" : _payload$formName, _payload$sortField = payload.sortField, sortField = _payload$sortField === void 0 ? "form_name" : _payload$sortField, _payload$sortDirectio = payload.sortDirection, sortDirection = _payload$sortDirectio === void 0 ? "ASC" : _payload$sortDirectio, formTypeId = payload.formTypeId, formId = payload.formId, _payload$diseases = payload.diseases, diseases = _payload$diseases === void 0 ? [] : _payload$diseases, _payload$countryIds = payload.countryIds, countryIds = _payload$countryIds === void 0 ? [] : _payload$countryIds, _payload$formIds = payload.formIds, formIds = _payload$formIds === void 0 ? [] : _payload$formIds, created_by = payload.created_by, clientId = payload.clientId, projectId = payload.projectId;
          _context6.next = 6;
          return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
            body: JSON.stringify({
              db_name: "".concat(process.env.REACT_APP_DB),
              query: queries$2.getAllForms(formName, sortField, sortDirection, formTypeId, formId, diseases, countryIds, formIds, created_by, clientId, projectId)
            })
          }));

        case 6:
          _ = _context6.sent;
          _context6.next = 9;
          return _.json();

        case 9:
          _ = _context6.sent;
          return _context6.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: _
          }));

        case 13:
          _context6.prev = 13;
          _context6.t0 = _context6["catch"](2);
          return _context6.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context6.t0.message
          })));

        case 16:
        case "end":
          return _context6.stop();
      }
    }
  }, _callee6, null, [[2, 13]]);
})));
var SUGESTIVE_SEARCH_ALL_FORMS = createAsyncThunk("formSlice/sugestiveSearchAllForms", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
  var payload,
      _ref14,
      rejectWithValue,
      _payload$formName2,
      formName,
      _payload$sortField2,
      sortField,
      _payload$sortDirectio2,
      sortDirection,
      formTypeId,
      formId,
      _,
      _args7 = arguments;

  return regeneratorRuntime.wrap(function _callee7$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          payload = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {};
          _ref14 = _args7.length > 1 ? _args7[1] : undefined, rejectWithValue = _ref14.rejectWithValue;
          _context7.prev = 2;
          _payload$formName2 = payload.formName, formName = _payload$formName2 === void 0 ? "" : _payload$formName2, _payload$sortField2 = payload.sortField, sortField = _payload$sortField2 === void 0 ? "form_name" : _payload$sortField2, _payload$sortDirectio2 = payload.sortDirection, sortDirection = _payload$sortDirectio2 === void 0 ? "ASC" : _payload$sortDirectio2, formTypeId = payload.formTypeId, formId = payload.formId;
          _context7.next = 6;
          return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
            body: JSON.stringify({
              db_name: "".concat(process.env.REACT_APP_DB),
              query: queries$2.getAllForms(formName, sortField, sortDirection, formTypeId, formId)
            })
          }));

        case 6:
          _ = _context7.sent;
          _context7.next = 9;
          return _.json();

        case 9:
          _ = _context7.sent;
          return _context7.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: _
          }));

        case 13:
          _context7.prev = 13;
          _context7.t0 = _context7["catch"](2);
          return _context7.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context7.t0.message
          })));

        case 16:
        case "end":
          return _context7.stop();
      }
    }
  }, _callee7, null, [[2, 13]]);
})));
var GET_ALL_FORM_TYPES = createAsyncThunk("formSlice/getAllFormTypes", /*#__PURE__*/function () {
  var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(payload, _ref15) {
    var rejectWithValue, _;

    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            rejectWithValue = _ref15.rejectWithValue;
            _context8.prev = 1;
            _context8.next = 4;
            return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
              body: JSON.stringify({
                db_name: "".concat(process.env.REACT_APP_DB),
                query: queries$2.getAllFormTypes()
              })
            }));

          case 4:
            _ = _context8.sent;
            _context8.next = 7;
            return _.json();

          case 7:
            _ = _context8.sent;
            return _context8.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
              data: _
            }));

          case 11:
            _context8.prev = 11;
            _context8.t0 = _context8["catch"](1);
            return _context8.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context8.t0.message
            })));

          case 14:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[1, 11]]);
  }));

  return function (_x7, _x8) {
    return _ref16.apply(this, arguments);
  };
}());
var GET_FORM_DETAIL_BY_ID = createAsyncThunk("formSlice/getFormDetailById", /*#__PURE__*/function () {
  var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(payload, _ref17) {
    var rejectWithValue, _$0$form, _$, form_id, _;

    return regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            rejectWithValue = _ref17.rejectWithValue;
            _context9.prev = 1;
            form_id = payload.form_id;
            _context9.next = 5;
            return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
              body: JSON.stringify({
                db_name: "".concat(process.env.REACT_APP_DB),
                query: queries$2.getFormDetailById(form_id)
              })
            }));

          case 5:
            _ = _context9.sent;
            _context9.next = 8;
            return _.json();

          case 8:
            _ = _context9.sent;
            _ = (_$0$form = (_$ = _[0]) === null || _$ === void 0 ? void 0 : _$.form) !== null && _$0$form !== void 0 ? _$0$form : {};
            return _context9.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
              data: _
            }));

          case 13:
            _context9.prev = 13;
            _context9.t0 = _context9["catch"](1);
            return _context9.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context9.t0.message
            })));

          case 16:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[1, 13]]);
  }));

  return function (_x9, _x10) {
    return _ref18.apply(this, arguments);
  };
}());
var GET_FORM_COMPONENTS = createAsyncThunk("formSlice/getFormComponents", /*#__PURE__*/function () {
  var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(payload, _ref19) {
    var rejectWithValue, _;

    return regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            rejectWithValue = _ref19.rejectWithValue;
            _context10.prev = 1;
            _context10.next = 4;
            return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
              body: JSON.stringify({
                db_name: "".concat(process.env.REACT_APP_DB),
                query: queries$2.getFormComponents()
              })
            }));

          case 4:
            _ = _context10.sent;
            _context10.next = 7;
            return _.json();

          case 7:
            _ = _context10.sent;
            return _context10.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
              data: _
            }));

          case 11:
            _context10.prev = 11;
            _context10.t0 = _context10["catch"](1);
            return _context10.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context10.t0.message
            })));

          case 14:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[1, 11]]);
  }));

  return function (_x11, _x12) {
    return _ref20.apply(this, arguments);
  };
}());
var GET_FORM_TREE = createAsyncThunk("formSlice/getFormTree", /*#__PURE__*/function () {
  var _ref22 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(payload, _ref21) {
    var rejectWithValue, form_id, _;

    return regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            rejectWithValue = _ref21.rejectWithValue;
            _context11.prev = 1;
            form_id = payload.form_id;
            _context11.next = 5;
            return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
              body: JSON.stringify({
                db_name: "".concat(process.env.REACT_APP_DB),
                query: queries$2.getFormTree(form_id)
              })
            }));

          case 5:
            _ = _context11.sent;
            _context11.next = 8;
            return _.json();

          case 8:
            _ = _context11.sent;
            return _context11.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
              data: _
            }));

          case 12:
            _context11.prev = 12;
            _context11.t0 = _context11["catch"](1);
            return _context11.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context11.t0.message
            })));

          case 15:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11, null, [[1, 12]]);
  }));

  return function (_x13, _x14) {
    return _ref22.apply(this, arguments);
  };
}());
var GET_SECTION_COMPONENTS = createAsyncThunk("formSlice/getSectionComponents", /*#__PURE__*/function () {
  var _ref24 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(payload, _ref23) {
    var rejectWithValue, section_id, _;

    return regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            rejectWithValue = _ref23.rejectWithValue;
            _context12.prev = 1;
            section_id = payload.section_id;
            _context12.next = 5;
            return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
              body: JSON.stringify({
                db_name: "".concat(process.env.REACT_APP_DB),
                query: queries$2.getSectionComponents(section_id)
              })
            }));

          case 5:
            _ = _context12.sent;
            _context12.next = 8;
            return _.json();

          case 8:
            _ = _context12.sent;
            return _context12.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
              data: _
            }));

          case 12:
            _context12.prev = 12;
            _context12.t0 = _context12["catch"](1);
            return _context12.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context12.t0.message
            })));

          case 15:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12, null, [[1, 12]]);
  }));

  return function (_x15, _x16) {
    return _ref24.apply(this, arguments);
  };
}());
var formSlice = createSlice({
  name: "formSlice",
  initialState: {
    getAllForms: _objectSpread2({}, defaultState.List),
    sugestiveSearchAllForms: _objectSpread2({}, defaultState.List),
    getAllFormTypes: _objectSpread2({}, defaultState.List),
    getFormDetailById: _objectSpread2({}, defaultState.Info),
    getFormComponents: _objectSpread2({}, defaultState.List),
    getFormTree: _objectSpread2({}, defaultState.List),
    getSectionComponents: _objectSpread2({}, defaultState.List),
    getFormTemplate: _objectSpread2({}, defaultState.List),
    upsertForm: _objectSpread2({}, defaultState.Info),
    upsertSection: _objectSpread2({}, defaultState.Info),
    upsertQuestion: _objectSpread2({}, defaultState.Info),
    upsertFormTemplate: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$2 = {}, _defineProperty(_extraReducers$2, GET_ALL_FORMS.fulfilled, function (state, action) {
    var _action$payload;

    state.getAllForms = (_action$payload = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload !== void 0 ? _action$payload : {};
  }), _defineProperty(_extraReducers$2, GET_ALL_FORMS.pending, function (state, action) {
    state.getAllForms.loading = true;
  }), _defineProperty(_extraReducers$2, GET_ALL_FORMS.rejected, function (state, action) {
    var _action$payload2;

    state.getAllForms = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$2, SUGESTIVE_SEARCH_ALL_FORMS.fulfilled, function (state, action) {
    var _action$payload3;

    state.sugestiveSearchAllForms = (_action$payload3 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload3 !== void 0 ? _action$payload3 : {};
  }), _defineProperty(_extraReducers$2, SUGESTIVE_SEARCH_ALL_FORMS.pending, function (state, action) {
    state.sugestiveSearchAllForms.loading = true;
  }), _defineProperty(_extraReducers$2, SUGESTIVE_SEARCH_ALL_FORMS.rejected, function (state, action) {
    var _action$payload4;

    state.sugestiveSearchAllForms = (_action$payload4 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload4 !== void 0 ? _action$payload4 : {};
  }), _defineProperty(_extraReducers$2, GET_ALL_FORM_TYPES.fulfilled, function (state, action) {
    var _action$payload5;

    state.getAllFormTypes = (_action$payload5 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload5 !== void 0 ? _action$payload5 : {};
  }), _defineProperty(_extraReducers$2, GET_ALL_FORM_TYPES.pending, function (state, action) {
    state.getAllFormTypes.loading = true;
  }), _defineProperty(_extraReducers$2, GET_ALL_FORM_TYPES.rejected, function (state, action) {
    var _action$payload6;

    state.getAllFormTypes = (_action$payload6 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload6 !== void 0 ? _action$payload6 : {};
  }), _defineProperty(_extraReducers$2, GET_FORM_DETAIL_BY_ID.fulfilled, function (state, action) {
    var _action$payload7;

    state.getFormDetailById = (_action$payload7 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload7 !== void 0 ? _action$payload7 : {};
  }), _defineProperty(_extraReducers$2, GET_FORM_DETAIL_BY_ID.pending, function (state, action) {
    state.getFormDetailById.loading = true;
  }), _defineProperty(_extraReducers$2, GET_FORM_DETAIL_BY_ID.rejected, function (state, action) {
    var _action$payload8;

    state.getFormDetailById = (_action$payload8 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload8 !== void 0 ? _action$payload8 : {};
  }), _defineProperty(_extraReducers$2, GET_FORM_COMPONENTS.fulfilled, function (state, action) {
    var _action$payload9;

    state.getFormComponents = (_action$payload9 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload9 !== void 0 ? _action$payload9 : {};
  }), _defineProperty(_extraReducers$2, GET_FORM_COMPONENTS.pending, function (state, action) {
    state.getFormComponents.loading = true;
  }), _defineProperty(_extraReducers$2, GET_FORM_COMPONENTS.rejected, function (state, action) {
    var _action$payload10;

    state.getFormComponents = (_action$payload10 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload10 !== void 0 ? _action$payload10 : {};
  }), _defineProperty(_extraReducers$2, GET_FORM_TREE.fulfilled, function (state, action) {
    var _action$payload11;

    state.getSectionComponents = (_action$payload11 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload11 !== void 0 ? _action$payload11 : {};
  }), _defineProperty(_extraReducers$2, GET_FORM_TREE.pending, function (state, action) {
    state.getSectionComponents.loading = true;
  }), _defineProperty(_extraReducers$2, GET_FORM_TREE.rejected, function (state, action) {
    var _action$payload12;

    state.getSectionComponents = (_action$payload12 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload12 !== void 0 ? _action$payload12 : {};
  }), _defineProperty(_extraReducers$2, GET_SECTION_COMPONENTS.fulfilled, function (state, action) {
    var _action$payload13;

    state.getSectionComponents = (_action$payload13 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload13 !== void 0 ? _action$payload13 : {};
  }), _defineProperty(_extraReducers$2, GET_SECTION_COMPONENTS.pending, function (state, action) {
    state.getSectionComponents.loading = true;
  }), _defineProperty(_extraReducers$2, GET_SECTION_COMPONENTS.rejected, function (state, action) {
    var _action$payload14;

    state.getSectionComponents = (_action$payload14 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload14 !== void 0 ? _action$payload14 : {};
  }), _defineProperty(_extraReducers$2, UPSERT_FORM.fulfilled, function (state, action) {
    var _action$payload15;

    state.upsertForm = (_action$payload15 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload15 !== void 0 ? _action$payload15 : {};
  }), _defineProperty(_extraReducers$2, UPSERT_FORM.pending, function (state, action) {
    state.upsertForm.loading = true;
  }), _defineProperty(_extraReducers$2, UPSERT_FORM.rejected, function (state, action) {
    var _action$payload16;

    state.upsertForm = (_action$payload16 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload16 !== void 0 ? _action$payload16 : {};
  }), _defineProperty(_extraReducers$2, UPSERT_SECTION.fulfilled, function (state, action) {
    var _action$payload17;

    state.upsertSection = (_action$payload17 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload17 !== void 0 ? _action$payload17 : {};
  }), _defineProperty(_extraReducers$2, UPSERT_SECTION.pending, function (state, action) {
    state.upsertSection.loading = true;
  }), _defineProperty(_extraReducers$2, UPSERT_SECTION.rejected, function (state, action) {
    var _action$payload18;

    state.upsertSection = (_action$payload18 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload18 !== void 0 ? _action$payload18 : {};
  }), _defineProperty(_extraReducers$2, UPSERT_QUESTION.fulfilled, function (state, action) {
    var _action$payload19;

    state.upsertQuestion = (_action$payload19 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload19 !== void 0 ? _action$payload19 : {};
  }), _defineProperty(_extraReducers$2, UPSERT_QUESTION.pending, function (state, action) {
    state.upsertQuestion.loading = true;
  }), _defineProperty(_extraReducers$2, UPSERT_QUESTION.rejected, function (state, action) {
    var _action$payload20;

    state.upsertQuestion = (_action$payload20 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload20 !== void 0 ? _action$payload20 : {};
  }), _defineProperty(_extraReducers$2, UPSERT_FORM_TEMPLATE.fulfilled, function (state, action) {
    var _action$payload21;

    state.upsertFormTemplate = (_action$payload21 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload21 !== void 0 ? _action$payload21 : {};
  }), _defineProperty(_extraReducers$2, UPSERT_FORM_TEMPLATE.pending, function (state, action) {
    state.upsertFormTemplate.loading = true;
  }), _defineProperty(_extraReducers$2, UPSERT_FORM_TEMPLATE.rejected, function (state, action) {
    var _action$payload22;

    state.upsertFormTemplate = (_action$payload22 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload22 !== void 0 ? _action$payload22 : {};
  }), _defineProperty(_extraReducers$2, GET_FORM_TEMPLATE.fulfilled, function (state, action) {
    var _action$payload23;

    state.getFormTemplate = (_action$payload23 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload23 !== void 0 ? _action$payload23 : {};
  }), _defineProperty(_extraReducers$2, GET_FORM_TEMPLATE.pending, function (state, action) {
    state.getFormTemplate.loading = true;
  }), _defineProperty(_extraReducers$2, GET_FORM_TEMPLATE.rejected, function (state, action) {
    var _action$payload24;

    state.getFormTemplate = (_action$payload24 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload24 !== void 0 ? _action$payload24 : {};
  }), _extraReducers$2)
});
var formActions = {
  GET_ALL_FORMS: GET_ALL_FORMS,
  SUGESTIVE_SEARCH_ALL_FORMS: SUGESTIVE_SEARCH_ALL_FORMS,
  GET_ALL_FORM_TYPES: GET_ALL_FORM_TYPES,
  GET_FORM_DETAIL_BY_ID: GET_FORM_DETAIL_BY_ID,
  GET_FORM_COMPONENTS: GET_FORM_COMPONENTS,
  GET_FORM_TREE: GET_FORM_TREE,
  GET_SECTION_COMPONENTS: GET_SECTION_COMPONENTS,
  GET_FORM_TEMPLATE: GET_FORM_TEMPLATE,
  UPSERT_FORM: UPSERT_FORM,
  UPSERT_SECTION: UPSERT_SECTION,
  UPSERT_QUESTION: UPSERT_QUESTION,
  UPSERT_FORM_TEMPLATE: UPSERT_FORM_TEMPLATE
};
var formSlice$1 = formSlice.reducer;

var giveMeFilterForEntry = function giveMeFilterForEntry(countryIds, level, key) {
  var _level$level, _level$level3, _level$level5, _level$level7, _level$level9, _level$level11, _level$level13, _level$level15, _level$level17, _level$level19, _level$level21, _level$level23;

  var filter = "";

  if (countryIds !== null && countryIds !== void 0 && countryIds.length) {
    countryIds.forEach(function (country) {
      filter += " filter \"".concat(country, "\" in ").concat(key, ".location.country");
    });
  }

  if (level !== null && level !== void 0 && (_level$level = level.level1) !== null && _level$level !== void 0 && _level$level.length) {
    var _level$level2;

    level === null || level === void 0 ? void 0 : (_level$level2 = level.level1) === null || _level$level2 === void 0 ? void 0 : _level$level2.forEach(function (level) {
      filter += " filter \"".concat(level, "\" in ").concat(key, ".location.level1");
    });
  }

  if (level !== null && level !== void 0 && (_level$level3 = level.level2) !== null && _level$level3 !== void 0 && _level$level3.length) {
    var _level$level4;

    level === null || level === void 0 ? void 0 : (_level$level4 = level.level2) === null || _level$level4 === void 0 ? void 0 : _level$level4.forEach(function (level) {
      filter += " filter \"".concat(level, "\" in ").concat(key, ".location.level2");
    });
  }

  if (level !== null && level !== void 0 && (_level$level5 = level.level3) !== null && _level$level5 !== void 0 && _level$level5.length) {
    var _level$level6;

    level === null || level === void 0 ? void 0 : (_level$level6 = level.level3) === null || _level$level6 === void 0 ? void 0 : _level$level6.forEach(function (level) {
      filter += " filter \"".concat(level, "\" in ").concat(key, ".location.level3");
    });
  }

  if (level !== null && level !== void 0 && (_level$level7 = level.level4) !== null && _level$level7 !== void 0 && _level$level7.length) {
    var _level$level8;

    level === null || level === void 0 ? void 0 : (_level$level8 = level.level4) === null || _level$level8 === void 0 ? void 0 : _level$level8.forEach(function (level) {
      filter += " filter \"".concat(level, "\" in ").concat(key, ".location.level4");
    });
  }

  if (level !== null && level !== void 0 && (_level$level9 = level.level5) !== null && _level$level9 !== void 0 && _level$level9.length) {
    var _level$level10;

    level === null || level === void 0 ? void 0 : (_level$level10 = level.level5) === null || _level$level10 === void 0 ? void 0 : _level$level10.forEach(function (level) {
      filter += " filter \"".concat(level, "\" in ").concat(key, ".location.level5");
    });
  }

  if (level !== null && level !== void 0 && (_level$level11 = level.level6) !== null && _level$level11 !== void 0 && _level$level11.length) {
    var _level$level12;

    level === null || level === void 0 ? void 0 : (_level$level12 = level.level6) === null || _level$level12 === void 0 ? void 0 : _level$level12.forEach(function (level) {
      filter += " filter \"".concat(level, "\" in ").concat(key, ".location.level6");
    });
  }

  if (level !== null && level !== void 0 && (_level$level13 = level.level7) !== null && _level$level13 !== void 0 && _level$level13.length) {
    var _level$level14;

    level === null || level === void 0 ? void 0 : (_level$level14 = level.level7) === null || _level$level14 === void 0 ? void 0 : _level$level14.forEach(function (level) {
      filter += " filter \"".concat(level, "\" in ").concat(key, ".location.level7");
    });
  }

  if (level !== null && level !== void 0 && (_level$level15 = level.level8) !== null && _level$level15 !== void 0 && _level$level15.length) {
    var _level$level16;

    level === null || level === void 0 ? void 0 : (_level$level16 = level.level8) === null || _level$level16 === void 0 ? void 0 : _level$level16.forEach(function (level) {
      filter += " filter \"".concat(level, "\" in ").concat(key, ".location.level8");
    });
  }

  if (level !== null && level !== void 0 && (_level$level17 = level.level9) !== null && _level$level17 !== void 0 && _level$level17.length) {
    var _level$level18;

    level === null || level === void 0 ? void 0 : (_level$level18 = level.level9) === null || _level$level18 === void 0 ? void 0 : _level$level18.forEach(function (level) {
      filter += " filter \"".concat(level, "\" in ").concat(key, ".location.level9");
    });
  }

  if (level !== null && level !== void 0 && (_level$level19 = level.level10) !== null && _level$level19 !== void 0 && _level$level19.length) {
    var _level$level20;

    level === null || level === void 0 ? void 0 : (_level$level20 = level.level10) === null || _level$level20 === void 0 ? void 0 : _level$level20.forEach(function (level) {
      filter += " filter \"".concat(level, "\" in ").concat(key, ".location.level10");
    });
  }

  if (level !== null && level !== void 0 && (_level$level21 = level.level11) !== null && _level$level21 !== void 0 && _level$level21.length) {
    var _level$level22;

    level === null || level === void 0 ? void 0 : (_level$level22 = level.level11) === null || _level$level22 === void 0 ? void 0 : _level$level22.forEach(function (level) {
      filter += " filter \"".concat(level, "\" in ").concat(key, ".location.level11");
    });
  }

  if (level !== null && level !== void 0 && (_level$level23 = level.level12) !== null && _level$level23 !== void 0 && _level$level23.length) {
    var _level$level24;

    level === null || level === void 0 ? void 0 : (_level$level24 = level.level12) === null || _level$level24 === void 0 ? void 0 : _level$level24.forEach(function (level) {
      filter += " filter \"".concat(level, "\" in ").concat(key, ".location.level12");
    });
  }

  return filter;
};
var patientDataColumn = [{
  type: "patient_name",
  title: "Patient Name",
  label: "Patient Name",
  field: "patient_name",
  value: "patient_name",
  width: "166px"
}, {
  type: "age_gender",
  title: "Gender & Age",
  label: "Gender & Age",
  field: "age_gender",
  value: "age_gender"
}, {
  type: "contact",
  title: "Mobile & Email",
  label: "Mobile & Email",
  field: "mobile",
  value: "mobile"
}];
var queries$3 = {
  //1. To get all forms
  getAllNotifiableForms: function getAllNotifiableForms(formName, sortField, sortDirection, formTypeId, formId) {
    var icd10 = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
    var classification = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
    var forms = arguments.length > 7 ? arguments[7] : undefined;
    var created_by = arguments.length > 8 ? arguments[8] : undefined;
    var countryIds = arguments.length > 9 ? arguments[9] : undefined;
    return "\n            ".concat(formName || (icd10 === null || icd10 === void 0 ? void 0 : icd10.length) > 0 || (classification === null || classification === void 0 ? void 0 : classification.length) > 0 ? "let form_keys = (\n                ".concat(formName ? "let icd_keys = (\n                    for icd_key in master_icd10\n                        filter icd_key.is_active == true && UPPER(icd_key.icd_10) like \"".concat(formName.toUpperCase(), "%\"\n                            return icd_key.icd_10_id\n                )") : "", "\n                for disease_key in master_disease\n                    filter disease_key.is_active == true ").concat(formName ? "&& UPPER(disease_key.disease_name) like \"".concat(formName.toUpperCase(), "%\" || icd_keys[0] in disease_key.icd_10") : "", "\n                    ").concat((icd10 === null || icd10 === void 0 ? void 0 : icd10.length) > 0 ? "".concat(icd10.map(function (_) {
      return "&& ".concat(_, " in disease_key.icd_10");
    })) : "", "\n                    ").concat((classification === null || classification === void 0 ? void 0 : classification.length) > 0 ? "&& disease_key.classification in [".concat(classification, "]") : "", "\n                        for rl_d_f in rl_disease_form\n                            filter rl_d_f.is_active == true && rl_d_f.disease_id == disease_key.disease_id\n                            for fr in forms\n                            filter fr.is_active == true && fr.form_id == rl_d_f.form_id\n                            return rl_d_f.form_id\n            )") : "", "\n\n            ").concat((forms === null || forms === void 0 ? void 0 : forms.length) === 0 && (countryIds === null || countryIds === void 0 ? void 0 : countryIds.length) > 0 ? "\n                    let countryForms = (\n                        for rl_d_f in rl_disease_form\n                            filter rl_d_f.is_active == true && rl_d_f.country_id in ".concat(JSON.stringify(countryIds), "\n                                return rl_d_f.form_id\n                    )\n            ") : "", "\n\n            for doc in forms \n                filter doc.is_active == true \n                ").concat(created_by ? "|| doc.created_by == \"".concat(created_by, "\"") : "", "    \n                ").concat(formName ? "filter UPPER(doc.form_name) like \"".concat(formName.toUpperCase(), "%\" || doc.form_id in form_keys") : "", "\n                ").concat(formTypeId ? "&& doc.form_type_id == \"".concat(formTypeId, "\"") : "", "\n                ").concat(formId ? "&& doc.form_id == \"".concat(formId, "\"") : "", "\n                ").concat((icd10 === null || icd10 === void 0 ? void 0 : icd10.length) > 0 || classification !== null && classification !== void 0 && classification.length ? "&& doc.form_id in form_keys" : "", "\n                ").concat((forms === null || forms === void 0 ? void 0 : forms.length) === 0 && (countryIds === null || countryIds === void 0 ? void 0 : countryIds.length) > 0 ? "filter doc.form_id in countryForms " : "", "\n                ").concat(forms.length ? "filter doc.form_id in ".concat(JSON.stringify(forms)) : "", "    \n                SORT doc.").concat(sortField, " ").concat(sortDirection, "  \n                LET types = (\n                    for ms in master_form_types \n                    filter ms.form_type_id == doc.form_type_id \n                        return {\n                            form_type_name : ms.form_type_name ,\n                            form_type_id: ms.form_type_id\n                        }\n                )\n                return { \n                    form_id : doc.form_id, \n                    form_name : doc.form_name, \n                    form_type : types[0], \n                    created_at : doc.created_at, \n                    updated_at: doc.updated_at,\n                    notification_count: LENGTH( \n                        for entry in form_entries\n                            filter entry.form_id == doc.form_id && entry.is_active == true && entry.notifier_status == 1\n                            filter entry.created_by == \"").concat(created_by, "\"\n                            return entry \n                    ),\n                    mapped_diseases: (\n                        for mapForm in rl_disease_form\n                            filter mapForm.is_active == true && mapForm.form_id == doc.form_id\n                                return FIRST(for mapForm_disease in master_disease\n                                    filter mapForm_disease.is_active == true && mapForm_disease.disease_id == mapForm.disease_id\n                                        return {\n                                            disease_name: mapForm_disease.disease_name,\n                                            disease_definition: mapForm_disease.disease_definition\n                                        }\n                                )       \n                    )   \n                }\n        ");
  },
  //2. To get forms for verification
  getAllVerificationForms: function getAllVerificationForms(formName, sortField, sortDirection, formTypeId, formId) {
    var icd10 = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
    var classification = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
    var forms = arguments.length > 7 ? arguments[7] : undefined;
    var created_by = arguments.length > 8 ? arguments[8] : undefined;
    var countryIds = arguments.length > 9 ? arguments[9] : undefined;
    var level = arguments.length > 10 ? arguments[10] : undefined;
    return "\n\n            \n        ".concat(formName || (icd10 === null || icd10 === void 0 ? void 0 : icd10.length) > 0 || (classification === null || classification === void 0 ? void 0 : classification.length) > 0 ? "let form_keys = (\n            ".concat(formName ? "let icd_keys = (\n                for icd_key in master_icd10\n                    filter icd_key.is_active == true && UPPER(icd_key.icd_10) like \"".concat(formName.toUpperCase(), "%\"\n                        return icd_key.icd_10_id\n            )") : "", "\n            for disease_key in master_disease\n                filter disease_key.is_active == true ").concat(formName ? "&& UPPER(disease_key.disease_name) like \"".concat(formName.toUpperCase(), "%\" || icd_keys[0] in disease_key.icd_10") : "", "\n                ").concat((icd10 === null || icd10 === void 0 ? void 0 : icd10.length) > 0 ? "".concat(icd10.map(function (_) {
      return "&& ".concat(_, " in disease_key.icd_10");
    })) : "", "\n                ").concat((classification === null || classification === void 0 ? void 0 : classification.length) > 0 ? "&& disease_key.classification in [".concat(classification, "]") : "", "\n                    for rl_d_f in rl_disease_form\n                        filter rl_d_f.is_active == true && rl_d_f.disease_id == disease_key.disease_id\n                        for fr in forms\n                        filter fr.is_active == true && fr.form_id == rl_d_f.form_id\n                        return rl_d_f.form_id\n        )") : "", "\n\n        ").concat((forms === null || forms === void 0 ? void 0 : forms.length) === 0 && (countryIds === null || countryIds === void 0 ? void 0 : countryIds.length) > 0 ? "\n        let countryForms = (\n            for rl_d_f in rl_disease_form\n                filter rl_d_f.is_active == true && rl_d_f.country_id in ".concat(JSON.stringify(countryIds), "\n                    return rl_d_f.form_id\n        )\n        ") : "", "\n\n        for doc in forms \n            filter doc.is_active == true \n            ").concat(created_by ? "|| doc.created_by == \"".concat(created_by, "\"") : "", "          \n            ").concat(formName ? "filter UPPER(doc.form_name) like \"".concat(formName.toUpperCase(), "%\" || doc.form_id in form_keys") : "", "\n            ").concat(formTypeId ? "&& doc.form_type_id == \"".concat(formTypeId, "\"") : "", "\n            ").concat(formId ? "&& doc.form_id == \"".concat(formId, "\"") : "", "\n            ").concat((icd10 === null || icd10 === void 0 ? void 0 : icd10.length) > 0 || classification !== null && classification !== void 0 && classification.length ? "&& doc.form_id in form_keys" : "", "\n            ").concat((forms === null || forms === void 0 ? void 0 : forms.length) === 0 && (countryIds === null || countryIds === void 0 ? void 0 : countryIds.length) > 0 ? "filter doc.form_id in countryForms " : "", "\n            ").concat(forms.length ? "filter doc.form_id in ".concat(JSON.stringify(forms)) : "", "    \n                SORT doc.").concat(sortField, " ").concat(sortDirection, "  \n                LET types = (\n                    for ms in master_form_types \n                    filter ms.form_type_id == doc.form_type_id \n                        return {\n                            form_type_name : ms.form_type_name ,\n                            form_type_id: ms.form_type_id\n                        }\n                )\n                return { \n                    form_id : doc.form_id, \n                    form_name : doc.form_name, \n                    form_type : types[0], \n                    created_at : doc.created_at, \n                    updated_at: doc.updated_at,\n                    for_verification_count: LENGTH( \n                        for entry in form_entries\n                            filter entry.is_active == true && entry.form_id == doc.form_id && entry.notifier_status == 1 && entry.verifier_status == 2\n                            ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                            return entry \n                    ),\n                    verified_count: LENGTH( \n                        for entry in form_entries\n                            filter entry.form_id == doc.form_id && entry.verifier_status == 3 \n                            ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                            return entry \n                    ),\n                    mapped_diseases: (\n                        for mapForm in rl_disease_form\n                            filter mapForm.is_active == true && mapForm.form_id == doc.form_id\n                                return FIRST(for mapForm_disease in master_disease\n                                    filter mapForm_disease.is_active == true && mapForm_disease.disease_id == mapForm.disease_id\n                                        return {\n                                            disease_name: mapForm_disease.disease_name,\n                                            disease_definition: mapForm_disease.disease_definition\n                                        }\n                                )       \n                    )     \n                }\n        ");
  },
  //3. To get forms for investigation
  getAllInvestigationForms: function getAllInvestigationForms(formName, sortField, sortDirection, formTypeId, formId) {
    var icd10 = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
    var classification = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
    var forms = arguments.length > 7 ? arguments[7] : undefined;
    var created_by = arguments.length > 8 ? arguments[8] : undefined;
    var countryIds = arguments.length > 9 ? arguments[9] : undefined;
    var level = arguments.length > 10 ? arguments[10] : undefined;
    return "\n\n           \n        ".concat(formName || (icd10 === null || icd10 === void 0 ? void 0 : icd10.length) > 0 || (classification === null || classification === void 0 ? void 0 : classification.length) > 0 ? "let form_keys = (\n            ".concat(formName ? "let icd_keys = (\n                for icd_key in master_icd10\n                    filter icd_key.is_active == true && UPPER(icd_key.icd_10) like \"".concat(formName.toUpperCase(), "%\"\n                        return icd_key.icd_10_id\n            )") : "", "\n            for disease_key in master_disease\n                filter disease_key.is_active == true ").concat(formName ? "&& UPPER(disease_key.disease_name) like \"".concat(formName.toUpperCase(), "%\" || icd_keys[0] in disease_key.icd_10") : "", "\n                ").concat((icd10 === null || icd10 === void 0 ? void 0 : icd10.length) > 0 ? "".concat(icd10.map(function (_) {
      return "&& ".concat(_, " in disease_key.icd_10");
    })) : "", "\n                ").concat((classification === null || classification === void 0 ? void 0 : classification.length) > 0 ? "&& disease_key.classification in [".concat(classification, "]") : "", "\n                    for rl_d_f in rl_disease_form\n                        filter rl_d_f.is_active == true && rl_d_f.disease_id == disease_key.disease_id\n                        for fr in forms\n                        filter fr.is_active == true && fr.form_id == rl_d_f.form_id\n                        return rl_d_f.form_id\n        )") : "", "\n\n        ").concat((forms === null || forms === void 0 ? void 0 : forms.length) === 0 && (countryIds === null || countryIds === void 0 ? void 0 : countryIds.length) > 0 ? "\n        let countryForms = (\n            for rl_d_f in rl_disease_form\n                filter rl_d_f.is_active == true && rl_d_f.country_id in ".concat(JSON.stringify(countryIds), "\n                    return rl_d_f.form_id\n        )\n        ") : "", "\n\n        for doc in forms \n            filter doc.is_active == true \n            ").concat(created_by ? "|| doc.created_by == \"".concat(created_by, "\"") : "", "      \n            ").concat(formName ? "filter UPPER(doc.form_name) like \"".concat(formName.toUpperCase(), "%\" || doc.form_id in form_keys") : "", "\n            ").concat(formTypeId ? "&& doc.form_type_id == \"".concat(formTypeId, "\"") : "", "\n            ").concat(formId ? "&& doc.form_id == \"".concat(formId, "\"") : "", "\n            ").concat((icd10 === null || icd10 === void 0 ? void 0 : icd10.length) > 0 || classification !== null && classification !== void 0 && classification.length ? "&& doc.form_id in form_keys" : "", "\n            ").concat((forms === null || forms === void 0 ? void 0 : forms.length) === 0 && (countryIds === null || countryIds === void 0 ? void 0 : countryIds.length) > 0 ? "filter doc.form_id in countryForms " : "", "\n            ").concat(forms.length ? "filter doc.form_id in ".concat(JSON.stringify(forms)) : "", "    \n                SORT doc.").concat(sortField, " ").concat(sortDirection, "  \n                LET types = (\n                    for ms in master_form_types \n                    filter ms.form_type_id == doc.form_type_id \n                        return {\n                            form_type_name : ms.form_type_name ,\n                            form_type_id: ms.form_type_id\n                        }\n                )\n                return { \n                    form_id : doc.form_id, \n                    form_name : doc.form_name, \n                    form_type : types[0], \n                    created_at : doc.created_at, \n                    updated_at: doc.updated_at,\n                    for_investigation_count: LENGTH( \n                        for entry in form_entries\n                            filter entry.is_active == true && entry.form_id == doc.form_id && entry.investigator_status == 5 && entry.registration_status == 8 && entry.verifier_status == 3\n                            ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                            return entry \n                    ),\n                    investigated_count: LENGTH( \n                        for entry in form_entries\n                            filter entry.form_id == doc.form_id && entry.verifier_status == 3 && entry.investigator_status == 6\n                            ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                            return entry \n                    ),\n                    verified_count: LENGTH( \n                        for entry in form_entries\n                            filter entry.form_id == doc.form_id && entry.verifier_status == 3 && entry.investigator_status == 3\n                            ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                            return entry \n                    ),\n                    archived_count: LENGTH( \n                        for entry in form_entries\n                            filter entry.form_id == doc.form_id && entry.verifier_status == 3 && entry.investigator_status == 4\n                            ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                            return entry \n                    ),\n                    mapped_diseases: (\n                        for mapForm in rl_disease_form\n                            filter mapForm.is_active == true && mapForm.form_id == doc.form_id\n                                return FIRST(for mapForm_disease in master_disease\n                                    filter mapForm_disease.is_active == true && mapForm_disease.disease_id == mapForm.disease_id\n                                        return {\n                                            disease_name: mapForm_disease.disease_name,\n                                            disease_definition: mapForm_disease.disease_definition\n                                        }\n                                )       \n                    )    \n                }\n        ");
  },
  //4. To get forms for case registration
  getAllCaseRegistrationForms: function getAllCaseRegistrationForms(formName, sortField, sortDirection, formTypeId, formId) {
    var icd10 = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
    var classification = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
    var forms = arguments.length > 7 ? arguments[7] : undefined;
    var created_by = arguments.length > 8 ? arguments[8] : undefined;
    var countryIds = arguments.length > 9 ? arguments[9] : undefined;
    var level = arguments.length > 10 ? arguments[10] : undefined;
    return "\n\n           \n        ".concat(formName || (icd10 === null || icd10 === void 0 ? void 0 : icd10.length) > 0 || (classification === null || classification === void 0 ? void 0 : classification.length) > 0 ? "let form_keys = (\n            ".concat(formName ? "let icd_keys = (\n                for icd_key in master_icd10\n                    filter icd_key.is_active == true && UPPER(icd_key.icd_10) like \"".concat(formName.toUpperCase(), "%\"\n                        return icd_key.icd_10_id\n            )") : "", "\n            for disease_key in master_disease\n                filter disease_key.is_active == true ").concat(formName ? "&& UPPER(disease_key.disease_name) like \"".concat(formName.toUpperCase(), "%\" || icd_keys[0] in disease_key.icd_10") : "", "\n                ").concat((icd10 === null || icd10 === void 0 ? void 0 : icd10.length) > 0 ? "".concat(icd10.map(function (_) {
      return "&& ".concat(_, " in disease_key.icd_10");
    })) : "", "\n                ").concat((classification === null || classification === void 0 ? void 0 : classification.length) > 0 ? "&& disease_key.classification in [".concat(classification, "]") : "", "\n                    for rl_d_f in rl_disease_form\n                        filter rl_d_f.is_active == true && rl_d_f.disease_id == disease_key.disease_id\n                        for fr in forms\n                        filter fr.is_active == true && fr.form_id == rl_d_f.form_id\n                        return rl_d_f.form_id\n        )") : "", "\n\n        ").concat((forms === null || forms === void 0 ? void 0 : forms.length) === 0 && (countryIds === null || countryIds === void 0 ? void 0 : countryIds.length) > 0 ? "\n        let countryForms = (\n            for rl_d_f in rl_disease_form\n                filter rl_d_f.is_active == true && rl_d_f.country_id in ".concat(JSON.stringify(countryIds), "\n                    return rl_d_f.form_id\n        )\n        ") : "", "\n\n        for doc in forms \n            filter doc.is_active == true \n            ").concat(created_by ? "|| doc.created_by == \"".concat(created_by, "\"") : "", "  \n            ").concat(formName ? "filter UPPER(doc.form_name) like \"".concat(formName.toUpperCase(), "%\" || doc.form_id in form_keys") : "", "\n            ").concat(formTypeId ? "&& doc.form_type_id == \"".concat(formTypeId, "\"") : "", "\n            ").concat(formId ? "&& doc.form_id == \"".concat(formId, "\"") : "", "\n            ").concat((icd10 === null || icd10 === void 0 ? void 0 : icd10.length) > 0 || classification !== null && classification !== void 0 && classification.length ? "&& doc.form_id in form_keys" : "", "\n            ").concat((forms === null || forms === void 0 ? void 0 : forms.length) === 0 && (countryIds === null || countryIds === void 0 ? void 0 : countryIds.length) > 0 ? "filter doc.form_id in countryForms " : "", "\n            ").concat(forms.length ? "filter doc.form_id in ".concat(JSON.stringify(forms)) : "", "    \n                SORT doc.").concat(sortField, " ").concat(sortDirection, "  \n                LET types = (\n                    for ms in master_form_types \n                    filter ms.form_type_id == doc.form_type_id \n                        return {\n                            form_type_name : ms.form_type_name ,\n                            form_type_id: ms.form_type_id\n                        }\n                )\n                return { \n                    form_id : doc.form_id, \n                    form_name : doc.form_name, \n                    form_type : types[0], \n                    created_at : doc.created_at, \n                    updated_at: doc.updated_at,\n                    case_registered: LENGTH( \n                        for entry in form_entries\n                            filter entry.is_active == true && entry.form_id == doc.form_id && entry.registration_status == 7 && entry.verifier_status == 3 \n                            ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                            return entry \n                    ),\n                    mapped_diseases: (\n                        for mapForm in rl_disease_form\n                            filter mapForm.is_active == true && mapForm.form_id == doc.form_id\n                                return FIRST(for mapForm_disease in master_disease\n                                    filter mapForm_disease.is_active == true && mapForm_disease.disease_id == mapForm.disease_id\n                                        return {\n                                            disease_name: mapForm_disease.disease_name,\n                                            disease_definition: mapForm_disease.disease_definition\n                                        }\n                                )       \n                    )     \n                }\n        ");
  },
  //5. To get entris by form_id and type
  getEntriesByFormId: function getEntriesByFormId(formId, type, user_profile_id, searchEntry, countryIds, level) {
    switch (type) {
      case "notification":
        return "\n                let form_detail = (\n                    for form in forms\n                        filter form.is_active == true && form.form_id == \"".concat(formId, "\"\n                        let mapped_diseases = (\n                            for mapForm in rl_disease_form\n                                filter mapForm.is_active == true && mapForm.form_id == form.form_id\n                                    return FIRST(for mapForm_disease in master_disease\n                                        filter mapForm_disease.is_active == true && mapForm_disease.disease_id == mapForm.disease_id\n                                            return {\n                                                disease_name: mapForm_disease.disease_name,\n                                                disease_definition: mapForm_disease.disease_definition\n                                            }\n                                    )       \n                        ) \n\n                        let tags = (for vertices , edges , paths in OUTBOUND form edge_form_section\n                                        filter vertices.parent_section_id == null && vertices.is_active == true \n                                        sort vertices.priority ASC\n                                        return {\n                                            id: vertices.section_id,\n                                            name: vertices.section_name,\n                                            is_form: vertices.is_form,\n                                            is_investigator_section: vertices.is_investigator_section,\n                                            columns: (\n                                                for qn in questions \n                                                    filter qn.section_id == vertices.section_id && qn.is_active == true\n                                                    sort qn.priority ASC\n                                                    return {\n                                                        title:qn.tag,\n                                                        label:qn.tag,\n                                                        field: qn.question_id,\n                                                        value: qn.question_id,\n                                                        ui_component: qn.ui_component\n                                                    }\n                                            ),\n                                            child_sections: (\n                                                for childSection1 in section\n                                                filter childSection1.parent_section_id == vertices.section_id && childSection1.is_active == true\n                                                    sort childSection1.priority ASC\n                                                    return {\n                                                        id: childSection1.section_id,\n                                                        name: childSection1.section_name,\n                                                        is_form: childSection1.is_form,\n                                                        is_investigator_section: childSection1.is_investigator_section,\n                                                        columns: (\n                                                            for qn1 in questions \n                                                                filter qn1.section_id == childSection1.section_id && qn1.is_active == true\n                                                                sort qn1.priority ASC\n                                                                return {\n                                                                    title: qn1.tag,\n                                                                    label: qn1.tag,\n                                                                    field: qn1.question_id,\n                                                                    value: qn1.question_id,\n                                                                    ui_component: qn1.ui_component\n                                                                }\n                                                        ),\n                                                        child_sections: (\n                                                            for childSection2 in section\n                                                            filter childSection2.parent_section_id == childSection1.section_id && childSection2.is_active == true\n                                                            sort childSection2.priority ASC\n                                                                return {\n                                                                    id: childSection2.section_id,\n                                                                    name: childSection2.section_name,\n                                                                    is_form: childSection2.is_form,\n                                                                    is_investigator_section: childSection2.is_investigator_section,\n                                                                    columns: (\n                                                                        for qn2 in questions \n                                                                            filter qn2.section_id == childSection2.section_id && qn2.is_active == true\n                                                                            sort qn2.priority ASC\n                                                                            return {\n                                                                            title: qn2.tag,\n                                                                            label: qn2.tag,\n                                                                            field: qn2.question_id,\n                                                                            value: qn2.question_id,\n                                                                            ui_component: qn2.ui_component\n                                                                            }\n                                                                    ),\n                                                                    child_sections: (\n                                                                        for childSection3 in section\n                                                                        filter childSection3.parent_section_id == childSection2.section_id && childSection3.is_active == true\n                                                                        sort childSection3.priority ASC\n                                                                            return  {\n                                                                                id: childSection3.section_id,\n                                                                                name: childSection3.section_name,\n                                                                                is_form: childSection3.is_form,\n                                                                                is_investigator_section: childSection3.is_investigator_section,\n                                                                                columns: (\n                                                                                    for qn3 in questions \n                                                                                        filter qn3.section_id == childSection3.section_id && qn3.is_active == true\n                                                                                        sort qn3.priority ASC\n                                                                                        return {\n                                                                                            title: qn3.tag,\n                                                                                            label: qn3.tag,\n                                                                                            field: qn3.question_id,\n                                                                                            value: qn3.question_id,\n                                                                                            ui_component: qn3.ui_component\n                                                                                        }\n                                                                                ),\n                                                                                child_sections:[]\n                                                                            }\n                                                                    )\n                                                                }\n                                                        )\n                                                    }\n                                            )\n                                    }\n                        )\n\n                        let columns = (for tr in tags\n                                        return tr.is_form == true && tr.is_investigator_section == false ? merge({expanded:[]} ,tr) : (\n                                            for tr1 in tr.child_sections\n                                                return tr1.is_form == true && tr1.is_investigator_section == false ? merge({expanded:[tr.id]}, tr1) : (\n                                                    for tr2 in tr1.child_sections\n                                                        return tr2.is_form == true && tr2.is_investigator_section == false ? merge({expanded:[tr.id,tr1.id]},tr2): (\n                                                            for tr3 in tr2.child_sections\n                                                                return tr3.is_form == true && tr3.is_investigator_section == false ? merge({expanded:[tr.id,tr1.id,tr2.id]},tr3) : (\n                                                                    for tr4 in tr3.child_sections\n                                                                        return merge({expanded: [tr.id,tr1.id,tr2.id,tr2.id]},tr4)\n                                                    )\n                                                )\n                                            )\n                                        )\n                                    )\n                                    \n                        return merge(\n                            form,{\n                                mapped_diseases,\n                                column:columns[****].columns[**],\n                                column_list:columns[****]\n                            }\n                        )\n                ) \n                \n                let notified = (for entry in form_entries\n                    filter length(form_detail) > 0 && entry.is_active == true && entry.form_id == \"").concat(formId, "\" && entry.notifier_status == 1\n                    filter entry.created_by == \"").concat(user_profile_id, "\"\n                    sort entry.created_at desc\n                    let tagAnswer = (\n                        for tagAns in entry.answers\n                            return {\n                                [tagAns.question_id]: tagAns.answer.answer\n                            }\n                    )\n\n                    let patientDetail = entry.patient_id ? first(\n                        for patient in patients\n                            filter patient.is_active == true && patient.patient_id == entry.patient_id\n                            return patient\n                    ) : {}\n                    \n                    let newAnswer = merge(entry,merge(tagAnswer),patientDetail)                    \n                    ").concat(searchEntry ? "filter ".concat(searchEntry) : '', "\n                    return newAnswer\n                )\n\n                let draft = (for entry in form_entries\n                    filter length(form_detail) > 0 && entry.is_active == true && entry.form_id == \"").concat(formId, "\" && entry.notifier_status == 9\n                    filter entry.created_by == \"").concat(user_profile_id, "\"\n                    sort entry.created_at desc\n                    let tagAnswer = (\n                        for tagAns in entry.answers\n                            return {\n                                [tagAns.question_id]: tagAns.answer.answer\n                            }\n                    )\n\n                    let patientDetail = entry.patient_id ? first(\n                        for patient in patients\n                            filter patient.is_active == true && patient.patient_id == entry.patient_id\n                            return patient\n                    ) : {}\n                    \n                    let newAnswer = merge(entry,merge(tagAnswer),patientDetail)\n                    ").concat(searchEntry ? "filter ".concat(searchEntry) : '', "\n                    return newAnswer\n                )\n\n                let statusArray = (\n                    for status in master_entry_status\n                    filter status.is_active == true && status.status_id in [1,9]\n                    sort status.status_id asc\n                        return {\n                            value : status.status_id,\n                            label : status.status_name\n                        }\n                )\n\n                let notificationColumn = first(\n                    for up in user_profiles\n                        filter up.is_active == true && up.user_profile_id == \"").concat(user_profile_id, "\"\n                            return up.notification ? up.notification : []\n                )\n                \n                let entryColumn = length(form_detail) > 0 && length(notificationColumn) == 0 ? slice(form_detail[0].column,0,3) : (\n                    for listCol in form_detail[0].column ? form_detail[0].column : []\n                        for profListCol in notificationColumn\n                            filter listCol.value in profListCol\n                                return listCol\n                )\n\n                let column = append(\n                    append(\n                        [\n                            {\n                                type: 'sno',  \n                                title: 'S No',\n                                width: \"40px\"\n                            },                        \n                            {\n                                type: 'button',  \n                                title: 'View',\n                                actionType: 'route',\n                                link: concat('/notify/edit/', \"").concat(formId, "\"),\n                                field: '',\n                                width: \"40px\"\n                            }\n                        ],  \n                        ").concat(JSON.stringify(patientDataColumn), "\n                    ),\n                    append(\n                        entryColumn,                 \n                        [\n                            {\n                                type: 'change_status',\n                                title: 'Current Status',\n                                field: '',\n                                options: statusArray,\n                            }\n                        ]\n                ))\n\n                let draftColumn = append(\n                    append(\n                        [\n                            {\n                                type: 'sno',  \n                                title: 'S No',\n                                width: \"40px\"\n                            },                        \n                            {\n                                type: 'action',  \n                                title: 'Action',\n                                actionType: 'delete',\n                                field: '',\n                                width: \"40px\"\n                            },\n                            {\n                                type: 'button',  \n                                title: 'View',\n                                actionType: 'route',\n                                link: concat('/notify/edit/', \"").concat(formId, "\"),\n                                field: '',\n                                width: \"40px\"\n                            }\n                        ],  \n                        ").concat(JSON.stringify(patientDataColumn), "\n                    ),\n                    append(\n                        entryColumn,                 \n                        [\n                            {\n                                type: 'change_status',\n                                title: 'Status',\n                                field: '',\n                                options: statusArray,\n                            }\n                        ]\n                ))\n                \n                return {\n                    allStatus : (\n                        for status in master_entry_status\n                        filter status.is_active == true\n                        return status\n                    ),\n                    form_detail: length(form_detail) > 0 ? form_detail[0] : {},\n                    notified : {\n                        column,\n                        defaultStatus: statusArray[0] ? statusArray[0] : {},\n                        row: notified\n                    },\n                    draft: {\n                        column: draftColumn,\n                        defaultStatus: statusArray[1] ? statusArray[1] : {},\n                        row: draft\n                    },\n                }\n                ");

      case "verifier":
        return "\n                let form_detail = (\n                    for form in forms\n                        filter form.is_active == true && form.form_id == \"".concat(formId, "\"\n                        let mapped_diseases = (\n                            for mapForm in rl_disease_form\n                                filter mapForm.is_active == true && mapForm.form_id == form.form_id\n                                    return FIRST(for mapForm_disease in master_disease\n                                        filter mapForm_disease.is_active == true && mapForm_disease.disease_id == mapForm.disease_id\n                                            return {\n                                                disease_name: mapForm_disease.disease_name,\n                                                disease_definition: mapForm_disease.disease_definition\n                                            }\n                                    )       \n                        ) \n                        \n                        let tags = (for vertices , edges , paths in OUTBOUND form edge_form_section\n                            filter vertices.parent_section_id == null && vertices.is_active == true \n                            sort vertices.priority ASC\n                            return {\n                                id: vertices.section_id,\n                                name: vertices.section_name,\n                                is_form: vertices.is_form,\n                                is_investigator_section: vertices.is_investigator_section,\n                                columns: (\n                                    for qn in questions \n                                        filter qn.section_id == vertices.section_id && qn.is_active == true\n                                        sort qn.priority ASC\n                                        return {\n                                            title:qn.tag,\n                                            label:qn.tag,\n                                            field: qn.question_id,\n                                            value: qn.question_id,\n                                            ui_component: qn.ui_component\n                                        }\n                                ),\n                                child_sections: (\n                                    for childSection1 in section\n                                    filter childSection1.parent_section_id == vertices.section_id && childSection1.is_active == true\n                                        sort childSection1.priority ASC\n                                        return {\n                                            id: childSection1.section_id,\n                                            name: childSection1.section_name,\n                                            is_form: childSection1.is_form,\n                                            is_investigator_section: childSection1.is_investigator_section,\n                                            columns: (\n                                                for qn1 in questions \n                                                    filter qn1.section_id == childSection1.section_id && qn1.is_active == true\n                                                    sort qn1.priority ASC\n                                                    return {\n                                                        title: qn1.tag,\n                                                        label: qn1.tag,\n                                                        field: qn1.question_id,\n                                                        value: qn1.question_id,\n                                                        ui_component: qn1.ui_component\n                                                    }\n                                            ),\n                                            child_sections: (\n                                                for childSection2 in section\n                                                filter childSection2.parent_section_id == childSection1.section_id && childSection2.is_active == true\n                                                sort childSection2.priority ASC\n                                                    return {\n                                                        id: childSection2.section_id,\n                                                        name: childSection2.section_name,\n                                                        is_form: childSection2.is_form,\n                                                        is_investigator_section: childSection2.is_investigator_section,\n                                                        columns: (\n                                                            for qn2 in questions \n                                                                filter qn2.section_id == childSection2.section_id && qn2.is_active == true\n                                                                sort qn2.priority ASC\n                                                                return {\n                                                                title: qn2.tag,\n                                                                label: qn2.tag,\n                                                                field: qn2.question_id,\n                                                                value: qn2.question_id,\n                                                                ui_component: qn2.ui_component\n                                                                }\n                                                        ),\n                                                        child_sections: (\n                                                            for childSection3 in section\n                                                            filter childSection3.parent_section_id == childSection2.section_id && childSection3.is_active == true\n                                                            sort childSection3.priority ASC\n                                                                return  {\n                                                                    id: childSection3.section_id,\n                                                                    name: childSection3.section_name,\n                                                                    is_form: childSection3.is_form,\n                                                                    is_investigator_section: childSection3.is_investigator_section,\n                                                                    columns: (\n                                                                        for qn3 in questions \n                                                                            filter qn3.section_id == childSection3.section_id && qn3.is_active == true\n                                                                            sort qn3.priority ASC\n                                                                            return {\n                                                                                title: qn3.tag,\n                                                                                label: qn3.tag,\n                                                                                field: qn3.question_id,\n                                                                                value: qn3.question_id,\n                                                                                ui_component: qn3.ui_component\n                                                                            }\n                                                                    ),\n                                                                    child_sections:[]\n                                                                }\n                                                        )\n                                                    }\n                                            )\n                                        }\n                                )\n                        }\n            )\n\n            let columns = (for tr in tags\n                            return tr.is_form == true && tr.is_investigator_section == false ? merge({expanded:[]} ,tr) : (\n                                for tr1 in tr.child_sections\n                                    return tr1.is_form == true && tr1.is_investigator_section == false ? merge({expanded:[tr.id]}, tr1) : (\n                                        for tr2 in tr1.child_sections\n                                            return tr2.is_form == true && tr2.is_investigator_section == false ? merge({expanded:[tr.id,tr1.id]},tr2): (\n                                                for tr3 in tr2.child_sections\n                                                    return tr3.is_form == true && tr3.is_investigator_section == false ? merge({expanded:[tr.id,tr1.id,tr2.id]},tr3) : (\n                                                        for tr4 in tr3.child_sections\n                                                            return merge({expanded: [tr.id,tr1.id,tr2.id,tr2.id]},tr4)\n                                        )\n                                    )\n                                )\n                            )\n                        )\n                        \n                    return merge(\n                        form,{\n                            mapped_diseases,\n                            column:columns[****].columns[**],\n                            column_list:columns[****]\n                        }\n                    )\n                ) \n                \n                let pending = (for entry in form_entries\n                    filter length(form_detail) > 0 && entry.is_active == true && entry.form_id == \"").concat(formId, "\" && entry.notifier_status == 1 && entry.verifier_status == 2\n                    ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                    sort entry.created_at desc\n                    let tagAnswer = (\n                        for tagAns in entry.answers\n                            return {\n                                [tagAns.question_id]: tagAns.answer.answer\n                            }\n                    )\n                    \n                    let patientDetail = entry.patient_id ? first(\n                        for patient in patients\n                            filter patient.is_active == true && patient.patient_id == entry.patient_id\n                            return patient\n                    ) : {}\n                    \n                    let newAnswer = merge(entry,merge(tagAnswer),patientDetail)\n                    ").concat(searchEntry ? "filter ".concat(searchEntry) : '', "\n                    return newAnswer\n                )\n\n                let verified = (for entry in form_entries\n                    filter length(form_detail) > 0 && entry.is_active == true && entry.form_id == \"").concat(formId, "\" && entry.verifier_status == 3\n                    ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                    sort entry.created_at desc\n                    let tagAnswer = (\n                        for tagAns in entry.answers\n                            return {\n                                [tagAns.question_id]: tagAns.answer.answer\n                            }\n                    )\n                    \n                    let patientDetail = entry.patient_id ? first(\n                        for patient in patients\n                            filter patient.is_active == true && patient.patient_id == entry.patient_id\n                            return patient\n                    ) : {}\n                    \n                    let newAnswer = merge(entry,merge(tagAnswer),patientDetail)\n                    ").concat(searchEntry ? "filter ".concat(searchEntry) : '', "\n                    return newAnswer    \n                )\n\n                let transfer = (for entry in form_entries\n                    filter length(form_detail) > 0 && entry.is_active == true && entry.form_id == \"").concat(formId, "\" && entry.verifier_status == 11\n                    ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                    sort entry.created_at desc\n                    let tagAnswer = (\n                        for tagAns in entry.answers\n                            return {\n                                [tagAns.question_id]: tagAns.answer.answer\n                            }\n                    )\n                    \n                    let patientDetail = entry.patient_id ? first(\n                        for patient in patients\n                            filter patient.is_active == true && patient.patient_id == entry.patient_id\n                            return patient\n                    ) : {}\n                    \n                    let newAnswer = merge(entry,merge(tagAnswer),patientDetail)\n                    ").concat(searchEntry ? "filter ".concat(searchEntry) : '', "\n                    return newAnswer    \n                )\n\n                let reject = (for entry in form_entries\n                    filter length(form_detail) > 0 && entry.is_active == true && entry.form_id == \"").concat(formId, "\" && entry.verifier_status == 10\n                    ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                    sort entry.created_at desc\n                    let tagAnswer = (\n                        for tagAns in entry.answers\n                            return {\n                                [tagAns.question_id]: tagAns.answer.answer\n                            }\n                    )\n                    \n                    let patientDetail = entry.patient_id ? first(\n                        for patient in patients\n                            filter patient.is_active == true && patient.patient_id == entry.patient_id\n                            return patient\n                    ) : {}\n                    \n                    let newAnswer = merge(entry,merge(tagAnswer),patientDetail)\n                    ").concat(searchEntry ? "filter ".concat(searchEntry) : '', "\n                    return newAnswer    \n                )\n\n                let statusArray = (\n                    for status in master_entry_status\n                    filter status.is_active == true && status.status_id in [2,3,10,11]\n                    sort status.verification_priority asc\n                        return {\n                            value : status.status_id,\n                            label : status.status_name\n                        }\n                )\n\n                let verificationColumn = first(\n                    for up in user_profiles\n                        filter up.is_active == true && up.user_profile_id == \"").concat(user_profile_id, "\"\n                            return up.verification ? up.verification : []\n                )\n\n                let entryColumn = length(form_detail) > 0 && length(verificationColumn) == 0 ? slice(form_detail[0].column,0,3) : (\n                    for listCol in form_detail[0].column\n                        for profListCol in verificationColumn\n                            filter listCol.value in profListCol\n                                return listCol\n                )\n\n                let column = append(\n                 append(\n                    [\n                      {\n                        type: 'sno',  \n                        title: 'S No',\n                        width: \"60px\"\n                      },  \n                      {\n                        type: 'button',  \n                        title: 'View',\n                        actionType: 'route',\n                        link: concat('/verify/view/', \"").concat(formId, "\"),\n                        field: '',\n                        width: \"60px\"\n                      }],\n                      ").concat(JSON.stringify(patientDataColumn), "\n                ),\n                      append(entryColumn,                      \n                      [{\n                          type: 'change_status',\n                          title: 'Current Status',\n                          field: '',\n                          options: statusArray,\n                      }])                      \n                )\n                \n                let transferColumn = append(\n                append([\n                    {\n                      type: 'sno',  \n                      title: 'S No',\n                      width: \"60px\"\n                    },  \n                    {\n                      type: 'button',  \n                      title: 'View',\n                      actionType: 'route',\n                      link: concat('/verify/view/', \"").concat(formId, "\"),\n                      field: '',\n                      width: \"60px\"\n                    }],\n                    ").concat(JSON.stringify(patientDataColumn), "\n                ),\n                    append(entryColumn,                      \n                    [\n                        {\n                            title: \"Transfer Reason\",\n                            field: 'reason_for_transfer',\n                        },\n                        {\n                            type: 'change_status',\n                            title: 'Current Status',\n                            field: '',\n                            options: statusArray,\n                        }\n                    ])                      \n                )\n\n                let rejectColumn = append(\n                append([\n                    {\n                      type: 'sno',  \n                      title: 'S No',\n                      width: \"60px\"\n                    },  \n                    {\n                      type: 'button',  \n                      title: 'View',\n                      actionType: 'route',\n                      link: concat('/verify/view/', \"").concat(formId, "\"),\n                      field: '',\n                      width: \"60px\"\n                    }],").concat(JSON.stringify(patientDataColumn), "\n                ),\n                    append(entryColumn,                      \n                    [\n                        {\n                            title: \"Rejected Reason\",\n                            field: 'reason_for_reject',\n                        },\n                        {\n                            type: 'change_status',\n                            title: 'Current Status',\n                            field: '',\n                            options: statusArray,\n                        }\n                    ])                      \n                )\n                \n                return {\n                    allStatus : (\n                        for status in master_entry_status\n                        filter status.is_active == true\n                        return status\n                    ),\n                    form_detail: length(form_detail) > 0 ? form_detail[0] : {},\n                    pending : {\n                        column,\n                        defaultStatus: statusArray[0] ? statusArray[0] : {},\n                        row: pending\n                    },\n                    verified: {\n                        column,\n                        defaultStatus: statusArray[1] ? statusArray[1] : {},\n                        row: verified\n                    },                    \n                    transfer: {\n                        column: transferColumn,\n                        defaultStatus: statusArray[2] ? statusArray[2] : {},\n                        row: transfer\n                    },\n                    reject: {\n                        column: rejectColumn,\n                        defaultStatus: statusArray[3] ? statusArray[3] : {},\n                        row: reject\n                    },\n                }\n                ");

      case "case_register":
        return "\n                    let form_detail = (\n                        for form in forms\n                            filter form.is_active == true && form.form_id == \"".concat(formId, "\"\n                            let mapped_diseases = (\n                                for mapForm in rl_disease_form\n                                    filter mapForm.is_active == true && mapForm.form_id == form.form_id\n                                        return FIRST(for mapForm_disease in master_disease\n                                            filter mapForm_disease.is_active == true && mapForm_disease.disease_id == mapForm.disease_id\n                                                return {\n                                                    disease_name: mapForm_disease.disease_name,\n                                                    disease_definition: mapForm_disease.disease_definition\n                                                }\n                                        )       \n                            ) \n                            let tags = (for vertices , edges , paths in OUTBOUND form edge_form_section\n                                filter vertices.parent_section_id == null && vertices.is_active == true \n                                sort vertices.priority ASC\n                                return {\n                                    id: vertices.section_id,\n                                    name: vertices.section_name,\n                                    is_form: vertices.is_form,\n                                    is_investigator_section: vertices.is_investigator_section,\n                                    columns: (\n                                        for qn in questions \n                                            filter qn.section_id == vertices.section_id && qn.is_active == true\n                                            sort qn.priority ASC\n                                            return {\n                                                title:qn.tag,\n                                                label:qn.tag,\n                                                field: qn.question_id,\n                                                value: qn.question_id,\n                                                ui_component: qn.ui_component\n                                            }\n                                    ),\n                                    child_sections: (\n                                        for childSection1 in section\n                                        filter childSection1.parent_section_id == vertices.section_id && childSection1.is_active == true\n                                            sort childSection1.priority ASC\n                                            return {\n                                                id: childSection1.section_id,\n                                                name: childSection1.section_name,\n                                                is_form: childSection1.is_form,\n                                                is_investigator_section: childSection1.is_investigator_section,\n                                                columns: (\n                                                    for qn1 in questions \n                                                        filter qn1.section_id == childSection1.section_id && qn1.is_active == true\n                                                        sort qn1.priority ASC\n                                                        return {\n                                                            title: qn1.tag,\n                                                            label: qn1.tag,\n                                                            field: qn1.question_id,\n                                                            value: qn1.question_id,\n                                                            ui_component: qn1.ui_component\n                                                        }\n                                                ),\n                                                child_sections: (\n                                                    for childSection2 in section\n                                                    filter childSection2.parent_section_id == childSection1.section_id && childSection2.is_active == true\n                                                    sort childSection2.priority ASC\n                                                        return {\n                                                            id: childSection2.section_id,\n                                                            name: childSection2.section_name,\n                                                            is_form: childSection2.is_form,\n                                                            is_investigator_section: childSection2.is_investigator_section,\n                                                            columns: (\n                                                                for qn2 in questions \n                                                                    filter qn2.section_id == childSection2.section_id && qn2.is_active == true\n                                                                    sort qn2.priority ASC\n                                                                    return {\n                                                                    title: qn2.tag,\n                                                                    label: qn2.tag,\n                                                                    field: qn2.question_id,\n                                                                    value: qn2.question_id,\n                                                                    ui_component: qn2.ui_component\n                                                                    }\n                                                            ),\n                                                            child_sections: (\n                                                                for childSection3 in section\n                                                                filter childSection3.parent_section_id == childSection2.section_id && childSection3.is_active == true\n                                                                sort childSection3.priority ASC\n                                                                    return  {\n                                                                        id: childSection3.section_id,\n                                                                        name: childSection3.section_name,\n                                                                        is_form: childSection3.is_form,\n                                                                        is_investigator_section: childSection3.is_investigator_section,\n                                                                        columns: (\n                                                                            for qn3 in questions \n                                                                                filter qn3.section_id == childSection3.section_id && qn3.is_active == true\n                                                                                sort qn3.priority ASC\n                                                                                return {\n                                                                                    title: qn3.tag,\n                                                                                    label: qn3.tag,\n                                                                                    field: qn3.question_id,\n                                                                                    value: qn3.question_id,\n                                                                                    ui_component: qn3.ui_component\n                                                                                }\n                                                                        ),\n                                                                        child_sections:[]\n                                                                    }\n                                                            )\n                                                        }\n                                                )\n                                            }\n                                    )\n                            }\n                )\n    \n                        let columns = (for tr in tags\n                                        return tr.is_form == true && tr.is_investigator_section == false ? merge({expanded:[]} ,tr) : (\n                                            for tr1 in tr.child_sections\n                                                return tr1.is_form == true && tr1.is_investigator_section == false ? merge({expanded:[tr.id]}, tr1) : (\n                                                    for tr2 in tr1.child_sections\n                                                        return tr2.is_form == true && tr2.is_investigator_section == false ? merge({expanded:[tr.id,tr1.id]},tr2): (\n                                                            for tr3 in tr2.child_sections\n                                                                return tr3.is_form == true && tr3.is_investigator_section == false ? merge({expanded:[tr.id,tr1.id,tr2.id]},tr3) : (\n                                                                    for tr4 in tr3.child_sections\n                                                                        return merge({expanded: [tr.id,tr1.id,tr2.id,tr2.id]},tr4)\n                                                    )\n                                                )\n                                            )\n                                        )\n                                    )\n                                    \n                                return merge(\n                                    form,{\n                                        mapped_diseases,\n                                        column:columns[****].columns[**],\n                                        column_list:columns[****]\n                                    }\n                                )\n                    ) \n                    \n                    let for_confirmation = (for entry in form_entries\n                        filter length(form_detail) > 0 && entry.is_active == true && entry.form_id == \"").concat(formId, "\" && entry.registration_status == 7 && entry.verifier_status == 3 \n                        ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                        sort entry.created_at desc\n                        let tagAnswer = (\n                            for tagAns in entry.answers\n                                return {\n                                    [tagAns.question_id]: tagAns.answer.answer\n                                }\n                        )\n                        \n                        let patientDetail = entry.patient_id ? first(\n                        for patient in patients\n                            filter patient.is_active == true && patient.patient_id == entry.patient_id\n                            return patient\n                    ) : {}\n                    \n                    let newAnswer = merge(entry,merge(tagAnswer),patientDetail)\n                        ").concat(searchEntry ? "filter ".concat(searchEntry) : '', "\n                        return newAnswer\n                    )\n    \n                    let registered = (for entry in form_entries\n                        filter length(form_detail) > 0 && entry.is_active == true && entry.form_id == \"").concat(formId, "\" && entry.registration_status == 8 && entry.verifier_status == 3 \n                        ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                        sort entry.created_at desc\n                        let tagAnswer = (\n                            for tagAns in entry.answers\n                                return {\n                                    [tagAns.question_id]: tagAns.answer.answer\n                                }\n                        )\n                        \n                        let patientDetail = entry.patient_id ? first(\n                        for patient in patients\n                            filter patient.is_active == true && patient.patient_id == entry.patient_id\n                            return patient\n                    ) : {}\n                    \n                    let newAnswer = merge(entry,merge(tagAnswer),patientDetail)\n                        ").concat(searchEntry ? "filter ".concat(searchEntry) : '', "\n                        return newAnswer\n                    )\n                    \n                    let transfer = (for entry in form_entries\n                        filter length(form_detail) > 0 && entry.is_active == true && entry.form_id == \"").concat(formId, "\" && entry.registration_status == 11\n                        ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                        sort entry.created_at desc\n                        let tagAnswer = (\n                            for tagAns in entry.answers\n                                return {\n                                    [tagAns.question_id]: tagAns.answer.answer\n                                }\n                        )\n                        \n                        let patientDetail = entry.patient_id ? first(\n                        for patient in patients\n                            filter patient.is_active == true && patient.patient_id == entry.patient_id\n                            return patient\n                    ) : {}\n                    \n                    let newAnswer = merge(entry,merge(tagAnswer),patientDetail)\n                        ").concat(searchEntry ? "filter ".concat(searchEntry) : '', "\n                        return newAnswer    \n                    )\n    \n                    let reject = (for entry in form_entries\n                        filter length(form_detail) > 0 && entry.is_active == true && entry.form_id == \"").concat(formId, "\" && entry.registration_status == 10\n                        ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                        sort entry.created_at desc\n                        let tagAnswer = (\n                            for tagAns in entry.answers\n                                return {\n                                    [tagAns.question_id]: tagAns.answer.answer\n                                }\n                        )\n                        \n                        let patientDetail = entry.patient_id ? first(\n                        for patient in patients\n                            filter patient.is_active == true && patient.patient_id == entry.patient_id\n                            return patient\n                    ) : {}\n                    \n                    let newAnswer = merge(entry,merge(tagAnswer),patientDetail)\n                        ").concat(searchEntry ? "filter ".concat(searchEntry) : '', "\n                        return newAnswer    \n                    )\n    \n    \n                    let statusArray = (\n                        for status in master_entry_status\n                        filter status.is_active == true && status.status_id in [7,8,10,11]\n                        sort status.registration_priority asc\n                            return {\n                                value : status.status_id,\n                                label : status.status_name\n                            }\n                    )\n                    \n                    let caseRegisterColumn = first(\n                        for up in user_profiles\n                            filter up.is_active == true && up.user_profile_id == \"").concat(user_profile_id, "\"\n                                return up.notification ? up.notification : []\n                    )\n                    \n                    let entryColumn = length(form_detail) > 0 && length(caseRegisterColumn) == 0 ? slice(form_detail[0].column,0,3) : (\n                        for listCol in form_detail[0].column\n                            for profListCol in caseRegisterColumn\n                                filter listCol.value in profListCol\n                                    return listCol\n                    )\n                    \n                    let column = append(\n                        append([\n                          {\n                            type: 'sno',  \n                            title: 'S No',\n                            width: \"60px\"\n                          },  \n                          {\n                            type: 'button',  \n                            title: 'View',\n                            actionType: 'route',\n                            link: concat('/register/view/', \"").concat(formId, "\"),\n                            field: '',\n                            width: \"60px\"\n                          }],\n                          ").concat(JSON.stringify(patientDataColumn), "\n                        ),\n                          append(entryColumn,[\n                          {\n                            type: 'change_status',\n                            title: 'Current Status',\n                            field: '',\n                            options: statusArray,\n                          },\n                        ])\n                    )\n                    \n                    let transferColumn = append(\n                    append([\n                        {\n                          type: 'sno',  \n                          title: 'S No',\n                          width: \"60px\"\n                        },  \n                        {\n                          type: 'button',  \n                          title: 'View',\n                          actionType: 'route',\n                          link: concat('/register/view/', \"").concat(formId, "\"),\n                          field: '',\n                          width: \"60px\"\n                        }],\n                    ").concat(JSON.stringify(patientDataColumn), "\n                    ),\n                        append(entryColumn,                      \n                        [\n                            {\n                                title: \"Transfer Reason\",\n                                field: 'reason_for_transfer',\n                            },\n                            {\n                                type: 'change_status',\n                                title: 'Current Status',\n                                field: '',\n                                options: statusArray,\n                            }\n                        ])                      \n                    )\n    \n                    let rejectColumn = append(\n                    append([\n                        {\n                          type: 'sno',  \n                          title: 'S No',\n                          width: \"60px\"\n                        },  \n                        {\n                          type: 'button',  \n                          title: 'View',\n                          actionType: 'route',\n                          link: concat('/register/view/', \"").concat(formId, "\"),\n                          field: '',\n                          width: \"60px\"\n                        }],\n                        ").concat(JSON.stringify(patientDataColumn), "\n                    ),\n                        append(entryColumn,                      \n                        [\n                            {\n                                title: \"Rejected Reason\",\n                                field: 'reason_for_reject',\n                            },\n                            {\n                                type: 'change_status',\n                                title: 'Current Status',\n                                field: '',\n                                options: statusArray,\n                            }\n                        ])                      \n                    )\n                    \n                    return {\n                        allStatus : (\n                            for status in master_entry_status\n                            filter status.is_active == true\n                            return status\n                        ),\n                        form_detail: length(form_detail) > 0 ? form_detail[0] : {},\n                        for_confirmation : {\n                            column,\n                            defaultStatus: statusArray[0] ? statusArray[0] : {},\n                            row: for_confirmation\n                        },\n                        registered : {\n                            column,\n                            defaultStatus: statusArray[1] ? statusArray[1] : {},\n                            row: registered\n                        },                        \n                        transfer: {\n                            column: transferColumn,\n                            defaultStatus: statusArray[2] ? statusArray[2] : {},\n                            row: transfer\n                        },\n                        reject: {\n                            column: rejectColumn,\n                            defaultStatus: statusArray[3] ? statusArray[3] : {},\n                            row: reject\n                        },\n                    }\n                    ");

      case "investigator":
        return "\n                let form_detail = (\n                    for form in forms\n                        filter form.is_active == true && form.form_id == \"".concat(formId, "\"\n                        let mapped_diseases = (\n                            for mapForm in rl_disease_form\n                                filter mapForm.is_active == true && mapForm.form_id == form.form_id\n                                    return FIRST(for mapForm_disease in master_disease\n                                        filter mapForm_disease.is_active == true && mapForm_disease.disease_id == mapForm.disease_id\n                                            return {\n                                                disease_name: mapForm_disease.disease_name,\n                                                disease_definition: mapForm_disease.disease_definition\n                                            }\n                                    )       \n                        ) \n                        let tags = (for vertices , edges , paths in OUTBOUND form edge_form_section\n                            filter vertices.parent_section_id == null && vertices.is_active == true \n                            sort vertices.priority ASC\n                            return {\n                                id: vertices.section_id,\n                                name: vertices.section_name,\n                                is_form: vertices.is_form,\n                                is_investigator_section: vertices.is_investigator_section,\n                                columns: (\n                                    for qn in questions \n                                        filter qn.section_id == vertices.section_id && qn.is_active == true\n                                        sort qn.priority ASC\n                                        return {\n                                            title:qn.tag,\n                                            label:qn.tag,\n                                            field: qn.question_id,\n                                            value: qn.question_id,\n                                            ui_component: qn.ui_component\n                                        }\n                                ),\n                                child_sections: (\n                                    for childSection1 in section\n                                    filter childSection1.parent_section_id == vertices.section_id && childSection1.is_active == true\n                                        sort childSection1.priority ASC\n                                        return {\n                                            id: childSection1.section_id,\n                                            name: childSection1.section_name,\n                                            is_form: childSection1.is_form,\n                                            is_investigator_section: childSection1.is_investigator_section,\n                                            columns: (\n                                                for qn1 in questions \n                                                    filter qn1.section_id == childSection1.section_id && qn1.is_active == true\n                                                    sort qn1.priority ASC\n                                                    return {\n                                                        title: qn1.tag,\n                                                        label: qn1.tag,\n                                                        field: qn1.question_id,\n                                                        value: qn1.question_id,\n                                                        ui_component: qn1.ui_component\n                                                    }\n                                            ),\n                                            child_sections: (\n                                                for childSection2 in section\n                                                filter childSection2.parent_section_id == childSection1.section_id && childSection2.is_active == true\n                                                sort childSection2.priority ASC\n                                                    return {\n                                                        id: childSection2.section_id,\n                                                        name: childSection2.section_name,\n                                                        is_form: childSection2.is_form,\n                                                        is_investigator_section: childSection2.is_investigator_section,\n                                                        columns: (\n                                                            for qn2 in questions \n                                                                filter qn2.section_id == childSection2.section_id && qn2.is_active == true\n                                                                sort qn2.priority ASC\n                                                                return {\n                                                                title: qn2.tag,\n                                                                label: qn2.tag,\n                                                                field: qn2.question_id,\n                                                                value: qn2.question_id,\n                                                                ui_component: qn2.ui_component\n                                                                }\n                                                        ),\n                                                        child_sections: (\n                                                            for childSection3 in section\n                                                            filter childSection3.parent_section_id == childSection2.section_id && childSection3.is_active == true\n                                                            sort childSection3.priority ASC\n                                                                return  {\n                                                                    id: childSection3.section_id,\n                                                                    name: childSection3.section_name,\n                                                                    is_form: childSection3.is_form,\n                                                                    is_investigator_section: childSection3.is_investigator_section,\n                                                                    columns: (\n                                                                        for qn3 in questions \n                                                                            filter qn3.section_id == childSection3.section_id && qn3.is_active == true\n                                                                            sort qn3.priority ASC\n                                                                            return {\n                                                                                title: qn3.tag,\n                                                                                label: qn3.tag,\n                                                                                field: qn3.question_id,\n                                                                                value: qn3.question_id,\n                                                                                ui_component: qn3.ui_component\n                                                                            }\n                                                                    ),\n                                                                    child_sections:[]\n                                                                }\n                                                        )\n                                                    }\n                                            )\n                                        }\n                                )\n                        }\n            )\n\n            let columns = (for tr in tags\n                            return tr.is_form == true ? merge({expanded:[]} ,tr) : (\n                                for tr1 in tr.child_sections\n                                    return tr1.is_form == true ? merge({expanded:[tr.id]}, tr1) : (\n                                        for tr2 in tr1.child_sections\n                                            return tr2.is_form == true ? merge({expanded:[tr.id,tr1.id]},tr2): (\n                                                for tr3 in tr2.child_sections\n                                                    return tr3.is_form == true ? merge({expanded:[tr.id,tr1.id,tr2.id]},tr3) : (\n                                                        for tr4 in tr3.child_sections\n                                                            return merge({expanded: [tr.id,tr1.id,tr2.id,tr2.id]},tr4)\n                                        )\n                                    )\n                                )\n                            )\n                        )\n                        \n            return merge(\n                form,{\n                    mapped_diseases,\n                    column:columns[****].columns[**],\n                    column_list:columns[****]\n                }\n            )\n        ) \n                \n                let for_investigation = (for entry in form_entries\n                    filter length(form_detail) > 0 && entry.is_active == true && entry.form_id == \"").concat(formId, "\" && entry.investigator_status == 5 && entry.registration_status == 8 && entry.verifier_status == 3\n                    ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                    sort entry.created_at desc\n                    let tagAnswer = (\n                        for tagAns in entry.answers\n                            return {\n                                [tagAns.question_id]: tagAns.answer.answer\n                            }\n                    )\n                    \n                    let patientDetail = entry.patient_id ? first(\n                        for patient in patients\n                            filter patient.is_active == true && patient.patient_id == entry.patient_id\n                            return patient\n                    ) : {}\n                    \n                    let newAnswer = merge(entry,merge(tagAnswer),patientDetail)\n                    ").concat(searchEntry ? "filter ".concat(searchEntry) : '', "\n                    return newAnswer\n                )\n\n                let investiated = (for entry in form_entries\n                    filter length(form_detail) > 0 && entry.is_active == true && entry.form_id == \"").concat(formId, "\" && entry.verifier_status == 3 && entry.investigator_status == 6 && entry.registration_status == 8 \n                    ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                    sort entry.created_at desc\n                    let tagAnswer = (\n                        for tagAns in entry.answers\n                            return {\n                                [tagAns.question_id]: tagAns.answer.answer\n                            }\n                    )\n                    \n                    let patientDetail = entry.patient_id ? first(\n                        for patient in patients\n                            filter patient.is_active == true && patient.patient_id == entry.patient_id\n                            return patient\n                    ) : {}\n                    \n                    let newAnswer = merge(entry,merge(tagAnswer),patientDetail)\n                    ").concat(searchEntry ? "filter ".concat(searchEntry) : '', " \n                    return newAnswer\n                )\n                \n                let statusArray = (\n                    for status in master_entry_status\n                    filter status.is_active == true && status.status_id in [5,6]\n                    sort status.status_id asc\n                        return {\n                            value : status.status_id,\n                            label : status.status_name\n                        }\n                )\n\n                let investigationColumn = first(\n                    for up in user_profiles\n                        filter up.is_active == true && up.user_profile_id == \"").concat(user_profile_id, "\"\n                            return up.investigation ? up.investigation : []\n                )\n                \n                let entryColumn = length(form_detail) > 0 && length(investigationColumn) == 0 ? slice(form_detail[0].column,0,3) : (\n                    for listCol in form_detail[0].column\n                        for profListCol in investigationColumn\n                            filter listCol.value in profListCol\n                                return listCol\n                )\n                \n                let for_investigation_column = append(\n                append([\n                      {\n                        type: 'sno',  \n                        title: 'S No',\n                        width: \"60px\"\n                      },\n                      {\n                        type: 'button',  \n                        title: 'Investigate',\n                        actionType: 'route',\n                        link: concat('/investigator/view/', \"").concat(formId, "\"),\n                        field: '',\n                        state: {\n                            isInvestigator: true,\n                        },\n                        width: \"60px\"\n                      }\n                    ],").concat(JSON.stringify(patientDataColumn), "\n                    ),\n                    append(entryColumn,[])\n                )\n\n                let column = append(\n                append([\n                    {\n                      type: 'sno',  \n                      title: 'S No',\n                      width: \"60px\"\n                    },  \n                    {\n                        type: 'button',  \n                        title: 'View',\n                        actionType: 'route',\n                        link: concat('/investigator/view/', \"").concat(formId, "\"),\n                        field: '',\n                        state: {\n                            isInvestigator: true,\n                        },\n                        width: \"60px\"\n                    }],").concat(JSON.stringify(patientDataColumn), "\n                    ),\n                    append(entryColumn,[\n                        {\n                            type: 'change_status',\n                            title: 'Status',\n                            field: '',\n                            options: statusArray,\n                        },\n                    ])\n                )\n\n                               \n                return {\n                    allStatus : (\n                        for status in master_entry_status\n                        filter status.is_active == true\n                        return status\n                    ),\n                    form_detail: length(form_detail) > 0 ? form_detail[0] : {},\n                    for_investigation : {\n                        column: for_investigation_column,\n                        row: for_investigation\n                    },\n                    investiated : {\n                        column,\n                        defaultStatus: statusArray[1] ? statusArray[1] : {},\n                        row: investiated\n                    },                    \n                }\n                ");

      default:
        return "";
    }
  }
};

var giveMeFilterForEntryBasedOnType = function giveMeFilterForEntryBasedOnType(type, key) {
  switch (type) {
    //Notifier
    case 0:
      return "filter ".concat(key, ".notifier_status in [1,9]");
    //Verifier    

    case 1:
      return "filter ".concat(key, ".notifier_status in [1]");
    //Register    

    case 2:
      return "filter ".concat(key, ".verifier_status in [3]");
    //Investigator    

    case 3:
      return "filter ".concat(key, ".registration_status in [8]");

    default:
      return '';
  }
};
var queries$4 = {
  //1. To get all render json
  getRenderJson: function getRenderJson(formId, entryId, secToShow, type, forms, created_by, countryIds, level) {
    return "\n        ".concat((forms === null || forms === void 0 ? void 0 : forms.length) === 0 && (countryIds === null || countryIds === void 0 ? void 0 : countryIds.length) > 0 ? "\n        let countryForms = (\n            for rl_d_f in rl_disease_form\n                filter rl_d_f.is_active == true && rl_d_f.country_id in ".concat(JSON.stringify(countryIds), "\n                    return rl_d_f.form_id\n        )\n        ") : "", "\n\n\n        for doc in forms \n            filter doc.form_id == \"").concat(formId, "\" && doc.is_active == true\n            ").concat((forms === null || forms === void 0 ? void 0 : forms.length) === 0 && (countryIds === null || countryIds === void 0 ? void 0 : countryIds.length) > 0 ? " \n            filter doc.form_id in countryForms \n            ".concat(created_by ? "|| doc.created_by == \"".concat(created_by, "\"") : "") : '', "\n            \n\n            let master_form_type = (\n                for mfty in master_form_types \n                    filter mfty.is_active == true && mfty.form_type_id == doc.form_type_id\n                    return {\n                        id: mfty.form_type_id,\n                        form_type: mfty.form_type_name\n                    }\n            )\n            \n            let form_detail = {\n                id: doc.form_id,\n                name: doc.form_name,\n                is_active: doc.is_active,\n                created_at: doc.created_at,\n                updated_at: doc.updated_at,\n                form_type: doc.form_type_id,\n                master_form_type: master_form_type[0],\n                mapped_diseases: (\n                    for mapForm in rl_disease_form\n                        filter mapForm.is_active == true && mapForm.form_id == doc.form_id\n                            return FIRST(for mapForm_disease in master_disease\n                                filter mapForm_disease.is_active == true && mapForm_disease.disease_id == mapForm.disease_id\n                                    return {\n                                        disease_name: mapForm_disease.disease_name,\n                                        disease_definition: mapForm_disease.disease_definition\n                                    }\n                            )       \n                ) \n            }\n            \n\n            let answers = (\n                for entry in form_entries \n                    filter entry.form_id==\"").concat(formId, "\" && entry.entry_id == \"").concat(entryId, "\"\n                    ").concat(giveMeFilterForEntryBasedOnType(type, "entry"), "\n                    ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                    return {\n                        bulkAnswers: entry,\n                        patientDetail: first(\n                            for patient in patients\n                                filter patient.is_active == true && patient.patient_id == entry.patient_id\n                                    return patient\n                        ),\n                        answers:    merge(\n                            for ans in entry.answers\n                                let qnDetail = first(\n                                    for qn in questions\n                                        filter qn.is_active == true && qn.question_id == ans.question_id\n                                        return {\n                                            tag: qn.tag,\n                                            ui_component: qn.ui_component\n                                        }\n                                )\n\n                                return {\n                                  [ans.question_id]:merge(ans.answer,qnDetail)\n                                }\n                        )\n                    }\n            )\n            \n            let tree = (for vertices , edges , paths in OUTBOUND CONCAT(\"forms/\" ,doc.form_id ) edge_form_section\n                filter vertices.parent_section_id == null && vertices.is_active == true ").concat((secToShow === null || secToShow === void 0 ? void 0 : secToShow.length) > 0 ? "&& vertices.section_type in ".concat(JSON.stringify(secToShow)) : "", "\n                sort vertices.priority ASC\n                return {\n                    id: vertices.section_id,\n                    form_id: vertices.form_id,\n                    is_form: vertices.is_form,\n                    section_name : vertices.section_name,\n                    description: vertices.description,\n                    formLayoutType:vertices.formLayoutType,\n                    priority: vertices.priority,\n                    is_skippable: vertices.is_skippable ? vertices.is_skippable :  false,\n                    is_smart_skip: vertices.is_smart_skip ? vertices.is_smart_skip : false,\n                    parent_section_id: vertices.parent_section_id,\n                    is_investigator_section: vertices.is_investigator_section,\n                    section_type: vertices.section_type,\n                    level: 1,\n                    is_active: vertices.is_active,\n                    created_by: vertices.created_at,\n                    updated_by: vertices.updated_at,\n                    framed_questions: (\n                        for qn in questions \n                            filter qn.section_id == vertices.section_id && qn.is_active == true\n                            sort qn.priority ASC\n                            return {\n                                id : qn.question_id,\n                                priority: IS_NULL(qn.priority) ? 1 : qn.priority,\n                                ui_component: qn.ui_component,\n                                is_required: qn.is_required,\n                                question: qn.question_name,\n                                question_options: qn.options,\n                                tag: qn.tag,\n                                table_scheme:qn.table_scheme,\n                                validation:qn.validation,\n                                has_dependency_qn: qn.has_dependency_qn,\n                                dependencies: qn.dependency ? qn.dependency : [],\n                                dependent: FIRST(\n                                    for dep_qn in dependency_questions\n                                        filter dep_qn.is_active == true && dep_qn.target_question_id == qn.question_id\n                                        return dep_qn\n                                )\n                            }\n                    ),\n                    dependent: FIRST(\n                        for dep_qn in dependency_questions\n                            filter dep_qn.is_active == true \n                            filter dep_qn.target_form_id == vertices.section_id || dep_qn.target_section_id == vertices.section_id\n                            return dep_qn\n                    ),\n                    child_sections: (\n                        for childSection1 in section\n                        filter childSection1.parent_section_id == vertices.section_id && childSection1.is_active == true\n                            sort childSection1.priority ASC\n                            return {\n                                id: childSection1.section_id,\n                                form_id: childSection1.form_id,\n                                is_form: childSection1.is_form,\n                                section_name : childSection1.section_name,\n                                description: childSection1.description,\n                                formLayoutType:childSection1.formLayoutType,\n                                priority: childSection1.priority,\n                                is_skippable: childSection1.is_skippable ? childSection1.is_skippable :  false,\n                                is_smart_skip: childSection1.is_smart_skip ? childSection1.is_smart_skip : false,\n                                parent_section_id: childSection1.parent_section_id,\n                                is_investigator_section: childSection1.is_investigator_section,\n                                section_type: childSection1.section_type,\n                                level: 2,\n                                is_active: childSection1.is_active,\n                                created_by: childSection1.created_at,\n                                updated_by: childSection1.updated_at,\n                                framed_questions: (\n                                    for qn1 in questions \n                                        filter qn1.section_id == childSection1.section_id && qn1.is_active == true\n                                        sort qn1.priority ASC\n                                        return {\n                                            id : qn1.question_id,\n                                            priority: IS_NULL(qn1.priority) ? 1 : qn1.priority,\n                                            ui_component: qn1.ui_component,\n                                            is_required: qn1.is_required,\n                                            question: qn1.question_name,\n                                            question_options: qn1.options,\n                                            tag: qn1.tag,\n                                            table_scheme:qn1.table_scheme,\n                                            validation:qn1.validation,\n                                            has_dependency_qn: qn1.has_dependency_qn,\n                                            dependencies: qn1.dependency ? qn1.dependency : [],\n                                            dependent: FIRST(\n                                                for dep_qn in dependency_questions\n                                                    filter dep_qn.is_active == true && dep_qn.target_question_id == qn1.question_id\n                                                    return dep_qn\n                                            )\n                                        }\n                                ),\n                                dependent: FIRST(\n                                    for dep_qn in dependency_questions\n                                        filter dep_qn.is_active == true \n                                        filter dep_qn.target_form_id == childSection1.section_id || dep_qn.target_section_id == childSection1.section_id\n                                        return dep_qn\n                                ),\n                                child_sections: (\n                                    for childSection2 in section\n                                    filter childSection2.parent_section_id == childSection1.section_id && childSection2.is_active == true\n                                    sort childSection2.priority ASC\n                                        return {\n                                            id: childSection2.section_id,\n                                            form_id: childSection2.form_id,\n                                            is_form: childSection2.is_form,\n                                            section_name : childSection2.section_name,\n                                            description: childSection2.description,\n                                            formLayoutType:childSection2.formLayoutType,\n                                            priority: childSection2.priority,\n                                            is_skippable: childSection2.is_skippable ? childSection2.is_skippable :  false,\n                                            is_smart_skip: childSection2.is_smart_skip ? childSection2.is_smart_skip : false,\n                                            parent_section_id: childSection2.parent_section_id,\n                                            is_investigator_section: childSection2.is_investigator_section,\n                                            section_type: childSection2.section_type,\n                                            level: 3,\n                                            is_active: childSection2.is_active,\n                                            created_by: childSection2.created_at,\n                                            updated_by: childSection2.updated_at,\n                                            framed_questions: (\n                                                for qn2 in questions \n                                                    filter qn2.section_id == childSection2.section_id && qn2.is_active == true\n                                                    sort qn2.priority ASC\n                                                    return {\n                                                        id : qn2.question_id,\n                                                        priority: IS_NULL(qn2.priority) ? 1 : qn2.priority,\n                                                        ui_component: qn2.ui_component,\n                                                        is_required: qn2.is_required,\n                                                        question: qn2.question_name,\n                                                        question_options: qn2.options,\n                                                        tag: qn2.tag,\n                                                        table_scheme:qn2.table_scheme,\n                                                        validation:qn2.validation,\n                                                        has_dependency_qn: qn2.has_dependency_qn,\n                                                        dependencies: qn2.dependency ? qn2.dependency : [],\n                                                        dependent: FIRST(\n                                                            for dep_qn in dependency_questions\n                                                                filter dep_qn.is_active == true && dep_qn.target_question_id == qn2.question_id\n                                                                return dep_qn\n                                                        )\n                                                    }\n                                            ),\n                                            dependent: FIRST(\n                                                for dep_qn in dependency_questions\n                                                    filter dep_qn.is_active == true \n                                                    filter dep_qn.target_form_id == childSection2.section_id || dep_qn.target_section_id == childSection2.section_id\n                                                    return dep_qn\n                                            ),\n                                            child_sections: (\n                                                for childSection3 in section\n                                                filter childSection3.parent_section_id == childSection2.section_id && childSection3.is_active == true\n                                                sort childSection3.priority ASC\n                                                    return  {\n                                                        id: childSection3.section_id,\n                                                        form_id: childSection3.form_id,\n                                                        is_form: childSection3.is_form,\n                                                        section_name : childSection3.section_name,\n                                                        description: childSection3.description,\n                                                        formLayoutType:childSection3.formLayoutType,\n                                                        priority: childSection3.priority,\n                                                        is_skippable: childSection3.is_skippable ? childSection3.is_skippable :  false,\n                                                        is_smart_skip: childSection3.is_smart_skip ? childSection3.is_smart_skip : false,\n                                                        parent_section_id: childSection3.parent_section_id,\n                                                        is_investigator_section: childSection3.is_investigator_section,\n                                                        section_type: childSection3.section_type,\n                                                        level: 4,\n                                                        is_active: childSection3.is_active,\n                                                        created_by: childSection3.created_at,\n                                                        updated_by: childSection3.updated_at,\n                                                        framed_questions: (\n                                                            for qn3 in questions \n                                                                filter qn3.section_id == childSection3.section_id && qn3.is_active == true\n                                                                sort qn3.priority ASC\n                                                                return {\n                                                                    id : qn3.question_id,\n                                                                    priority: IS_NULL(qn3.priority) ? 1 : qn3.priority,\n                                                                    ui_component: qn3.ui_component,\n                                                                    is_required: qn3.is_required,\n                                                                    question: qn3.question_name,\n                                                                    question_options: qn3.options,\n                                                                    tag: qn3.tag,\n                                                                    table_scheme:qn3.table_scheme,\n                                                                    validation:qn3.validation,\n                                                                    has_dependency_qn: qn3.has_dependency_qn,\n                                                                    dependencies: qn3.dependency ? qn3.dependency : [],\n                                                                    dependent: FIRST(\n                                                                        for dep_qn in dependency_questions\n                                                                            filter dep_qn.is_active == true && dep_qn.target_question_id == qn3.question_id\n                                                                            return dep_qn\n                                                                    )\n                                                                }\n                                                        ),            \n                                                        dependent: FIRST(\n                                                            for dep_qn in dependency_questions\n                                                                filter dep_qn.is_active == true \n                                                                filter dep_qn.target_form_id == childSection3.section_id || dep_qn.target_section_id == childSection3.section_id\n                                                                return dep_qn\n                                                        ),                                            \n                                                        child_sections:[]\n                                                    }\n                                            )\n                                        }\n                                )\n                            }\n                    )\n            })\n            \n            let form = (for tr in tree\n                return tr.is_form == true ? merge({expanded:[]} ,tr) : (\n                    for tr1 in tr.child_sections\n                        return tr1.is_form == true ? merge({expanded:[tr.id]}, tr1) : (\n                            for tr2 in tr1.child_sections\n                                return tr2.is_form == true ? merge({expanded:[tr.id,tr1.id]},tr2): (\n                                    for tr3 in tr2.child_sections\n                                        return tr3.is_form == true ? merge({expanded:[tr.id,tr1.id,tr2.id]},tr3) : (\n                                            for tr4 in tr3.child_sections\n                                                return merge({expanded: [tr.id,tr1.id,tr2.id,tr2.id]},tr4)\n                            )\n                        )\n                    )\n                )\n            )\n\n            let statusArray = (\n                for status in master_entry_status\n                filter status.is_active == true && status.status_id in ").concat(JSON.stringify(giveMeStatuArray(type)), "\n                sort status.status_id asc\n                    return {\n                        value : status.status_id,\n                        label : status.status_name\n                    }\n            )        \n                \n    return {\n        form_detail: form_detail,\n        tree: tree,\n        form: form[****],\n        bulkAnswers: answers[0] ? answers[0].bulkAnswers ? answers[0].bulkAnswers : {}  : {},\n        answers: answers[0] ? answers[0].answers ? answers[0].answers : {}  : {},\n        patientDetail: answers[0] ? answers[0].patientDetail ? answers[0].patientDetail : {}  : {},\n        statusArray: statusArray\n    }");
  }
};

var _extraReducers$3;
var GET_RENDER_JSON = createAsyncThunk("renderSlice/getRenderJson", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
  var payload,
      _ref2,
      rejectWithValue,
      _$,
      _ref3,
      formId,
      entryId,
      secToShow,
      type,
      forms,
      created_by,
      _payload$countryIds,
      countryIds,
      _payload$level,
      level,
      _,
      _args = arguments;

  return regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          formId = payload.formId, entryId = payload.entryId, secToShow = payload.secToShow, type = payload.type, forms = payload.forms, created_by = payload.created_by, _payload$countryIds = payload.countryIds, countryIds = _payload$countryIds === void 0 ? [] : _payload$countryIds, _payload$level = payload.level, level = _payload$level === void 0 ? {} : _payload$level;
          _context.next = 6;
          return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
            body: JSON.stringify({
              db_name: "".concat(process.env.REACT_APP_DB),
              query: queries$4.getRenderJson(formId, entryId, secToShow, type, forms, created_by, countryIds, level)
            })
          }));

        case 6:
          _ = _context.sent;
          _context.next = 9;
          return _.json();

        case 9:
          _ = _context.sent;
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: (_$ = (_ref3 = _) === null || _ref3 === void 0 ? void 0 : _ref3[0]) !== null && _$ !== void 0 ? _$ : {}
          }));

        case 13:
          _context.prev = 13;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context.t0.message
          })));

        case 16:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 13]]);
})));
var UPSERT_ENTRY = createAsyncThunk("formSlice/upsertForm", /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(payload, _ref4) {
    var rejectWithValue, getState, _getState, _getState$authSlice, _getState$authSlice$l, _getState$authSlice$l2, user_profile_id, data, entry_id, form_id, notifier_status, verifier_status, investigator_status, registration_status, location, _payload$notifyType, notifyType, _payload$roles, roles, _payload$patient_id, patient_id, doc, filter, answers, _;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            rejectWithValue = _ref4.rejectWithValue, getState = _ref4.getState;
            _context2.prev = 1;
            user_profile_id = (_getState = getState()) === null || _getState === void 0 ? void 0 : (_getState$authSlice = _getState.authSlice) === null || _getState$authSlice === void 0 ? void 0 : (_getState$authSlice$l = _getState$authSlice.login) === null || _getState$authSlice$l === void 0 ? void 0 : (_getState$authSlice$l2 = _getState$authSlice$l.data) === null || _getState$authSlice$l2 === void 0 ? void 0 : _getState$authSlice$l2.user_profile_id;
            data = payload.data, entry_id = payload.entry_id, form_id = payload.form_id, notifier_status = payload.notifier_status, verifier_status = payload.verifier_status, investigator_status = payload.investigator_status, registration_status = payload.registration_status, location = payload.location, _payload$notifyType = payload.notifyType, notifyType = _payload$notifyType === void 0 ? 0 : _payload$notifyType, _payload$roles = payload.roles, roles = _payload$roles === void 0 ? [] : _payload$roles, _payload$patient_id = payload.patient_id, patient_id = _payload$patient_id === void 0 ? null : _payload$patient_id;
            doc = {};
            filter = null;
            doc.patient_id = patient_id;
            doc[statusUpdatedBy[payload.secName]] = user_profile_id;
            doc[statusUpdatedByDate[payload.secName]] = new Date().toISOString();
            doc.form_id = form_id;
            doc.is_active = true;

            if (!entry_id) {
              filter = null;
              doc.created_at = new Date().toISOString();
              doc.created_by = user_profile_id ? user_profile_id : "user profile id not available";
              doc.notifier_status = 1;
              doc.verifier_status = 2;
              doc.investigator_status = 5;
              doc.registration_status = 7;
              if (notifier_status) doc.notifier_status = notifier_status;
              if (verifier_status) doc.verifier_status = verifier_status;
              if (investigator_status) doc.investigator_status = investigator_status;
              if (registration_status) doc.registration_status = registration_status;
            } else {
              if (notifier_status) doc.notifier_status = notifier_status;
              if (verifier_status) doc.verifier_status = verifier_status;
              if (investigator_status) doc.investigator_status = investigator_status;
              if (registration_status) doc.registration_status = registration_status;
              filter = {
                "_key": entry_id
              };
            }

            doc.updated_at = new Date().toISOString();
            doc.updated_by = user_profile_id ? user_profile_id : "user profile id not available";
            doc.entry_id = entry_id ? entry_id : v4();
            doc._key = doc.entry_id;
            doc.location = location;
            answers = Object.values(data);
            doc.answers = answers.map(function (ans, index) {
              return {
                question_id: ans.id,
                answer: ans
              };
            });
            _context2.next = 21;
            return fetch("".concat(__baseUrl__, "/upsert_document"), _objectSpread2(_objectSpread2({}, __options({
              notifyType: notifyType,
              "user-profile-id": user_profile_id,
              "entry-id": doc.entry_id,
              "form-id": doc.form_id,
              roles: roles,
              "revert-user-profile-id": doc[statusUpdatedBy[payload.secName - 1]]
            })), {}, {
              body: JSON.stringify([_objectSpread2(_objectSpread2({}, upsertQuery.upsertEntry), {}, {
                filter: filter,
                doc: doc
              })])
            }));

          case 21:
            _ = _context2.sent;
            _context2.next = 24;
            return _.json();

          case 24:
            _ = _context2.sent;
            return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
              data: _
            }));

          case 28:
            _context2.prev = 28;
            _context2.t0 = _context2["catch"](1);
            return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context2.t0.message
            })));

          case 31:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 28]]);
  }));

  return function (_x, _x2) {
    return _ref5.apply(this, arguments);
  };
}());
var renderSlice = createSlice({
  name: "renderSlice",
  initialState: {
    getRenderJson: _objectSpread2({}, defaultState.List),
    upsertEntry: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$3 = {}, _defineProperty(_extraReducers$3, GET_RENDER_JSON.fulfilled, function (state, action) {
    var _action$payload;

    state.getRenderJson = (_action$payload = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload !== void 0 ? _action$payload : {};
  }), _defineProperty(_extraReducers$3, GET_RENDER_JSON.pending, function (state, action) {
    state.getRenderJson.loading = true;
  }), _defineProperty(_extraReducers$3, GET_RENDER_JSON.rejected, function (state, action) {
    var _action$payload2;

    state.getRenderJson = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$3, UPSERT_ENTRY.fulfilled, function (state, action) {
    var _action$payload3;

    state.upsertEntry = (_action$payload3 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload3 !== void 0 ? _action$payload3 : {};
  }), _defineProperty(_extraReducers$3, UPSERT_ENTRY.pending, function (state, action) {
    state.upsertEntry.loading = true;
  }), _defineProperty(_extraReducers$3, UPSERT_ENTRY.rejected, function (state, action) {
    var _action$payload4;

    state.upsertEntry = (_action$payload4 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload4 !== void 0 ? _action$payload4 : {};
  }), _extraReducers$3)
});
var renderActions = {
  GET_RENDER_JSON: GET_RENDER_JSON,
  UPSERT_ENTRY: UPSERT_ENTRY
};
var renderSlice$1 = renderSlice.reducer;

var _extraReducers$4;
var GET_ALL_NOTIFIABLE_FORMS = createAsyncThunk("workflowSlice/getAllNotifiableForms", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
  var payload,
      _ref2,
      rejectWithValue,
      getState,
      formName,
      sortField,
      sortDirection,
      formTypeId,
      formId,
      _payload$icd,
      icd10,
      _payload$classificati,
      classification,
      forms,
      created_by,
      _payload$countryIds,
      countryIds,
      _,
      _args = arguments;

  return regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue, getState = _ref2.getState;
          _context.prev = 2;
          formName = payload.formName, sortField = payload.sortField, sortDirection = payload.sortDirection, formTypeId = payload.formTypeId, formId = payload.formId, _payload$icd = payload.icd10, icd10 = _payload$icd === void 0 ? [] : _payload$icd, _payload$classificati = payload.classification, classification = _payload$classificati === void 0 ? [] : _payload$classificati, forms = payload.forms, created_by = payload.created_by, _payload$countryIds = payload.countryIds, countryIds = _payload$countryIds === void 0 ? [] : _payload$countryIds;
          _context.next = 6;
          return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
            body: JSON.stringify({
              db_name: "".concat(process.env.REACT_APP_DB),
              query: queries$3.getAllNotifiableForms(formName, sortField, sortDirection, formTypeId, formId, icd10, classification, forms, created_by, countryIds)
            })
          }));

        case 6:
          _ = _context.sent;
          _context.next = 9;
          return _.json();

        case 9:
          _ = _context.sent;
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: _
          }));

        case 13:
          _context.prev = 13;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context.t0.message
          })));

        case 16:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 13]]);
})));
var SUGGESTIVE_SEARCH_NOTIFIABLE_FORMS = createAsyncThunk("workflowSlice/suggestiveSearchNotifiableForms", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
  var payload,
      _ref4,
      rejectWithValue,
      getState,
      formObj,
      formName,
      sortField,
      sortDirection,
      formTypeId,
      formId,
      _payload$icd2,
      icd10,
      _payload$classificati2,
      classification,
      _,
      _args2 = arguments;

  return regeneratorRuntime.wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
          _ref4 = _args2.length > 1 ? _args2[1] : undefined, rejectWithValue = _ref4.rejectWithValue, getState = _ref4.getState;
          _context2.prev = 2;
          formObj = {};
          formName = payload.formName, sortField = payload.sortField, sortDirection = payload.sortDirection, formTypeId = payload.formTypeId, formId = payload.formId, _payload$icd2 = payload.icd10, icd10 = _payload$icd2 === void 0 ? [] : _payload$icd2, _payload$classificati2 = payload.classification, classification = _payload$classificati2 === void 0 ? [] : _payload$classificati2;
          _context2.next = 7;
          return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
            body: JSON.stringify({
              db_name: "".concat(process.env.REACT_APP_DB),
              query: queries$3.getAllNotifiableForms(formName, sortField, sortDirection, formTypeId, formId, icd10, classification, formObj)
            })
          }));

        case 7:
          _ = _context2.sent;
          _context2.next = 10;
          return _.json();

        case 10:
          _ = _context2.sent;
          return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: _
          }));

        case 14:
          _context2.prev = 14;
          _context2.t0 = _context2["catch"](2);
          return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context2.t0.message
          })));

        case 17:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[2, 14]]);
})));
var GET_ALL_VERIFICATION_FORMS = createAsyncThunk("workflowSlice/getAllVerificationForms", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
  var payload,
      _ref6,
      rejectWithValue,
      getState,
      formName,
      sortField,
      sortDirection,
      formTypeId,
      formId,
      _payload$icd3,
      icd10,
      _payload$classificati3,
      classification,
      forms,
      created_by,
      _payload$countryIds2,
      countryIds,
      _payload$level,
      level,
      _,
      _args3 = arguments;

  return regeneratorRuntime.wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
          _ref6 = _args3.length > 1 ? _args3[1] : undefined, rejectWithValue = _ref6.rejectWithValue, getState = _ref6.getState;
          _context3.prev = 2;
          formName = payload.formName, sortField = payload.sortField, sortDirection = payload.sortDirection, formTypeId = payload.formTypeId, formId = payload.formId, _payload$icd3 = payload.icd10, icd10 = _payload$icd3 === void 0 ? [] : _payload$icd3, _payload$classificati3 = payload.classification, classification = _payload$classificati3 === void 0 ? [] : _payload$classificati3, forms = payload.forms, created_by = payload.created_by, _payload$countryIds2 = payload.countryIds, countryIds = _payload$countryIds2 === void 0 ? [] : _payload$countryIds2, _payload$level = payload.level, level = _payload$level === void 0 ? {} : _payload$level;
          _context3.next = 6;
          return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
            body: JSON.stringify({
              db_name: "".concat(process.env.REACT_APP_DB),
              query: queries$3.getAllVerificationForms(formName, sortField, sortDirection, formTypeId, formId, icd10, classification, forms, created_by, countryIds, level)
            })
          }));

        case 6:
          _ = _context3.sent;
          _context3.next = 9;
          return _.json();

        case 9:
          _ = _context3.sent;
          return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: _
          }));

        case 13:
          _context3.prev = 13;
          _context3.t0 = _context3["catch"](2);
          return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context3.t0.message
          })));

        case 16:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3, null, [[2, 13]]);
})));
var SUGGESTIVE_SEARCH_VERIFICATION_FORMS = createAsyncThunk("workflowSlice/suggestiveSearchVerificationForms", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
  var payload,
      _ref8,
      rejectWithValue,
      getState,
      _getState,
      _getState$authSlice,
      _getState$authSlice$l,
      formObj,
      formName,
      sortField,
      sortDirection,
      formTypeId,
      formId,
      _payload$icd4,
      icd10,
      _payload$classificati4,
      classification,
      _,
      _args4 = arguments;

  return regeneratorRuntime.wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
          _ref8 = _args4.length > 1 ? _args4[1] : undefined, rejectWithValue = _ref8.rejectWithValue, getState = _ref8.getState;
          _context4.prev = 2;
          formObj = giveMeFormsToShow((_getState = getState()) === null || _getState === void 0 ? void 0 : (_getState$authSlice = _getState.authSlice) === null || _getState$authSlice === void 0 ? void 0 : (_getState$authSlice$l = _getState$authSlice.login) === null || _getState$authSlice$l === void 0 ? void 0 : _getState$authSlice$l.data);
          formName = payload.formName, sortField = payload.sortField, sortDirection = payload.sortDirection, formTypeId = payload.formTypeId, formId = payload.formId, _payload$icd4 = payload.icd10, icd10 = _payload$icd4 === void 0 ? [] : _payload$icd4, _payload$classificati4 = payload.classification, classification = _payload$classificati4 === void 0 ? [] : _payload$classificati4;
          _context4.next = 7;
          return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
            body: JSON.stringify({
              db_name: "".concat(process.env.REACT_APP_DB),
              query: queries$3.getAllVerificationForms(formName, sortField, sortDirection, formTypeId, formId, icd10, classification, formObj)
            })
          }));

        case 7:
          _ = _context4.sent;
          _context4.next = 10;
          return _.json();

        case 10:
          _ = _context4.sent;
          return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: _
          }));

        case 14:
          _context4.prev = 14;
          _context4.t0 = _context4["catch"](2);
          return _context4.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context4.t0.message
          })));

        case 17:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, null, [[2, 14]]);
})));
var GET_ALL_INVESTIGATION_FORMS = createAsyncThunk("workflowSlice/getAllInvestigationForms", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
  var payload,
      _ref10,
      rejectWithValue,
      getState,
      _getState2,
      _getState2$authSlice,
      _getState2$authSlice$,
      formObj,
      formName,
      sortField,
      sortDirection,
      formTypeId,
      formId,
      _payload$icd5,
      icd10,
      _payload$classificati5,
      classification,
      forms,
      created_by,
      _payload$countryIds3,
      countryIds,
      _payload$level2,
      level,
      _,
      _args5 = arguments;

  return regeneratorRuntime.wrap(function _callee5$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          payload = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
          _ref10 = _args5.length > 1 ? _args5[1] : undefined, rejectWithValue = _ref10.rejectWithValue, getState = _ref10.getState;
          _context5.prev = 2;
          formObj = giveMeFormsToShow((_getState2 = getState()) === null || _getState2 === void 0 ? void 0 : (_getState2$authSlice = _getState2.authSlice) === null || _getState2$authSlice === void 0 ? void 0 : (_getState2$authSlice$ = _getState2$authSlice.login) === null || _getState2$authSlice$ === void 0 ? void 0 : _getState2$authSlice$.data);
          formName = payload.formName, sortField = payload.sortField, sortDirection = payload.sortDirection, formTypeId = payload.formTypeId, formId = payload.formId, _payload$icd5 = payload.icd10, icd10 = _payload$icd5 === void 0 ? [] : _payload$icd5, _payload$classificati5 = payload.classification, classification = _payload$classificati5 === void 0 ? [] : _payload$classificati5, forms = payload.forms, created_by = payload.created_by, _payload$countryIds3 = payload.countryIds, countryIds = _payload$countryIds3 === void 0 ? [] : _payload$countryIds3, _payload$level2 = payload.level, level = _payload$level2 === void 0 ? {} : _payload$level2;
          _context5.next = 7;
          return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
            body: JSON.stringify({
              db_name: "".concat(process.env.REACT_APP_DB),
              query: queries$3.getAllInvestigationForms(formName, sortField, sortDirection, formTypeId, formId, icd10, classification, forms, created_by, countryIds, level)
            })
          }));

        case 7:
          _ = _context5.sent;
          _context5.next = 10;
          return _.json();

        case 10:
          _ = _context5.sent;
          return _context5.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: _
          }));

        case 14:
          _context5.prev = 14;
          _context5.t0 = _context5["catch"](2);
          return _context5.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context5.t0.message
          })));

        case 17:
        case "end":
          return _context5.stop();
      }
    }
  }, _callee5, null, [[2, 14]]);
})));
var SUGGESTIVE_SEARCH_INVESTIGATION_FORMS = createAsyncThunk("workflowSlice/suggestiveSearchInvestigationForms", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
  var payload,
      _ref12,
      rejectWithValue,
      getState,
      _getState3,
      _getState3$authSlice,
      _getState3$authSlice$,
      formObj,
      formName,
      sortField,
      sortDirection,
      formTypeId,
      formId,
      _payload$icd6,
      icd10,
      _payload$classificati6,
      classification,
      _,
      _args6 = arguments;

  return regeneratorRuntime.wrap(function _callee6$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          payload = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {};
          _ref12 = _args6.length > 1 ? _args6[1] : undefined, rejectWithValue = _ref12.rejectWithValue, getState = _ref12.getState;
          _context6.prev = 2;
          formObj = giveMeFormsToShow((_getState3 = getState()) === null || _getState3 === void 0 ? void 0 : (_getState3$authSlice = _getState3.authSlice) === null || _getState3$authSlice === void 0 ? void 0 : (_getState3$authSlice$ = _getState3$authSlice.login) === null || _getState3$authSlice$ === void 0 ? void 0 : _getState3$authSlice$.data);
          formName = payload.formName, sortField = payload.sortField, sortDirection = payload.sortDirection, formTypeId = payload.formTypeId, formId = payload.formId, _payload$icd6 = payload.icd10, icd10 = _payload$icd6 === void 0 ? [] : _payload$icd6, _payload$classificati6 = payload.classification, classification = _payload$classificati6 === void 0 ? [] : _payload$classificati6;
          _context6.next = 7;
          return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
            body: JSON.stringify({
              db_name: "".concat(process.env.REACT_APP_DB),
              query: queries$3.getAllInvestigationForms(formName, sortField, sortDirection, formTypeId, formId, icd10, classification, formObj)
            })
          }));

        case 7:
          _ = _context6.sent;
          _context6.next = 10;
          return _.json();

        case 10:
          _ = _context6.sent;
          return _context6.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: _
          }));

        case 14:
          _context6.prev = 14;
          _context6.t0 = _context6["catch"](2);
          return _context6.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context6.t0.message
          })));

        case 17:
        case "end":
          return _context6.stop();
      }
    }
  }, _callee6, null, [[2, 14]]);
})));
var GET_ALL_CASE_REGISTRATION_FORMS = createAsyncThunk("workflowSlice/getAllCaseRegistrationForms", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
  var payload,
      _ref14,
      rejectWithValue,
      getState,
      _getState4,
      _getState4$authSlice,
      _getState4$authSlice$,
      formObj,
      formName,
      sortField,
      sortDirection,
      formTypeId,
      formId,
      _payload$icd7,
      icd10,
      _payload$classificati7,
      classification,
      forms,
      created_by,
      _payload$countryIds4,
      countryIds,
      _payload$level3,
      level,
      _,
      _args7 = arguments;

  return regeneratorRuntime.wrap(function _callee7$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          payload = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {};
          _ref14 = _args7.length > 1 ? _args7[1] : undefined, rejectWithValue = _ref14.rejectWithValue, getState = _ref14.getState;
          _context7.prev = 2;
          formObj = giveMeFormsToShow((_getState4 = getState()) === null || _getState4 === void 0 ? void 0 : (_getState4$authSlice = _getState4.authSlice) === null || _getState4$authSlice === void 0 ? void 0 : (_getState4$authSlice$ = _getState4$authSlice.login) === null || _getState4$authSlice$ === void 0 ? void 0 : _getState4$authSlice$.data);
          formName = payload.formName, sortField = payload.sortField, sortDirection = payload.sortDirection, formTypeId = payload.formTypeId, formId = payload.formId, _payload$icd7 = payload.icd10, icd10 = _payload$icd7 === void 0 ? [] : _payload$icd7, _payload$classificati7 = payload.classification, classification = _payload$classificati7 === void 0 ? [] : _payload$classificati7, forms = payload.forms, created_by = payload.created_by, _payload$countryIds4 = payload.countryIds, countryIds = _payload$countryIds4 === void 0 ? [] : _payload$countryIds4, _payload$level3 = payload.level, level = _payload$level3 === void 0 ? {} : _payload$level3;
          _context7.next = 7;
          return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
            body: JSON.stringify({
              db_name: "".concat(process.env.REACT_APP_DB),
              query: queries$3.getAllCaseRegistrationForms(formName, sortField, sortDirection, formTypeId, formId, icd10, classification, forms, created_by, countryIds, level)
            })
          }));

        case 7:
          _ = _context7.sent;
          _context7.next = 10;
          return _.json();

        case 10:
          _ = _context7.sent;
          return _context7.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: _
          }));

        case 14:
          _context7.prev = 14;
          _context7.t0 = _context7["catch"](2);
          return _context7.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context7.t0.message
          })));

        case 17:
        case "end":
          return _context7.stop();
      }
    }
  }, _callee7, null, [[2, 14]]);
})));
var SUGGESTIVE_SEARCH_CASE_REGISTRATION_FORMS = createAsyncThunk("workflowSlice/suggestiveSearchCaseRegistrationForms", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
  var payload,
      _ref16,
      rejectWithValue,
      getState,
      _getState5,
      _getState5$authSlice,
      _getState5$authSlice$,
      formObj,
      formName,
      sortField,
      sortDirection,
      formTypeId,
      formId,
      _payload$icd8,
      icd10,
      _payload$classificati8,
      classification,
      _,
      _args8 = arguments;

  return regeneratorRuntime.wrap(function _callee8$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          payload = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {};
          _ref16 = _args8.length > 1 ? _args8[1] : undefined, rejectWithValue = _ref16.rejectWithValue, getState = _ref16.getState;
          _context8.prev = 2;
          formObj = giveMeFormsToShow((_getState5 = getState()) === null || _getState5 === void 0 ? void 0 : (_getState5$authSlice = _getState5.authSlice) === null || _getState5$authSlice === void 0 ? void 0 : (_getState5$authSlice$ = _getState5$authSlice.login) === null || _getState5$authSlice$ === void 0 ? void 0 : _getState5$authSlice$.data);
          formName = payload.formName, sortField = payload.sortField, sortDirection = payload.sortDirection, formTypeId = payload.formTypeId, formId = payload.formId, _payload$icd8 = payload.icd10, icd10 = _payload$icd8 === void 0 ? [] : _payload$icd8, _payload$classificati8 = payload.classification, classification = _payload$classificati8 === void 0 ? [] : _payload$classificati8;
          _context8.next = 7;
          return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
            body: JSON.stringify({
              db_name: "".concat(process.env.REACT_APP_DB),
              query: queries$3.getAllInvestigationForms(formName, sortField, sortDirection, formTypeId, formId, icd10, classification, formObj)
            })
          }));

        case 7:
          _ = _context8.sent;
          _context8.next = 10;
          return _.json();

        case 10:
          _ = _context8.sent;
          return _context8.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: _
          }));

        case 14:
          _context8.prev = 14;
          _context8.t0 = _context8["catch"](2);
          return _context8.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context8.t0.message
          })));

        case 17:
        case "end":
          return _context8.stop();
      }
    }
  }, _callee8, null, [[2, 14]]);
})));
var GET_ENTRIES_BY_FORM_ID = createAsyncThunk("workflowSlice/getEntriesByFormId", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
  var payload,
      _ref18,
      rejectWithValue,
      getState,
      _getState$authSlice$l2,
      _getState6,
      _getState6$authSlice,
      _getState6$authSlice$,
      _$,
      _ref20,
      formId,
      type,
      _payload$searchEntry,
      searchEntry,
      _payload$countryIds5,
      countryIds,
      _payload$level4,
      level,
      _ref19,
      user_profile_id,
      _,
      _args9 = arguments;

  return regeneratorRuntime.wrap(function _callee9$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          payload = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : {};
          _ref18 = _args9.length > 1 ? _args9[1] : undefined, rejectWithValue = _ref18.rejectWithValue, getState = _ref18.getState;
          _context9.prev = 2;
          formId = payload.formId, type = payload.type, _payload$searchEntry = payload.searchEntry, searchEntry = _payload$searchEntry === void 0 ? '' : _payload$searchEntry, _payload$countryIds5 = payload.countryIds, countryIds = _payload$countryIds5 === void 0 ? [] : _payload$countryIds5, _payload$level4 = payload.level, level = _payload$level4 === void 0 ? {} : _payload$level4;
          _ref19 = (_getState$authSlice$l2 = (_getState6 = getState()) === null || _getState6 === void 0 ? void 0 : (_getState6$authSlice = _getState6.authSlice) === null || _getState6$authSlice === void 0 ? void 0 : (_getState6$authSlice$ = _getState6$authSlice.login) === null || _getState6$authSlice$ === void 0 ? void 0 : _getState6$authSlice$.data) !== null && _getState$authSlice$l2 !== void 0 ? _getState$authSlice$l2 : {
            user_profile_id: user_profile_id
          }, user_profile_id = _ref19.user_profile_id;

          if (type) {
            _context9.next = 7;
            break;
          }

          throw "'type' not sent";

        case 7:
          _context9.next = 9;
          return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
            body: JSON.stringify({
              db_name: "".concat(process.env.REACT_APP_DB),
              query: queries$3.getEntriesByFormId(formId, type, user_profile_id, searchEntry, countryIds, level)
            })
          }));

        case 9:
          _ = _context9.sent;
          _context9.next = 12;
          return _.json();

        case 12:
          _ = _context9.sent;
          return _context9.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: (_$ = (_ref20 = _) === null || _ref20 === void 0 ? void 0 : _ref20[0]) !== null && _$ !== void 0 ? _$ : {}
          }));

        case 16:
          _context9.prev = 16;
          _context9.t0 = _context9["catch"](2);
          return _context9.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context9.t0.message
          })));

        case 19:
        case "end":
          return _context9.stop();
      }
    }
  }, _callee9, null, [[2, 16]]);
})));
var UPDATE_ENTRY_STATUS = createAsyncThunk("workflowSlice/updateEntryStatus", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
  var payload,
      _ref22,
      rejectWithValue,
      getState,
      _getState7,
      _getState7$authSlice,
      _getState7$authSlice$,
      _getState7$authSlice$2,
      _getState8,
      _getState8$authSlice,
      _getState8$authSlice$,
      _getState8$authSlice$2,
      _getState8$authSlice$3,
      _payload$reason,
      user_profile_id,
      roles,
      customHeader,
      filter,
      _,
      _args10 = arguments;

  return regeneratorRuntime.wrap(function _callee10$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          payload = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : {};
          _ref22 = _args10.length > 1 ? _args10[1] : undefined, rejectWithValue = _ref22.rejectWithValue, getState = _ref22.getState;
          _context10.prev = 2;
          user_profile_id = (_getState7 = getState()) === null || _getState7 === void 0 ? void 0 : (_getState7$authSlice = _getState7.authSlice) === null || _getState7$authSlice === void 0 ? void 0 : (_getState7$authSlice$ = _getState7$authSlice.login) === null || _getState7$authSlice$ === void 0 ? void 0 : (_getState7$authSlice$2 = _getState7$authSlice$.data) === null || _getState7$authSlice$2 === void 0 ? void 0 : _getState7$authSlice$2.user_profile_id;
          roles = (_getState8 = getState()) === null || _getState8 === void 0 ? void 0 : (_getState8$authSlice = _getState8.authSlice) === null || _getState8$authSlice === void 0 ? void 0 : (_getState8$authSlice$ = _getState8$authSlice.login) === null || _getState8$authSlice$ === void 0 ? void 0 : (_getState8$authSlice$2 = _getState8$authSlice$.data) === null || _getState8$authSlice$2 === void 0 ? void 0 : (_getState8$authSlice$3 = _getState8$authSlice$2.mapped_roles) === null || _getState8$authSlice$3 === void 0 ? void 0 : _getState8$authSlice$3.map(function (_) {
            return _.role_id;
          });
          payload[statusUpdatedBy[payload.secName]] = user_profile_id;
          payload[statusUpdatedByDate[payload.secName]] = new Date().toISOString();
          payload.updated_at = new Date().toISOString();
          payload.updated_by = user_profile_id;
          customHeader = {
            notifyType: payload.notifyType,
            "user-profile-id": user_profile_id,
            "entry-id": payload.entry_id,
            "form-id": payload.form_id,
            roles: roles,
            "revert-user-profile-id": payload[statusUpdatedBy[payload.secName - 1]],
            reason: (_payload$reason = payload === null || payload === void 0 ? void 0 : payload.reason) !== null && _payload$reason !== void 0 ? _payload$reason : ""
          };
          delete payload.notifyType;
          delete payload.secName;
          delete payload.reason;
          filter = {
            "_key": payload.entry_id
          };
          _context10.next = 16;
          return fetch("".concat(__baseUrl__, "/upsert_document"), _objectSpread2(_objectSpread2({}, __options(customHeader)), {}, {
            body: JSON.stringify([_objectSpread2(_objectSpread2({}, upsertQuery.upsertEntry), {}, {
              filter: filter,
              doc: payload
            })])
          }));

        case 16:
          _ = _context10.sent;
          _context10.next = 19;
          return _.json();

        case 19:
          _ = _context10.sent;
          return _context10.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: _
          }));

        case 23:
          _context10.prev = 23;
          _context10.t0 = _context10["catch"](2);
          return _context10.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context10.t0.message
          })));

        case 26:
        case "end":
          return _context10.stop();
      }
    }
  }, _callee10, null, [[2, 23]]);
})));
var DELETE_ENTRY = createAsyncThunk("workflowSlice/deleteEntry", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
  var payload,
      _ref24,
      rejectWithValue,
      getState,
      filter,
      _,
      _args11 = arguments;

  return regeneratorRuntime.wrap(function _callee11$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          payload = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : {};
          _ref24 = _args11.length > 1 ? _args11[1] : undefined, rejectWithValue = _ref24.rejectWithValue, getState = _ref24.getState;
          _context11.prev = 2;
          filter = {
            "_key": payload.entry_id
          };
          _context11.next = 6;
          return fetch("".concat(__baseUrl__, "/upsert_document"), _objectSpread2(_objectSpread2({}, __options()), {}, {
            body: JSON.stringify([_objectSpread2(_objectSpread2({}, upsertQuery.upsertEntry), {}, {
              filter: filter,
              doc: {
                is_active: false
              }
            })])
          }));

        case 6:
          _ = _context11.sent;
          _context11.next = 9;
          return _.json();

        case 9:
          _ = _context11.sent;
          return _context11.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: _
          }));

        case 13:
          _context11.prev = 13;
          _context11.t0 = _context11["catch"](2);
          return _context11.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context11.t0.message
          })));

        case 16:
        case "end":
          return _context11.stop();
      }
    }
  }, _callee11, null, [[2, 13]]);
})));
var ADD_COLUMN_TO_LIST = createAsyncThunk("workflowSlice/addColumnToList", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
  var payload,
      _ref26,
      rejectWithValue,
      filter,
      _,
      _args12 = arguments;

  return regeneratorRuntime.wrap(function _callee12$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          payload = _args12.length > 0 && _args12[0] !== undefined ? _args12[0] : {};
          _ref26 = _args12.length > 1 ? _args12[1] : undefined, rejectWithValue = _ref26.rejectWithValue;
          _context12.prev = 2;
          payload.updated_at = new Date().toISOString();
          filter = {
            "_key": payload.user_profile_id
          };
          _context12.next = 7;
          return fetch("".concat(__baseUrl__, "/upsert_document"), _objectSpread2(_objectSpread2({}, __options()), {}, {
            body: JSON.stringify([_objectSpread2(_objectSpread2({}, upsertQuery.upsertUser), {}, {
              filter: filter,
              doc: payload
            })])
          }));

        case 7:
          _ = _context12.sent;
          _context12.next = 10;
          return _.json();

        case 10:
          _ = _context12.sent;
          return _context12.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: _
          }));

        case 14:
          _context12.prev = 14;
          _context12.t0 = _context12["catch"](2);
          return _context12.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context12.t0.message
          })));

        case 17:
        case "end":
          return _context12.stop();
      }
    }
  }, _callee12, null, [[2, 14]]);
})));
var workflowSlice = createSlice({
  name: "workflowSlice",
  initialState: {
    getAllNotifiableForms: _objectSpread2({}, defaultState.List),
    suggestiveSearchNotifiableForms: _objectSpread2({}, defaultState.List),
    getAllVerificationForms: _objectSpread2({}, defaultState.List),
    suggestiveSearchVerificationForms: _objectSpread2({}, defaultState.List),
    getAllInvestigationForms: _objectSpread2({}, defaultState.List),
    suggestiveSearchInvestigationForms: _objectSpread2({}, defaultState.List),
    getAllCaseRegistrationForms: _objectSpread2({}, defaultState.List),
    suggestiveSearchCaseRegistrationForms: _objectSpread2({}, defaultState.List),
    getEntriesByFormId: _objectSpread2({}, defaultState.Info),
    updateEntryStatus: _objectSpread2({}, defaultState.Info),
    deleteEntry: _objectSpread2({}, defaultState.Info),
    addColumnToList: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$4 = {}, _defineProperty(_extraReducers$4, GET_ALL_NOTIFIABLE_FORMS.fulfilled, function (state, action) {
    var _action$payload;

    state.getAllNotifiableForms = (_action$payload = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload !== void 0 ? _action$payload : {};
  }), _defineProperty(_extraReducers$4, GET_ALL_NOTIFIABLE_FORMS.pending, function (state, action) {
    state.getAllNotifiableForms.loading = true;
  }), _defineProperty(_extraReducers$4, GET_ALL_NOTIFIABLE_FORMS.rejected, function (state, action) {
    var _action$payload2;

    state.getAllNotifiableForms = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$4, SUGGESTIVE_SEARCH_NOTIFIABLE_FORMS.fulfilled, function (state, action) {
    var _action$payload3;

    state.suggestiveSearchNotifiableForms = (_action$payload3 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload3 !== void 0 ? _action$payload3 : {};
  }), _defineProperty(_extraReducers$4, SUGGESTIVE_SEARCH_NOTIFIABLE_FORMS.pending, function (state, action) {
    state.suggestiveSearchNotifiableForms.loading = true;
  }), _defineProperty(_extraReducers$4, SUGGESTIVE_SEARCH_NOTIFIABLE_FORMS.rejected, function (state, action) {
    var _action$payload4;

    state.suggestiveSearchNotifiableForms = (_action$payload4 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload4 !== void 0 ? _action$payload4 : {};
  }), _defineProperty(_extraReducers$4, GET_ALL_VERIFICATION_FORMS.fulfilled, function (state, action) {
    var _action$payload5;

    state.getAllVerificationForms = (_action$payload5 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload5 !== void 0 ? _action$payload5 : {};
  }), _defineProperty(_extraReducers$4, GET_ALL_VERIFICATION_FORMS.pending, function (state, action) {
    state.getAllVerificationForms.loading = true;
  }), _defineProperty(_extraReducers$4, GET_ALL_VERIFICATION_FORMS.rejected, function (state, action) {
    var _action$payload6;

    state.getAllVerificationForms = (_action$payload6 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload6 !== void 0 ? _action$payload6 : {};
  }), _defineProperty(_extraReducers$4, SUGGESTIVE_SEARCH_VERIFICATION_FORMS.fulfilled, function (state, action) {
    var _action$payload7;

    state.suggestiveSearchVerificationForms = (_action$payload7 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload7 !== void 0 ? _action$payload7 : {};
  }), _defineProperty(_extraReducers$4, SUGGESTIVE_SEARCH_VERIFICATION_FORMS.pending, function (state, action) {
    state.suggestiveSearchVerificationForms.loading = true;
  }), _defineProperty(_extraReducers$4, SUGGESTIVE_SEARCH_VERIFICATION_FORMS.rejected, function (state, action) {
    var _action$payload8;

    state.suggestiveSearchVerificationForms = (_action$payload8 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload8 !== void 0 ? _action$payload8 : {};
  }), _defineProperty(_extraReducers$4, GET_ALL_INVESTIGATION_FORMS.fulfilled, function (state, action) {
    var _action$payload9;

    state.getAllInvestigationForms = (_action$payload9 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload9 !== void 0 ? _action$payload9 : {};
  }), _defineProperty(_extraReducers$4, GET_ALL_INVESTIGATION_FORMS.pending, function (state, action) {
    state.getAllInvestigationForms.loading = true;
  }), _defineProperty(_extraReducers$4, GET_ALL_INVESTIGATION_FORMS.rejected, function (state, action) {
    var _action$payload10;

    state.getAllInvestigationForms = (_action$payload10 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload10 !== void 0 ? _action$payload10 : {};
  }), _defineProperty(_extraReducers$4, SUGGESTIVE_SEARCH_INVESTIGATION_FORMS.fulfilled, function (state, action) {
    var _action$payload11;

    state.suggestiveSearchInvestigationForms = (_action$payload11 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload11 !== void 0 ? _action$payload11 : {};
  }), _defineProperty(_extraReducers$4, SUGGESTIVE_SEARCH_INVESTIGATION_FORMS.pending, function (state, action) {
    state.suggestiveSearchInvestigationForms.loading = true;
  }), _defineProperty(_extraReducers$4, SUGGESTIVE_SEARCH_INVESTIGATION_FORMS.rejected, function (state, action) {
    var _action$payload12;

    state.suggestiveSearchInvestigationForms = (_action$payload12 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload12 !== void 0 ? _action$payload12 : {};
  }), _defineProperty(_extraReducers$4, GET_ALL_CASE_REGISTRATION_FORMS.fulfilled, function (state, action) {
    var _action$payload13;

    state.getAllCaseRegistrationForms = (_action$payload13 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload13 !== void 0 ? _action$payload13 : {};
  }), _defineProperty(_extraReducers$4, GET_ALL_CASE_REGISTRATION_FORMS.pending, function (state, action) {
    state.getAllCaseRegistrationForms.loading = true;
  }), _defineProperty(_extraReducers$4, GET_ALL_CASE_REGISTRATION_FORMS.rejected, function (state, action) {
    var _action$payload14;

    state.getAllCaseRegistrationForms = (_action$payload14 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload14 !== void 0 ? _action$payload14 : {};
  }), _defineProperty(_extraReducers$4, SUGGESTIVE_SEARCH_CASE_REGISTRATION_FORMS.fulfilled, function (state, action) {
    var _action$payload15;

    state.suggestiveSearchCaseRegistrationForms = (_action$payload15 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload15 !== void 0 ? _action$payload15 : {};
  }), _defineProperty(_extraReducers$4, SUGGESTIVE_SEARCH_CASE_REGISTRATION_FORMS.pending, function (state, action) {
    state.suggestiveSearchCaseRegistrationForms.loading = true;
  }), _defineProperty(_extraReducers$4, SUGGESTIVE_SEARCH_CASE_REGISTRATION_FORMS.rejected, function (state, action) {
    var _action$payload16;

    state.suggestiveSearchCaseRegistrationForms = (_action$payload16 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload16 !== void 0 ? _action$payload16 : {};
  }), _defineProperty(_extraReducers$4, GET_ENTRIES_BY_FORM_ID.fulfilled, function (state, action) {
    var _action$payload17;

    state.getEntriesByFormId = (_action$payload17 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload17 !== void 0 ? _action$payload17 : {};
  }), _defineProperty(_extraReducers$4, GET_ENTRIES_BY_FORM_ID.pending, function (state, action) {
    state.getEntriesByFormId.loading = true;
  }), _defineProperty(_extraReducers$4, GET_ENTRIES_BY_FORM_ID.rejected, function (state, action) {
    var _action$payload18;

    state.getEntriesByFormId = (_action$payload18 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload18 !== void 0 ? _action$payload18 : {};
  }), _defineProperty(_extraReducers$4, UPDATE_ENTRY_STATUS.fulfilled, function (state, action) {
    var _action$payload19;

    state.updateEntryStatus = (_action$payload19 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload19 !== void 0 ? _action$payload19 : {};
  }), _defineProperty(_extraReducers$4, UPDATE_ENTRY_STATUS.pending, function (state, action) {
    state.updateEntryStatus.loading = true;
  }), _defineProperty(_extraReducers$4, UPDATE_ENTRY_STATUS.rejected, function (state, action) {
    var _action$payload20;

    state.updateEntryStatus = (_action$payload20 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload20 !== void 0 ? _action$payload20 : {};
  }), _defineProperty(_extraReducers$4, DELETE_ENTRY.fulfilled, function (state, action) {
    var _action$payload21;

    state.deleteEntry = (_action$payload21 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload21 !== void 0 ? _action$payload21 : {};
  }), _defineProperty(_extraReducers$4, DELETE_ENTRY.pending, function (state, action) {
    state.deleteEntry.loading = true;
  }), _defineProperty(_extraReducers$4, DELETE_ENTRY.rejected, function (state, action) {
    var _action$payload22;

    state.deleteEntry = (_action$payload22 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload22 !== void 0 ? _action$payload22 : {};
  }), _defineProperty(_extraReducers$4, ADD_COLUMN_TO_LIST.fulfilled, function (state, action) {
    var _action$payload23;

    state.addColumnToList = (_action$payload23 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload23 !== void 0 ? _action$payload23 : {};
  }), _defineProperty(_extraReducers$4, ADD_COLUMN_TO_LIST.pending, function (state, action) {
    state.addColumnToList.loading = true;
  }), _defineProperty(_extraReducers$4, ADD_COLUMN_TO_LIST.rejected, function (state, action) {
    var _action$payload24;

    state.addColumnToList = (_action$payload24 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload24 !== void 0 ? _action$payload24 : {};
  }), _extraReducers$4)
});
var workflowActions = {
  GET_ALL_NOTIFIABLE_FORMS: GET_ALL_NOTIFIABLE_FORMS,
  SUGGESTIVE_SEARCH_NOTIFIABLE_FORMS: SUGGESTIVE_SEARCH_NOTIFIABLE_FORMS,
  GET_ALL_VERIFICATION_FORMS: GET_ALL_VERIFICATION_FORMS,
  SUGGESTIVE_SEARCH_VERIFICATION_FORMS: SUGGESTIVE_SEARCH_VERIFICATION_FORMS,
  GET_ALL_INVESTIGATION_FORMS: GET_ALL_INVESTIGATION_FORMS,
  SUGGESTIVE_SEARCH_INVESTIGATION_FORMS: SUGGESTIVE_SEARCH_INVESTIGATION_FORMS,
  GET_ALL_CASE_REGISTRATION_FORMS: GET_ALL_CASE_REGISTRATION_FORMS,
  SUGGESTIVE_SEARCH_CASE_REGISTRATION_FORMS: SUGGESTIVE_SEARCH_CASE_REGISTRATION_FORMS,
  GET_ENTRIES_BY_FORM_ID: GET_ENTRIES_BY_FORM_ID,
  UPDATE_ENTRY_STATUS: UPDATE_ENTRY_STATUS,
  DELETE_ENTRY: DELETE_ENTRY,
  ADD_COLUMN_TO_LIST: ADD_COLUMN_TO_LIST
};
var workflowSlice$1 = workflowSlice.reducer;

var queries$5 = {
  //1. To get all Roles
  getAllRoles: function getAllRoles(roleName, sortField, sortDirection, roleId, myRole, countryIds, created_by) {
    return "\n        for role in roles\n        filter role.is_active == true \n        ".concat(created_by ? "|| role.created_by == \"".concat(created_by, "\" ") : "", "\n        filter UPPER(role.role_name) like \"").concat(roleName.toUpperCase(), "%\"\n        ").concat(myRole !== null && myRole !== void 0 && myRole.length ? "filter role.role_id not in ".concat(JSON.stringify(myRole)) : "", "\n        ").concat(countryIds !== null && countryIds !== void 0 && countryIds.length ? "filter role.data_security.country.country_id in ".concat(JSON.stringify(countryIds)) : "", "\n        ").concat(roleId ? "FILTER role.role_id == \"".concat(roleId, "\"") : "", "\n        SORT role.").concat(sortField, " ").concat(sortDirection, " \n            return merge(role,{\n                value:role.role_id,\n                label:role.role_name\n            })\n        ");
  },
  //2. To get role by id
  getRoleId: function getRoleId(roleId) {
    return "\n        for role in roles\n        filter role.is_active == true && role.role_id==\"".concat(roleId, "\"\n            return role\n        ");
  },
  //3. To get role by user id
  getRolesByUserId: function getRolesByUserId(userId, myRole, countryIds, created_by) {
    return "\n        for role in roles\n            filter role.is_active == true \n            ".concat(myRole !== null && myRole !== void 0 && myRole.length ? "filter role.role_id not in ".concat(JSON.stringify(myRole)) : "", "\n            ").concat(countryIds !== null && countryIds !== void 0 && countryIds.length ? "filter role.data_security.country.country_id in ".concat(JSON.stringify(countryIds)) : "", "\n            ").concat(created_by ? "|| role.created_by == \"".concat(created_by, "\" ") : "", "\n                let mapped_profiles = (\n                    for up in user_roles\n                        filter up.is_active == true && up.user_profile_id == \"").concat(userId, "\" && up.role_id == role.role_id\n                        return up\n                )\n                return merge(\n                    role,\n                    {\n                        is_mapped: length(mapped_profiles) > 0 ? true : false\n                    },\n                    {\n                        mapped_edge: mapped_profiles[0] ? mapped_profiles[0] : {}\n                    }\n                )\n        ");
  },
  //4. To get Notifications Actions
  getNotificationsAction: function getNotificationsAction() {
    return "\n        for action in master_notification_actions\n        filter action.is_active == true\n            return  merge(action,{\n                value:action.notification_action_id,\n                label:action.action_name\n            })\n        ";
  },
  //5. To get notification_actions
  getManageNotificationById: function getManageNotificationById(roleId) {
    return "\n    for notification in notification_flow\n    filter notification.is_active == true && notification.role_id==\"".concat(roleId, "\"\n        return notification\n    ");
  }
};

var _extraReducers$5;
var UPSERT_ROLE = createAsyncThunk("roleSlice/upsertRole", /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(payload, _ref) {
    var _getState, _getState$authSlice, _getState$authSlice$l, _getState$authSlice$l2;

    var rejectWithValue, getState, user_profile_id, isActive, roleId, roleName, roleDescription, isRoleActive, previlages, data_security, doc, _;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            rejectWithValue = _ref.rejectWithValue, getState = _ref.getState;
            user_profile_id = (_getState = getState()) === null || _getState === void 0 ? void 0 : (_getState$authSlice = _getState.authSlice) === null || _getState$authSlice === void 0 ? void 0 : (_getState$authSlice$l = _getState$authSlice.login) === null || _getState$authSlice$l === void 0 ? void 0 : (_getState$authSlice$l2 = _getState$authSlice$l.data) === null || _getState$authSlice$l2 === void 0 ? void 0 : _getState$authSlice$l2.user_profile_id;
            _context.prev = 2;
            isActive = payload.isActive, roleId = payload.roleId, roleName = payload.roleName, roleDescription = payload.roleDescription, isRoleActive = payload.isRoleActive, previlages = payload.previlages, data_security = payload.data_security;
            doc = {};
            doc.is_active = isActive === null ? true : isActive;
            doc.is_role_active = isRoleActive === null ? true : isRoleActive;
            if (previlages) doc.previlages = previlages;
            if (data_security) doc.data_security = data_security;

            if (!roleId) {
              doc.created_at = new Date().toISOString();
              doc.created_by = user_profile_id ? user_profile_id : "user profile id not available";
              doc.is_active = true;
              doc.is_role_active = true;
            }

            doc.updated_at = new Date().toISOString();
            doc.updated_by = user_profile_id ? user_profile_id : "user profile id not available";
            roleId = roleId ? roleId : v4();
            doc.role_id = roleId;
            doc._key = roleId;
            doc.role_description = roleDescription;

            if (roleName) {
              doc.role_name = roleName;
            }

            _context.next = 19;
            return fetch("".concat(__baseUrl__, "/upsert_document"), _objectSpread2(_objectSpread2({}, __options()), {}, {
              body: JSON.stringify([_objectSpread2(_objectSpread2({}, upsertQuery.upsertRole), {}, {
                filter: {
                  role_id: String(roleId)
                },
                doc: doc
              })])
            }));

          case 19:
            _ = _context.sent;
            _context.next = 22;
            return _.json();

          case 22:
            _ = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
              data: _
            }));

          case 26:
            _context.prev = 26;
            _context.t0 = _context["catch"](2);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 29:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 26]]);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());
var GET_ALL_ROLES = createAsyncThunk("roleSlice/getAllRoles", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
  var payload,
      _ref4,
      rejectWithValue,
      _payload$roleName,
      roleName,
      _payload$sortField,
      sortField,
      _payload$sortDirectio,
      sortDirection,
      roleId,
      _payload$myRole,
      myRole,
      _payload$countryIds,
      countryIds,
      created_by,
      _,
      _args2 = arguments;

  return regeneratorRuntime.wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
          _ref4 = _args2.length > 1 ? _args2[1] : undefined, rejectWithValue = _ref4.rejectWithValue;
          _context2.prev = 2;
          _payload$roleName = payload.roleName, roleName = _payload$roleName === void 0 ? "" : _payload$roleName, _payload$sortField = payload.sortField, sortField = _payload$sortField === void 0 ? 'role_name' : _payload$sortField, _payload$sortDirectio = payload.sortDirection, sortDirection = _payload$sortDirectio === void 0 ? 'ASC' : _payload$sortDirectio, roleId = payload.roleId, _payload$myRole = payload.myRole, myRole = _payload$myRole === void 0 ? [] : _payload$myRole, _payload$countryIds = payload.countryIds, countryIds = _payload$countryIds === void 0 ? [] : _payload$countryIds, created_by = payload.created_by;
          _context2.next = 6;
          return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
            body: JSON.stringify({
              db_name: "".concat(process.env.REACT_APP_DB),
              query: queries$5.getAllRoles(roleName, sortField, sortDirection, roleId, myRole, countryIds, created_by)
            })
          }));

        case 6:
          _ = _context2.sent;
          _context2.next = 9;
          return _.json();

        case 9:
          _ = _context2.sent;
          return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: _
          }));

        case 13:
          _context2.prev = 13;
          _context2.t0 = _context2["catch"](2);
          return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context2.t0.message
          })));

        case 16:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[2, 13]]);
})));
var SUGGESTIVE_SEARCH_ALL_ROLES = createAsyncThunk("roleSlice/sugestivesearchAllRoles", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
  var payload,
      _ref6,
      rejectWithValue,
      _payload$roleName2,
      roleName,
      _payload$sortField2,
      sortField,
      _payload$sortDirectio2,
      sortDirection,
      roleId,
      _,
      _args3 = arguments;

  return regeneratorRuntime.wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
          _ref6 = _args3.length > 1 ? _args3[1] : undefined, rejectWithValue = _ref6.rejectWithValue;
          _context3.prev = 2;
          _payload$roleName2 = payload.roleName, roleName = _payload$roleName2 === void 0 ? "" : _payload$roleName2, _payload$sortField2 = payload.sortField, sortField = _payload$sortField2 === void 0 ? 'role_name' : _payload$sortField2, _payload$sortDirectio2 = payload.sortDirection, sortDirection = _payload$sortDirectio2 === void 0 ? 'ASC' : _payload$sortDirectio2, roleId = payload.roleId;
          _context3.next = 6;
          return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
            body: JSON.stringify({
              db_name: "".concat(process.env.REACT_APP_DB),
              query: queries$5.getAllRoles(roleName, sortField, sortDirection, roleId)
            })
          }));

        case 6:
          _ = _context3.sent;
          _context3.next = 9;
          return _.json();

        case 9:
          _ = _context3.sent;
          return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: _
          }));

        case 13:
          _context3.prev = 13;
          _context3.t0 = _context3["catch"](2);
          return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context3.t0.message
          })));

        case 16:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3, null, [[2, 13]]);
})));
var GET_ROLE_BY_ID = createAsyncThunk("roleSlice/roleById", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
  var payload,
      _ref8,
      rejectWithValue,
      _$,
      _ref9,
      _payload$roleId,
      roleId,
      _,
      _args4 = arguments;

  return regeneratorRuntime.wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
          _ref8 = _args4.length > 1 ? _args4[1] : undefined, rejectWithValue = _ref8.rejectWithValue;
          _context4.prev = 2;
          _payload$roleId = payload.roleId, roleId = _payload$roleId === void 0 ? "" : _payload$roleId;
          _context4.next = 6;
          return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
            body: JSON.stringify({
              db_name: "".concat(process.env.REACT_APP_DB),
              query: queries$5.getRoleId(roleId)
            })
          }));

        case 6:
          _ = _context4.sent;
          _context4.next = 9;
          return _.json();

        case 9:
          _ = _context4.sent;
          return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: (_$ = (_ref9 = _) === null || _ref9 === void 0 ? void 0 : _ref9[0]) !== null && _$ !== void 0 ? _$ : {}
          }));

        case 13:
          _context4.prev = 13;
          _context4.t0 = _context4["catch"](2);
          return _context4.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context4.t0.message
          })));

        case 16:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, null, [[2, 13]]);
})));
var GET_MANAGE_NOTIFICATION_BY_ID = createAsyncThunk("roleSlice/getManageNotificationById", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
  var payload,
      _ref11,
      rejectWithValue,
      _payload$roleId2,
      roleId,
      _,
      _args5 = arguments;

  return regeneratorRuntime.wrap(function _callee5$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          payload = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
          _ref11 = _args5.length > 1 ? _args5[1] : undefined, rejectWithValue = _ref11.rejectWithValue;
          _context5.prev = 2;
          _payload$roleId2 = payload.roleId, roleId = _payload$roleId2 === void 0 ? "" : _payload$roleId2;
          _context5.next = 6;
          return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
            body: JSON.stringify({
              db_name: "".concat(process.env.REACT_APP_DB),
              query: queries$5.getManageNotificationById(roleId)
            })
          }));

        case 6:
          _ = _context5.sent;
          _context5.next = 9;
          return _.json();

        case 9:
          _ = _context5.sent;
          return _context5.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: _
          }));

        case 13:
          _context5.prev = 13;
          _context5.t0 = _context5["catch"](2);
          return _context5.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context5.t0.message
          })));

        case 16:
        case "end":
          return _context5.stop();
      }
    }
  }, _callee5, null, [[2, 13]]);
})));
var GET_ROLES_BY_USER_ID = createAsyncThunk("roleSlice/getRolesByUserId", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
  var payload,
      _ref13,
      rejectWithValue,
      _payload$userId,
      userId,
      _payload$myRole2,
      myRole,
      _payload$countryIds2,
      countryIds,
      created_by,
      _,
      _args6 = arguments;

  return regeneratorRuntime.wrap(function _callee6$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          payload = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {};
          _ref13 = _args6.length > 1 ? _args6[1] : undefined, rejectWithValue = _ref13.rejectWithValue;
          _context6.prev = 2;
          _payload$userId = payload.userId, userId = _payload$userId === void 0 ? "" : _payload$userId, _payload$myRole2 = payload.myRole, myRole = _payload$myRole2 === void 0 ? [] : _payload$myRole2, _payload$countryIds2 = payload.countryIds, countryIds = _payload$countryIds2 === void 0 ? [] : _payload$countryIds2, created_by = payload.created_by;
          _context6.next = 6;
          return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
            body: JSON.stringify({
              db_name: "".concat(process.env.REACT_APP_DB),
              query: queries$5.getRolesByUserId(userId, myRole, countryIds, created_by)
            })
          }));

        case 6:
          _ = _context6.sent;
          _context6.next = 9;
          return _.json();

        case 9:
          _ = _context6.sent;
          return _context6.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: _
          }));

        case 13:
          _context6.prev = 13;
          _context6.t0 = _context6["catch"](2);
          return _context6.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context6.t0.message
          })));

        case 16:
        case "end":
          return _context6.stop();
      }
    }
  }, _callee6, null, [[2, 13]]);
})));
var MAP_UNMAP_ROLES_TO_PROFILE = createAsyncThunk("roleSlice/mapUnmapRole", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
  var _getState2, _getState2$authSlice, _getState2$authSlice$, _getState2$authSlice$2;

  var payload,
      _ref15,
      rejectWithValue,
      getState,
      user_profile_id,
      roleId,
      userProfileId,
      isActive,
      mapId,
      mappedLocation,
      doc,
      filter,
      _,
      _args7 = arguments;

  return regeneratorRuntime.wrap(function _callee7$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          payload = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {};
          _ref15 = _args7.length > 1 ? _args7[1] : undefined, rejectWithValue = _ref15.rejectWithValue, getState = _ref15.getState;
          user_profile_id = (_getState2 = getState()) === null || _getState2 === void 0 ? void 0 : (_getState2$authSlice = _getState2.authSlice) === null || _getState2$authSlice === void 0 ? void 0 : (_getState2$authSlice$ = _getState2$authSlice.login) === null || _getState2$authSlice$ === void 0 ? void 0 : (_getState2$authSlice$2 = _getState2$authSlice$.data) === null || _getState2$authSlice$2 === void 0 ? void 0 : _getState2$authSlice$2.user_profile_id;
          _context7.prev = 3;
          roleId = payload.roleId, userProfileId = payload.userProfileId, isActive = payload.isActive, mapId = payload.mapId, mappedLocation = payload.mappedLocation;
          doc = {};
          doc.is_active = isActive;
          doc.role_id = roleId;
          doc.mapped_location = mappedLocation;
          doc._from = "roles/" + roleId;
          doc.user_profile_id = userProfileId;
          doc._to = "user_profiles/" + userProfileId;
          doc.created_at = new Date().toISOString();
          doc.created_by = user_profile_id ? user_profile_id : "user profile id not available";
          doc.updated_at = new Date().toISOString();
          doc.updated_by = user_profile_id ? user_profile_id : "user profile id not available";
          filter = null;

          if (mapId) {
            filter = {
              _key: mapId
            };
          } else {
            mapId = v4();
            doc._key = mapId;
          }

          _context7.next = 20;
          return fetch("".concat(__baseUrl__, "/upsert_document"), _objectSpread2(_objectSpread2({}, __options()), {}, {
            body: JSON.stringify([_objectSpread2(_objectSpread2({}, upsertQuery.upsertEdgeUserRole), {}, {
              filter: filter,
              doc: doc
            })])
          }));

        case 20:
          _ = _context7.sent;
          _context7.next = 23;
          return _.json();

        case 23:
          _ = _context7.sent;
          return _context7.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: _
          }));

        case 27:
          _context7.prev = 27;
          _context7.t0 = _context7["catch"](3);
          return _context7.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context7.t0.message
          })));

        case 30:
        case "end":
          return _context7.stop();
      }
    }
  }, _callee7, null, [[3, 27]]);
})));
var GET_NOTIFICATIONS_ACTIONS = createAsyncThunk("roleSlice/getNotificationsAction", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
  var payload,
      _ref17,
      rejectWithValue,
      _,
      _args8 = arguments;

  return regeneratorRuntime.wrap(function _callee8$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          payload = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {};
          _ref17 = _args8.length > 1 ? _args8[1] : undefined, rejectWithValue = _ref17.rejectWithValue;
          _context8.prev = 2;
          _context8.next = 5;
          return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
            body: JSON.stringify({
              db_name: "".concat(process.env.REACT_APP_DB),
              query: queries$5.getNotificationsAction()
            })
          }));

        case 5:
          _ = _context8.sent;
          _context8.next = 8;
          return _.json();

        case 8:
          _ = _context8.sent;
          return _context8.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: _
          }));

        case 12:
          _context8.prev = 12;
          _context8.t0 = _context8["catch"](2);
          return _context8.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context8.t0.message
          })));

        case 15:
        case "end":
          return _context8.stop();
      }
    }
  }, _callee8, null, [[2, 12]]);
})));
var MANAGE_NOTIFICATION_TABLE = createAsyncThunk("roleSlice/manageNotificationTable", /*#__PURE__*/function () {
  var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(payload, _ref18) {
    var _getState3, _getState3$authSlice, _getState3$authSlice$, _getState3$authSlice$2;

    var rejectWithValue, getState, user_profile_id, isActive, roleId, roleName, manage_notification, doc, _;

    return regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            rejectWithValue = _ref18.rejectWithValue, getState = _ref18.getState;
            user_profile_id = (_getState3 = getState()) === null || _getState3 === void 0 ? void 0 : (_getState3$authSlice = _getState3.authSlice) === null || _getState3$authSlice === void 0 ? void 0 : (_getState3$authSlice$ = _getState3$authSlice.login) === null || _getState3$authSlice$ === void 0 ? void 0 : (_getState3$authSlice$2 = _getState3$authSlice$.data) === null || _getState3$authSlice$2 === void 0 ? void 0 : _getState3$authSlice$2.user_profile_id;
            _context9.prev = 2;
            isActive = payload.isActive, roleId = payload.roleId, roleName = payload.roleName, manage_notification = payload.manage_notification;
            doc = {};
            doc.is_active = isActive === null ? true : isActive;

            if (manage_notification) {
              doc.manage_notification = manage_notification;
            }

            if (!roleId) {
              doc.created_at = new Date().toISOString();
              doc.created_by = user_profile_id ? user_profile_id : "user profile id not available";
              doc.is_active = true;
            }

            doc.updated_at = new Date().toISOString();
            doc.updated_by = user_profile_id ? user_profile_id : "user profile id not available";
            roleId = roleId;
            doc.role_id = roleId;
            doc._key = roleId;

            if (roleName) {
              doc.role_name = roleName;
            }

            _context9.next = 16;
            return fetch("".concat(__baseUrl__, "/upsert_document"), _objectSpread2(_objectSpread2({}, __options()), {}, {
              body: JSON.stringify([_objectSpread2(_objectSpread2({}, upsertQuery.upsertManageNotification), {}, {
                filter: {
                  role_id: String(roleId)
                },
                doc: doc
              })])
            }));

          case 16:
            _ = _context9.sent;
            _context9.next = 19;
            return _.json();

          case 19:
            _ = _context9.sent;
            return _context9.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
              data: _
            }));

          case 23:
            _context9.prev = 23;
            _context9.t0 = _context9["catch"](2);
            return _context9.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context9.t0.message
            })));

          case 26:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[2, 23]]);
  }));

  return function (_x3, _x4) {
    return _ref19.apply(this, arguments);
  };
}());
var roleSlice = createSlice({
  name: "roleSlice",
  initialState: {
    getAllRoles: _objectSpread2({}, defaultState.List),
    getNotificationsAction: _objectSpread2({}, defaultState.List),
    sugestivesearchAllRoles: _objectSpread2({}, defaultState.List),
    getRolesByUserId: _objectSpread2({}, defaultState.List),
    roleById: _objectSpread2({}, defaultState.Info),
    getManageNotificationById: _objectSpread2({}, defaultState.List),
    mapUnmapRole: _objectSpread2({}, defaultState.Info),
    upsertRole: _objectSpread2({}, defaultState.Info),
    manageNotificationTable: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$5 = {}, _defineProperty(_extraReducers$5, GET_ALL_ROLES.fulfilled, function (state, action) {
    var _action$payload;

    state.getAllRoles = (_action$payload = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload !== void 0 ? _action$payload : {};
  }), _defineProperty(_extraReducers$5, GET_ALL_ROLES.pending, function (state, action) {
    state.getAllRoles.loading = true;
  }), _defineProperty(_extraReducers$5, GET_ALL_ROLES.rejected, function (state, action) {
    var _action$payload2;

    state.getAllRoles = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$5, SUGGESTIVE_SEARCH_ALL_ROLES.fulfilled, function (state, action) {
    var _action$payload3;

    state.sugestivesearchAllRoles = (_action$payload3 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload3 !== void 0 ? _action$payload3 : {};
  }), _defineProperty(_extraReducers$5, SUGGESTIVE_SEARCH_ALL_ROLES.pending, function (state, action) {
    state.sugestivesearchAllRoles.loading = true;
  }), _defineProperty(_extraReducers$5, SUGGESTIVE_SEARCH_ALL_ROLES.rejected, function (state, action) {
    var _action$payload4;

    state.sugestivesearchAllRoles = (_action$payload4 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload4 !== void 0 ? _action$payload4 : {};
  }), _defineProperty(_extraReducers$5, GET_ROLE_BY_ID.fulfilled, function (state, action) {
    var _action$payload5;

    state.roleById = (_action$payload5 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload5 !== void 0 ? _action$payload5 : {};
  }), _defineProperty(_extraReducers$5, GET_ROLE_BY_ID.pending, function (state, action) {
    state.roleById.loading = true;
  }), _defineProperty(_extraReducers$5, GET_ROLE_BY_ID.rejected, function (state, action) {
    var _action$payload6;

    state.roleById = (_action$payload6 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload6 !== void 0 ? _action$payload6 : {};
  }), _defineProperty(_extraReducers$5, GET_ROLES_BY_USER_ID.fulfilled, function (state, action) {
    var _action$payload7;

    state.getRolesByUserId = (_action$payload7 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload7 !== void 0 ? _action$payload7 : {};
  }), _defineProperty(_extraReducers$5, GET_ROLES_BY_USER_ID.pending, function (state, action) {
    state.getRolesByUserId.loading = true;
  }), _defineProperty(_extraReducers$5, GET_ROLES_BY_USER_ID.rejected, function (state, action) {
    var _action$payload8;

    state.getRolesByUserId = (_action$payload8 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload8 !== void 0 ? _action$payload8 : {};
  }), _defineProperty(_extraReducers$5, MAP_UNMAP_ROLES_TO_PROFILE.fulfilled, function (state, action) {
    var _action$payload9;

    state.mapUnmapRole = (_action$payload9 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload9 !== void 0 ? _action$payload9 : {};
  }), _defineProperty(_extraReducers$5, MAP_UNMAP_ROLES_TO_PROFILE.pending, function (state, action) {
    state.mapUnmapRole.loading = true;
  }), _defineProperty(_extraReducers$5, MAP_UNMAP_ROLES_TO_PROFILE.rejected, function (state, action) {
    var _action$payload10;

    state.mapUnmapRole = (_action$payload10 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload10 !== void 0 ? _action$payload10 : {};
  }), _defineProperty(_extraReducers$5, UPSERT_ROLE.fulfilled, function (state, action) {
    var _action$payload11;

    state.upsertRole = (_action$payload11 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload11 !== void 0 ? _action$payload11 : {};
  }), _defineProperty(_extraReducers$5, UPSERT_ROLE.pending, function (state, action) {
    state.upsertRole.loading = true;
  }), _defineProperty(_extraReducers$5, UPSERT_ROLE.rejected, function (state, action) {
    var _action$payload12;

    state.upsertRole = (_action$payload12 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload12 !== void 0 ? _action$payload12 : {};
  }), _defineProperty(_extraReducers$5, GET_NOTIFICATIONS_ACTIONS.fulfilled, function (state, action) {
    var _action$payload13;

    state.getNotificationsAction = (_action$payload13 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload13 !== void 0 ? _action$payload13 : {};
  }), _defineProperty(_extraReducers$5, GET_NOTIFICATIONS_ACTIONS.pending, function (state, action) {
    state.getNotificationsAction.loading = true;
  }), _defineProperty(_extraReducers$5, GET_NOTIFICATIONS_ACTIONS.rejected, function (state, action) {
    var _action$payload14;

    state.getNotificationsAction = (_action$payload14 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload14 !== void 0 ? _action$payload14 : {};
  }), _defineProperty(_extraReducers$5, MANAGE_NOTIFICATION_TABLE.fulfilled, function (state, action) {
    var _action$payload15;

    state.manageNotificationTable = (_action$payload15 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload15 !== void 0 ? _action$payload15 : {};
  }), _defineProperty(_extraReducers$5, MANAGE_NOTIFICATION_TABLE.pending, function (state, action) {
    state.manageNotificationTable.loading = true;
  }), _defineProperty(_extraReducers$5, MANAGE_NOTIFICATION_TABLE.rejected, function (state, action) {
    var _action$payload16;

    state.manageNotificationTable = (_action$payload16 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload16 !== void 0 ? _action$payload16 : {};
  }), _defineProperty(_extraReducers$5, GET_MANAGE_NOTIFICATION_BY_ID.fulfilled, function (state, action) {
    var _action$payload17;

    state.getManageNotificationById = (_action$payload17 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload17 !== void 0 ? _action$payload17 : {};
  }), _defineProperty(_extraReducers$5, GET_MANAGE_NOTIFICATION_BY_ID.pending, function (state, action) {
    state.getManageNotificationById.loading = true;
  }), _defineProperty(_extraReducers$5, GET_MANAGE_NOTIFICATION_BY_ID.rejected, function (state, action) {
    var _action$payload18;

    state.getManageNotificationById = (_action$payload18 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload18 !== void 0 ? _action$payload18 : {};
  }), _extraReducers$5)
});
var roleActions = {
  GET_ALL_ROLES: GET_ALL_ROLES,
  GET_NOTIFICATIONS_ACTIONS: GET_NOTIFICATIONS_ACTIONS,
  SUGGESTIVE_SEARCH_ALL_ROLES: SUGGESTIVE_SEARCH_ALL_ROLES,
  GET_ROLE_BY_ID: GET_ROLE_BY_ID,
  GET_ROLES_BY_USER_ID: GET_ROLES_BY_USER_ID,
  GET_MANAGE_NOTIFICATION_BY_ID: GET_MANAGE_NOTIFICATION_BY_ID,
  MAP_UNMAP_ROLES_TO_PROFILE: MAP_UNMAP_ROLES_TO_PROFILE,
  UPSERT_ROLE: UPSERT_ROLE,
  MANAGE_NOTIFICATION_TABLE: MANAGE_NOTIFICATION_TABLE
};
var roleSlice$1 = roleSlice.reducer;

var queries$6 = {
  //1. To get all user_profile
  getAllUsers: function getAllUsers(firstName, sortField, sortDirection, userProfileId, diseases, countryIds, created_by) {
    return "\n            ".concat(countryIds !== null && countryIds !== void 0 && countryIds.length ? "\n                let userProfileIds = (\n                    for role in roles\n                        filter role.is_active == true && role.data_security.country.country_id in ".concat(JSON.stringify(countryIds), "\n                            for userRoles in user_roles\n                                filter userRoles.is_active == true && userRoles.role_id == role.role_id\n                                    return userRoles.user_profile_id\n                )\n            ") : "", "\n\n            for user_profile in user_profiles\n                filter user_profile.is_active == true \n                ").concat(created_by ? "|| user_profile.created_by == \"".concat(created_by, "\"") : "", "\n                filter UPPER(user_profile.first_name) like \"").concat(firstName.toUpperCase(), "%\"\n                ").concat(userProfileId ? "FILTER user_profile.user_profile_id == \"".concat(userProfileId, "\"") : "", "\n                ").concat(countryIds !== null && countryIds !== void 0 && countryIds.length ? "FILTER user_profile.user_profile_id in userProfileIds" : "", "\n                ").concat(created_by ? "&& user_profile.user_profile_id != \"".concat(created_by, "\"") : "", "\n                SORT user_profile.").concat(sortField, " ").concat(sortDirection, " \n                        return user_profile\n        ");
  },
  //2. To get all users based on role
  getAllUsersByRoleId: function getAllUsersByRoleId(roleId) {
    return "\n            for user_role in user_roles\n                filter user_role.role_id == \"".concat(roleId, "\"\n                    return first(for user_profile in user_profiles\n                        filter user_profile.user_profile_id == user_role.user_profile_id\n                        filter user_profile.is_active == true\n                        filter user_profile.is_user_active == true\n                            return merge(user_profile,{value: user_profile.user_profile_id, label: concat(user_profile.first_name,' (',user_profile.email_id,')')})\n                    )\n        ");
  }
};

var _extraReducers$6;
var UPSERT_USER = createAsyncThunk("userSlice/upsertUser", /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(payload, _ref) {
    var rejectWithValue, getState, _getState, _getState$authSlice, _getState$authSlice$l, _getState$authSlice$l2, user_profile_id, _;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            rejectWithValue = _ref.rejectWithValue, getState = _ref.getState;
            _context.prev = 1;
            user_profile_id = (_getState = getState()) === null || _getState === void 0 ? void 0 : (_getState$authSlice = _getState.authSlice) === null || _getState$authSlice === void 0 ? void 0 : (_getState$authSlice$l = _getState$authSlice.login) === null || _getState$authSlice$l === void 0 ? void 0 : (_getState$authSlice$l2 = _getState$authSlice$l.data) === null || _getState$authSlice$l2 === void 0 ? void 0 : _getState$authSlice$l2.user_profile_id;
            _context.next = 5;
            return fetch("".concat(__baseUrl__, "/auth/user/create"), _objectSpread2(_objectSpread2({}, __options()), {}, {
              body: JSON.stringify(_objectSpread2(_objectSpread2({}, payload), {}, {
                upsertUser: upsertQuery.upsertUser,
                created_by: user_profile_id
              }))
            }));

          case 5:
            _ = _context.sent;
            _context.next = 8;
            return _.json();

          case 8:
            _ = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), _));

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 12]]);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());
var GET_ALL_USERS = createAsyncThunk("userSlice/getAllUsers", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
  var payload,
      _ref4,
      rejectWithValue,
      _payload$firstName,
      firstName,
      _payload$sortField,
      sortField,
      _payload$sortDirectio,
      sortDirection,
      userProfileId,
      _payload$diseases,
      diseases,
      _payload$countryIds,
      countryIds,
      created_by,
      _,
      _args2 = arguments;

  return regeneratorRuntime.wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
          _ref4 = _args2.length > 1 ? _args2[1] : undefined, rejectWithValue = _ref4.rejectWithValue;
          _context2.prev = 2;
          _payload$firstName = payload.firstName, firstName = _payload$firstName === void 0 ? "" : _payload$firstName, _payload$sortField = payload.sortField, sortField = _payload$sortField === void 0 ? 'first_name' : _payload$sortField, _payload$sortDirectio = payload.sortDirection, sortDirection = _payload$sortDirectio === void 0 ? 'ASC' : _payload$sortDirectio, userProfileId = payload.userProfileId, _payload$diseases = payload.diseases, diseases = _payload$diseases === void 0 ? [] : _payload$diseases, _payload$countryIds = payload.countryIds, countryIds = _payload$countryIds === void 0 ? [] : _payload$countryIds, created_by = payload.created_by;
          _context2.next = 6;
          return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
            body: JSON.stringify({
              db_name: "".concat(process.env.REACT_APP_DB),
              query: queries$6.getAllUsers(firstName, sortField, sortDirection, userProfileId, diseases, countryIds, created_by)
            })
          }));

        case 6:
          _ = _context2.sent;
          _context2.next = 9;
          return _.json();

        case 9:
          _ = _context2.sent;
          return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: _
          }));

        case 13:
          _context2.prev = 13;
          _context2.t0 = _context2["catch"](2);
          return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context2.t0.message
          })));

        case 16:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[2, 13]]);
})));
var GET_ALL_USERS_BY_ROLEID = createAsyncThunk("userSlice/getAllUsersByRoleId", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
  var payload,
      _ref6,
      rejectWithValue,
      roleId,
      _,
      _args3 = arguments;

  return regeneratorRuntime.wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
          _ref6 = _args3.length > 1 ? _args3[1] : undefined, rejectWithValue = _ref6.rejectWithValue;
          _context3.prev = 2;
          roleId = payload.roleId;
          _context3.next = 6;
          return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
            body: JSON.stringify({
              db_name: "".concat(process.env.REACT_APP_DB),
              query: queries$6.getAllUsersByRoleId(roleId)
            })
          }));

        case 6:
          _ = _context3.sent;
          _context3.next = 9;
          return _.json();

        case 9:
          _ = _context3.sent;
          return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: _
          }));

        case 13:
          _context3.prev = 13;
          _context3.t0 = _context3["catch"](2);
          return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context3.t0.message
          })));

        case 16:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3, null, [[2, 13]]);
})));
var SUGESTIVE_SEARCH_ALL_USERS = createAsyncThunk("userSlice/sugestiveSearchAllUsers", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
  var payload,
      _ref8,
      rejectWithValue,
      _payload$firstName2,
      firstName,
      _payload$sortField2,
      sortField,
      _payload$sortDirectio2,
      sortDirection,
      userProfileId,
      _,
      _args4 = arguments;

  return regeneratorRuntime.wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
          _ref8 = _args4.length > 1 ? _args4[1] : undefined, rejectWithValue = _ref8.rejectWithValue;
          _context4.prev = 2;
          _payload$firstName2 = payload.firstName, firstName = _payload$firstName2 === void 0 ? "" : _payload$firstName2, _payload$sortField2 = payload.sortField, sortField = _payload$sortField2 === void 0 ? 'first_name' : _payload$sortField2, _payload$sortDirectio2 = payload.sortDirection, sortDirection = _payload$sortDirectio2 === void 0 ? 'ASC' : _payload$sortDirectio2, userProfileId = payload.userProfileId;
          _context4.next = 6;
          return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
            body: JSON.stringify({
              db_name: "".concat(process.env.REACT_APP_DB),
              query: queries$6.getAllUsers(firstName, sortField, sortDirection, userProfileId)
            })
          }));

        case 6:
          _ = _context4.sent;
          _context4.next = 9;
          return _.json();

        case 9:
          _ = _context4.sent;
          return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: _
          }));

        case 13:
          _context4.prev = 13;
          _context4.t0 = _context4["catch"](2);
          return _context4.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context4.t0.message
          })));

        case 16:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, null, [[2, 13]]);
})));
var userSlice = createSlice({
  name: "userSlice",
  initialState: {
    getAllUsers: _objectSpread2({}, defaultState.List),
    getAllUsersByRoleId: _objectSpread2({}, defaultState.List),
    sugestiveSearchAllUsers: _objectSpread2({}, defaultState.List),
    upsertUser: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$6 = {}, _defineProperty(_extraReducers$6, GET_ALL_USERS.fulfilled, function (state, action) {
    var _action$payload;

    state.getAllUsers = (_action$payload = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload !== void 0 ? _action$payload : {};
  }), _defineProperty(_extraReducers$6, GET_ALL_USERS.pending, function (state, action) {
    state.getAllUsers.loading = true;
  }), _defineProperty(_extraReducers$6, GET_ALL_USERS.rejected, function (state, action) {
    var _action$payload2;

    state.getAllUsers = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$6, GET_ALL_USERS_BY_ROLEID.fulfilled, function (state, action) {
    var _action$payload3;

    state.getAllUsersByRoleId = (_action$payload3 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload3 !== void 0 ? _action$payload3 : {};
  }), _defineProperty(_extraReducers$6, GET_ALL_USERS_BY_ROLEID.pending, function (state, action) {
    state.getAllUsersByRoleId.loading = true;
  }), _defineProperty(_extraReducers$6, GET_ALL_USERS_BY_ROLEID.rejected, function (state, action) {
    var _action$payload4;

    state.getAllUsersByRoleId = (_action$payload4 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload4 !== void 0 ? _action$payload4 : {};
  }), _defineProperty(_extraReducers$6, SUGESTIVE_SEARCH_ALL_USERS.fulfilled, function (state, action) {
    var _action$payload5;

    state.sugestiveSearchAllUsers = (_action$payload5 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload5 !== void 0 ? _action$payload5 : {};
  }), _defineProperty(_extraReducers$6, SUGESTIVE_SEARCH_ALL_USERS.pending, function (state, action) {
    state.sugestiveSearchAllUsers.loading = true;
  }), _defineProperty(_extraReducers$6, SUGESTIVE_SEARCH_ALL_USERS.rejected, function (state, action) {
    var _action$payload6;

    state.sugestiveSearchAllUsers = (_action$payload6 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload6 !== void 0 ? _action$payload6 : {};
  }), _defineProperty(_extraReducers$6, UPSERT_USER.fulfilled, function (state, action) {
    var _action$payload7;

    state.upsertUser = (_action$payload7 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload7 !== void 0 ? _action$payload7 : {};
  }), _defineProperty(_extraReducers$6, UPSERT_USER.pending, function (state, action) {
    state.upsertUser.loading = true;
  }), _defineProperty(_extraReducers$6, UPSERT_USER.rejected, function (state, action) {
    var _action$payload8;

    state.upsertUser = (_action$payload8 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload8 !== void 0 ? _action$payload8 : {};
  }), _extraReducers$6)
});
var userActions = {
  GET_ALL_USERS: GET_ALL_USERS,
  GET_ALL_USERS_BY_ROLEID: GET_ALL_USERS_BY_ROLEID,
  SUGESTIVE_SEARCH_ALL_USERS: SUGESTIVE_SEARCH_ALL_USERS,
  UPSERT_USER: UPSERT_USER
};
var userSlice$1 = userSlice.reducer;

var queries$7 = {
  //1. To get logged in user details by email
  getUserDetailByEmail: function getUserDetailByEmail(email, password) {
    return "\n        for up in user_profiles \n            filter up.is_active == true && up.is_user_active == true && up.email_id == \"".concat(email, "\"\n            let role = (\n                for vertices , edges , paths in INBOUND up user_roles\n                    filter edges.is_active==true && vertices.is_active ==true && vertices.is_role_active == true\n                return vertices\n            )\n            return merge(up,{ mapped_roles : role })\n        ");
  }
};

var _extraReducers$7;
var LOGIN = createAsyncThunk("authSlice/login", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
  var payload,
      _ref2,
      rejectWithValue,
      email,
      password,
      _payload$isLogOut,
      isLogOut,
      _,
      _args = arguments;

  return regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          email = payload.email, password = payload.password, _payload$isLogOut = payload.isLogOut, isLogOut = _payload$isLogOut === void 0 ? false : _payload$isLogOut;

          if (!isLogOut) {
            _context.next = 6;
            break;
          }

          return _context.abrupt("return", _objectSpread2({}, defaultState.Info));

        case 6:
          _context.next = 8;
          return fetch("".concat(__baseUrl__, "/auth/login"), _objectSpread2(_objectSpread2({}, __options()), {}, {
            body: JSON.stringify({
              email: email,
              password: password,
              "db_name": "".concat(process.env.REACT_APP_DB)
            })
          }));

        case 8:
          _ = _context.sent;
          _context.next = 11;
          return _.json();

        case 11:
          _ = _context.sent;

          if (!_.error) {
            _context.next = 14;
            break;
          }

          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: {
              "message": _.message ? _.message : "Invalid Credentials"
            },
            error: true,
            loading: false,
            message: _.message ? _.message : "Invalid Credentials"
          }));

        case 14:
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: _.data
          }));

        case 17:
          _context.prev = 17;
          _context.t0 = _context["catch"](2);
          console.log('Auth Error :', _context.t0);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: "Invalid Credentials"
          })));

        case 21:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 17]]);
})));
var FORGOT_PASSWORD = createAsyncThunk("authSlice/forgotPassword", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
  var payload,
      _ref4,
      rejectWithValue,
      emailId,
      _,
      _args2 = arguments;

  return regeneratorRuntime.wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
          _ref4 = _args2.length > 1 ? _args2[1] : undefined, rejectWithValue = _ref4.rejectWithValue;
          _context2.prev = 2;
          emailId = payload.emailId;
          _context2.next = 6;
          return fetch("".concat(__baseUrl__, "/auth/forgot_password"), _objectSpread2(_objectSpread2({}, __options()), {}, {
            body: JSON.stringify({
              emailId: emailId,
              "db_name": "".concat(process.env.REACT_APP_DB)
            })
          }));

        case 6:
          _ = _context2.sent;
          _context2.next = 9;
          return _.json();

        case 9:
          _ = _context2.sent;

          if (!_.error) {
            _context2.next = 12;
            break;
          }

          return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: {
              "message": _.message ? _.message : "Invalid Credentials"
            },
            error: true,
            loading: false,
            message: _.message ? _.message : "Invalid Credentials"
          }));

        case 12:
          return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: _.data,
            error: false,
            loading: false,
            message: _.message ? _.message : "Invalid Credentials"
          }));

        case 15:
          _context2.prev = 15;
          _context2.t0 = _context2["catch"](2);
          console.log('Auth Error :', _context2.t0);
          return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: "Invalid Credentials"
          })));

        case 19:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[2, 15]]);
})));
var GIVE_ME_USER_PROFILE = createAsyncThunk("authSlice/userProfile", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
  var payload,
      _ref6,
      rejectWithValue,
      getState,
      _getState$authSlice,
      _getState$authSlice$l,
      data,
      _,
      _args3 = arguments;

  return regeneratorRuntime.wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
          _ref6 = _args3.length > 1 ? _args3[1] : undefined, rejectWithValue = _ref6.rejectWithValue, getState = _ref6.getState;
          _context3.prev = 2;
          data = (_getState$authSlice = getState().authSlice) === null || _getState$authSlice === void 0 ? void 0 : (_getState$authSlice$l = _getState$authSlice.login) === null || _getState$authSlice$l === void 0 ? void 0 : _getState$authSlice$l.data;
          _context3.next = 6;
          return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
            body: JSON.stringify({
              db_name: "".concat(process.env.REACT_APP_DB),
              query: queries$7.getUserDetailByEmail(data === null || data === void 0 ? void 0 : data.email_id)
            })
          }));

        case 6:
          _ = _context3.sent;
          _context3.next = 9;
          return _.json();

        case 9:
          _ = _context3.sent;

          if (!(_.length === 0)) {
            _context3.next = 12;
            break;
          }

          return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: {
              "message": "Invalid Credentials"
            },
            error: true,
            loading: false,
            message: "Invalid Credentials"
          }));

        case 12:
          return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: _objectSpread2(_objectSpread2({}, data), _[0])
          }));

        case 15:
          _context3.prev = 15;
          _context3.t0 = _context3["catch"](2);
          console.log('error:', _context3.t0);
          return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: "Invalid Credentials"
          })));

        case 19:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3, null, [[2, 15]]);
})));
var REFRESH = createAsyncThunk("authSlice/refresh", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
  var payload,
      _ref8,
      rejectWithValue,
      _,
      _args4 = arguments;

  return regeneratorRuntime.wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
          _ref8 = _args4.length > 1 ? _args4[1] : undefined, rejectWithValue = _ref8.rejectWithValue;
          _context4.prev = 2;
          _context4.next = 5;
          return fetch("".concat(__baseUrl__, "/auth/refresh"), {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "Authorization": localStorage.getItem('auth_token'),
              "dbname": "".concat(process.env.REACT_APP_DB)
            }
          });

        case 5:
          _ = _context4.sent;
          _context4.next = 8;
          return _.json();

        case 8:
          _ = _context4.sent;

          if (!_.error) {
            _context4.next = 11;
            break;
          }

          return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: {
              "message": _.message ? _.message : "Unauthorized Access"
            },
            error: true,
            loading: false,
            message: _.message ? _.message : "Unauthorized Access"
          }));

        case 11:
          return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: _.data,
            error: _.error
          }));

        case 14:
          _context4.prev = 14;
          _context4.t0 = _context4["catch"](2);
          console.log('Refresh Error :', _context4.t0);
          return _context4.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: "Unauthorized Access"
          })));

        case 18:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, null, [[2, 14]]);
})));
var authSlice = createSlice({
  name: "authSlice",
  initialState: {
    login: _objectSpread2({}, defaultState.Info),
    forgotPassword: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$7 = {}, _defineProperty(_extraReducers$7, LOGIN.fulfilled, function (state, action) {
    var _action$payload;

    state.login = (_action$payload = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload !== void 0 ? _action$payload : {};
  }), _defineProperty(_extraReducers$7, LOGIN.pending, function (state, action) {
    state.login.loading = true;
  }), _defineProperty(_extraReducers$7, LOGIN.rejected, function (state, action) {
    var _action$payload2;

    state.login = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$7, GIVE_ME_USER_PROFILE.fulfilled, function (state, action) {
    var _action$payload3;

    state.login = (_action$payload3 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload3 !== void 0 ? _action$payload3 : {};
  }), _defineProperty(_extraReducers$7, GIVE_ME_USER_PROFILE.pending, function (state, action) {
    state.login.loading = true;
  }), _defineProperty(_extraReducers$7, GIVE_ME_USER_PROFILE.rejected, function (state, action) {
    var _action$payload4;

    state.login = (_action$payload4 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload4 !== void 0 ? _action$payload4 : {};
  }), _defineProperty(_extraReducers$7, REFRESH.fulfilled, function (state, action) {
    var _action$payload5;

    state.login = (_action$payload5 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload5 !== void 0 ? _action$payload5 : {};
  }), _defineProperty(_extraReducers$7, REFRESH.pending, function (state, action) {
    state.login.loading = true;
  }), _defineProperty(_extraReducers$7, REFRESH.rejected, function (state, action) {
    var _action$payload6;

    state.login = (_action$payload6 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload6 !== void 0 ? _action$payload6 : {};
  }), _defineProperty(_extraReducers$7, FORGOT_PASSWORD.fulfilled, function (state, action) {
    var _action$payload7;

    state.forgotPassword = (_action$payload7 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload7 !== void 0 ? _action$payload7 : {};
  }), _defineProperty(_extraReducers$7, FORGOT_PASSWORD.pending, function (state, action) {
    state.forgotPassword.loading = true;
  }), _defineProperty(_extraReducers$7, FORGOT_PASSWORD.rejected, function (state, action) {
    var _action$payload8;

    state.forgotPassword = (_action$payload8 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload8 !== void 0 ? _action$payload8 : {};
  }), _extraReducers$7)
});
var authActions = {
  LOGIN: LOGIN,
  REFRESH: REFRESH,
  GIVE_ME_USER_PROFILE: GIVE_ME_USER_PROFILE,
  FORGOT_PASSWORD: FORGOT_PASSWORD
};
var authSlice$1 = authSlice.reducer;

var queries$8 = {
  //1. To get all Todo
  getAllTodo: function getAllTodo(profileId) {
    return "            \n        FOR td IN todos\n            FILTER td.is_active == true && td.assigned_to == \"".concat(profileId, "\"\n                SORT td.created_at DESC\n                    let createdUserDetail = first(\n                        for userDetail in user_profiles\n                            filter userDetail.is_active == true && userDetail.user_profile_id == td.created_by\n                                return userDetail\n                    )\n\n                    let formDetail = first(\n                        for form in forms\n                            filter form.is_active == true && form.form_id == td.form_id\n                                return form\n                    )\n\n                    let entryDetail = first(\n                        for entry in form_entries\n                            filter entry.is_active == true && entry.entry_id == td.entry_id\n                            let patientDetail = first(\n                                for patient in patients\n                                    filter patient.is_active == true && patient.patient_id == entry.patient_id\n                                        return patient\n                            )\n                            return {\n                                patient_name: patientDetail.patient_name,\n                                gender: patientDetail.gender,\n                                mobile: patientDetail.mobile,\n                                email: patientDetail.email\n                            }\n                    )\n\n\n                    RETURN merge({\n                        todo_id : td.todo_id,\n                        todo : td.todo ? td.todo : \"\",\n                        is_completed: td.is_completed,\n                        created_by: td.created_by,\n                        updated_by: td.updated_by,\n                        created_at: td.created_at,\n                        updated_at: td.updated_at,\n                        is_active: td.is_active,\n                        is_checked: td.is_checked,\n                        created_by_detail: createdUserDetail,\n                        form_detail: formDetail,\n                        patient_detail: entryDetail\n                    },td)\n        ");
  }
};

var _extraReducers$8;
var UPSERT_TODO = createAsyncThunk("todoSlice/upsertTodo", /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(payload, _ref) {
    var _getState, _getState$authSlice, _getState$authSlice$l, _getState$authSlice$l2;

    var rejectWithValue, getState, user_profile_id, todoName, isActive, todoId, isChecked, doc, _;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            rejectWithValue = _ref.rejectWithValue, getState = _ref.getState;
            user_profile_id = (_getState = getState()) === null || _getState === void 0 ? void 0 : (_getState$authSlice = _getState.authSlice) === null || _getState$authSlice === void 0 ? void 0 : (_getState$authSlice$l = _getState$authSlice.login) === null || _getState$authSlice$l === void 0 ? void 0 : (_getState$authSlice$l2 = _getState$authSlice$l.data) === null || _getState$authSlice$l2 === void 0 ? void 0 : _getState$authSlice$l2.user_profile_id;
            _context.prev = 2;
            todoName = payload.todoName, isActive = payload.isActive, todoId = payload.todoId, isChecked = payload.isChecked;
            doc = {};
            doc.is_active = isActive === null ? true : isActive;

            if (!todoId) {
              doc.created_at = new Date().toISOString();
              doc.is_checked = false;
              doc.is_active = true;
              doc.is_completed = false;
              doc.created_by = user_profile_id ? user_profile_id : "user profile id not available";
              doc.assigned_to = user_profile_id ? user_profile_id : "user profile id not available";
            }

            todoId = todoId ? todoId : v4();
            doc.updated_at = new Date().toISOString();
            doc.is_checked = isChecked ? isChecked : false;
            doc.is_completed = isChecked ? isChecked : false;
            doc.updated_by = user_profile_id ? user_profile_id : "user profile id not available";
            doc.todo_id = todoId;

            if (todoName) {
              doc.todo = todoName;
            }

            _context.next = 16;
            return fetch("".concat(__baseUrl__, "/upsert_document"), _objectSpread2(_objectSpread2({}, __options()), {}, {
              body: JSON.stringify([_objectSpread2(_objectSpread2({}, upsertQuery.upsertTodo), {}, {
                filter: {
                  todo_id: String(todoId)
                },
                doc: doc
              })])
            }));

          case 16:
            _ = _context.sent;
            _context.next = 19;
            return _.json();

          case 19:
            _ = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
              data: _
            }));

          case 23:
            _context.prev = 23;
            _context.t0 = _context["catch"](2);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 26:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 23]]);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());
var GET_ALL_TODO = createAsyncThunk("todoSlice/getAllTodo", /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(payload, _ref3) {
    var _getState2, _getState2$authSlice, _getState2$authSlice$, _getState2$authSlice$2;

    var rejectWithValue, getState, user_profile_id, _;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            rejectWithValue = _ref3.rejectWithValue, getState = _ref3.getState;
            user_profile_id = (_getState2 = getState()) === null || _getState2 === void 0 ? void 0 : (_getState2$authSlice = _getState2.authSlice) === null || _getState2$authSlice === void 0 ? void 0 : (_getState2$authSlice$ = _getState2$authSlice.login) === null || _getState2$authSlice$ === void 0 ? void 0 : (_getState2$authSlice$2 = _getState2$authSlice$.data) === null || _getState2$authSlice$2 === void 0 ? void 0 : _getState2$authSlice$2.user_profile_id;
            _context2.prev = 2;
            _context2.next = 5;
            return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
              body: JSON.stringify({
                db_name: "".concat(process.env.REACT_APP_DB),
                query: queries$8.getAllTodo(user_profile_id)
              })
            }));

          case 5:
            _ = _context2.sent;
            _context2.next = 8;
            return _.json();

          case 8:
            _ = _context2.sent;
            return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
              data: _
            }));

          case 12:
            _context2.prev = 12;
            _context2.t0 = _context2["catch"](2);
            return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context2.t0.message
            })));

          case 15:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[2, 12]]);
  }));

  return function (_x3, _x4) {
    return _ref4.apply(this, arguments);
  };
}());
var todoSlice = createSlice({
  name: "todoSlice",
  initialState: {
    getAllTodo: _objectSpread2({}, defaultState.List),
    upsertTodo: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$8 = {}, _defineProperty(_extraReducers$8, GET_ALL_TODO.fulfilled, function (state, action) {
    var _action$payload;

    state.getAllTodo = (_action$payload = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload !== void 0 ? _action$payload : {};
  }), _defineProperty(_extraReducers$8, GET_ALL_TODO.pending, function (state, action) {
    state.getAllTodo.loading = true;
  }), _defineProperty(_extraReducers$8, GET_ALL_TODO.rejected, function (state, action) {
    var _action$payload2;

    state.getAllTodo = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$8, UPSERT_TODO.fulfilled, function (state, action) {
    var _action$payload3;

    state.upsertTodo = (_action$payload3 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload3 !== void 0 ? _action$payload3 : {};
  }), _defineProperty(_extraReducers$8, UPSERT_TODO.pending, function (state, action) {
    state.upsertTodo.loading = true;
  }), _defineProperty(_extraReducers$8, UPSERT_TODO.rejected, function (state, action) {
    var _action$payload4;

    state.upsertTodo = (_action$payload4 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload4 !== void 0 ? _action$payload4 : {};
  }), _extraReducers$8)
});
var todoActions = {
  GET_ALL_TODO: GET_ALL_TODO,
  UPSERT_TODO: UPSERT_TODO
};
var todoSlice$1 = todoSlice.reducer;

var queries$9 = {
  //1. To get all my activites
  getMyActivities: function getMyActivities(user_profile_id, payload) {
    var countryIds = payload.countryIds,
        created_by = payload.created_by,
        level = payload.level,
        isNotifier = payload.isNotifier;
    return "\n        let notified = length(\n            for entry in form_entries\n                filter entry.notifier_status == 1 \n                filter \"".concat(payload === null || payload === void 0 ? void 0 : payload.strDate, "\" <= entry.updated_at and entry.updated_at <= \"").concat(payload === null || payload === void 0 ? void 0 : payload.endDate, "\"\n                ").concat(isNotifier ? " filter entry.notified_by == \"".concat(created_by, "\" ") : "", " \n                ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                return entry\n        )\n\n        let for_verification = length(\n            for entry in form_entries\n                filter entry.verifier_status == 2 && entry.notifier_status == 1\n                filter \"").concat(payload === null || payload === void 0 ? void 0 : payload.strDate, "\" <= entry.updated_at and entry.updated_at <= \"").concat(payload === null || payload === void 0 ? void 0 : payload.endDate, "\"\n                ").concat(isNotifier ? " filter entry.notified_by == \"".concat(created_by, "\" ") : "", " \n                ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                return entry\n        )\n        \n        let verified = length(\n            for entry in form_entries\n                filter entry.verifier_status == 3\n                filter \"").concat(payload === null || payload === void 0 ? void 0 : payload.strDate, "\" <= entry.updated_at and entry.updated_at <= \"").concat(payload === null || payload === void 0 ? void 0 : payload.endDate, "\"\n                ").concat(isNotifier ? " filter entry.notified_by == \"".concat(created_by, "\" ") : "", " \n                ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                return entry\n        )\n        \n        let for_registration = length(\n            for entry in form_entries\n                filter entry.registration_status == 7 && entry.verifier_status == 3\n                filter \"").concat(payload === null || payload === void 0 ? void 0 : payload.strDate, "\" <= entry.updated_at and entry.updated_at <= \"").concat(payload === null || payload === void 0 ? void 0 : payload.endDate, "\"\n                ").concat(isNotifier ? " filter entry.notified_by == \"".concat(created_by, "\" ") : "", " \n                ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                return entry\n        )\n\n        let registered = length(\n            for entry in form_entries\n                filter entry.registration_status == 8 && entry.verifier_status == 3 \n                filter \"").concat(payload === null || payload === void 0 ? void 0 : payload.strDate, "\" <= entry.updated_at and entry.updated_at <= \"").concat(payload === null || payload === void 0 ? void 0 : payload.endDate, "\"\n                ").concat(isNotifier ? " filter entry.notified_by == \"".concat(created_by, "\" ") : "", " \n                ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                return entry\n        )\n\n        let for_investigation = length(\n            for entry in form_entries\n                filter entry.investigator_status == 5 && entry.verifier_status == 3 && entry.registration_status == 8 \n                filter \"").concat(payload === null || payload === void 0 ? void 0 : payload.strDate, "\" <= entry.updated_at and entry.updated_at <= \"").concat(payload === null || payload === void 0 ? void 0 : payload.endDate, "\"\n                ").concat(isNotifier ? " filter entry.notified_by == \"".concat(created_by, "\" ") : "", " \n                ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                return entry\n        )\n\n        let investigated = length(\n            for entry in form_entries\n                filter entry.investigator_status == 6 && entry.verifier_status == 3 && entry.registration_status == 8\n                filter \"").concat(payload === null || payload === void 0 ? void 0 : payload.strDate, "\" <= entry.updated_at and entry.updated_at <= \"").concat(payload === null || payload === void 0 ? void 0 : payload.endDate, "\"\n                ").concat(isNotifier ? " filter entry.notified_by == \"".concat(created_by, "\" ") : "", " \n                ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                return entry\n        )\n\n        \n        return {\n            notified,\n            verified,\n            for_verification,\n            investigated,\n            for_investigation,\n            registered,\n            for_registration\n        }\n        ");
  },
  //2. To get all trending diseases for the last five days
  getTrendingDiseases: function getTrendingDiseases(days, user_profile_id) {
    var _days$, _days$2, _days$3, _days$4, _days$5, _days$6, _days$7, _days$8, _days$9, _days$10, _days$11, _days$12, _days$13, _days$14, _days$15;

    return "\n        let trending_diseases = (for disease in master_disease\n            filter disease.is_active == true\n                let form_entries = (\n                    for mapped_form in rl_disease_form\n                        filter mapped_form.disease_id == disease.disease_id\n                        for form in forms\n                            filter form.is_active == true && form.form_id == mapped_form.form_id\n                                return {\n                                    form_name: form.form_name,\n                                    \"1\": length(\n                                        for entry in form_entries\n                                            filter entry.form_id == form.form_id \n                                            filter \"".concat(days === null || days === void 0 ? void 0 : (_days$ = days["1"]) === null || _days$ === void 0 ? void 0 : _days$.strDate, "\" <= entry.updated_at and entry.updated_at <= \"").concat(days === null || days === void 0 ? void 0 : (_days$2 = days["1"]) === null || _days$2 === void 0 ? void 0 : _days$2.endDate, "\"\n                                            return entry\n                                    ),\n                                    \"2\": length(\n                                        for entry in form_entries\n                                            filter entry.form_id == form.form_id \n                                            filter \"").concat(days === null || days === void 0 ? void 0 : (_days$3 = days["2"]) === null || _days$3 === void 0 ? void 0 : _days$3.strDate, "\" <= entry.updated_at and entry.updated_at <= \"").concat(days === null || days === void 0 ? void 0 : (_days$4 = days["2"]) === null || _days$4 === void 0 ? void 0 : _days$4.endDate, "\"\n                                            return entry\n                                    ),\n                                    \"3\": length(\n                                        for entry in form_entries\n                                            filter entry.form_id == form.form_id \n                                            filter \"").concat(days === null || days === void 0 ? void 0 : (_days$5 = days["3"]) === null || _days$5 === void 0 ? void 0 : _days$5.strDate, "\" <= entry.updated_at and entry.updated_at <= \"").concat(days === null || days === void 0 ? void 0 : (_days$6 = days["3"]) === null || _days$6 === void 0 ? void 0 : _days$6.endDate, "\"\n                                            return entry\n                                    ),\n                                    \"4\": length(\n                                        for entry in form_entries\n                                            filter entry.form_id == form.form_id \n                                            filter \"").concat(days === null || days === void 0 ? void 0 : (_days$7 = days["4"]) === null || _days$7 === void 0 ? void 0 : _days$7.strDate, "\" <= entry.updated_at and entry.updated_at <= \"").concat(days === null || days === void 0 ? void 0 : (_days$8 = days["4"]) === null || _days$8 === void 0 ? void 0 : _days$8.endDate, "\"\n                                            return entry\n                                    ),\n                                    \"5\": length(\n                                        for entry in form_entries\n                                            filter entry.form_id == form.form_id \n                                            filter \"").concat(days === null || days === void 0 ? void 0 : (_days$9 = days["5"]) === null || _days$9 === void 0 ? void 0 : _days$9.strDate, "\" <= entry.updated_at and entry.updated_at <= \"").concat(days === null || days === void 0 ? void 0 : (_days$10 = days["5"]) === null || _days$10 === void 0 ? void 0 : _days$10.endDate, "\"\n                                            return entry\n                                    ),\n                                }\n                                \n                )\n                sort form_entries desc\n                return {\n                    disease_name: disease.disease_name,\n                    form_entries\n                }\n                \n        )\n        \n        let y_axis = (for td in trending_diseases\n            return td.disease_name\n        )\n        \n        let daysCount = (for td in trending_diseases\n            return {\n                    \"1\":sum(for fent in td.form_entries\n                        return fent[\"1\"]\n                    ),\n                    \"2\":sum(for fent in td.form_entries\n                        return fent[\"2\"]\n                    ),\n                    \"3\":sum(for fent in td.form_entries\n                        return fent[\"3\"]\n                    ),\n                    \"4\":sum(for fent in td.form_entries\n                        return fent[\"4\"]\n                    ),\n                    \"5\":sum(for fent in td.form_entries\n                        return fent[\"5\"]\n                    )\n                }\n        )\n        \n        return [\n            slice(append(['Date'],y_axis),0,6),\n            slice(append(['").concat(days === null || days === void 0 ? void 0 : (_days$11 = days["1"]) === null || _days$11 === void 0 ? void 0 : _days$11.date, "'],(for cnt in daysCount return cnt[\"1\"])),0,6),\n            slice(append(['").concat(days === null || days === void 0 ? void 0 : (_days$12 = days["2"]) === null || _days$12 === void 0 ? void 0 : _days$12.date, "'],(for cnt in daysCount return cnt[\"2\"])),0,6),\n            slice(append(['").concat(days === null || days === void 0 ? void 0 : (_days$13 = days["3"]) === null || _days$13 === void 0 ? void 0 : _days$13.date, "'],(for cnt in daysCount return cnt[\"3\"])),0,6),\n            slice(append(['").concat(days === null || days === void 0 ? void 0 : (_days$14 = days["4"]) === null || _days$14 === void 0 ? void 0 : _days$14.date, "'],(for cnt in daysCount return cnt[\"4\"])),0,6),\n            slice(append(['").concat(days === null || days === void 0 ? void 0 : (_days$15 = days["5"]) === null || _days$15 === void 0 ? void 0 : _days$15.date, "'],(for cnt in daysCount return cnt[\"5\"])),0,6),\n        ]\n        \n        ");
  },
  //3. To get all stats for the last five days
  getStats: function getStats(payload, user_profile_id) {
    var _days$16, _days$17, _days$18, _days$19, _days$20, _days$21, _days$22, _days$23, _days$24, _days$25, _days$26, _days$27, _days$28, _days$29, _days$30, _days$31, _days$32, _days$33, _days$34, _days$35, _days$36, _days$37, _days$38, _days$39, _days$40, _days$41, _days$42, _days$43, _days$44, _days$45, _days$46, _days$47, _days$48, _days$49, _days$50, _days$51, _days$52, _days$53, _days$54, _days$55, _days$56, _days$57, _days$58, _days$59, _days$60;

    var countryIds = payload.countryIds,
        created_by = payload.created_by,
        level = payload.level,
        isNotifier = payload.isNotifier,
        days = payload.days;
    return "\n        return [\n            ['Date', 'NOTIFIED', 'VERIFIED', 'REGISTERED', 'INVESTIGATED'],    \n            [\n                '".concat(days === null || days === void 0 ? void 0 : (_days$16 = days["1"]) === null || _days$16 === void 0 ? void 0 : _days$16.date, "',\n                length(\n                    for entry in form_entries\n                        filter entry.notifier_status == 1\n                        filter \"").concat(days === null || days === void 0 ? void 0 : (_days$17 = days["1"]) === null || _days$17 === void 0 ? void 0 : _days$17.strDate, "\" <= entry.updated_at and entry.updated_at <= \"").concat(days === null || days === void 0 ? void 0 : (_days$18 = days["1"]) === null || _days$18 === void 0 ? void 0 : _days$18.endDate, "\"\n                        ").concat(isNotifier ? " filter entry.notified_by == \"".concat(created_by, "\" ") : "", " \n                        ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                        return entry\n                ),\n                length(\n                    for entry in form_entries\n                        filter entry.verifier_status == 3\n                        filter \"").concat(days === null || days === void 0 ? void 0 : (_days$19 = days["1"]) === null || _days$19 === void 0 ? void 0 : _days$19.strDate, "\" <= entry.updated_at and entry.updated_at <= \"").concat(days === null || days === void 0 ? void 0 : (_days$20 = days["1"]) === null || _days$20 === void 0 ? void 0 : _days$20.endDate, "\"\n                        ").concat(isNotifier ? " filter entry.notified_by == \"".concat(created_by, "\" ") : "", " \n                        ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                        return entry\n                ),\n                length(\n                    for entry in form_entries\n                        filter entry.registration_status == 8 && entry.verifier_status == 3 \n                        filter \"").concat(days === null || days === void 0 ? void 0 : (_days$21 = days["1"]) === null || _days$21 === void 0 ? void 0 : _days$21.strDate, "\" <= entry.updated_at and entry.updated_at <= \"").concat(days === null || days === void 0 ? void 0 : (_days$22 = days["1"]) === null || _days$22 === void 0 ? void 0 : _days$22.endDate, "\"\n                        ").concat(isNotifier ? " filter entry.notified_by == \"".concat(created_by, "\" ") : "", " \n                        ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                        return entry\n                ),\n                length(\n                    for entry in form_entries\n                        filter entry.investigator_status == 6 && entry.verifier_status == 3 && entry.registration_status == 8\n                        filter \"").concat(days === null || days === void 0 ? void 0 : (_days$23 = days["1"]) === null || _days$23 === void 0 ? void 0 : _days$23.strDate, "\" <= entry.updated_at and entry.updated_at <= \"").concat(days === null || days === void 0 ? void 0 : (_days$24 = days["1"]) === null || _days$24 === void 0 ? void 0 : _days$24.endDate, "\"\n                        ").concat(isNotifier ? " filter entry.notified_by == \"".concat(created_by, "\" ") : "", " \n                        ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                        return entry\n                ),\n            ],\n            [\n                '").concat(days === null || days === void 0 ? void 0 : (_days$25 = days["2"]) === null || _days$25 === void 0 ? void 0 : _days$25.date, "',\n                length(\n                    for entry in form_entries\n                        filter entry.notifier_status == 1\n                        filter \"").concat(days === null || days === void 0 ? void 0 : (_days$26 = days["2"]) === null || _days$26 === void 0 ? void 0 : _days$26.strDate, "\" <= entry.updated_at and entry.updated_at <= \"").concat(days === null || days === void 0 ? void 0 : (_days$27 = days["2"]) === null || _days$27 === void 0 ? void 0 : _days$27.endDate, "\"\n                        ").concat(isNotifier ? " filter entry.notified_by == \"".concat(created_by, "\" ") : "", " \n                        ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                        return entry\n                ),\n                length(\n                    for entry in form_entries\n                        filter entry.verifier_status == 3\n                        filter \"").concat(days === null || days === void 0 ? void 0 : (_days$28 = days["2"]) === null || _days$28 === void 0 ? void 0 : _days$28.strDate, "\" <= entry.updated_at and entry.updated_at <= \"").concat(days === null || days === void 0 ? void 0 : (_days$29 = days["2"]) === null || _days$29 === void 0 ? void 0 : _days$29.endDate, "\"\n                        ").concat(isNotifier ? " filter entry.notified_by == \"".concat(created_by, "\" ") : "", " \n                        ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                        return entry\n                ),\n                length(\n                    for entry in form_entries\n                        filter entry.registration_status == 8 && entry.verifier_status == 3 \n                        filter \"").concat(days === null || days === void 0 ? void 0 : (_days$30 = days["2"]) === null || _days$30 === void 0 ? void 0 : _days$30.strDate, "\" <= entry.updated_at and entry.updated_at <= \"").concat(days === null || days === void 0 ? void 0 : (_days$31 = days["2"]) === null || _days$31 === void 0 ? void 0 : _days$31.endDate, "\"\n                        ").concat(isNotifier ? " filter entry.notified_by == \"".concat(created_by, "\" ") : "", " \n                        ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                        return entry\n                ),\n                length(\n                    for entry in form_entries\n                        filter entry.investigator_status == 6 && entry.verifier_status == 3 && entry.registration_status == 8\n                        filter \"").concat(days === null || days === void 0 ? void 0 : (_days$32 = days["2"]) === null || _days$32 === void 0 ? void 0 : _days$32.strDate, "\" <= entry.updated_at and entry.updated_at <= \"").concat(days === null || days === void 0 ? void 0 : (_days$33 = days["2"]) === null || _days$33 === void 0 ? void 0 : _days$33.endDate, "\"\n                        ").concat(isNotifier ? " filter entry.notified_by == \"".concat(created_by, "\" ") : "", " \n                        ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                        return entry\n                ),\n            ],\n            [\n                '").concat(days === null || days === void 0 ? void 0 : (_days$34 = days["3"]) === null || _days$34 === void 0 ? void 0 : _days$34.date, "',\n                length(\n                    for entry in form_entries\n                        filter entry.notifier_status == 1\n                        filter \"").concat(days === null || days === void 0 ? void 0 : (_days$35 = days["3"]) === null || _days$35 === void 0 ? void 0 : _days$35.strDate, "\" <= entry.updated_at and entry.updated_at <= \"").concat(days === null || days === void 0 ? void 0 : (_days$36 = days["3"]) === null || _days$36 === void 0 ? void 0 : _days$36.endDate, "\"\n                        ").concat(isNotifier ? " filter entry.notified_by == \"".concat(created_by, "\" ") : "", " \n                        ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                        return entry\n                ),\n                length(\n                    for entry in form_entries\n                        filter entry.verifier_status == 3\n                        filter \"").concat(days === null || days === void 0 ? void 0 : (_days$37 = days["3"]) === null || _days$37 === void 0 ? void 0 : _days$37.strDate, "\" <= entry.updated_at and entry.updated_at <= \"").concat(days === null || days === void 0 ? void 0 : (_days$38 = days["3"]) === null || _days$38 === void 0 ? void 0 : _days$38.endDate, "\"\n                        ").concat(isNotifier ? " filter entry.notified_by == \"".concat(created_by, "\" ") : "", " \n                        ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                        return entry\n                ),\n                length(\n                    for entry in form_entries\n                        filter entry.registration_status == 8 && entry.verifier_status == 3 \n                        filter \"").concat(days === null || days === void 0 ? void 0 : (_days$39 = days["3"]) === null || _days$39 === void 0 ? void 0 : _days$39.strDate, "\" <= entry.updated_at and entry.updated_at <= \"").concat(days === null || days === void 0 ? void 0 : (_days$40 = days["3"]) === null || _days$40 === void 0 ? void 0 : _days$40.endDate, "\"\n                        ").concat(isNotifier ? " filter entry.notified_by == \"".concat(created_by, "\" ") : "", " \n                        ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                        return entry\n                ),\n                length(\n                    for entry in form_entries\n                        filter entry.investigator_status == 6 && entry.verifier_status == 3 && entry.registration_status == 8\n                        filter \"").concat(days === null || days === void 0 ? void 0 : (_days$41 = days["3"]) === null || _days$41 === void 0 ? void 0 : _days$41.strDate, "\" <= entry.updated_at and entry.updated_at <= \"").concat(days === null || days === void 0 ? void 0 : (_days$42 = days["3"]) === null || _days$42 === void 0 ? void 0 : _days$42.endDate, "\"\n                        ").concat(isNotifier ? " filter entry.notified_by == \"".concat(created_by, "\" ") : "", " \n                        ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                        return entry\n                ),\n            ],\n            [\n                '").concat(days === null || days === void 0 ? void 0 : (_days$43 = days["4"]) === null || _days$43 === void 0 ? void 0 : _days$43.date, "',\n                length(\n                    for entry in form_entries\n                        filter entry.notifier_status == 1\n                        filter \"").concat(days === null || days === void 0 ? void 0 : (_days$44 = days["4"]) === null || _days$44 === void 0 ? void 0 : _days$44.strDate, "\" <= entry.updated_at and entry.updated_at <= \"").concat(days === null || days === void 0 ? void 0 : (_days$45 = days["4"]) === null || _days$45 === void 0 ? void 0 : _days$45.endDate, "\"\n                        ").concat(isNotifier ? " filter entry.notified_by == \"".concat(created_by, "\" ") : "", " \n                        ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                        return entry\n                ),\n                length(\n                    for entry in form_entries\n                        filter entry.verifier_status == 3\n                        filter \"").concat(days === null || days === void 0 ? void 0 : (_days$46 = days["4"]) === null || _days$46 === void 0 ? void 0 : _days$46.strDate, "\" <= entry.updated_at and entry.updated_at <= \"").concat(days === null || days === void 0 ? void 0 : (_days$47 = days["4"]) === null || _days$47 === void 0 ? void 0 : _days$47.endDate, "\"\n                        ").concat(isNotifier ? " filter entry.notified_by == \"".concat(created_by, "\" ") : "", " \n                        ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                        return entry\n                ),\n                length(\n                    for entry in form_entries\n                        filter entry.registration_status == 8 && entry.verifier_status == 3 \n                        filter \"").concat(days === null || days === void 0 ? void 0 : (_days$48 = days["4"]) === null || _days$48 === void 0 ? void 0 : _days$48.strDate, "\" <= entry.updated_at and entry.updated_at <= \"").concat(days === null || days === void 0 ? void 0 : (_days$49 = days["4"]) === null || _days$49 === void 0 ? void 0 : _days$49.endDate, "\"\n                        ").concat(isNotifier ? " filter entry.notified_by == \"".concat(created_by, "\" ") : "", " \n                        ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                        return entry\n                ),\n                length(\n                    for entry in form_entries\n                        filter entry.investigator_status == 6 && entry.verifier_status == 3 && entry.registration_status == 8\n                        filter \"").concat(days === null || days === void 0 ? void 0 : (_days$50 = days["4"]) === null || _days$50 === void 0 ? void 0 : _days$50.strDate, "\" <= entry.updated_at and entry.updated_at <= \"").concat(days === null || days === void 0 ? void 0 : (_days$51 = days["4"]) === null || _days$51 === void 0 ? void 0 : _days$51.endDate, "\"\n                        ").concat(isNotifier ? " filter entry.notified_by == \"".concat(created_by, "\" ") : "", " \n                        ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                        return entry\n                ),\n            ],\n            [\n                '").concat(days === null || days === void 0 ? void 0 : (_days$52 = days["5"]) === null || _days$52 === void 0 ? void 0 : _days$52.date, "',\n                length(\n                    for entry in form_entries\n                        filter entry.notifier_status == 1\n                        filter \"").concat(days === null || days === void 0 ? void 0 : (_days$53 = days["5"]) === null || _days$53 === void 0 ? void 0 : _days$53.strDate, "\" <= entry.updated_at and entry.updated_at <= \"").concat(days === null || days === void 0 ? void 0 : (_days$54 = days["5"]) === null || _days$54 === void 0 ? void 0 : _days$54.endDate, "\"\n                        ").concat(isNotifier ? " filter entry.notified_by == \"".concat(created_by, "\" ") : "", " \n                        ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                        return entry\n                ),\n                length(\n                    for entry in form_entries\n                        filter entry.verifier_status == 3\n                        filter \"").concat(days === null || days === void 0 ? void 0 : (_days$55 = days["5"]) === null || _days$55 === void 0 ? void 0 : _days$55.strDate, "\" <= entry.updated_at and entry.updated_at <= \"").concat(days === null || days === void 0 ? void 0 : (_days$56 = days["5"]) === null || _days$56 === void 0 ? void 0 : _days$56.endDate, "\"\n                        ").concat(isNotifier ? " filter entry.notified_by == \"".concat(created_by, "\" ") : "", " \n                        ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                        return entry\n                ),\n                length(\n                    for entry in form_entries\n                        filter entry.registration_status == 8 && entry.verifier_status == 3 \n                        filter \"").concat(days === null || days === void 0 ? void 0 : (_days$57 = days["5"]) === null || _days$57 === void 0 ? void 0 : _days$57.strDate, "\" <= entry.updated_at and entry.updated_at <= \"").concat(days === null || days === void 0 ? void 0 : (_days$58 = days["5"]) === null || _days$58 === void 0 ? void 0 : _days$58.endDate, "\"\n                        ").concat(isNotifier ? " filter entry.notified_by == \"".concat(created_by, "\" ") : "", " \n                        ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                        return entry\n                ),\n                length(\n                    for entry in form_entries\n                        filter entry.investigator_status == 6 && entry.verifier_status == 3 && entry.registration_status == 8\n                        filter \"").concat(days === null || days === void 0 ? void 0 : (_days$59 = days["5"]) === null || _days$59 === void 0 ? void 0 : _days$59.strDate, "\" <= entry.updated_at and entry.updated_at <= \"").concat(days === null || days === void 0 ? void 0 : (_days$60 = days["5"]) === null || _days$60 === void 0 ? void 0 : _days$60.endDate, "\"\n                        ").concat(isNotifier ? " filter entry.notified_by == \"".concat(created_by, "\" ") : "", " \n                        ").concat(giveMeFilterForEntry(countryIds, level, "entry"), "\n                        return entry\n                ),\n            ]\n        ]\n        ");
  }
};

var _extraReducers$9;
var GET_ALL_ACTIVITIES = createAsyncThunk("dashboardSlice/myActivities", /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(payload, _ref) {
    var _getState, _getState$authSlice, _getState$authSlice$l, _getState$authSlice$l2;

    var rejectWithValue, getState, user_profile_id, _$, _ref3, _;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            rejectWithValue = _ref.rejectWithValue, getState = _ref.getState;
            user_profile_id = (_getState = getState()) === null || _getState === void 0 ? void 0 : (_getState$authSlice = _getState.authSlice) === null || _getState$authSlice === void 0 ? void 0 : (_getState$authSlice$l = _getState$authSlice.login) === null || _getState$authSlice$l === void 0 ? void 0 : (_getState$authSlice$l2 = _getState$authSlice$l.data) === null || _getState$authSlice$l2 === void 0 ? void 0 : _getState$authSlice$l2.user_profile_id;
            _context.prev = 2;
            _context.next = 5;
            return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
              body: JSON.stringify({
                db_name: "".concat(process.env.REACT_APP_DB),
                query: queries$9.getMyActivities(user_profile_id, payload)
              })
            }));

          case 5:
            _ = _context.sent;
            _context.next = 8;
            return _.json();

          case 8:
            _ = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
              data: (_$ = (_ref3 = _) === null || _ref3 === void 0 ? void 0 : _ref3[0]) !== null && _$ !== void 0 ? _$ : {}
            }));

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](2);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 12]]);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());
var GET_TRENDING_DISEASES = createAsyncThunk("dashboardSlice/trendingDiseases", /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(payload, _ref4) {
    var _getState2, _getState2$authSlice, _getState2$authSlice$, _getState2$authSlice$2;

    var rejectWithValue, getState, user_profile_id, _$2, _ref6, _;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            rejectWithValue = _ref4.rejectWithValue, getState = _ref4.getState;
            user_profile_id = (_getState2 = getState()) === null || _getState2 === void 0 ? void 0 : (_getState2$authSlice = _getState2.authSlice) === null || _getState2$authSlice === void 0 ? void 0 : (_getState2$authSlice$ = _getState2$authSlice.login) === null || _getState2$authSlice$ === void 0 ? void 0 : (_getState2$authSlice$2 = _getState2$authSlice$.data) === null || _getState2$authSlice$2 === void 0 ? void 0 : _getState2$authSlice$2.user_profile_id;
            _context2.prev = 2;
            _context2.next = 5;
            return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
              body: JSON.stringify({
                db_name: "".concat(process.env.REACT_APP_DB),
                query: queries$9.getTrendingDiseases(payload === null || payload === void 0 ? void 0 : payload.days, user_profile_id)
              })
            }));

          case 5:
            _ = _context2.sent;
            _context2.next = 8;
            return _.json();

          case 8:
            _ = _context2.sent;
            return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
              data: (_$2 = (_ref6 = _) === null || _ref6 === void 0 ? void 0 : _ref6[0]) !== null && _$2 !== void 0 ? _$2 : {}
            }));

          case 12:
            _context2.prev = 12;
            _context2.t0 = _context2["catch"](2);
            return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context2.t0.message
            })));

          case 15:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[2, 12]]);
  }));

  return function (_x3, _x4) {
    return _ref5.apply(this, arguments);
  };
}());
var GET_STATS = createAsyncThunk("dashboardSlice/getStats", /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(payload, _ref7) {
    var _getState3, _getState3$authSlice, _getState3$authSlice$, _getState3$authSlice$2;

    var rejectWithValue, getState, user_profile_id, _$3, _ref9, _;

    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            rejectWithValue = _ref7.rejectWithValue, getState = _ref7.getState;
            user_profile_id = (_getState3 = getState()) === null || _getState3 === void 0 ? void 0 : (_getState3$authSlice = _getState3.authSlice) === null || _getState3$authSlice === void 0 ? void 0 : (_getState3$authSlice$ = _getState3$authSlice.login) === null || _getState3$authSlice$ === void 0 ? void 0 : (_getState3$authSlice$2 = _getState3$authSlice$.data) === null || _getState3$authSlice$2 === void 0 ? void 0 : _getState3$authSlice$2.user_profile_id;
            _context3.prev = 2;
            _context3.next = 5;
            return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
              body: JSON.stringify({
                db_name: "".concat(process.env.REACT_APP_DB),
                query: queries$9.getStats(payload, user_profile_id)
              })
            }));

          case 5:
            _ = _context3.sent;
            _context3.next = 8;
            return _.json();

          case 8:
            _ = _context3.sent;
            return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
              data: (_$3 = (_ref9 = _) === null || _ref9 === void 0 ? void 0 : _ref9[0]) !== null && _$3 !== void 0 ? _$3 : {}
            }));

          case 12:
            _context3.prev = 12;
            _context3.t0 = _context3["catch"](2);
            return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context3.t0.message
            })));

          case 15:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[2, 12]]);
  }));

  return function (_x5, _x6) {
    return _ref8.apply(this, arguments);
  };
}());
var dashboardSlice = createSlice({
  name: "dashboardSlice",
  initialState: {
    myActivities: _objectSpread2({}, defaultState.List),
    trendingDiseases: _objectSpread2({}, defaultState.List),
    getStats: _objectSpread2({}, defaultState.List)
  },
  extraReducers: (_extraReducers$9 = {}, _defineProperty(_extraReducers$9, GET_ALL_ACTIVITIES.fulfilled, function (state, action) {
    var _action$payload;

    state.myActivities = (_action$payload = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload !== void 0 ? _action$payload : {};
  }), _defineProperty(_extraReducers$9, GET_ALL_ACTIVITIES.pending, function (state, action) {
    state.myActivities.loading = true;
  }), _defineProperty(_extraReducers$9, GET_ALL_ACTIVITIES.rejected, function (state, action) {
    var _action$payload2;

    state.myActivities = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$9, GET_TRENDING_DISEASES.fulfilled, function (state, action) {
    var _action$payload3;

    state.trendingDiseases = (_action$payload3 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload3 !== void 0 ? _action$payload3 : {};
  }), _defineProperty(_extraReducers$9, GET_TRENDING_DISEASES.pending, function (state, action) {
    state.trendingDiseases.loading = true;
  }), _defineProperty(_extraReducers$9, GET_TRENDING_DISEASES.rejected, function (state, action) {
    var _action$payload4;

    state.trendingDiseases = (_action$payload4 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload4 !== void 0 ? _action$payload4 : {};
  }), _defineProperty(_extraReducers$9, GET_STATS.fulfilled, function (state, action) {
    var _action$payload5;

    state.getStats = (_action$payload5 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload5 !== void 0 ? _action$payload5 : {};
  }), _defineProperty(_extraReducers$9, GET_STATS.pending, function (state, action) {
    state.getStats.loading = true;
  }), _defineProperty(_extraReducers$9, GET_STATS.rejected, function (state, action) {
    var _action$payload6;

    state.getStats = (_action$payload6 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload6 !== void 0 ? _action$payload6 : {};
  }), _extraReducers$9)
});
var dashboardActions = {
  GET_ALL_ACTIVITIES: GET_ALL_ACTIVITIES,
  GET_TRENDING_DISEASES: GET_TRENDING_DISEASES,
  GET_STATS: GET_STATS
};
var dashboardSlice$1 = dashboardSlice.reducer;

var queries$a = {
  //1. To get all Todo
  getCountryLocations: function getCountryLocations(countryId, profileId) {
    return "\n        let level1 = first(\n            for l1 in country_level_1\n                filter l1.is_active == true \n                filter l1.country_id == '".concat(countryId, "'\n                return merge(l1,{\n                    child:(\n                        for l1c in country_level_1_childs\n                            filter l1c.is_active == true\n                            filter l1c.level_id == l1.level_id\n                            SORT l1c.created_at ASC\n                            return merge(l1c,{\n                                value: l1c.child_level_id,\n                                label: l1c.child_name\n                            })\n                    )\n                },{\n                    value: l1.level_id,\n                    label: l1.level_name\n                })\n        )\n        let level2 = first(\n            for l2 in country_level_2\n                filter l2.is_active == true \n                filter l2.country_id == '").concat(countryId, "'\n                return merge(l2,{\n                    child:(\n                        for l2c in country_level_2_childs\n                            filter l2c.is_active == true\n                            filter l2c.level_id == l2.level_id\n                            SORT l2c.created_at ASC\n                            return merge(l2c,{\n                                value: l2c.child_level_id,\n                                label: l2c.child_name\n                            })\n                    )\n                },{\n                    value: l2.level_id,\n                    label: l2.level_name\n                })\n        )\n        let level3 = first(\n            for l3 in country_level_3\n                filter l3.is_active == true \n                filter l3.country_id == '").concat(countryId, "'\n                return merge(l3,{\n                    child:(\n                        for l3c in country_level_3_childs\n                            filter l3c.is_active == true\n                            filter l3c.level_id == l3.level_id\n                            SORT l3c.created_at ASC\n                            return merge(l3c,{\n                                value: l3c.child_level_id,\n                                label: l3c.child_name\n                            })\n                    )\n                },{\n                    value: l3.level_id,\n                    label: l3.level_name\n                })\n        )\n        let level4 = first(\n            for l4 in country_level_4\n                filter l4.is_active == true \n                filter l4.country_id == '").concat(countryId, "'\n                return merge(l4,{\n                    child:(\n                        for l4c in country_level_4_childs\n                            filter l4c.is_active == true\n                            filter l4c.level_id == l4.level_id\n                            SORT l4c.created_at ASC\n                            return merge(l4c,{\n                                value: l4c.child_level_id,\n                                label: l4c.child_name\n                            })\n                    )\n                },{\n                    value: l4.level_id,\n                    label: l4.level_name\n                })\n        )\n        let level5 = first(\n            for l5 in country_level_5\n                filter l5.is_active == true \n                filter l5.country_id == '").concat(countryId, "'\n                return merge(l5,{\n                    child:(\n                        for l5c in country_level_5_childs\n                            filter l5c.is_active == true\n                            filter l5c.level_id == l5.level_id\n                            SORT l5c.created_at ASC\n                            return merge(l5c,{\n                                value: l5c.child_level_id,\n                                label: l5c.child_name\n                            })\n                    )\n                },{\n                    value: l5.level_id,\n                    label: l5.level_name\n                })\n        )\n        let level6 = first(\n            for l6 in country_level_6\n                filter l6.is_active == true \n                filter l6.country_id == '").concat(countryId, "'\n                return merge(l6,{\n                    child:(\n                        for l6c in country_level_6_childs\n                            filter l6c.is_active == true\n                            filter l6c.level_id == l6.level_id\n                            SORT l6c.created_at ASC\n                            return merge(l6c,{\n                                value: l6c.child_level_id,\n                                label: l6c.child_name\n                            })\n                    )\n                },{\n                    value: l6.level_id,\n                    label: l6.level_name\n                })\n        )\n        let level7 = first(\n            for l7 in country_level_7\n                filter l7.is_active == true \n                filter l7.country_id == '").concat(countryId, "'\n                return merge(l7,{\n                    child:(\n                        for l7c in country_level_7_childs\n                            filter l7c.is_active == true\n                            filter l7c.level_id == l7.level_id\n                            SORT l7c.created_at ASC\n                            return merge(l7c,{\n                                value: l7c.child_level_id,\n                                label: l7c.child_name\n                            })\n                    )\n                },{\n                    value: l7.level_id,\n                    label: l7.level_name\n                })\n        )\n        let level8 = first(\n            for l8 in country_level_8\n                filter l8.is_active == true \n                filter l8.country_id == '").concat(countryId, "'\n                return merge(l8,{\n                    child:(\n                        for l8c in country_level_8_childs\n                            filter l8c.is_active == true\n                            filter l8c.level_id == l8.level_id\n                            SORT l8c.created_at ASC\n                            return merge(l8c,{\n                                value: l8c.child_level_id,\n                                label: l8c.child_name\n                            })\n                    )\n                },{\n                    value: l8.level_id,\n                    label: l8.level_name\n                })\n        )\n        let level9 = first(\n            for l9 in country_level_9\n                filter l9.is_active == true \n                filter l9.country_id == '").concat(countryId, "'\n                return merge(l9,{\n                    child:(\n                        for l9c in country_level_9_childs\n                            filter l9c.is_active == true\n                            filter l9c.level_id == l9.level_id\n                            SORT l9c.created_at ASC\n                            return merge(l9c,{\n                                value: l9c.child_level_id,\n                                label: l9c.child_name\n                            })\n                    )\n                },{\n                    value: l9.level_id,\n                    label: l9.level_name\n                })\n        )\n        let level10 = first(\n            for l10 in country_level_10\n                filter l10.is_active == true \n                filter l10.country_id == '").concat(countryId, "'\n                return merge(l10,{\n                    child:(\n                        for l10c in country_level_10_childs\n                            filter l10c.is_active == true\n                            filter l10c.level_id == l10.level_id\n                            SORT l10c.created_at ASC\n                            return merge(l10c,{\n                                value: l10c.child_level_id,\n                                label: l10c.child_name\n                            })\n                    )\n                },{\n                    value: l10.level_id,\n                    label: l10.level_name\n                })\n        )\n        let level11 = first(\n            for l11 in country_level_11\n                filter l11.is_active == true \n                filter l11.country_id == '").concat(countryId, "'\n                return merge(l11,{\n                    child:(\n                        for l11c in country_level_11_childs\n                            filter l11c.is_active == true\n                            filter l11c.level_id == l11.level_id\n                            SORT l11c.created_at ASC\n                            return merge(l11c,{\n                                value: l11c.child_level_id,\n                                label: l11c.child_name\n                            })\n                    )\n                },{\n                    value: l11.level_id,\n                    label: l11.level_name\n                })\n        )\n        let level12 = first(\n            for l12 in country_level_12\n                filter l12.is_active == true \n                filter l12.country_id == '").concat(countryId, "'\n                return merge(l12,{\n                    child:(\n                        for l12c in country_level_12_childs\n                            filter l12c.is_active == true\n                            filter l12c.level_id == l12.level_id\n                            SORT l12c.created_at ASC\n                            return merge(l12c,{\n                                value: l12c.child_level_id,\n                                label: l12c.child_name\n                            })\n                    )\n                },{\n                    value: l12.level_id,\n                    label: l12.level_name\n                })\n        )\n        return {\n            level1: IS_NULL(level1) ? [] : level1,\n            level2: IS_NULL(level2) ? [] : level2,\n            level3: IS_NULL(level3) ? [] : level3,\n            level4: IS_NULL(level4) ? [] : level4,\n            level5: IS_NULL(level5) ? [] : level5,\n            level6: IS_NULL(level6) ? [] : level6,\n            level7: IS_NULL(level7) ? [] : level7,\n            level8: IS_NULL(level8) ? [] : level8,\n            level9: IS_NULL(level9) ? [] : level9,\n            level10: IS_NULL(level10) ? [] : level10,\n            level11: IS_NULL(level11) ? [] : level11,\n            level12: IS_NULL(level12) ? [] : level12,\n        }\n        ");
  },
  //2. To get country name
  getCountryName: function getCountryName(countryId) {
    return "\n        let country = first(\n            FOR country in master_country\n            FILTER country.is_active == true && country.country_id == '".concat(countryId, "'\n            return country\n         ) \n             return merge(country,{\n                 country:country.country_name\n            })\n             ");
  },
  //3. To get levels based on the country
  getCountrLevel: function getCountrLevel(countryId, level, parent_child_level_id) {
    return "for level in country_level_".concat(level, "\n        filter level.is_active == true \n        filter level.country_id == '").concat(countryId, "'\n        return merge(level,{\n            child:(\n                for level_child in country_level_").concat(level, "_childs\n                    filter level_child.is_active == true\n                    filter level_child.level_id == level.level_id\n                    ").concat(level > 1 ? "filter level_child.parent_level_id == \"".concat(parent_child_level_id, "\"") : "", "\n                    SORT level_child.created_at ASC\n                    return merge(\n                        level_child,{\n                            value:level_child.child_level_id,\n                            label:level_child:child_name\n                        })\n            )\n        })");
  }
};

var _extraReducers$a;
var UPSERT_LOCATION_LEVEL = createAsyncThunk("manageLocationSlice/upsertLocationLevel", /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(payload, _ref) {
    var _getState, _getState$authSlice, _getState$authSlice$l, _getState$authSlice$l2;

    var rejectWithValue, getState, user_profile_id, countryId, level_name, level_id, level, _payload$isActive, isActive, doc, _;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            rejectWithValue = _ref.rejectWithValue, getState = _ref.getState;
            user_profile_id = (_getState = getState()) === null || _getState === void 0 ? void 0 : (_getState$authSlice = _getState.authSlice) === null || _getState$authSlice === void 0 ? void 0 : (_getState$authSlice$l = _getState$authSlice.login) === null || _getState$authSlice$l === void 0 ? void 0 : (_getState$authSlice$l2 = _getState$authSlice$l.data) === null || _getState$authSlice$l2 === void 0 ? void 0 : _getState$authSlice$l2.user_profile_id;
            _context.prev = 2;
            countryId = payload.countryId, level_name = payload.level_name, level_id = payload.level_id, level = payload.level, _payload$isActive = payload.isActive, isActive = _payload$isActive === void 0 ? true : _payload$isActive;
            level_id = level_id ? level_id : v4();

            if (level) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: 'Need to send location level'
            })));

          case 7:
            doc = {};
            doc._key = level_id;
            doc.level_id = level_id;
            doc.level_name = level_name;
            doc.country_id = countryId;
            doc.is_active = isActive;

            if (!level_id) {
              level_id = v4();
              doc.created_at = new Date().toISOString();
              doc.created_by = user_profile_id ? user_profile_id : "user profile id not available";
            }

            doc.updated_at = new Date().toISOString();
            doc.updated_by = user_profile_id ? user_profile_id : "user profile id not available";
            _context.next = 18;
            return fetch("".concat(__baseUrl__, "/upsert_document"), _objectSpread2(_objectSpread2({}, __options()), {}, {
              body: JSON.stringify([_objectSpread2(_objectSpread2({}, upsertQuery.upsertLocation(level)), {}, {
                filter: {
                  _key: level_id
                },
                doc: doc
              })])
            }));

          case 18:
            _ = _context.sent;
            _context.next = 21;
            return _.json();

          case 21:
            _ = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
              data: _
            }));

          case 25:
            _context.prev = 25;
            _context.t0 = _context["catch"](2);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 28:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 25]]);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());
var UPSERT_LOCATION_LEVEL_CHILD = createAsyncThunk("manageLocationSlice/upsertLocationLevelChild", /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(payload, _ref3) {
    var _getState2, _getState2$authSlice, _getState2$authSlice$, _getState2$authSlice$2;

    var rejectWithValue, getState, user_profile_id, _payload$childs, childs, countryId, level_id, parent_child_level_id, level, isActive, child_level_id, parent, initialCeate, doc, childDoc, _;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            rejectWithValue = _ref3.rejectWithValue, getState = _ref3.getState;
            user_profile_id = (_getState2 = getState()) === null || _getState2 === void 0 ? void 0 : (_getState2$authSlice = _getState2.authSlice) === null || _getState2$authSlice === void 0 ? void 0 : (_getState2$authSlice$ = _getState2$authSlice.login) === null || _getState2$authSlice$ === void 0 ? void 0 : (_getState2$authSlice$2 = _getState2$authSlice$.data) === null || _getState2$authSlice$2 === void 0 ? void 0 : _getState2$authSlice$2.user_profile_id;
            _context2.prev = 2;
            _payload$childs = payload.childs, childs = _payload$childs === void 0 ? [] : _payload$childs, countryId = payload.countryId, level_id = payload.level_id, parent_child_level_id = payload.parent_child_level_id, level = payload.level, isActive = payload.isActive, child_level_id = payload.child_level_id, parent = payload.parent, initialCeate = payload.initialCeate;

            if (level) {
              _context2.next = 6;
              break;
            }

            return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: 'Need to send location level'
            })));

          case 6:
            doc = [];
            isActive = isActive;
            child_level_id = child_level_id; // if (isActive) {

            if (isActive === false) {
              childDoc = {};
              childDoc.is_active = isActive;
              childDoc.child_level_id = child_level_id;
              childDoc._key = child_level_id;
              doc.push(_objectSpread2(_objectSpread2({}, upsertQuery.upsertChild(level)), {}, {
                filter: {
                  _key: child_level_id
                },
                doc: childDoc
              }));
            }

            childs === null || childs === void 0 ? void 0 : childs.map(function (child, index) {
              var value = child.value,
                  child_level_id = child.child_level_id,
                  isActive = child.isActive;
              var childDoc = {};

              if (!child_level_id) {
                child_level_id = v4();
                childDoc.created_at = new Date().toISOString();
                childDoc.created_by = user_profile_id ? user_profile_id : "user profile id not available";
              }

              childDoc.child_level_id = child_level_id;
              childDoc._key = child_level_id;
              childDoc.country_id = countryId;
              childDoc.child_name = value;
              childDoc.level_id = level_id;
              childDoc.parent_child_level_id = parent_child_level_id; // if(parent_child_level_id) {childDoc.parent_child_level_id} ;

              childDoc.parent = parent;
              childDoc.is_active = isActive === null ? true : isActive;
              childDoc.updated_at = new Date().toISOString();
              childDoc.updated_by = user_profile_id ? user_profile_id : "user profile id not available";
              doc.push(_objectSpread2(_objectSpread2({}, upsertQuery.upsertChild(level)), {}, {
                filter: {
                  _key: child_level_id
                },
                doc: childDoc
              }));
            });
            _context2.next = 13;
            return fetch("".concat(__baseUrl__, "/upsert_document"), _objectSpread2(_objectSpread2({}, __options()), {}, {
              body: JSON.stringify(doc)
            }));

          case 13:
            _ = _context2.sent;
            _context2.next = 16;
            return _.json();

          case 16:
            _ = _context2.sent;
            return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
              data: _
            }));

          case 20:
            _context2.prev = 20;
            _context2.t0 = _context2["catch"](2);
            return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context2.t0.message
            })));

          case 23:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[2, 20]]);
  }));

  return function (_x3, _x4) {
    return _ref4.apply(this, arguments);
  };
}());
var GET_COUNTRY_LEVELS = createAsyncThunk("manageLocationSlice/countrylevels", /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(payload, _ref5) {
    var _getState3, _getState3$authSlice, _getState3$authSlice$, _getState3$authSlice$2;

    var rejectWithValue, getState, user_profile_id, _$, _ref7, _;

    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            rejectWithValue = _ref5.rejectWithValue, getState = _ref5.getState;
            user_profile_id = (_getState3 = getState()) === null || _getState3 === void 0 ? void 0 : (_getState3$authSlice = _getState3.authSlice) === null || _getState3$authSlice === void 0 ? void 0 : (_getState3$authSlice$ = _getState3$authSlice.login) === null || _getState3$authSlice$ === void 0 ? void 0 : (_getState3$authSlice$2 = _getState3$authSlice$.data) === null || _getState3$authSlice$2 === void 0 ? void 0 : _getState3$authSlice$2.user_profile_id;
            _context3.prev = 2;
            _context3.next = 5;
            return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
              body: JSON.stringify({
                db_name: "".concat(process.env.REACT_APP_DB),
                query: queries$a.getCountryLocations(payload === null || payload === void 0 ? void 0 : payload.countryId, user_profile_id)
              })
            }));

          case 5:
            _ = _context3.sent;
            _context3.next = 8;
            return _.json();

          case 8:
            _ = _context3.sent;
            return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
              data: (_$ = (_ref7 = _) === null || _ref7 === void 0 ? void 0 : _ref7[0]) !== null && _$ !== void 0 ? _$ : {}
            }));

          case 12:
            _context3.prev = 12;
            _context3.t0 = _context3["catch"](2);
            return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context3.t0.message
            })));

          case 15:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[2, 12]]);
  }));

  return function (_x5, _x6) {
    return _ref6.apply(this, arguments);
  };
}());
var GET_COUNTRY_NAME = createAsyncThunk("manageLocationSlice/countryname", /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(payload, _ref8) {
    var _getState4, _getState4$authSlice, _getState4$authSlice$, _getState4$authSlice$2;

    var rejectWithValue, getState, user_profile_id, _;

    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            rejectWithValue = _ref8.rejectWithValue, getState = _ref8.getState;
            user_profile_id = (_getState4 = getState()) === null || _getState4 === void 0 ? void 0 : (_getState4$authSlice = _getState4.authSlice) === null || _getState4$authSlice === void 0 ? void 0 : (_getState4$authSlice$ = _getState4$authSlice.login) === null || _getState4$authSlice$ === void 0 ? void 0 : (_getState4$authSlice$2 = _getState4$authSlice$.data) === null || _getState4$authSlice$2 === void 0 ? void 0 : _getState4$authSlice$2.user_profile_id;
            _context4.prev = 2;
            _context4.next = 5;
            return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
              body: JSON.stringify({
                db_name: "".concat(process.env.REACT_APP_DB),
                query: queries$a.getCountryName(payload === null || payload === void 0 ? void 0 : payload.countryId, user_profile_id)
              })
            }));

          case 5:
            _ = _context4.sent;
            _context4.next = 8;
            return _.json();

          case 8:
            _ = _context4.sent;
            return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
              data: _
            }));

          case 12:
            _context4.prev = 12;
            _context4.t0 = _context4["catch"](2);
            return _context4.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context4.t0.message
            })));

          case 15:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[2, 12]]);
  }));

  return function (_x7, _x8) {
    return _ref9.apply(this, arguments);
  };
}());
var manageLocationSlice = createSlice({
  name: "manageLocationSlice",
  initialState: {
    countrylevels: _objectSpread2({}, defaultState.List),
    countryname: _objectSpread2({}, defaultState.List),
    upsertLocationLevel: _objectSpread2({}, defaultState.Info),
    upsertLocationLevelChild: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$a = {}, _defineProperty(_extraReducers$a, GET_COUNTRY_LEVELS.fulfilled, function (state, action) {
    var _action$payload;

    state.countrylevels = (_action$payload = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload !== void 0 ? _action$payload : {};
  }), _defineProperty(_extraReducers$a, GET_COUNTRY_LEVELS.pending, function (state, action) {
    state.countrylevels.loading = true;
  }), _defineProperty(_extraReducers$a, GET_COUNTRY_LEVELS.rejected, function (state, action) {
    var _action$payload2;

    state.countrylevels = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$a, GET_COUNTRY_NAME.fulfilled, function (state, action) {
    var _action$payload3;

    state.countryname = (_action$payload3 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload3 !== void 0 ? _action$payload3 : {};
  }), _defineProperty(_extraReducers$a, GET_COUNTRY_NAME.pending, function (state, action) {
    state.countryname.loading = true;
  }), _defineProperty(_extraReducers$a, GET_COUNTRY_NAME.rejected, function (state, action) {
    var _action$payload4;

    state.countryname = (_action$payload4 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload4 !== void 0 ? _action$payload4 : {};
  }), _defineProperty(_extraReducers$a, UPSERT_LOCATION_LEVEL.fulfilled, function (state, action) {
    var _action$payload5;

    state.upsertLocationLevel = (_action$payload5 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload5 !== void 0 ? _action$payload5 : {};
  }), _defineProperty(_extraReducers$a, UPSERT_LOCATION_LEVEL.pending, function (state, action) {
    state.upsertLocationLevel.loading = true;
  }), _defineProperty(_extraReducers$a, UPSERT_LOCATION_LEVEL.rejected, function (state, action) {
    var _action$payload6;

    state.upsertLocationLevel = (_action$payload6 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload6 !== void 0 ? _action$payload6 : {};
  }), _defineProperty(_extraReducers$a, UPSERT_LOCATION_LEVEL_CHILD.fulfilled, function (state, action) {
    var _action$payload7;

    state.upsertLocationLevelChild = (_action$payload7 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload7 !== void 0 ? _action$payload7 : {};
  }), _defineProperty(_extraReducers$a, UPSERT_LOCATION_LEVEL_CHILD.pending, function (state, action) {
    state.upsertLocationLevelChild.loading = true;
  }), _defineProperty(_extraReducers$a, UPSERT_LOCATION_LEVEL_CHILD.rejected, function (state, action) {
    var _action$payload8;

    state.upsertLocationLevelChild = (_action$payload8 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload8 !== void 0 ? _action$payload8 : {};
  }), _extraReducers$a)
});
var manageLocationActions = {
  GET_COUNTRY_LEVELS: GET_COUNTRY_LEVELS,
  GET_COUNTRY_NAME: GET_COUNTRY_NAME,
  UPSERT_LOCATION_LEVEL: UPSERT_LOCATION_LEVEL,
  UPSERT_LOCATION_LEVEL_CHILD: UPSERT_LOCATION_LEVEL_CHILD
};
var manageLocationSlice$1 = manageLocationSlice.reducer;

var queries$b = {
  //1. To get all notifications
  getAllNotifications: function getAllNotifications(profileId) {
    return "\n        FOR notify IN notifications\n            FILTER notify.is_active == true && notify.to == \"".concat(profileId, "\"\n            SORT notify.created_at DESC\n\n\n                let createdUserDetail = first(\n                    for userDetail in user_profiles\n                        filter userDetail.is_active == true && userDetail.user_profile_id == notify.created_by\n                            return userDetail\n                )\n\n                let formDetail = first(\n                    for form in forms\n                        filter form.is_active == true && form.form_id == notify.form_id\n                            return form\n                )\n\n                let entryDetail = first(\n                    for entry in form_entries\n                        filter entry.is_active == true && entry.entry_id == notify.entry_id\n                        let patientDetail = first(\n                            for patient in patients\n                                filter patient.is_active == true && patient.patient_id == entry.patient_id\n                                    return patient\n                        )\n                        return {\n                            patient_name: patientDetail.patient_name,\n                            gender: patientDetail.gender,\n                            mobile: patientDetail.mobile,\n                            email: patientDetail.email\n                        }\n                )\n\n\n                RETURN merge({\n                    created_by_detail: createdUserDetail,\n                    form_detail: formDetail,\n                    patient_detail: entryDetail,\n                },notify)\n    ");
  },
  //2. To get all NotificationsCounts
  NotificationsCounts: function NotificationsCounts(profileId) {
    return "\n        FOR notify IN notifications\n        FILTER notify.is_active == true && notify.to == \"".concat(profileId, "\" && notify.is_readed == false\n                  return notify\n        ");
  },
  // 3 .markAllAsRead
  markAllAsRead: function markAllAsRead(profileId) {
    return "\n        FOR notification IN notifications\n            FILTER notification.to == \"".concat(profileId, "\"\n            FILTER notification.is_readed == false\n                return notification.notification_id\n            \n        ");
  }
};

var _extraReducers$b;
var GET_ALL_NOTIFICATIONS = createAsyncThunk("notificationSlice/getAllNotifications", /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(payload, _ref) {
    var _getState, _getState$authSlice, _getState$authSlice$l, _getState$authSlice$l2;

    var rejectWithValue, getState, user_profile_id, _;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            rejectWithValue = _ref.rejectWithValue, getState = _ref.getState;
            user_profile_id = (_getState = getState()) === null || _getState === void 0 ? void 0 : (_getState$authSlice = _getState.authSlice) === null || _getState$authSlice === void 0 ? void 0 : (_getState$authSlice$l = _getState$authSlice.login) === null || _getState$authSlice$l === void 0 ? void 0 : (_getState$authSlice$l2 = _getState$authSlice$l.data) === null || _getState$authSlice$l2 === void 0 ? void 0 : _getState$authSlice$l2.user_profile_id;
            _context.prev = 2;
            _context.next = 5;
            return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
              body: JSON.stringify({
                db_name: "".concat(process.env.REACT_APP_DB),
                query: queries$b.getAllNotifications(user_profile_id)
              })
            }));

          case 5:
            _ = _context.sent;
            _context.next = 8;
            return _.json();

          case 8:
            _ = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
              data: _
            }));

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](2);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 12]]);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());
var NOTIFICATIONS_COUNTS = createAsyncThunk("notificationSlice/NotificationsCounts", /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(payload, _ref3) {
    var _getState2, _getState2$authSlice, _getState2$authSlice$, _getState2$authSlice$2;

    var rejectWithValue, getState, user_profile_id, _;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            rejectWithValue = _ref3.rejectWithValue, getState = _ref3.getState;
            user_profile_id = (_getState2 = getState()) === null || _getState2 === void 0 ? void 0 : (_getState2$authSlice = _getState2.authSlice) === null || _getState2$authSlice === void 0 ? void 0 : (_getState2$authSlice$ = _getState2$authSlice.login) === null || _getState2$authSlice$ === void 0 ? void 0 : (_getState2$authSlice$2 = _getState2$authSlice$.data) === null || _getState2$authSlice$2 === void 0 ? void 0 : _getState2$authSlice$2.user_profile_id;
            _context2.prev = 2;
            _context2.next = 5;
            return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
              body: JSON.stringify({
                db_name: "".concat(process.env.REACT_APP_DB),
                query: queries$b.NotificationsCounts(user_profile_id)
              })
            }));

          case 5:
            _ = _context2.sent;
            _context2.next = 8;
            return _.json();

          case 8:
            _ = _context2.sent;
            return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
              data: _
            }));

          case 12:
            _context2.prev = 12;
            _context2.t0 = _context2["catch"](2);
            return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context2.t0.message
            })));

          case 15:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[2, 12]]);
  }));

  return function (_x3, _x4) {
    return _ref4.apply(this, arguments);
  };
}());
var NOTIFICATION_READ_STATUS = createAsyncThunk("notificationSlice/notificationReadStatus", /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(payload, _ref5) {
    var _getState3, _getState3$authSlice, _getState3$authSlice$, _getState3$authSlice$2;

    var rejectWithValue, getState, user_profile_id, notificationStatusId, doc, _;

    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            rejectWithValue = _ref5.rejectWithValue, getState = _ref5.getState;
            user_profile_id = (_getState3 = getState()) === null || _getState3 === void 0 ? void 0 : (_getState3$authSlice = _getState3.authSlice) === null || _getState3$authSlice === void 0 ? void 0 : (_getState3$authSlice$ = _getState3$authSlice.login) === null || _getState3$authSlice$ === void 0 ? void 0 : (_getState3$authSlice$2 = _getState3$authSlice$.data) === null || _getState3$authSlice$2 === void 0 ? void 0 : _getState3$authSlice$2.user_profile_id;
            _context3.prev = 2;
            notificationStatusId = payload.notificationStatusId;
            doc = {};
            doc.updated_at = new Date().toISOString();
            doc.is_readed = true;
            doc.updated_by = user_profile_id ? user_profile_id : "user profile id not available";
            _context3.next = 10;
            return fetch("".concat(__baseUrl__, "/upsert_document"), _objectSpread2(_objectSpread2({}, __options()), {}, {
              body: JSON.stringify([_objectSpread2(_objectSpread2({}, upsertQuery.upsertNotificationStatus), {}, {
                filter: {
                  notification_id: String(notificationStatusId)
                },
                doc: doc
              })])
            }));

          case 10:
            _ = _context3.sent;
            _context3.next = 13;
            return _.json();

          case 13:
            _ = _context3.sent;
            return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
              data: _
            }));

          case 17:
            _context3.prev = 17;
            _context3.t0 = _context3["catch"](2);
            return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context3.t0.message
            })));

          case 20:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[2, 17]]);
  }));

  return function (_x5, _x6) {
    return _ref6.apply(this, arguments);
  };
}());
var NOTIFICATION_ALLREAD_STATUS = createAsyncThunk("notificationSlice/notificationAllReadStatus", /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(payload, _ref7) {
    var _getState4, _getState4$authSlice, _getState4$authSlice$, _getState4$authSlice$2;

    var rejectWithValue, getState, user_profile_id, _$map, _ref9, doc, _, unReadNotify;

    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            rejectWithValue = _ref7.rejectWithValue, getState = _ref7.getState;
            user_profile_id = (_getState4 = getState()) === null || _getState4 === void 0 ? void 0 : (_getState4$authSlice = _getState4.authSlice) === null || _getState4$authSlice === void 0 ? void 0 : (_getState4$authSlice$ = _getState4$authSlice.login) === null || _getState4$authSlice$ === void 0 ? void 0 : (_getState4$authSlice$2 = _getState4$authSlice$.data) === null || _getState4$authSlice$2 === void 0 ? void 0 : _getState4$authSlice$2.user_profile_id;
            _context4.prev = 2;
            doc = {}; // doc.is_active = isActive === null ? true : isActive;

            doc.updated_at = new Date().toISOString();
            doc.is_readed = true;
            doc.updated_by = user_profile_id ? user_profile_id : "user profile id not available";
            _context4.next = 9;
            return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
              body: JSON.stringify({
                db_name: "".concat(process.env.REACT_APP_DB),
                query: queries$b.markAllAsRead(user_profile_id)
              })
            }));

          case 9:
            _ = _context4.sent;
            _context4.next = 12;
            return _.json();

          case 12:
            _ = _context4.sent;
            unReadNotify = [];
            unReadNotify = (_$map = (_ref9 = _) === null || _ref9 === void 0 ? void 0 : _ref9.map(function (notification_id) {
              return {
                db_name: "".concat(process.env.REACT_APP_DB),
                entity: "notifications",
                is_metadata: false,
                filter: {
                  _key: notification_id
                },
                doc: {
                  is_readed: true,
                  updated_by: user_profile_id,
                  updated_at: new Date().toISOString()
                }
              };
            })) !== null && _$map !== void 0 ? _$map : [];

            if (!unReadNotify.length) {
              _context4.next = 19;
              break;
            }

            _context4.next = 18;
            return fetch("".concat(__baseUrl__, "/upsert_document"), _objectSpread2(_objectSpread2({}, __options()), {}, {
              body: JSON.stringify(unReadNotify)
            }));

          case 18:
            _ = _context4.sent;

          case 19:
            return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
              data: _
            }));

          case 22:
            _context4.prev = 22;
            _context4.t0 = _context4["catch"](2);
            return _context4.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context4.t0.message
            })));

          case 25:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[2, 22]]);
  }));

  return function (_x7, _x8) {
    return _ref8.apply(this, arguments);
  };
}());
var notificationSlice = createSlice({
  name: "notificationSlice",
  initialState: {
    getAllNotifications: _objectSpread2({}, defaultState.List),
    notificationReadStatus: _objectSpread2({}, defaultState.Info),
    notificationAllReadStatus: _objectSpread2({}, defaultState.Info),
    NotificationsCounts: _objectSpread2({}, defaultState.List)
  },
  extraReducers: (_extraReducers$b = {}, _defineProperty(_extraReducers$b, GET_ALL_NOTIFICATIONS.fulfilled, function (state, action) {
    var _action$payload;

    state.getAllNotifications = (_action$payload = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload !== void 0 ? _action$payload : {};
  }), _defineProperty(_extraReducers$b, GET_ALL_NOTIFICATIONS.pending, function (state, action) {
    state.getAllNotifications.loading = true;
  }), _defineProperty(_extraReducers$b, GET_ALL_NOTIFICATIONS.rejected, function (state, action) {
    var _action$payload2;

    state.getAllNotifications = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$b, NOTIFICATIONS_COUNTS.fulfilled, function (state, action) {
    var _action$payload3;

    state.NotificationsCounts = (_action$payload3 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload3 !== void 0 ? _action$payload3 : {};
  }), _defineProperty(_extraReducers$b, NOTIFICATIONS_COUNTS.pending, function (state, action) {
    state.NotificationsCounts.loading = true;
  }), _defineProperty(_extraReducers$b, NOTIFICATIONS_COUNTS.rejected, function (state, action) {
    var _action$payload4;

    state.NotificationsCounts = (_action$payload4 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload4 !== void 0 ? _action$payload4 : {};
  }), _defineProperty(_extraReducers$b, NOTIFICATION_READ_STATUS.fulfilled, function (state, action) {
    var _action$payload5;

    state.notificationReadStatus = (_action$payload5 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload5 !== void 0 ? _action$payload5 : {};
  }), _defineProperty(_extraReducers$b, NOTIFICATION_READ_STATUS.pending, function (state, action) {
    state.notificationReadStatus.loading = true;
  }), _defineProperty(_extraReducers$b, NOTIFICATION_READ_STATUS.rejected, function (state, action) {
    var _action$payload6;

    state.notificationReadStatus = (_action$payload6 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload6 !== void 0 ? _action$payload6 : {};
  }), _defineProperty(_extraReducers$b, NOTIFICATION_ALLREAD_STATUS.fulfilled, function (state, action) {
    var _action$payload7;

    state.notificationAllReadStatus = (_action$payload7 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload7 !== void 0 ? _action$payload7 : {};
  }), _defineProperty(_extraReducers$b, NOTIFICATION_ALLREAD_STATUS.pending, function (state, action) {
    state.notificationAllReadStatus.loading = true;
  }), _defineProperty(_extraReducers$b, NOTIFICATION_ALLREAD_STATUS.rejected, function (state, action) {
    var _action$payload8;

    state.notificationAllReadStatus = (_action$payload8 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload8 !== void 0 ? _action$payload8 : {};
  }), _extraReducers$b)
});
var notificationActions = {
  GET_ALL_NOTIFICATIONS: GET_ALL_NOTIFICATIONS,
  NOTIFICATIONS_COUNTS: NOTIFICATIONS_COUNTS,
  NOTIFICATION_READ_STATUS: NOTIFICATION_READ_STATUS,
  NOTIFICATION_ALLREAD_STATUS: NOTIFICATION_ALLREAD_STATUS
};
var notificationSlice$1 = notificationSlice.reducer;

var queries$c = {
  //1. To get all Todo
  getAllPatient: function getAllPatient(profileId, filter, searchKey) {
    // console.log(profileId, filter, searchKey);
    return "  \n            FOR patient in patients\n                FILTER patient.is_active == true  ".concat(filter ? "".concat(filter) : '', " \n                ").concat(searchKey ? "\n                    filter UPPER(patient.patient_name.first_name) like \"".concat(searchKey.toUpperCase(), "%\" \n                    || UPPER(patient.mobile.number) like \"").concat(searchKey.toUpperCase(), "%\"\n                    || UPPER(patient.email) like \"").concat(searchKey.toUpperCase(), "%\"") : '', "\n                RETURN patient         \n        ");
  },
  // 2. getEntriesByPatientId
  getEntriesByPatientId: function getEntriesByPatientId(patient_id) {
    return "  \n        FOR entries in form_entries\n            filter entries.is_active == true && entries.patient_id == \"".concat(patient_id, "\" \n            let mapped_diseases = (\n                for mapForm in rl_disease_form\n                    filter mapForm.is_active == true && mapForm.form_id == entries.form_id\n                        return FIRST(for mapForm_disease in master_disease\n                            filter mapForm_disease.is_active == true && mapForm_disease.disease_id == mapForm.disease_id\n                                return {\n                                    disease_name: mapForm_disease.disease_name,\n                                    disease_definition: mapForm_disease.disease_definition\n                                }\n                        )       \n            )  \n            let form_detail =(\n                for form in forms\n                filter form.is_active == true && form.form_id == entries.form_id \n                return form\n            )\n                RETURN merge(entries,{mapped_diseases,form_detail})       \n    ");
  }
};

var _extraReducers$c;
var UPSERT_PATIENT = createAsyncThunk("patientSlice/upsertPatient", /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(payload, _ref) {
    var _getState, _getState$authSlice, _getState$authSlice$l, _getState$authSlice$l2;

    var rejectWithValue, getState, user_profile_id, doc, _;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            rejectWithValue = _ref.rejectWithValue, getState = _ref.getState;
            user_profile_id = (_getState = getState()) === null || _getState === void 0 ? void 0 : (_getState$authSlice = _getState.authSlice) === null || _getState$authSlice === void 0 ? void 0 : (_getState$authSlice$l = _getState$authSlice.login) === null || _getState$authSlice$l === void 0 ? void 0 : (_getState$authSlice$l2 = _getState$authSlice$l.data) === null || _getState$authSlice$l2 === void 0 ? void 0 : _getState$authSlice$l2.user_profile_id;
            _context.prev = 2;
            doc = {};

            if (!payload.patient_id) {
              doc.created_at = new Date().toISOString();
              doc.created_by = user_profile_id ? user_profile_id : "user profile id not available";
              doc.patient_id = v4();
              doc._key = doc.patient_id;
            }

            doc.is_active = true;
            doc.updated_at = new Date().toISOString();
            doc.updated_by = user_profile_id ? user_profile_id : "user profile id not available";
            doc = _objectSpread2(_objectSpread2({}, doc), payload);
            _context.next = 11;
            return fetch("".concat(__baseUrl__, "/upsert_document"), _objectSpread2(_objectSpread2({}, __options()), {}, {
              body: JSON.stringify([_objectSpread2(_objectSpread2({}, upsertQuery.upsertPatient), {}, {
                filter: {
                  patient_id: String(doc.patient_id),
                  _key: String(doc._key)
                },
                doc: doc
              })])
            }));

          case 11:
            _ = _context.sent;
            _context.next = 14;
            return _.json();

          case 14:
            _ = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
              data: _objectSpread2({
                patient_id: doc.patient_id
              }, _)
            }));

          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](2);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 21:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 18]]);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());
var GET_ALL_PATIENTS = createAsyncThunk("patientSlice/getAllPatient", /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(payload, _ref3) {
    var _getState2, _getState2$authSlice, _getState2$authSlice$, _getState2$authSlice$2;

    var rejectWithValue, getState, user_profile_id, _payload$filter, _;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            rejectWithValue = _ref3.rejectWithValue, getState = _ref3.getState;
            user_profile_id = (_getState2 = getState()) === null || _getState2 === void 0 ? void 0 : (_getState2$authSlice = _getState2.authSlice) === null || _getState2$authSlice === void 0 ? void 0 : (_getState2$authSlice$ = _getState2$authSlice.login) === null || _getState2$authSlice$ === void 0 ? void 0 : (_getState2$authSlice$2 = _getState2$authSlice$.data) === null || _getState2$authSlice$2 === void 0 ? void 0 : _getState2$authSlice$2.user_profile_id;
            _context2.prev = 2;

            if (payload !== null && payload !== void 0 && payload.filter) {
              _context2.next = 5;
              break;
            }

            return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
              data: []
            }));

          case 5:
            _context2.next = 7;
            return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
              body: JSON.stringify({
                db_name: "".concat(process.env.REACT_APP_DB),
                query: queries$c.getAllPatient(user_profile_id, (_payload$filter = payload === null || payload === void 0 ? void 0 : payload.filter) !== null && _payload$filter !== void 0 ? _payload$filter : "", payload === null || payload === void 0 ? void 0 : payload.searchKey)
              })
            }));

          case 7:
            _ = _context2.sent;
            _context2.next = 10;
            return _.json();

          case 10:
            _ = _context2.sent;
            return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
              data: _
            }));

          case 14:
            _context2.prev = 14;
            _context2.t0 = _context2["catch"](2);
            return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context2.t0.message
            })));

          case 17:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[2, 14]]);
  }));

  return function (_x3, _x4) {
    return _ref4.apply(this, arguments);
  };
}());
var GET_PATIENTS_ENTRIES_BY_PATIENT_ID = createAsyncThunk("patientSlice/getPatientEntriesByPatientId", /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(payload, _ref5) {
    var rejectWithValue, getState, patient_id, _;

    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            rejectWithValue = _ref5.rejectWithValue, getState = _ref5.getState;
            _context3.prev = 1;
            patient_id = payload.patient_id;
            _context3.next = 5;
            return fetch("".concat(__baseUrl__, "/execute_aql"), _objectSpread2(_objectSpread2({}, __options()), {}, {
              body: JSON.stringify({
                db_name: "".concat(process.env.REACT_APP_DB),
                query: queries$c.getEntriesByPatientId(patient_id)
              })
            }));

          case 5:
            _ = _context3.sent;
            _context3.next = 8;
            return _.json();

          case 8:
            _ = _context3.sent;
            return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
              data: _
            }));

          case 12:
            _context3.prev = 12;
            _context3.t0 = _context3["catch"](1);
            return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context3.t0.message
            })));

          case 15:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[1, 12]]);
  }));

  return function (_x5, _x6) {
    return _ref6.apply(this, arguments);
  };
}());
var patientSlice = createSlice({
  name: "patientSlice",
  initialState: {
    getAllPatient: _objectSpread2({}, defaultState.List),
    getPatientEntriesByPatientId: _objectSpread2({}, defaultState.List),
    upsertPatient: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$c = {}, _defineProperty(_extraReducers$c, GET_ALL_PATIENTS.fulfilled, function (state, action) {
    var _action$payload;

    state.getAllPatient = (_action$payload = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload !== void 0 ? _action$payload : {};
  }), _defineProperty(_extraReducers$c, GET_ALL_PATIENTS.pending, function (state, action) {
    state.getAllPatient.loading = true;
  }), _defineProperty(_extraReducers$c, GET_ALL_PATIENTS.rejected, function (state, action) {
    var _action$payload2;

    state.getAllPatient = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$c, GET_PATIENTS_ENTRIES_BY_PATIENT_ID.fulfilled, function (state, action) {
    var _action$payload3;

    state.getPatientEntriesByPatientId = (_action$payload3 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload3 !== void 0 ? _action$payload3 : {};
  }), _defineProperty(_extraReducers$c, GET_PATIENTS_ENTRIES_BY_PATIENT_ID.pending, function (state, action) {
    state.getPatientEntriesByPatientId.loading = true;
  }), _defineProperty(_extraReducers$c, GET_PATIENTS_ENTRIES_BY_PATIENT_ID.rejected, function (state, action) {
    var _action$payload4;

    state.getPatientEntriesByPatientId = (_action$payload4 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload4 !== void 0 ? _action$payload4 : {};
  }), _defineProperty(_extraReducers$c, UPSERT_PATIENT.fulfilled, function (state, action) {
    var _action$payload5;

    state.upsertPatient = (_action$payload5 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload5 !== void 0 ? _action$payload5 : {};
  }), _defineProperty(_extraReducers$c, UPSERT_PATIENT.pending, function (state, action) {
    state.upsertPatient.loading = true;
  }), _defineProperty(_extraReducers$c, UPSERT_PATIENT.rejected, function (state, action) {
    var _action$payload6;

    state.upsertPatient = (_action$payload6 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload6 !== void 0 ? _action$payload6 : {};
  }), _extraReducers$c)
});
var patientActions = {
  GET_ALL_PATIENTS: GET_ALL_PATIENTS,
  UPSERT_PATIENT: UPSERT_PATIENT,
  GET_PATIENTS_ENTRIES_BY_PATIENT_ID: GET_PATIENTS_ENTRIES_BY_PATIENT_ID
};
var patientSlice$1 = patientSlice.reducer;

var _actions = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, countryActions), diseaseActions), formActions), renderActions), workflowActions), roleActions), userActions), authActions), todoActions), dashboardActions), manageLocationActions), notificationActions), patientActions);

var rootReducer = combineReducers({
  countrySlice: countrySlice$1,
  diseaseSlice: diseaseSlice$1,
  formSlice: formSlice$1,
  renderSlice: renderSlice$1,
  workflowSlice: workflowSlice$1,
  roleSlice: roleSlice$1,
  userSlice: userSlice$1,
  authSlice: authSlice$1,
  todoSlice: todoSlice$1,
  dashboardSlice: dashboardSlice$1,
  manageLocationSlice: manageLocationSlice$1,
  notificationSlice: notificationSlice$1,
  patientSlice: patientSlice$1
});

var store = configureStore({
  reducer: rootReducer
});

exports.actions = _actions;
exports.store = store;
